import { mergeModels as Da, useModel as Ba, computed as B, openBlock as v, createElementBlock as m, normalizeClass as w, toDisplayString as ie, createCommentVNode as D, defineComponent as Oe, ref as V, resolveComponent as ze, Fragment as ce, normalizeStyle as nt, createElementVNode as y, createBlock as me, renderSlot as we, createVNode as re, Transition as Aa, withCtx as dt, withDirectives as Kr, vShow as bo, reactive as it, renderList as Re, resolveDynamicComponent as Ii, normalizeProps as Yc, guardReactiveProps as Uc, mergeProps as Mi, createTextVNode as _n, useCssVars as ir, resolveDirective as $0, unref as tt, withModifiers as Ct, getCurrentInstance as C0, shallowRef as S0, onMounted as Tt, onUnmounted as xi, isRef as nr, isReactive as pc, watch as vt, nextTick as Li, h as Nr, isVNode as k0, createApp as hc, watchEffect as Lt, onBeforeMount as Fi, toRefs as Wc, useSlots as Gc, createSlots as Zc, vModelText as q0, pushScopeId as D0, popScopeId as B0, vModelDynamic as A0, onBeforeUnmount as _o, provide as T0, inject as O0 } from "vue";
import { Chart as Kc } from "highcharts-vue";
import gc from "highcharts";
var fe = /* @__PURE__ */ ((e) => (e[e.dp12 = 12] = "dp12", e[e.dp16 = 16] = "dp16", e[e.dp20 = 20] = "dp20", e[e.dp24 = 24] = "dp24", e[e.dp32 = 32] = "dp32", e[e.dp40 = 40] = "dp40", e[e.dp48 = 48] = "dp48", e[e.dp64 = 64] = "dp64", e[e.dp72 = 72] = "dp72", e[e.dp80 = 80] = "dp80", e[e.dp96 = 96] = "dp96", e[e.dp112 = 112] = "dp112", e[e.dp128 = 128] = "dp128", e))(fe || {}), Xe = /* @__PURE__ */ ((e) => (e.emphasisBaseLow = "emphasis-base-low", e.emphasisBaseMedium = "emphasis-base-medium", e.emphasisBaseHigh = "emphasis-base-high", e.emphasisBaseDisabled = "emphasis-base-disabled", e.emphasisBaseInverseLow = "emphasis-base-low-inverse", e.emphasisBaseInverseMedium = "emphasis-base-medium-inverse", e.emphasisBaseInverseHigh = "emphasis-base-high-inverse", e.emphasisBaseInverseDisabled = "emphasis-base-disabled-inverse", e.emphasisBaseMedium70 = "emphasis-base-medium-70", e.primaryBase = "primary-base", e.primaryBaseInverse = "primary-base-inverse", e.statusError = "status-error", e.statusErrorInverse = "status-error-inverse", e.statusSuccess = "status-success", e.statusSuccessInverse = "status-success-inverse", e.statusInformative = "status-informative", e.statusInformativeInverse = "status-informative-inverse", e.statusWarning = "status-warning", e.statusWarningInverse = "status-warning-inverse", e))(Xe || {});
const I0 = {
  key: 0,
  class: "orq-counter__value--small"
}, M0 = {
  key: 1,
  class: "orq-counter__value--small"
}, x0 = {
  key: 2,
  class: "orq-counter__value--large"
}, L0 = {
  key: 3,
  class: "orq-counter__value--large"
}, Xc = {
  __name: "Counter",
  props: /* @__PURE__ */ Da({
    size: {
      type: String,
      default: "large"
    },
    type: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  }, {
    modelValue: { type: Number },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const a = e, r = Ba(e, "modelValue"), s = B(
      () => a.size === "small" && r.value >= 10 ? "9+" : r.value
    ), o = B(
      () => a.size === "small" && r.value >= 999 ? "999+" : r.value
    ), d = B(
      () => a.size === "large" && r.value >= 10 ? "9+" : r.value
    ), u = B(
      () => a.size === "large" && r.value >= 999 ? "999+" : r.value
    ), f = B(() => ({
      "orq-counter": !0,
      "orq-counter--small orq-counter--small--circle": a.size === "small" && a.type === "circle",
      "orq-counter--small orq-counter--small--pill": a.size === "small" && a.type === "pill",
      "orq-counter--large orq-counter--large--circle": a.size === "large" && a.type === "circle",
      "orq-counter--large orq-counter--large--pill": a.size === "large" && a.type === "pill",
      "orq-counter--inverse": a.inverse
    }));
    return (c, g) => (v(), m("div", {
      class: w(f.value)
    }, [
      r.value && e.size === "small" && e.type === "circle" ? (v(), m("span", I0, ie(s.value), 1)) : D("", !0),
      r.value && e.size === "small" && e.type === "pill" ? (v(), m("span", M0, ie(o.value), 1)) : D("", !0),
      r.value && e.size === "large" && e.type === "circle" ? (v(), m("span", x0, ie(d.value), 1)) : D("", !0),
      r.value && e.size === "large" && e.type === "pill" ? (v(), m("span", L0, ie(u.value), 1)) : D("", !0)
    ], 2));
  }
}, wo = {
  __name: "Bullet",
  props: {
    appearance: {
      type: String,
      default: "neutral"
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = e, r = B(
      () => a.appearance ? `orq-bullet--${a.appearance}` : ""
    ), s = B(
      () => a.inverse ? `${r.value}--inverse` : ""
    );
    return (o, d) => (v(), m("span", {
      class: w(`orq-bullet ${r.value} ${s.value}`)
    }, null, 2));
  }
}, F0 = Oe({
  name: "OrqIconContainer",
  components: {
    OrqCounter: Xc,
    OrqBullet: wo
  },
  props: {
    name: {
      type: String,
      required: !0
    },
    size: {
      type: Number,
      default: 16
    },
    circle: {
      type: Boolean,
      default: !1
    },
    outline: {
      type: Boolean,
      default: !1
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: ""
    },
    role: {
      type: String,
      default: ""
    },
    value: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: "none"
    },
    customCircleBackgroundColor: {
      type: String,
      default: ""
    }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    let r = V(e.size), s = V(
      r.value > 80 ? "large" : "small"
    ), o = V("small"), d = V("circle");
    const u = () => {
      if (e.circle && r.value >= 24 || !e.circle)
        return !0;
    }, f = V(e.value), c = () => {
      a("click");
    };
    return {
      containerClasses: B(() => ({
        "icon-container": !0,
        "icon-container__circle": e.circle,
        "icon-container__circle--inverse": e.circle && e.inverse,
        "icon-container__circle--inverse--outline": e.inverse && e.outline,
        "icon-container__circle--outline": e.circle && e.outline
      })),
      iconClasses: B(() => ({
        "icon-container__icon": !0,
        [`icon-${e.name}`]: e.name,
        [`icon-container__icon--${e.color}`]: e.color
      })),
      containerStyle: B(() => ({
        width: e.circle ? `${r.value}px` : "",
        height: e.circle ? `${r.value}px` : "",
        backgroundColor: e.customCircleBackgroundColor
      })),
      iconCircleStyle: B(() => ({
        fontSize: e.circle && r.value < fe.dp64 && r.value !== fe.dp48 ? `${r.value / 2 + 4}px` : e.circle && r.value === fe.dp48 ? `${r.value / 2 + 8}px` : e.circle && r.value === fe.dp72 ? `${r.value / 2 + 4}px` : e.circle && r.value > fe.dp64 && r.value !== fe.dp96 ? `${r.value / 2 + 8}px` : e.circle && r.value === fe.dp64 ? `${r.value - fe.dp24}px` : e.circle && r.value === fe.dp96 ? `${r.value - fe.dp32}px` : `${r.value}px`
      })),
      iconTypeNoneStyle: B(() => ({
        fontSize: e.circle && r.value <= fe.dp64 ? `${r.value / 2}px` : e.circle && r.value > fe.dp64 ? `${r.value / 2 + 8}px` : `${r.value}px`
      })),
      iconTypeCounterStyle: B(() => ({
        fontSize: e.circle && r.value <= fe.dp64 ? `${r.value / 2}px` : e.circle && r.value > fe.dp64 ? `${r.value / 2 + 8}px` : `${r.value}px`
      })),
      bulletDefaultStyle: B(() => ({
        marginLeft: r.value === fe.dp16 ? "-8px" : r.value === fe.dp24 ? "-9px" : r.value >= fe.dp32 ? "-12px" : "",
        marginTop: r.value <= fe.dp24 ? "-1px" : r.value >= fe.dp32 ? "3px" : ""
      })),
      counterDefaultStyle: B(() => ({
        marginLeft: r.value <= fe.dp40 || r.value <= fe.dp48 ? "-17px" : r.value <= fe.dp64 ? "-21px" : r.value <= fe.dp72 ? "-22px" : r.value <= fe.dp80 ? "-24px" : r.value <= fe.dp96 ? "-30px" : r.value <= fe.dp112 ? "-36px" : r.value === fe.dp128 ? "-40px" : "",
        marginTop: r.value <= fe.dp40 ? "-1px" : r.value <= fe.dp48 ? "0px" : r.value <= fe.dp64 ? "3px" : r.value <= fe.dp72 ? "4px" : r.value <= fe.dp80 ? "7px" : r.value <= fe.dp96 ? "4px" : r.value <= fe.dp112 ? "8px" : r.value === fe.dp128 ? "11px" : ""
      })),
      bulletCircleStyle: B(() => ({
        marginLeft: r.value <= fe.dp24 ? "-8px" : r.value <= fe.dp32 ? "-9px" : "",
        marginBottom: r.value === fe.dp16 ? "5px" : r.value <= fe.dp24 ? "12px" : "16px",
        zIndex: "99",
        position: "relative"
      })),
      counterCircleStyle: B(() => ({
        zIndex: "99",
        position: "relative",
        marginTop: r.value === fe.dp40 ? "-42px" : r.value === fe.dp48 ? "-48px" : r.value === fe.dp64 ? "-64px" : r.value === fe.dp72 ? "-72px" : r.value === fe.dp80 ? "-78px" : r.value === fe.dp96 ? "-92px" : r.value === fe.dp112 ? "-104px" : r.value === fe.dp128 ? "-118px" : "",
        marginLeft: r.value <= fe.dp40 ? "24px" : r.value === fe.dp48 ? "32px" : r.value === fe.dp64 ? "48px" : r.value === fe.dp72 ? "52px" : r.value === fe.dp80 ? "56px" : r.value === fe.dp96 ? "70px" : r.value === fe.dp112 ? "86px" : r.value === fe.dp128 ? "98px" : ""
      })),
      bulletTypeCircleStyle: B(() => ({
        marginLeft: r.value <= fe.dp24 ? "-8px" : r.value <= fe.dp32 ? "-9px" : r.value <= fe.dp40 ? "-10px" : r.value === fe.dp48 ? "-12px" : r.value === fe.dp64 ? "-14px" : r.value === fe.dp72 ? "-16px" : r.value === fe.dp80 ? "-17px" : r.value === fe.dp96 ? "-19px" : r.value === fe.dp112 ? "-21px" : r.value === fe.dp128 ? "-24px" : "",
        marginBottom: r.value === fe.dp16 ? "5px" : r.value <= fe.dp24 ? "12px" : r.value === fe.dp32 ? "17px" : r.value === fe.dp40 ? "21px" : r.value === fe.dp48 ? "28px" : r.value === fe.dp64 ? "37px" : r.value === fe.dp72 ? "40px" : r.value === fe.dp80 ? "46px" : r.value === fe.dp96 ? "59px" : r.value === fe.dp112 ? "64px" : r.value === fe.dp128 ? "74px" : "",
        zIndex: "99",
        position: "relative"
      })),
      valueProp: f,
      onClick: c,
      circleValidation: u,
      counterDefaultSize: s,
      counterSmallSize: o,
      counterCircleType: d,
      iconContainerSize: r
    };
  }
}), ae = (e, a) => {
  const r = e.__vccOpts || e;
  for (const [s, o] of a)
    r[s] = o;
  return r;
}, E0 = ["role"];
function P0(e, a, r, s, o, d) {
  const u = ze("OrqBullet"), f = ze("OrqCounter");
  return v(), m(ce, null, [
    e.circleValidation() ? (v(), m("div", {
      key: 0,
      class: w(e.containerClasses),
      style: nt(e.containerStyle),
      role: e.role,
      onClick: a[1] || (a[1] = (c) => e.onClick())
    }, [
      e.circle ? (v(), m("i", {
        key: 0,
        class: w(e.iconClasses),
        style: nt(e.iconCircleStyle)
      }, null, 6)) : D("", !0),
      e.type === "none" && !e.circle ? (v(), m("i", {
        key: 1,
        class: w(e.iconClasses),
        style: nt(e.iconTypeNoneStyle)
      }, null, 6)) : D("", !0),
      e.type === "counter" && !e.circle ? (v(), m(ce, { key: 2 }, [
        y("i", {
          class: w(e.iconClasses),
          style: nt(e.iconTypeCounterStyle)
        }, null, 6),
        e.iconContainerSize <= 32 ? (v(), me(u, {
          key: 0,
          appearance: "info",
          inverse: e.inverse,
          style: nt(e.bulletDefaultStyle)
        }, null, 8, ["inverse", "style"])) : D("", !0),
        e.iconContainerSize > 32 ? (v(), me(f, {
          key: 1,
          modelValue: e.valueProp,
          "onUpdate:modelValue": a[0] || (a[0] = (c) => e.valueProp = c),
          type: e.counterCircleType,
          size: e.counterDefaultSize,
          inverse: e.inverse,
          style: nt(e.counterDefaultStyle)
        }, null, 8, ["modelValue", "type", "size", "inverse", "style"])) : D("", !0)
      ], 64)) : D("", !0)
    ], 14, E0)) : D("", !0),
    e.type === "counter" && e.circle && e.iconContainerSize >= 24 ? (v(), m(ce, { key: 1 }, [
      e.iconContainerSize <= 32 ? (v(), me(u, {
        key: 0,
        appearance: "info",
        inverse: e.inverse,
        style: nt(e.bulletCircleStyle)
      }, null, 8, ["inverse", "style"])) : D("", !0),
      e.iconContainerSize > 32 ? (v(), me(f, {
        key: 1,
        "v-model": e.valueProp,
        type: e.counterCircleType,
        size: e.counterSmallSize,
        inverse: e.inverse,
        style: nt(e.counterCircleStyle)
      }, null, 8, ["v-model", "type", "size", "inverse", "style"])) : D("", !0)
    ], 64)) : D("", !0),
    e.type === "bullet" && e.circle && e.iconContainerSize >= 24 ? (v(), me(u, {
      key: 2,
      appearance: "info",
      inverse: e.inverse,
      style: nt(e.bulletTypeCircleStyle)
    }, null, 8, ["inverse", "style"])) : D("", !0)
  ], 64);
}
const Te = /* @__PURE__ */ ae(F0, [["render", P0]]), z0 = { class: "header" }, R0 = {
  __name: "AccordionHeader",
  props: {
    title: {
      type: String,
      default: ""
    },
    open: {
      type: Boolean,
      default: !1
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    altInverse: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (a, r) => (v(), m("div", z0, [
      y("div", null, [
        we(a.$slots, "title", {}, () => [
          y("div", {
            class: w(["title", e.inverse])
          }, ie(e.title), 3)
        ], !0)
      ]),
      y("div", null, [
        we(a.$slots, "action", { open: e.open }, () => [
          re(Te, {
            color: e.inverse ? "emphasis-base-high-inverse" : "emphasis-base-high",
            name: `chevron${e.open ? "-up" : "-down"}`,
            size: 24
          }, null, 8, ["color", "name"])
        ], !0)
      ])
    ]));
  }
}, N0 = /* @__PURE__ */ ae(R0, [["__scopeId", "data-v-6dab67b3"]]);
var Jc = {
  update: null,
  begin: null,
  loopBegin: null,
  changeBegin: null,
  change: null,
  changeComplete: null,
  loopComplete: null,
  complete: null,
  loop: 1,
  direction: "normal",
  autoplay: !0,
  timelineOffset: 0
}, $o = {
  duration: 1e3,
  delay: 0,
  endDelay: 0,
  easing: "easeOutElastic(1, .5)",
  round: 0
}, H0 = ["translateX", "translateY", "translateZ", "rotate", "rotateX", "rotateY", "rotateZ", "scale", "scaleX", "scaleY", "scaleZ", "skew", "skewX", "skewY", "perspective", "matrix", "matrix3d"], Di = {
  CSS: {},
  springs: {}
};
function An(e, a, r) {
  return Math.min(Math.max(e, a), r);
}
function _a(e, a) {
  return e.indexOf(a) > -1;
}
function no(e, a) {
  return e.apply(null, a);
}
var Ce = {
  arr: function(e) {
    return Array.isArray(e);
  },
  obj: function(e) {
    return _a(Object.prototype.toString.call(e), "Object");
  },
  pth: function(e) {
    return Ce.obj(e) && e.hasOwnProperty("totalLength");
  },
  svg: function(e) {
    return e instanceof SVGElement;
  },
  inp: function(e) {
    return e instanceof HTMLInputElement;
  },
  dom: function(e) {
    return e.nodeType || Ce.svg(e);
  },
  str: function(e) {
    return typeof e == "string";
  },
  fnc: function(e) {
    return typeof e == "function";
  },
  und: function(e) {
    return typeof e > "u";
  },
  nil: function(e) {
    return Ce.und(e) || e === null;
  },
  hex: function(e) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(e);
  },
  rgb: function(e) {
    return /^rgb/.test(e);
  },
  hsl: function(e) {
    return /^hsl/.test(e);
  },
  col: function(e) {
    return Ce.hex(e) || Ce.rgb(e) || Ce.hsl(e);
  },
  key: function(e) {
    return !Jc.hasOwnProperty(e) && !$o.hasOwnProperty(e) && e !== "targets" && e !== "keyframes";
  }
};
function Qc(e) {
  var a = /\(([^)]+)\)/.exec(e);
  return a ? a[1].split(",").map(function(r) {
    return parseFloat(r);
  }) : [];
}
function jc(e, a) {
  var r = Qc(e), s = An(Ce.und(r[0]) ? 1 : r[0], 0.1, 100), o = An(Ce.und(r[1]) ? 100 : r[1], 0.1, 100), d = An(Ce.und(r[2]) ? 10 : r[2], 0.1, 100), u = An(Ce.und(r[3]) ? 0 : r[3], 0.1, 100), f = Math.sqrt(o / s), c = d / (2 * Math.sqrt(o * s)), g = c < 1 ? f * Math.sqrt(1 - c * c) : 0, h = 1, q = c < 1 ? (c * f + -u) / g : -u + f;
  function C(S) {
    var I = a ? a * S / 1e3 : S;
    return c < 1 ? I = Math.exp(-I * c * f) * (h * Math.cos(g * I) + q * Math.sin(g * I)) : I = (h + q * I) * Math.exp(-I * f), S === 0 || S === 1 ? S : 1 - I;
  }
  function O() {
    var S = Di.springs[e];
    if (S)
      return S;
    for (var I = 1 / 6, M = 0, F = 0; ; )
      if (M += I, C(M) === 1) {
        if (F++, F >= 16)
          break;
      } else
        F = 0;
    var P = M * I * 1e3;
    return Di.springs[e] = P, P;
  }
  return a ? C : O;
}
function V0(e) {
  return e === void 0 && (e = 10), function(a) {
    return Math.ceil(An(a, 1e-6, 1) * e) * (1 / e);
  };
}
var Y0 = function() {
  var e = 11, a = 1 / (e - 1);
  function r(h, q) {
    return 1 - 3 * q + 3 * h;
  }
  function s(h, q) {
    return 3 * q - 6 * h;
  }
  function o(h) {
    return 3 * h;
  }
  function d(h, q, C) {
    return ((r(q, C) * h + s(q, C)) * h + o(q)) * h;
  }
  function u(h, q, C) {
    return 3 * r(q, C) * h * h + 2 * s(q, C) * h + o(q);
  }
  function f(h, q, C, O, S) {
    var I, M, F = 0;
    do
      M = q + (C - q) / 2, I = d(M, O, S) - h, I > 0 ? C = M : q = M;
    while (Math.abs(I) > 1e-7 && ++F < 10);
    return M;
  }
  function c(h, q, C, O) {
    for (var S = 0; S < 4; ++S) {
      var I = u(q, C, O);
      if (I === 0)
        return q;
      var M = d(q, C, O) - h;
      q -= M / I;
    }
    return q;
  }
  function g(h, q, C, O) {
    if (!(0 <= h && h <= 1 && 0 <= C && C <= 1))
      return;
    var S = new Float32Array(e);
    if (h !== q || C !== O)
      for (var I = 0; I < e; ++I)
        S[I] = d(I * a, h, C);
    function M(F) {
      for (var P = 0, x = 1, $ = e - 1; x !== $ && S[x] <= F; ++x)
        P += a;
      --x;
      var Y = (F - S[x]) / (S[x + 1] - S[x]), R = P + Y * a, T = u(R, h, C);
      return T >= 1e-3 ? c(F, R, h, C) : T === 0 ? R : f(F, P, P + a, h, C);
    }
    return function(F) {
      return h === q && C === O || F === 0 || F === 1 ? F : d(M(F), q, O);
    };
  }
  return g;
}(), ed = function() {
  var e = { linear: function() {
    return function(s) {
      return s;
    };
  } }, a = {
    Sine: function() {
      return function(s) {
        return 1 - Math.cos(s * Math.PI / 2);
      };
    },
    Expo: function() {
      return function(s) {
        return s ? Math.pow(2, 10 * s - 10) : 0;
      };
    },
    Circ: function() {
      return function(s) {
        return 1 - Math.sqrt(1 - s * s);
      };
    },
    Back: function() {
      return function(s) {
        return s * s * (3 * s - 2);
      };
    },
    Bounce: function() {
      return function(s) {
        for (var o, d = 4; s < ((o = Math.pow(2, --d)) - 1) / 11; )
          ;
        return 1 / Math.pow(4, 3 - d) - 7.5625 * Math.pow((o * 3 - 2) / 22 - s, 2);
      };
    },
    Elastic: function(s, o) {
      s === void 0 && (s = 1), o === void 0 && (o = 0.5);
      var d = An(s, 1, 10), u = An(o, 0.1, 2);
      return function(f) {
        return f === 0 || f === 1 ? f : -d * Math.pow(2, 10 * (f - 1)) * Math.sin((f - 1 - u / (Math.PI * 2) * Math.asin(1 / d)) * (Math.PI * 2) / u);
      };
    }
  }, r = ["Quad", "Cubic", "Quart", "Quint"];
  return r.forEach(function(s, o) {
    a[s] = function() {
      return function(d) {
        return Math.pow(d, o + 2);
      };
    };
  }), Object.keys(a).forEach(function(s) {
    var o = a[s];
    e["easeIn" + s] = o, e["easeOut" + s] = function(d, u) {
      return function(f) {
        return 1 - o(d, u)(1 - f);
      };
    }, e["easeInOut" + s] = function(d, u) {
      return function(f) {
        return f < 0.5 ? o(d, u)(f * 2) / 2 : 1 - o(d, u)(f * -2 + 2) / 2;
      };
    }, e["easeOutIn" + s] = function(d, u) {
      return function(f) {
        return f < 0.5 ? (1 - o(d, u)(1 - f * 2)) / 2 : (o(d, u)(f * 2 - 1) + 1) / 2;
      };
    };
  }), e;
}();
function Co(e, a) {
  if (Ce.fnc(e))
    return e;
  var r = e.split("(")[0], s = ed[r], o = Qc(e);
  switch (r) {
    case "spring":
      return jc(e, a);
    case "cubicBezier":
      return no(Y0, o);
    case "steps":
      return no(V0, o);
    default:
      return no(s, o);
  }
}
function td(e) {
  try {
    var a = document.querySelectorAll(e);
    return a;
  } catch {
    return;
  }
}
function Ei(e, a) {
  for (var r = e.length, s = arguments.length >= 2 ? arguments[1] : void 0, o = [], d = 0; d < r; d++)
    if (d in e) {
      var u = e[d];
      a.call(s, u, d, e) && o.push(u);
    }
  return o;
}
function Pi(e) {
  return e.reduce(function(a, r) {
    return a.concat(Ce.arr(r) ? Pi(r) : r);
  }, []);
}
function mc(e) {
  return Ce.arr(e) ? e : (Ce.str(e) && (e = td(e) || e), e instanceof NodeList || e instanceof HTMLCollection ? [].slice.call(e) : [e]);
}
function So(e, a) {
  return e.some(function(r) {
    return r === a;
  });
}
function ko(e) {
  var a = {};
  for (var r in e)
    a[r] = e[r];
  return a;
}
function uo(e, a) {
  var r = ko(e);
  for (var s in e)
    r[s] = a.hasOwnProperty(s) ? a[s] : e[s];
  return r;
}
function zi(e, a) {
  var r = ko(e);
  for (var s in a)
    r[s] = Ce.und(e[s]) ? a[s] : e[s];
  return r;
}
function U0(e) {
  var a = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(e);
  return a ? "rgba(" + a[1] + ",1)" : e;
}
function W0(e) {
  var a = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, r = e.replace(a, function(f, c, g, h) {
    return c + c + g + g + h + h;
  }), s = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(r), o = parseInt(s[1], 16), d = parseInt(s[2], 16), u = parseInt(s[3], 16);
  return "rgba(" + o + "," + d + "," + u + ",1)";
}
function G0(e) {
  var a = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(e) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(e), r = parseInt(a[1], 10) / 360, s = parseInt(a[2], 10) / 100, o = parseInt(a[3], 10) / 100, d = a[4] || 1;
  function u(C, O, S) {
    return S < 0 && (S += 1), S > 1 && (S -= 1), S < 1 / 6 ? C + (O - C) * 6 * S : S < 1 / 2 ? O : S < 2 / 3 ? C + (O - C) * (2 / 3 - S) * 6 : C;
  }
  var f, c, g;
  if (s == 0)
    f = c = g = o;
  else {
    var h = o < 0.5 ? o * (1 + s) : o + s - o * s, q = 2 * o - h;
    f = u(q, h, r + 1 / 3), c = u(q, h, r), g = u(q, h, r - 1 / 3);
  }
  return "rgba(" + f * 255 + "," + c * 255 + "," + g * 255 + "," + d + ")";
}
function Z0(e) {
  if (Ce.rgb(e))
    return U0(e);
  if (Ce.hex(e))
    return W0(e);
  if (Ce.hsl(e))
    return G0(e);
}
function Un(e) {
  var a = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(e);
  if (a)
    return a[1];
}
function K0(e) {
  if (_a(e, "translate") || e === "perspective")
    return "px";
  if (_a(e, "rotate") || _a(e, "skew"))
    return "deg";
}
function co(e, a) {
  return Ce.fnc(e) ? e(a.target, a.id, a.total) : e;
}
function Tn(e, a) {
  return e.getAttribute(a);
}
function qo(e, a, r) {
  var s = Un(a);
  if (So([r, "deg", "rad", "turn"], s))
    return a;
  var o = Di.CSS[a + r];
  if (!Ce.und(o))
    return o;
  var d = 100, u = document.createElement(e.tagName), f = e.parentNode && e.parentNode !== document ? e.parentNode : document.body;
  f.appendChild(u), u.style.position = "absolute", u.style.width = d + r;
  var c = d / u.offsetWidth;
  f.removeChild(u);
  var g = c * parseFloat(a);
  return Di.CSS[a + r] = g, g;
}
function nd(e, a, r) {
  if (a in e.style) {
    var s = a.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), o = e.style[a] || getComputedStyle(e).getPropertyValue(s) || "0";
    return r ? qo(e, o, r) : o;
  }
}
function Do(e, a) {
  if (Ce.dom(e) && !Ce.inp(e) && (!Ce.nil(Tn(e, a)) || Ce.svg(e) && e[a]))
    return "attribute";
  if (Ce.dom(e) && So(H0, a))
    return "transform";
  if (Ce.dom(e) && a !== "transform" && nd(e, a))
    return "css";
  if (e[a] != null)
    return "object";
}
function rd(e) {
  if (Ce.dom(e)) {
    for (var a = e.style.transform || "", r = /(\w+)\(([^)]*)\)/g, s = /* @__PURE__ */ new Map(), o; o = r.exec(a); )
      s.set(o[1], o[2]);
    return s;
  }
}
function X0(e, a, r, s) {
  var o = _a(a, "scale") ? 1 : 0 + K0(a), d = rd(e).get(a) || o;
  return r && (r.transforms.list.set(a, d), r.transforms.last = a), s ? qo(e, d, s) : d;
}
function Bo(e, a, r, s) {
  switch (Do(e, a)) {
    case "transform":
      return X0(e, a, s, r);
    case "css":
      return nd(e, a, r);
    case "attribute":
      return Tn(e, a);
    default:
      return e[a] || 0;
  }
}
function Ao(e, a) {
  var r = /^(\*=|\+=|-=)/.exec(e);
  if (!r)
    return e;
  var s = Un(e) || 0, o = parseFloat(a), d = parseFloat(e.replace(r[0], ""));
  switch (r[0][0]) {
    case "+":
      return o + d + s;
    case "-":
      return o - d + s;
    case "*":
      return o * d + s;
  }
}
function ad(e, a) {
  if (Ce.col(e))
    return Z0(e);
  if (/\s/g.test(e))
    return e;
  var r = Un(e), s = r ? e.substr(0, e.length - r.length) : e;
  return a ? s + a : s;
}
function To(e, a) {
  return Math.sqrt(Math.pow(a.x - e.x, 2) + Math.pow(a.y - e.y, 2));
}
function J0(e) {
  return Math.PI * 2 * Tn(e, "r");
}
function Q0(e) {
  return Tn(e, "width") * 2 + Tn(e, "height") * 2;
}
function j0(e) {
  return To(
    { x: Tn(e, "x1"), y: Tn(e, "y1") },
    { x: Tn(e, "x2"), y: Tn(e, "y2") }
  );
}
function id(e) {
  for (var a = e.points, r = 0, s, o = 0; o < a.numberOfItems; o++) {
    var d = a.getItem(o);
    o > 0 && (r += To(s, d)), s = d;
  }
  return r;
}
function eb(e) {
  var a = e.points;
  return id(e) + To(a.getItem(a.numberOfItems - 1), a.getItem(0));
}
function sd(e) {
  if (e.getTotalLength)
    return e.getTotalLength();
  switch (e.tagName.toLowerCase()) {
    case "circle":
      return J0(e);
    case "rect":
      return Q0(e);
    case "line":
      return j0(e);
    case "polyline":
      return id(e);
    case "polygon":
      return eb(e);
  }
}
function tb(e) {
  var a = sd(e);
  return e.setAttribute("stroke-dasharray", a), a;
}
function nb(e) {
  for (var a = e.parentNode; Ce.svg(a) && Ce.svg(a.parentNode); )
    a = a.parentNode;
  return a;
}
function od(e, a) {
  var r = a || {}, s = r.el || nb(e), o = s.getBoundingClientRect(), d = Tn(s, "viewBox"), u = o.width, f = o.height, c = r.viewBox || (d ? d.split(" ") : [0, 0, u, f]);
  return {
    el: s,
    viewBox: c,
    x: c[0] / 1,
    y: c[1] / 1,
    w: u,
    h: f,
    vW: c[2],
    vH: c[3]
  };
}
function rb(e, a) {
  var r = Ce.str(e) ? td(e)[0] : e, s = a || 100;
  return function(o) {
    return {
      property: o,
      el: r,
      svg: od(r),
      totalLength: sd(r) * (s / 100)
    };
  };
}
function ab(e, a, r) {
  function s(h) {
    h === void 0 && (h = 0);
    var q = a + h >= 1 ? a + h : 0;
    return e.el.getPointAtLength(q);
  }
  var o = od(e.el, e.svg), d = s(), u = s(-1), f = s(1), c = r ? 1 : o.w / o.vW, g = r ? 1 : o.h / o.vH;
  switch (e.property) {
    case "x":
      return (d.x - o.x) * c;
    case "y":
      return (d.y - o.y) * g;
    case "angle":
      return Math.atan2(f.y - u.y, f.x - u.x) * 180 / Math.PI;
  }
}
function yc(e, a) {
  var r = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g, s = ad(Ce.pth(e) ? e.totalLength : e, a) + "";
  return {
    original: s,
    numbers: s.match(r) ? s.match(r).map(Number) : [0],
    strings: Ce.str(e) || a ? s.split(r) : []
  };
}
function Oo(e) {
  var a = e ? Pi(Ce.arr(e) ? e.map(mc) : mc(e)) : [];
  return Ei(a, function(r, s, o) {
    return o.indexOf(r) === s;
  });
}
function ld(e) {
  var a = Oo(e);
  return a.map(function(r, s) {
    return { target: r, id: s, total: a.length, transforms: { list: rd(r) } };
  });
}
function ib(e, a) {
  var r = ko(a);
  if (/^spring/.test(r.easing) && (r.duration = jc(r.easing)), Ce.arr(e)) {
    var s = e.length, o = s === 2 && !Ce.obj(e[0]);
    o ? e = { value: e } : Ce.fnc(a.duration) || (r.duration = a.duration / s);
  }
  var d = Ce.arr(e) ? e : [e];
  return d.map(function(u, f) {
    var c = Ce.obj(u) && !Ce.pth(u) ? u : { value: u };
    return Ce.und(c.delay) && (c.delay = f ? 0 : a.delay), Ce.und(c.endDelay) && (c.endDelay = f === d.length - 1 ? a.endDelay : 0), c;
  }).map(function(u) {
    return zi(u, r);
  });
}
function sb(e) {
  for (var a = Ei(Pi(e.map(function(d) {
    return Object.keys(d);
  })), function(d) {
    return Ce.key(d);
  }).reduce(function(d, u) {
    return d.indexOf(u) < 0 && d.push(u), d;
  }, []), r = {}, s = function(d) {
    var u = a[d];
    r[u] = e.map(function(f) {
      var c = {};
      for (var g in f)
        Ce.key(g) ? g == u && (c.value = f[g]) : c[g] = f[g];
      return c;
    });
  }, o = 0; o < a.length; o++) s(o);
  return r;
}
function ob(e, a) {
  var r = [], s = a.keyframes;
  s && (a = zi(sb(s), a));
  for (var o in a)
    Ce.key(o) && r.push({
      name: o,
      tweens: ib(a[o], e)
    });
  return r;
}
function lb(e, a) {
  var r = {};
  for (var s in e) {
    var o = co(e[s], a);
    Ce.arr(o) && (o = o.map(function(d) {
      return co(d, a);
    }), o.length === 1 && (o = o[0])), r[s] = o;
  }
  return r.duration = parseFloat(r.duration), r.delay = parseFloat(r.delay), r;
}
function ub(e, a) {
  var r;
  return e.tweens.map(function(s) {
    var o = lb(s, a), d = o.value, u = Ce.arr(d) ? d[1] : d, f = Un(u), c = Bo(a.target, e.name, f, a), g = r ? r.to.original : c, h = Ce.arr(d) ? d[0] : g, q = Un(h) || Un(c), C = f || q;
    return Ce.und(u) && (u = g), o.from = yc(h, C), o.to = yc(Ao(u, h), C), o.start = r ? r.end : 0, o.end = o.start + o.delay + o.duration + o.endDelay, o.easing = Co(o.easing, o.duration), o.isPath = Ce.pth(d), o.isPathTargetInsideSVG = o.isPath && Ce.svg(a.target), o.isColor = Ce.col(o.from.original), o.isColor && (o.round = 1), r = o, o;
  });
}
var ud = {
  css: function(e, a, r) {
    return e.style[a] = r;
  },
  attribute: function(e, a, r) {
    return e.setAttribute(a, r);
  },
  object: function(e, a, r) {
    return e[a] = r;
  },
  transform: function(e, a, r, s, o) {
    if (s.list.set(a, r), a === s.last || o) {
      var d = "";
      s.list.forEach(function(u, f) {
        d += f + "(" + u + ") ";
      }), e.style.transform = d;
    }
  }
};
function cd(e, a) {
  var r = ld(e);
  r.forEach(function(s) {
    for (var o in a) {
      var d = co(a[o], s), u = s.target, f = Un(d), c = Bo(u, o, f, s), g = f || Un(c), h = Ao(ad(d, g), c), q = Do(u, o);
      ud[q](u, o, h, s.transforms, !0);
    }
  });
}
function cb(e, a) {
  var r = Do(e.target, a.name);
  if (r) {
    var s = ub(a, e), o = s[s.length - 1];
    return {
      type: r,
      property: a.name,
      animatable: e,
      tweens: s,
      duration: o.end,
      delay: s[0].delay,
      endDelay: o.endDelay
    };
  }
}
function db(e, a) {
  return Ei(Pi(e.map(function(r) {
    return a.map(function(s) {
      return cb(r, s);
    });
  })), function(r) {
    return !Ce.und(r);
  });
}
function dd(e, a) {
  var r = e.length, s = function(d) {
    return d.timelineOffset ? d.timelineOffset : 0;
  }, o = {};
  return o.duration = r ? Math.max.apply(Math, e.map(function(d) {
    return s(d) + d.duration;
  })) : a.duration, o.delay = r ? Math.min.apply(Math, e.map(function(d) {
    return s(d) + d.delay;
  })) : a.delay, o.endDelay = r ? o.duration - Math.max.apply(Math, e.map(function(d) {
    return s(d) + d.duration - d.endDelay;
  })) : a.endDelay, o;
}
var bc = 0;
function fb(e) {
  var a = uo(Jc, e), r = uo($o, e), s = ob(r, e), o = ld(e.targets), d = db(o, s), u = dd(d, r), f = bc;
  return bc++, zi(a, {
    id: f,
    children: [],
    animatables: o,
    animations: d,
    duration: u.duration,
    delay: u.delay,
    endDelay: u.endDelay
  });
}
var yn = [], fd = function() {
  var e;
  function a() {
    !e && (!_c() || !at.suspendWhenDocumentHidden) && yn.length > 0 && (e = requestAnimationFrame(r));
  }
  function r(o) {
    for (var d = yn.length, u = 0; u < d; ) {
      var f = yn[u];
      f.paused ? (yn.splice(u, 1), d--) : (f.tick(o), u++);
    }
    e = u > 0 ? requestAnimationFrame(r) : void 0;
  }
  function s() {
    at.suspendWhenDocumentHidden && (_c() ? e = cancelAnimationFrame(e) : (yn.forEach(
      function(o) {
        return o._onDocumentVisibility();
      }
    ), fd()));
  }
  return typeof document < "u" && document.addEventListener("visibilitychange", s), a;
}();
function _c() {
  return !!document && document.hidden;
}
function at(e) {
  e === void 0 && (e = {});
  var a = 0, r = 0, s = 0, o, d = 0, u = null;
  function f(P) {
    var x = window.Promise && new Promise(function($) {
      return u = $;
    });
    return P.finished = x, x;
  }
  var c = fb(e);
  f(c);
  function g() {
    var P = c.direction;
    P !== "alternate" && (c.direction = P !== "normal" ? "normal" : "reverse"), c.reversed = !c.reversed, o.forEach(function(x) {
      return x.reversed = c.reversed;
    });
  }
  function h(P) {
    return c.reversed ? c.duration - P : P;
  }
  function q() {
    a = 0, r = h(c.currentTime) * (1 / at.speed);
  }
  function C(P, x) {
    x && x.seek(P - x.timelineOffset);
  }
  function O(P) {
    if (c.reversePlayback)
      for (var $ = d; $--; )
        C(P, o[$]);
    else
      for (var x = 0; x < d; x++)
        C(P, o[x]);
  }
  function S(P) {
    for (var x = 0, $ = c.animations, Y = $.length; x < Y; ) {
      var R = $[x], T = R.animatable, z = R.tweens, le = z.length - 1, K = z[le];
      le && (K = Ei(z, function(Ne) {
        return P < Ne.end;
      })[0] || K);
      for (var se = An(P - K.start - K.delay, 0, K.duration) / K.duration, oe = isNaN(se) ? 1 : K.easing(se), ve = K.to.strings, ee = K.round, Q = [], J = K.to.numbers.length, te = void 0, G = 0; G < J; G++) {
        var de = void 0, ge = K.to.numbers[G], N = K.from.numbers[G] || 0;
        K.isPath ? de = ab(K.value, oe * ge, K.isPathTargetInsideSVG) : de = N + oe * (ge - N), ee && (K.isColor && G > 2 || (de = Math.round(de * ee) / ee)), Q.push(de);
      }
      var ne = ve.length;
      if (!ne)
        te = Q[0];
      else {
        te = ve[0];
        for (var ue = 0; ue < ne; ue++) {
          ve[ue];
          var Se = ve[ue + 1], Me = Q[ue];
          isNaN(Me) || (Se ? te += Me + Se : te += Me + " ");
        }
      }
      ud[R.type](T.target, R.property, te, T.transforms), R.currentValue = te, x++;
    }
  }
  function I(P) {
    c[P] && !c.passThrough && c[P](c);
  }
  function M() {
    c.remaining && c.remaining !== !0 && c.remaining--;
  }
  function F(P) {
    var x = c.duration, $ = c.delay, Y = x - c.endDelay, R = h(P);
    c.progress = An(R / x * 100, 0, 100), c.reversePlayback = R < c.currentTime, o && O(R), !c.began && c.currentTime > 0 && (c.began = !0, I("begin")), !c.loopBegan && c.currentTime > 0 && (c.loopBegan = !0, I("loopBegin")), R <= $ && c.currentTime !== 0 && S(0), (R >= Y && c.currentTime !== x || !x) && S(x), R > $ && R < Y ? (c.changeBegan || (c.changeBegan = !0, c.changeCompleted = !1, I("changeBegin")), I("change"), S(R)) : c.changeBegan && (c.changeCompleted = !0, c.changeBegan = !1, I("changeComplete")), c.currentTime = An(R, 0, x), c.began && I("update"), P >= x && (r = 0, M(), c.remaining ? (a = s, I("loopComplete"), c.loopBegan = !1, c.direction === "alternate" && g()) : (c.paused = !0, c.completed || (c.completed = !0, I("loopComplete"), I("complete"), !c.passThrough && "Promise" in window && (u(), f(c)))));
  }
  return c.reset = function() {
    var P = c.direction;
    c.passThrough = !1, c.currentTime = 0, c.progress = 0, c.paused = !0, c.began = !1, c.loopBegan = !1, c.changeBegan = !1, c.completed = !1, c.changeCompleted = !1, c.reversePlayback = !1, c.reversed = P === "reverse", c.remaining = c.loop, o = c.children, d = o.length;
    for (var x = d; x--; )
      c.children[x].reset();
    (c.reversed && c.loop !== !0 || P === "alternate" && c.loop === 1) && c.remaining++, S(c.reversed ? c.duration : 0);
  }, c._onDocumentVisibility = q, c.set = function(P, x) {
    return cd(P, x), c;
  }, c.tick = function(P) {
    s = P, a || (a = s), F((s + (r - a)) * at.speed);
  }, c.seek = function(P) {
    F(h(P));
  }, c.pause = function() {
    c.paused = !0, q();
  }, c.play = function() {
    c.paused && (c.completed && c.reset(), c.paused = !1, yn.push(c), q(), fd());
  }, c.reverse = function() {
    g(), c.completed = !c.reversed, q();
  }, c.restart = function() {
    c.reset(), c.play();
  }, c.remove = function(P) {
    var x = Oo(P);
    vd(x, c);
  }, c.reset(), c.autoplay && c.play(), c;
}
function wc(e, a) {
  for (var r = a.length; r--; )
    So(e, a[r].animatable.target) && a.splice(r, 1);
}
function vd(e, a) {
  var r = a.animations, s = a.children;
  wc(e, r);
  for (var o = s.length; o--; ) {
    var d = s[o], u = d.animations;
    wc(e, u), !u.length && !d.children.length && s.splice(o, 1);
  }
  !r.length && !s.length && a.pause();
}
function vb(e) {
  for (var a = Oo(e), r = yn.length; r--; ) {
    var s = yn[r];
    vd(a, s);
  }
}
function pb(e, a) {
  a === void 0 && (a = {});
  var r = a.direction || "normal", s = a.easing ? Co(a.easing) : null, o = a.grid, d = a.axis, u = a.from || 0, f = u === "first", c = u === "center", g = u === "last", h = Ce.arr(e), q = parseFloat(h ? e[0] : e), C = h ? parseFloat(e[1]) : 0, O = Un(h ? e[1] : e) || 0, S = a.start || 0 + (h ? q : 0), I = [], M = 0;
  return function(F, P, x) {
    if (f && (u = 0), c && (u = (x - 1) / 2), g && (u = x - 1), !I.length) {
      for (var $ = 0; $ < x; $++) {
        if (!o)
          I.push(Math.abs(u - $));
        else {
          var Y = c ? (o[0] - 1) / 2 : u % o[0], R = c ? (o[1] - 1) / 2 : Math.floor(u / o[0]), T = $ % o[0], z = Math.floor($ / o[0]), le = Y - T, K = R - z, se = Math.sqrt(le * le + K * K);
          d === "x" && (se = -le), d === "y" && (se = -K), I.push(se);
        }
        M = Math.max.apply(Math, I);
      }
      s && (I = I.map(function(ve) {
        return s(ve / M) * M;
      })), r === "reverse" && (I = I.map(function(ve) {
        return d ? ve < 0 ? ve * -1 : -ve : Math.abs(M - ve);
      }));
    }
    var oe = h ? (C - q) / M : q;
    return S + oe * (Math.round(I[P] * 100) / 100) + O;
  };
}
function hb(e) {
  e === void 0 && (e = {});
  var a = at(e);
  return a.duration = 0, a.add = function(r, s) {
    var o = yn.indexOf(a), d = a.children;
    o > -1 && yn.splice(o, 1);
    function u(C) {
      C.passThrough = !0;
    }
    for (var f = 0; f < d.length; f++)
      u(d[f]);
    var c = zi(r, uo($o, e));
    c.targets = c.targets || e.targets;
    var g = a.duration;
    c.autoplay = !1, c.direction = a.direction, c.timelineOffset = Ce.und(s) ? g : Ao(s, g), u(a), a.seek(c.timelineOffset);
    var h = at(c);
    u(h), d.push(h);
    var q = dd(d, e);
    return a.delay = q.delay, a.endDelay = q.endDelay, a.duration = q.duration, a.seek(0), a.reset(), a.autoplay && a.play(), a;
  }, a;
}
at.version = "3.2.1";
at.speed = 1;
at.suspendWhenDocumentHidden = !0;
at.running = yn;
at.remove = vb;
at.get = Bo;
at.set = cd;
at.convertPx = qo;
at.path = rb;
at.setDashoffset = tb;
at.stagger = pb;
at.timeline = hb;
at.easing = Co;
at.penner = ed;
at.random = function(e, a) {
  return Math.floor(Math.random() * (a - e + 1)) + e;
};
const gb = { class: "dropdown__inner-container" }, mb = {
  __name: "Accordion",
  props: /* @__PURE__ */ Da({
    title: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    altInverse: {
      type: Boolean,
      default: !1
    },
    duration: {
      type: Number,
      default: 200
    }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const a = e, r = Ba(e, "modelValue"), s = V(0), o = V(null), d = () => {
      r.value = !r.value;
    }, u = (c, g) => {
      o.value.style.height || (s.value = o.value.clientHeight), o.value.style.height = 0, at({
        targets: o.value,
        height: s.value,
        duration: a.duration,
        easing: "easeInOutQuad",
        complete: () => {
          o.value && (o.value.style.height = "auto"), g();
        }
      });
    }, f = (c, g) => {
      o.value.style.height = `${s.value}px`, at({
        targets: o.value,
        easing: "easeInOutQuad",
        height: 0,
        duration: a.duration,
        complete: () => {
          g();
        }
      });
    };
    return (c, g) => (v(), m("div", {
      class: w(["dropdown", { inverse: e.inverse, "alt-inverse": e.altInverse }])
    }, [
      y("div", gb, [
        y("div", {
          class: w(["dropdown__header", {
            "dropdown__header--open": r.value
          }]),
          onClick: d
        }, [
          we(c.$slots, "header", { open: r.value }, () => [
            re(N0, {
              inverse: e.inverse,
              open: r.value,
              title: e.title
            }, null, 8, ["inverse", "open", "title"])
          ])
        ], 2),
        re(Aa, {
          appear: "",
          css: !1,
          onEnter: u,
          onLeave: f,
          onAfterLeave: c.onAfterLeave,
          onBeforeLeave: c.onBeforeLeave
        }, {
          default: dt(() => [
            Kr(y("div", {
              ref_key: "accordion",
              ref: o,
              class: "dropdown__content-container"
            }, [
              we(c.$slots, "default", { open: r.value })
            ], 512), [
              [bo, r.value]
            ])
          ]),
          _: 3
        }, 8, ["onAfterLeave", "onBeforeLeave"])
      ])
    ], 2));
  }
}, M3 = /* @__PURE__ */ ae(mb, [["__scopeId", "data-v-395db792"]]), rr = {
  CLP: "$",
  USD: "US$",
  UF: "UF"
}, Hr = {
  NONE: {},
  PLAIN: {
    minDecimalDigits: 0,
    maxDecimalDigits: 0
  },
  PLAINEXT3: {
    preffix: "",
    minDecimalDigits: 3,
    maxDecimalDigits: 3
  },
  CLP: {
    preffix: rr.CLP,
    minDecimalDigits: 0,
    maxDecimalDigits: 0,
    prefixSpace: !1
  },
  CLPEXT: {
    preffix: rr.CLP,
    minDecimalDigits: 2,
    maxDecimalDigits: 2,
    prefixSpace: !1
  },
  CLPSHORT: {
    preffix: rr.CLP,
    minDecimalDigits: 0,
    maxDecimalDigits: 0,
    prefixSpace: !1,
    suffix: "MM",
    suffixSpace: !0
  },
  CLPSHORTEXT: {
    preffix: rr.CLP,
    minDecimalDigits: 2,
    maxDecimalDigits: 2,
    prefixSpace: !1,
    suffix: "MM",
    suffixSpace: !0
  },
  UF: {
    preffix: rr.UF,
    minDecimalDigits: 4,
    maxDecimalDigits: 4,
    prefixSpace: !0
  },
  POINTS: {
    preffix: "",
    minDecimalDigits: 4,
    maxDecimalDigits: 4,
    prefixSpace: !1
  },
  USD: {
    preffix: rr.USD,
    minDecimalDigits: 2,
    maxDecimalDigits: 2,
    prefixSpace: !1
  },
  USDEXT: {
    preffix: rr.USD,
    minDecimalDigits: 0,
    maxDecimalDigits: 0,
    prefixSpace: !1
  },
  USDSHORTEXT: {
    preffix: rr.USD,
    prefixSpace: !1,
    suffix: "MM",
    suffixSpace: !0
  },
  GBP: {
    preffix: "£",
    prefixSpace: !0
  },
  JPY: {
    preffix: "¥",
    prefixSpace: !0
  },
  PEN: {
    preffix: "PEN",
    prefixSpace: !0
  },
  BRL: {
    preffix: "BRL",
    prefixSpace: !0
  },
  PERCENTSIMPLE: {
    suffix: "%",
    minDecimalDigits: 0,
    maxDecimalDigits: 0
  },
  PERCENT: {
    suffix: "%",
    minDecimalDigits: 2,
    maxDecimalDigits: 2
  },
  PERCENTEXT: {
    suffix: "%",
    minDecimalDigits: 3,
    maxDecimalDigits: 3
  },
  PERCENTDOUBLE: {
    minDecimalDigits: 4,
    maxDecimalDigits: 4
  },
  COUNT: {
    preffix: "#",
    minDecimalDigits: 0,
    maxDecimalDigits: 0,
    prefixSpace: !1
  },
  DECIMALS: {
    minDecimalDigits: 0,
    maxDecimalDigits: 5
  }
}, yb = { key: 0 }, bb = {
  key: 1,
  class: "amount__tendency-icon"
}, _b = { key: 0 }, wb = { key: 0 }, $b = { key: 5 }, Cb = { key: 7 }, Sb = {
  __name: "Amount",
  props: {
    amount: {
      type: [Number, String],
      required: !0
    },
    withColor: { type: Boolean, default: !1 },
    inverse: { type: Boolean, default: !1 },
    extraClass: { type: String, default: "" },
    tendency: { type: String, default: "" },
    showAmountIndicator: { type: Boolean, default: !1 },
    hidden: { type: Boolean, default: !1 },
    wrap: {
      type: Array,
      default: () => []
    },
    verticalAlign: {
      type: String,
      default: "middle"
    },
    format: {
      type: String,
      default: "NONE",
      validator: (e) => Object.keys(Hr).includes(e)
    },
    formatInfo: { type: Object, default: null },
    subSymbol: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = e, r = B(() => {
      if (a.formatInfo !== null) return a.formatInfo;
      const d = Object.keys(Hr).includes(a.format) ? a.format : "NONE";
      return Hr[d];
    }), s = B(() => Math.sign(a.amount)), o = B(() => Math.abs(parseFloat(a.amount || 0)).toLocaleString("nl-NL", {
      minimumFractionDigits: "minDecimalDigits" in r.value ? r.value.minDecimalDigits : 2,
      maximumFractionDigits: "maxDecimalDigits" in r.value ? r.value.maxDecimalDigits : 2
    }));
    return (d, u) => (v(), m("span", {
      class: w(["amount", {
        "amount--positive": e.withColor && s.value === 1,
        "amount--negative": e.withColor && s.value === -1,
        "amount--inverse": e.inverse,
        "amount--neutral": e.withColor && s.value === 0,
        "amount--disable": !e.withColor,
        [e.extraClass]: !0
      }]),
      style: nt({
        verticalAlign: e.verticalAlign
      })
    }, [
      e.wrap[0] ? (v(), m("span", yb, ie(e.wrap[0]), 1)) : D("", !0),
      e.tendency ? (v(), m("div", bb, [
        e.tendency === "up" ? (v(), me(Te, {
          key: 0,
          name: "arrow-up"
        })) : D("", !0),
        e.tendency === "down" ? (v(), me(Te, {
          key: 1,
          name: "arrow-down"
        })) : D("", !0)
      ])) : D("", !0),
      e.showAmountIndicator ? (v(), m(ce, { key: 2 }, [
        s.value === 1 ? (v(), m("span", _b, "+")) : D("", !0)
      ], 64)) : D("", !0),
      e.hidden ? D("", !0) : (v(), m(ce, { key: 3 }, [
        s.value === -1 ? (v(), m("span", wb, "-")) : D("", !0)
      ], 64)),
      r.value.preffix ? (v(), m("span", {
        key: 4,
        class: w(["amount__preffix", { "amount__sub-symbol": e.subSymbol }])
      }, ie(r.value.preffix), 3)) : D("", !0),
      r.value.prefixSpace ? (v(), m("span", $b, " ")) : D("", !0),
      y("span", null, ie(e.hidden ? " • • • • • • " : o.value), 1),
      r.value.suffix ? (v(), m("span", {
        key: 6,
        class: w([r.value.suffixSpace ? "ml-1" : ""])
      }, ie(r.value.suffix), 3)) : D("", !0),
      e.wrap[1] ? (v(), m("span", Cb, ie(e.wrap[1]), 1)) : D("", !0)
    ], 6));
  }
}, x3 = /* @__PURE__ */ ae(Sb, [["__scopeId", "data-v-55827423"]]), kb = { class: "orq-image-container" }, qb = ["src", "alt"], Ta = {
  __name: "ImageContainer",
  props: {
    src: {
      type: String,
      required: !0
    },
    alt: {
      type: String,
      required: !0
    },
    shape: {
      type: String,
      default: "rounded"
    },
    size: {
      type: Number,
      default: 40
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    outline: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = e, r = V("orq-image-container__image"), s = B(
      () => a.size ? `${r.value}--size-${a.size}` : ""
    ), o = B(
      () => a.shape ? `${r.value}--size-${a.size}--${a.shape}` : ""
    ), d = B(
      () => a.inverse ? `${r.value}--inverse` : ""
    ), u = B(
      () => a.outline ? `${r.value}--outline` : ""
    ), f = B(
      () => `${r.value} ${s.value} ${o.value} ${d.value} ${u.value}`
    );
    return (c, g) => (v(), m("div", kb, [
      y("img", {
        src: e.src,
        class: w(f.value),
        alt: e.alt,
        tabindex: 0
      }, null, 10, qb)
    ]));
  }
};
class Db {
  toCamelCase(a, r = "") {
    if (a)
      return a.includes(r) ? a.split(r).map(
        (s, o) => o === 0 ? s : `${s[0].toUpperCase()}${s.slice(1)}`
      ).join("") : a;
  }
}
const Bb = new Db(), Ab = Oe({
  name: "ShimmerAccordion",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__accordion--loading--inverse" : "orq-shimmer__accordion--loading--default"
      )
    };
  }
}), Tb = {
  key: 0,
  class: "orq-shimmer"
}, Ob = {
  "data-test": "orq-shimmer-accordion",
  class: "orq-shimmer__accordion"
}, Ib = { class: "orq-shimmer__accordion--loading" };
function Mb(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", Tb, [
    y("div", Ob, [
      y("div", Ib, [
        y("div", {
          class: w(`orq-shimmer__accordion--loading--text ${e.inverseClass}`)
        }, null, 2),
        y("div", {
          class: w(`orq-shimmer__accordion--loading--accordion ${e.inverseClass}`)
        }, null, 2)
      ])
    ])
  ])) : D("", !0);
}
const xb = /* @__PURE__ */ ae(Ab, [["render", Mb]]), Lb = Oe({
  name: "ShimmerAvatar",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 1
    },
    sizeAvatar: {
      type: String,
      default: "24"
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__avatar--loading--inverse" : "orq-shimmer__avatar--loading--default"
      )
    };
  }
}), Fb = {
  key: 0,
  class: "orq-shimmer"
}, Eb = {
  "data-test": "orq-shimmer-avatar",
  class: "orq-shimmer__avatar"
};
function Pb(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", Fb, [
    y("div", Eb, [
      (v(!0), m(ce, null, Re(new Array(e.$props.rows), (u, f) => (v(), m("div", {
        key: f,
        class: "orq-shimmer__avatar--loading"
      }, [
        y("div", {
          class: w(`orq-shimmer__avatar--loading-rounded orq-shimmer__avatar--loading--size-${e.sizeAvatar} ${e.inverseClass}`)
        }, null, 2)
      ]))), 128))
    ])
  ])) : D("", !0);
}
const zb = /* @__PURE__ */ ae(Lb, [["render", Pb]]), Rb = Oe({
  name: "ShimmerBadge",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: "small"
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__badge--loading--inverse" : "orq-shimmer__badge--loading--default"
      )
    };
  }
}), Nb = {
  key: 0,
  class: "orq-shimmer"
}, Hb = { class: "orq-shimmer__badge" }, Vb = { class: "orq-shimmer__badge--loading" };
function Yb(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", Nb, [
    y("div", Hb, [
      y("div", Vb, [
        y("div", {
          class: w(`badge--loading orq-shimmer__badge--loading--${e.size} ${e.inverseClass}`)
        }, null, 2)
      ])
    ])
  ])) : D("", !0);
}
const Ub = /* @__PURE__ */ ae(Rb, [["render", Yb]]), Wb = Oe({
  name: "ShimmerBanner",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    sizeBanner: {
      type: String,
      default: "large"
    },
    sizeBannerImage: {
      type: String,
      default: "default"
    },
    imageAlignRight: {
      type: String,
      default: "left"
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    e = it(e);
    const a = V(
      e.sizeBannerImage === "default" || e.sizeBannerImage === "large"
    ), r = () => e.sizeBannerImage === "default" || e.sizeBannerImage === "large" ? "default" : e.sizeBannerImage === "rounded" ? "rounded" : "";
    return {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__banner--loading--inverse" : "orq-shimmer__banner--loading--default"
      ),
      imageAlignRightClass: B(
        () => e.imageAlignRight === "right" ? `orq-shimmer__banner--loading--${e.sizeBanner}--${e.sizeBannerImage}--right` : `orq-shimmer__banner--loading--${e.sizeBanner}--${e.sizeBannerImage}--left`
      ),
      defaultAndRoundedSizeBannerImage: B(
        () => e.imageAlignRight === "right" ? `orq-shimmer__banner--loading--${e.sizeBanner}--${r()}--right` : `orq-shimmer__banner--loading--${e.sizeBanner}--${r()}--left`
      ),
      getDefaultAndLargeSize: r,
      defaultOrLargeSize: a
    };
  }
}), Gb = {
  key: 0,
  class: "orq-shimmer"
}, Zb = { class: "orq-shimmer__banner" }, Kb = { class: "orq-shimmer__banner--loading--container-xsmall" }, Xb = { class: "orq-shimmer__banner--loading--box" }, Jb = { class: "orq-shimmer__banner--loading--container-xsmall" }, Qb = { class: "orq-shimmer__banner--loading--box" }, jb = { class: "orq-shimmer__banner--loading--container-small" }, e_ = { class: "orq-shimmer__banner--loading--box" }, t_ = { class: "orq-shimmer__banner--loading--content-box" }, n_ = {
  key: 1,
  class: /* @__PURE__ */ w("banner--loading orq-shimmer__banner--loading--small--rounded")
}, r_ = { class: "orq-shimmer__banner--loading--image-box" }, a_ = { class: "orq-shimmer__banner--loading--container-small" }, i_ = { class: "orq-shimmer__banner--loading--box" }, s_ = { class: "orq-shimmer__banner--loading--content-box" }, o_ = { class: "orq-shimmer__banner--loading--container-medium" }, l_ = { class: "orq-shimmer__banner--loading--box" }, u_ = { class: "orq-shimmer__banner--loading--content-box" }, c_ = {
  key: 1,
  class: /* @__PURE__ */ w("banner--loading orq-shimmer__banner--loading--medium--rounded")
}, d_ = { class: "orq-shimmer__banner--loading--image-box" }, f_ = { class: "orq-shimmer__banner--loading--container-medium" }, v_ = { class: "orq-shimmer__banner--loading--box" }, p_ = { class: "orq-shimmer__banner--loading--content-box" }, h_ = { class: "orq-shimmer__banner--loading--container-large" }, g_ = { class: "orq-shimmer__banner--loading--box" }, m_ = { class: "orq-shimmer__banner--loading--content-box" }, y_ = { class: "orq-shimmer__banner--loading--container-large" }, b_ = { class: "orq-shimmer__banner--loading--box" }, __ = { class: "orq-shimmer__banner--loading--content-box" }, w_ = { class: "orq-shimmer__banner--loading--container-wide" }, $_ = { class: "orq-shimmer__banner--loading--box" }, C_ = { class: "orq-shimmer__banner--loading--content-box" }, S_ = { class: "orq-shimmer__banner--loading--image-box" }, k_ = { class: "orq-shimmer__banner--loading--container-wide" }, q_ = { class: "orq-shimmer__banner--loading--box" }, D_ = { class: "orq-shimmer__banner--loading--content-box" };
function B_(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", Gb, [
    y("div", Zb, [
      e.sizeBanner === "xsmall" ? (v(), m(ce, { key: 0 }, [
        e.defaultOrLargeSize ? (v(), m("div", {
          key: 0,
          class: w(`banner--loading orq-shimmer__banner--loading--xsmall--default ${e.defaultAndRoundedSizeBannerImage}`)
        }, [
          y("div", {
            class: w(`orq-shimmer__banner--loading--image ${e.inverseClass}`)
          }, null, 2),
          y("div", Kb, [
            y("div", Xb, [
              y("div", {
                class: w(`orq-shimmer__banner--loading--text ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__banner--loading--card ${e.inverseClass}`)
              }, null, 2)
            ])
          ])
        ], 2)) : D("", !0),
        e.sizeBannerImage === "rounded" ? (v(), m("div", {
          key: 1,
          class: w(`banner--loading orq-shimmer__banner--loading--xsmall--rounded ${e.defaultAndRoundedSizeBannerImage}`)
        }, [
          y("div", {
            class: w(`orq-shimmer__banner--loading--image ${e.inverseClass}`)
          }, null, 2),
          y("div", Jb, [
            y("div", Qb, [
              y("div", {
                class: w(`orq-shimmer__banner--loading--text ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__banner--loading--card ${e.inverseClass}`)
              }, null, 2)
            ])
          ])
        ], 2)) : D("", !0)
      ], 64)) : D("", !0),
      e.sizeBanner === "small" ? (v(), m(ce, { key: 1 }, [
        e.defaultOrLargeSize ? (v(), m("div", {
          key: 0,
          class: w(`banner--loading orq-shimmer__banner--loading--small--default ${e.defaultAndRoundedSizeBannerImage}`)
        }, [
          y("div", {
            class: w(`orq-shimmer__banner--loading--image ${e.inverseClass}`)
          }, null, 2),
          y("div", jb, [
            y("div", e_, [
              y("div", {
                class: w(`orq-shimmer__banner--loading--text ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__banner--loading--subtext ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__banner--loading--card ${e.inverseClass}`)
              }, null, 2)
            ]),
            y("div", {
              class: w(`orq-shimmer__banner--loading--divider ${e.inverseClass}`)
            }, null, 2),
            y("div", t_, [
              y("div", {
                class: w(`orq-shimmer__banner--loading--content ${e.inverseClass}`)
              }, null, 2)
            ])
          ])
        ], 2)) : D("", !0),
        e.sizeBannerImage === "rounded" ? (v(), m("div", n_, [
          y("div", r_, [
            y("div", {
              class: w(`orq-shimmer__banner--loading--image ${e.inverseClass}`)
            }, null, 2)
          ]),
          y("div", a_, [
            y("div", i_, [
              y("div", {
                class: w(`orq-shimmer__banner--loading--text ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__banner--loading--subtext ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__banner--loading--card ${e.inverseClass}`)
              }, null, 2)
            ]),
            y("div", {
              class: w(`orq-shimmer__banner--loading--divider ${e.inverseClass}`)
            }, null, 2),
            y("div", s_, [
              y("div", {
                class: w(`orq-shimmer__banner--loading--content ${e.inverseClass}`)
              }, null, 2)
            ])
          ])
        ])) : D("", !0)
      ], 64)) : D("", !0),
      e.sizeBanner === "medium" ? (v(), m(ce, { key: 2 }, [
        e.defaultOrLargeSize ? (v(), m("div", {
          key: 0,
          class: w(`banner--loading orq-shimmer__banner--loading--medium--default ${e.defaultAndRoundedSizeBannerImage}`)
        }, [
          y("div", {
            class: w(`orq-shimmer__banner--loading--image ${e.inverseClass}`)
          }, null, 2),
          y("div", o_, [
            y("div", l_, [
              y("div", {
                class: w(`orq-shimmer__banner--loading--text ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__banner--loading--subtext ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__banner--loading--card ${e.inverseClass}`)
              }, null, 2)
            ]),
            y("div", {
              class: w(`orq-shimmer__banner--loading--divider ${e.inverseClass}`)
            }, null, 2),
            y("div", u_, [
              y("div", {
                class: w(`orq-shimmer__banner--loading--content ${e.inverseClass}`)
              }, null, 2)
            ])
          ])
        ], 2)) : D("", !0),
        e.sizeBannerImage === "rounded" ? (v(), m("div", c_, [
          y("div", d_, [
            y("div", {
              class: w(`orq-shimmer__banner--loading--image ${e.inverseClass}`)
            }, null, 2)
          ]),
          y("div", f_, [
            y("div", v_, [
              y("div", {
                class: w(`orq-shimmer__banner--loading--text ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__banner--loading--subtext ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__banner--loading--card ${e.inverseClass}`)
              }, null, 2)
            ]),
            y("div", {
              class: w(`orq-shimmer__banner--loading--divider ${e.inverseClass}`)
            }, null, 2),
            y("div", p_, [
              y("div", {
                class: w(`orq-shimmer__banner--loading--content ${e.inverseClass}`)
              }, null, 2)
            ])
          ])
        ])) : D("", !0)
      ], 64)) : D("", !0),
      e.sizeBanner === "large" ? (v(), m(ce, { key: 3 }, [
        e.defaultOrLargeSize ? (v(), m("div", {
          key: 0,
          class: w(`banner--loading orq-shimmer__banner--loading--large--default ${e.defaultAndRoundedSizeBannerImage} ${e.imageAlignRightClass}`)
        }, [
          y("div", {
            class: w(`orq-shimmer__banner--loading--image ${e.inverseClass}`)
          }, null, 2),
          y("div", h_, [
            y("div", g_, [
              y("div", {
                class: w(`orq-shimmer__banner--loading--text ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__banner--loading--subtext ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__banner--loading--card ${e.inverseClass}`)
              }, null, 2)
            ]),
            y("div", {
              class: w(`orq-shimmer__banner--loading--divider ${e.inverseClass}`)
            }, null, 2),
            y("div", m_, [
              y("div", {
                class: w(`orq-shimmer__banner--loading--content ${e.inverseClass}`)
              }, null, 2)
            ])
          ])
        ], 2)) : D("", !0),
        e.sizeBannerImage === "rounded" ? (v(), m("div", {
          key: 1,
          class: w(`banner--loading orq-shimmer__banner--loading--large--rounded ${e.imageAlignRightClass}`)
        }, [
          y("div", {
            class: w(`orq-shimmer__banner--loading--image ${e.inverseClass}`)
          }, null, 2),
          y("div", y_, [
            y("div", b_, [
              y("div", {
                class: w(`orq-shimmer__banner--loading--text ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__banner--loading--subtext ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__banner--loading--card ${e.inverseClass}`)
              }, null, 2)
            ]),
            y("div", {
              class: w(`orq-shimmer__banner--loading--divider ${e.inverseClass}`)
            }, null, 2),
            y("div", __, [
              y("div", {
                class: w(`orq-shimmer__banner--loading--content ${e.inverseClass}`)
              }, null, 2)
            ])
          ])
        ], 2)) : D("", !0)
      ], 64)) : D("", !0),
      e.sizeBanner === "wide" ? (v(), m(ce, { key: 4 }, [
        e.defaultOrLargeSize ? (v(), m("div", {
          key: 0,
          class: w(`banner--loading orq-shimmer__banner--loading--wide--default ${e.defaultAndRoundedSizeBannerImage} ${e.imageAlignRightClass}`)
        }, [
          y("div", {
            class: w(`orq-shimmer__banner--loading--image ${e.inverseClass}`)
          }, null, 2),
          y("div", w_, [
            y("div", $_, [
              y("div", {
                class: w(`orq-shimmer__banner--loading--text ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__banner--loading--subtext ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__banner--loading--card ${e.inverseClass}`)
              }, null, 2)
            ]),
            y("div", {
              class: w(`orq-shimmer__banner--loading--divider ${e.inverseClass}`)
            }, null, 2),
            y("div", C_, [
              y("div", {
                class: w(`orq-shimmer__banner--loading--content ${e.inverseClass}`)
              }, null, 2)
            ])
          ])
        ], 2)) : D("", !0),
        e.sizeBannerImage === "rounded" ? (v(), m("div", {
          key: 1,
          class: w(`banner--loading orq-shimmer__banner--loading--wide--rounded ${e.imageAlignRightClass}`)
        }, [
          y("div", S_, [
            y("div", {
              class: w(`orq-shimmer__banner--loading--image ${e.inverseClass}`)
            }, null, 2)
          ]),
          y("div", k_, [
            y("div", q_, [
              y("div", {
                class: w(`orq-shimmer__banner--loading--text ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__banner--loading--subtext ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__banner--loading--card ${e.inverseClass}`)
              }, null, 2)
            ]),
            y("div", D_, [
              y("div", {
                class: w(`orq-shimmer__banner--loading--content ${e.inverseClass}`)
              }, null, 2)
            ])
          ])
        ], 2)) : D("", !0)
      ], 64)) : D("", !0)
    ])
  ])) : D("", !0);
}
const A_ = /* @__PURE__ */ ae(Wb, [["render", B_]]), T_ = Oe({
  name: "ShimmerSwitcher",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: "small"
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__switcher--loading--inverse" : "orq-shimmer__switcher--loading--default"
      )
    };
  }
}), O_ = {
  key: 0,
  class: "orq-shimmer"
}, I_ = { class: "orq-shimmer__switcher" }, M_ = { class: "orq-shimmer__switcher--loading" };
function x_(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", O_, [
    y("div", I_, [
      y("div", M_, [
        y("div", {
          class: w(`switcher--loading orq-shimmer__switcher--loading--${e.size} ${e.inverseClass}`)
        }, null, 2)
      ])
    ])
  ])) : D("", !0);
}
const L_ = /* @__PURE__ */ ae(T_, [["render", x_]]), F_ = Oe({
  name: "ShimmerButton",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: "small"
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__button--loading--inverse" : "orq-shimmer__button--loading--default"
      )
    };
  }
}), E_ = {
  key: 0,
  class: "orq-shimmer"
}, P_ = { class: "orq-shimmer__button" }, z_ = { class: "orq-shimmer__button--loading" };
function R_(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", E_, [
    y("div", P_, [
      y("div", z_, [
        y("div", {
          class: w(`button--loading orq-shimmer__button--loading--${e.size} ${e.inverseClass}`)
        }, null, 2)
      ])
    ])
  ])) : D("", !0);
}
const N_ = /* @__PURE__ */ ae(F_, [["render", R_]]), H_ = Oe({
  name: "ShimmerImageGroup",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "small"
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__image-group--loading--inverse" : "orq-shimmer__image-group--loading--default"
      )
    };
  }
}), V_ = {
  key: 0,
  class: "orq-shimmer"
}, Y_ = { class: "orq-shimmer__image-group" }, U_ = { class: "orq-shimmer__image-group--loading" };
function W_(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", V_, [
    y("div", Y_, [
      y("div", U_, [
        y("div", {
          class: w(`orq-shimmer__image-group--loading-radius orq-shimmer__image-group--loading-main orq-shimmer__image-group--loading-main--${e.size} ${e.inverseClass}`)
        }, [
          y("div", {
            class: w(`orq-shimmer__image-group--loading-radius orq-shimmer__image-group--loading-minor orq-shimmer__image-group--loading-minor--${e.size} ${e.inverseClass}`)
          }, null, 2)
        ], 2)
      ])
    ])
  ])) : D("", !0);
}
const G_ = /* @__PURE__ */ ae(H_, [["render", W_]]), Z_ = Oe({
  name: "ShimmerTag",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    typeTag: {
      type: String,
      default: "search"
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__tag--loading--inverse" : "orq-shimmer__tag--loading--default"
      )
    };
  }
}), K_ = {
  key: 0,
  class: "orq-shimmer"
}, X_ = { class: "orq-shimmer__tag" }, J_ = { class: "orq-shimmer__tag--loading" };
function Q_(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", K_, [
    y("div", X_, [
      y("div", J_, [
        y("div", {
          class: w(`tag--loading orq-shimmer__tag--loading--${e.typeTag} ${e.inverseClass}`)
        }, null, 2)
      ])
    ])
  ])) : D("", !0);
}
const j_ = /* @__PURE__ */ ae(Z_, [["render", Q_]]), e1 = Oe({
  name: "ShimmerCheckbox",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 1
    },
    checkboxPosition: {
      type: String,
      default: "left"
    },
    checkboxLabel: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__checkbox--loading--inverse" : "orq-shimmer__checkbox--loading--default"
      ),
      checkboxPositionClass: B(
        () => e.checkboxPosition === "left" && e.checkboxLabel ? "orq-shimmer__checkbox--loading-check--inverse" : ""
      ),
      checkboxLabelClass: B(
        () => e.checkboxLabel && e.checkboxPosition ? "orq-shimmer__checkbox--loading--checkbox" : "orq-shimmer__checkbox--loading--checkbox-minor"
      )
    };
  }
}), t1 = {
  key: 0,
  class: "orq-shimmer"
}, n1 = { class: "orq-shimmer__checkbox" };
function r1(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", t1, [
    y("div", n1, [
      y("div", {
        class: w(`orq-shimmer__checkbox--loading ${e.checkboxPositionClass}`)
      }, [
        e.checkboxLabel === !0 ? (v(), m("div", {
          key: 0,
          class: w(`orq-shimmer__checkbox--loading--text ${e.inverseClass}`)
        }, null, 2)) : D("", !0),
        y("div", {
          class: w(`${e.checkboxLabelClass} ${e.inverseClass}`)
        }, null, 2)
      ], 2)
    ])
  ])) : D("", !0);
}
const a1 = /* @__PURE__ */ ae(e1, [["render", r1]]), i1 = Oe({
  name: "ShimmerContentSwitcher",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__content-switcher--loading--inverse" : "orq-shimmer__content-switcher--loading--default"
      )
    };
  }
}), s1 = {
  key: 0,
  class: "orq-shimmer"
}, o1 = { class: "orq-shimmer__content-switcher" }, l1 = { class: "orq-shimmer__content-switcher--loading" };
function u1(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", s1, [
    y("div", o1, [
      y("div", l1, [
        y("div", {
          class: w(`content-switcher--loading ${e.inverseClass}`)
        }, null, 2)
      ])
    ])
  ])) : D("", !0);
}
const c1 = /* @__PURE__ */ ae(i1, [["render", u1]]), d1 = Oe({
  name: "ShimmerTab",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 1
    },
    tabItems: {
      type: Number,
      default: 1
    },
    tabDirection: {
      type: String,
      default: "horizontal"
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__tab--loading--inverse" : "orq-shimmer__tab--loading--default"
      )
    };
  }
}), f1 = {
  key: 0,
  class: "orq-shimmer"
}, v1 = { class: "orq-shimmer__tab" }, p1 = { class: "orq-shimmer__tab--loading-content" };
function h1(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", f1, [
    y("div", v1, [
      (v(!0), m(ce, null, Re(new Array(e.$props.rows), (u, f) => (v(), m("div", {
        key: f,
        class: "orq-shimmer__tab--loading-container"
      }, [
        y("div", p1, [
          (v(!0), m(ce, null, Re(new Array(e.$props.tabItems), (c, g) => (v(), m("div", {
            key: g,
            class: w(`orq-shimmer__progress-bar-loading-status orq-shimmer__tab--loading-content--${e.tabDirection} ${e.inverseClass}`)
          }, null, 2))), 128))
        ]),
        y("div", {
          class: w(`orq-shimmer__tab--loading-progress ${e.inverseClass}`)
        }, null, 2)
      ]))), 128))
    ])
  ])) : D("", !0);
}
const g1 = /* @__PURE__ */ ae(d1, [["render", h1]]), m1 = Oe({
  name: "ShimmerProgressBar",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__progress-bar--loading--inverse" : "orq-shimmer__progress-bar--loading--default"
      )
    };
  }
}), y1 = {
  key: 0,
  class: "orq-shimmer"
}, b1 = { class: "orq-shimmer__progress-bar" };
function _1(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", y1, [
    y("div", b1, [
      (v(!0), m(ce, null, Re(new Array(e.$props.rows), (u, f) => (v(), m("div", {
        key: f,
        class: "orq-shimmer__progress-bar--loading"
      }, [
        y("div", {
          class: w(`orq-shimmer__progress-bar--loading-content ${e.inverseClass}`)
        }, null, 2),
        y("div", {
          class: w(`orq-shimmer__progress-bar--loading-status ${e.inverseClass}`)
        }, null, 2)
      ]))), 128))
    ])
  ])) : D("", !0);
}
const w1 = /* @__PURE__ */ ae(m1, [["render", _1]]), $1 = Oe({
  name: "ShimmerProgressRing",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: "small"
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 1
    },
    typeRing: {
      type: String,
      default: "image"
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__progress-ring--loading--inverse" : "orq-shimmer__progress-ring--loading--default"
      ),
      inverseContentClass: B(
        () => e.inverse ? "orq-shimmer__progress-ring--loading-content--inverse" : "orq-shimmer__progress-ring--loading-content--default"
      ),
      loadingTrackSizeClass: B(
        () => e.size === "large" ? `orq-shimmer__progress-ring--loading-track__${e.typeRing}--${e.size}` : ""
      ),
      loadingContentSizeClass: B(
        () => e.size === "large" ? `orq-shimmer__progress-ring--loading-content__${e.typeRing}--${e.size}` : ""
      )
    };
  }
}), C1 = {
  key: 0,
  class: "orq-shimmer"
}, S1 = { class: "orq-shimmer__progress-ring" };
function k1(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", C1, [
    y("div", S1, [
      (v(!0), m(ce, null, Re(new Array(e.$props.rows), (u, f) => (v(), m("div", {
        key: f,
        class: "orq-shimmer__progress-ring--loading"
      }, [
        y("div", {
          class: w(`orq-shimmer__progress-ring--loading-track orq-shimmer__progress-ring--loading-track__${e.typeRing} ${e.loadingTrackSizeClass} ${e.inverseClass}`)
        }, [
          y("div", {
            class: w(`orq-shimmer__progress-ring--loading-content orq-shimmer__progress-ring--loading-content__${e.typeRing} ${e.loadingContentSizeClass} ${e.inverseContentClass}`)
          }, null, 2)
        ], 2)
      ]))), 128))
    ])
  ])) : D("", !0);
}
const q1 = /* @__PURE__ */ ae($1, [["render", k1]]), D1 = Oe({
  name: "ShimmerProgressTracker",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__progress-tracker--loading--inverse" : "orq-shimmer__progress-tracker--loading--default"
      )
    };
  }
}), B1 = {
  key: 0,
  class: "orq-shimmer"
}, A1 = { class: "orq-shimmer__progress-tracker" }, T1 = { class: "orq-shimmer__progress-tracker--loading-content" };
function O1(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", B1, [
    y("div", A1, [
      (v(!0), m(ce, null, Re(new Array(e.$props.rows), (u, f) => (v(), m("div", {
        key: f,
        class: "orq-shimmer__progress-tracker--loading"
      }, [
        y("div", {
          class: w(`orq-shimmer__progress-tracker--loading-bar ${e.inverseClass}`)
        }, null, 2),
        y("div", T1, [
          (v(!0), m(ce, null, Re(new Array(3).fill(null), (c, g) => (v(), m("div", {
            key: g,
            class: w(`orq-shimmer__progress-tracker--loading-status ${e.inverseClass}`)
          }, null, 2))), 128))
        ])
      ]))), 128))
    ])
  ])) : D("", !0);
}
const I1 = /* @__PURE__ */ ae(D1, [["render", O1]]), M1 = Oe({
  name: "ShimmerRadioButton",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 1
    },
    radioButtonPosition: {
      type: String,
      default: "left"
    },
    typeRadioButton: {
      type: String,
      default: "label"
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__radio-button--loading--inverse" : "orq-shimmer__radio-button--loading--default"
      ),
      positionInverseClass: B(() => ({
        "orq-shimmer__radio-button--loading": !0,
        "orq-shimmer__radio-button--loading-radio--inverse": e.radioButtonPosition === "left" && e.typeRadioButton === "label"
      }))
    };
  }
}), x1 = {
  key: 0,
  class: "orq-shimmer"
}, L1 = { class: "orq-shimmer__radio-button" };
function F1(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", x1, [
    y("div", L1, [
      e.typeRadioButton === "label" ? (v(!0), m(ce, { key: 0 }, Re(new Array(e.$props.rows), (u) => (v(), m("div", {
        key: u,
        class: w(e.positionInverseClass)
      }, [
        e.typeRadioButton === "label" ? (v(), m("div", {
          key: 0,
          class: w(`orq-shimmer__radio-button--loading--radio-button ${e.inverseClass}`)
        }, null, 2)) : D("", !0),
        e.typeRadioButton === "label" ? (v(), m("div", {
          key: 1,
          class: w(`orq-shimmer__radio-button--loading--label ${e.inverseClass}`)
        }, null, 2)) : D("", !0)
      ], 2))), 128)) : D("", !0),
      e.typeRadioButton === "card" || e.typeRadioButton === "box" ? (v(), m("div", {
        key: 1,
        class: w(e.positionInverseClass)
      }, [
        (v(!0), m(ce, null, Re(new Array(e.$props.rows), (u) => (v(), m("div", {
          key: u,
          class: w(`orq-shimmer__radio-button--loading--${e.typeRadioButton} ${e.inverseClass}`)
        }, null, 2))), 128))
      ], 2)) : D("", !0)
    ])
  ])) : D("", !0);
}
const E1 = /* @__PURE__ */ ae(M1, [["render", F1]]), P1 = Oe({
  name: "ShimmerSelectInline",
  props: {
    loading: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(e) {
    return e = it(e), {
      selectInlineInverseClass: B(() => ({
        "orq-shimmer__select-inline--loading--accordion": !0,
        "orq-shimmer__select-inline--loading--inverse": e.inverse,
        "orq-shimmer__select-inline--loading--default": !0
      })),
      selectInlineTextInverseClass: B(() => ({
        "orq-shimmer__select-inline--loading--text": !0,
        "orq-shimmer__select-inline--loading--inverse": e.inverse,
        "orq-shimmer__select-inline--loading--default": !0
      }))
    };
  }
}), z1 = {
  key: 0,
  class: "orq-shimmer"
}, R1 = { class: "orq-shimmer__select-inline" };
function N1(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", z1, [
    y("div", R1, [
      (v(!0), m(ce, null, Re(new Array(e.$props.rows), (u) => (v(), m("div", {
        key: u,
        class: "orq-shimmer__select-inline--loading"
      }, [
        y("div", {
          class: w(e.selectInlineTextInverseClass)
        }, null, 2),
        y("div", {
          class: w(e.selectInlineInverseClass)
        }, null, 2)
      ]))), 128))
    ])
  ])) : D("", !0);
}
const H1 = /* @__PURE__ */ ae(P1, [["render", N1]]), V1 = Oe({
  name: "ShimmerSelect",
  props: {
    loading: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "small"
    },
    typeSelect: {
      type: String,
      default: "default"
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(e) {
    e = it(e);
    const a = e.inverse ? "orq-shimmer__select--loading--inverse" : "orq-shimmer__select--loading--default", r = e.typeSelect === "two-lines" ? "-two-lines" : "", s = e.size === "small" ? "orq-shimmer__select--loading--small" : "", o = e.size === "small" ? "-small" : "";
    return {
      inverseClass: a,
      selectTypeClass: r,
      sizeClass: s,
      sizeIcon: o
    };
  }
}), Y1 = {
  key: 0,
  class: "orq-shimmer"
};
function U1(e, a, r, s, o, d) {
  return v(), m(ce, null, [
    e.loading ? (v(), m("div", Y1, [
      y("div", {
        class: w(`orq-shimmer__select${e.selectTypeClass}`)
      }, [
        (v(!0), m(ce, null, Re(new Array(e.$props.rows), (u) => (v(), m("div", {
          key: u,
          class: w(`orq-shimmer__select${e.selectTypeClass}--loading`)
        }, [
          y("div", {
            class: w(`orq-shimmer__select${e.selectTypeClass}--loading--title ${e.inverseClass}`)
          }, null, 2),
          y("div", {
            class: w(`orq-shimmer__select${e.selectTypeClass}--loading-container`)
          }, [
            e.typeSelect === "default" ? (v(), m(ce, { key: 0 }, [
              y("div", {
                class: w(`orq-shimmer__select--loading--icon${e.sizeIcon} ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__select--loading--description ${e.sizeClass} ${e.inverseClass}`)
              }, null, 2)
            ], 64)) : (v(), m(ce, { key: 1 }, [
              y("div", {
                class: w(`orq-shimmer__select-two-lines--loading--image ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__select-two-lines--loading--description ${e.inverseClass}`)
              }, null, 2),
              y("div", {
                class: w(`orq-shimmer__select-two-lines--loading--icon ${e.inverseClass}`)
              }, null, 2)
            ], 64))
          ], 2),
          y("div", {
            class: w(`orq-shimmer__select${e.selectTypeClass}--loading--text ${e.inverseClass}`)
          }, null, 2)
        ], 2))), 128))
      ], 2)
    ])) : D("", !0),
    we(e.$slots, "default")
  ], 64);
}
const W1 = /* @__PURE__ */ ae(V1, [["render", U1]]), G1 = Oe({
  name: "ShimmerSlider",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__slider--loading--inverse" : "orq-shimmer__slider--loading--default"
      )
    };
  }
}), Z1 = {
  key: 0,
  class: "orq-shimmer"
}, K1 = { class: "orq-shimmer__slider" }, X1 = { class: "orq-shimmer__slider--loading--paragraph" }, J1 = { class: "orq-shimmer__slider--loading--caption" };
function Q1(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", Z1, [
    y("div", K1, [
      (v(!0), m(ce, null, Re(new Array(e.$props.rows), (u, f) => (v(), m("div", {
        key: f,
        class: "orq-shimmer__slider--loading"
      }, [
        y("div", X1, [
          y("div", {
            class: w(`orq-shimmer__slider--loading--title ${e.inverseClass}`)
          }, null, 2),
          y("div", {
            class: w(`orq-shimmer__slider--loading--value ${e.inverseClass}`)
          }, null, 2)
        ]),
        y("div", {
          class: w(`orq-shimmer__slider--loading--slider ${e.inverseClass}`)
        }, null, 2),
        y("div", J1, [
          y("div", {
            class: w(`orq-shimmer__slider--loading--title ${e.inverseClass}`)
          }, null, 2),
          y("div", {
            class: w(`orq-shimmer__slider--loading--value orq-shimmer__slider--loading--caption-value ${e.inverseClass}`)
          }, null, 2),
          y("div", {
            class: w(`orq-shimmer__slider--loading--caption-left ${e.inverseClass}`)
          }, null, 2),
          y("div", {
            class: w(`orq-shimmer__slider--loading--caption-right ${e.inverseClass}`)
          }, null, 2)
        ])
      ]))), 128))
    ])
  ])) : D("", !0);
}
const j1 = /* @__PURE__ */ ae(G1, [["render", Q1]]), ew = Oe({
  name: "ShimmerInput",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: "small"
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__input--loading--inverse" : "orq-shimmer__input--loading--default"
      )
    };
  }
}), tw = {
  key: 0,
  class: "orq-shimmer"
}, nw = { class: "orq-shimmer__input" };
function rw(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", tw, [
    y("div", nw, [
      (v(!0), m(ce, null, Re(new Array(e.$props.rows), (u, f) => (v(), m("div", {
        key: f,
        class: "orq-shimmer__input--loading"
      }, [
        y("div", {
          class: w(`orq-shimmer__input--loading--title orq-shimmer__input--loading--title--${e.size} ${e.inverseClass}`)
        }, null, 2),
        y("div", {
          class: w(`orq-shimmer__input--loading--input orq-shimmer__input--loading--input--${e.size} ${e.inverseClass}`)
        }, null, 2),
        y("div", {
          class: w(`orq-shimmer__input--loading--text orq-shimmer__input--loading--text--${e.size} ${e.inverseClass}`)
        }, null, 2)
      ]))), 128))
    ])
  ])) : D("", !0);
}
const aw = /* @__PURE__ */ ae(ew, [["render", rw]]), iw = Oe({
  name: "ShimmerNotification",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__notification--loading--inverse" : "orq-shimmer__notification--loading--default"
      )
    };
  }
}), sw = {
  key: 0,
  class: "orq-shimmer"
}, ow = { class: "orq-shimmer__notification" }, lw = { class: "orq-shimmer__notification--loading-container" };
function uw(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", sw, [
    y("div", ow, [
      (v(!0), m(ce, null, Re(new Array(e.$props.rows), (u, f) => (v(), m("div", {
        key: f,
        class: "orq-shimmer__notification--loading"
      }, [
        y("div", lw, [
          y("div", {
            class: w(`orq-shimmer__notification--loading--icon
            ${e.inverseClass}`)
          }, null, 2),
          y("div", {
            class: w(`orq-shimmer__notification--loading--title
            ${e.inverseClass}`)
          }, null, 2)
        ]),
        y("div", {
          class: w(`orq-shimmer__notification--loading--text
          ${e.inverseClass}`)
        }, null, 2)
      ]))), 128))
    ])
  ])) : D("", !0);
}
const cw = /* @__PURE__ */ ae(iw, [["render", uw]]), dw = Oe({
  name: "ShimmerFileUploader",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__avatar--loading--inverse" : "orq-shimmer__avatar--loading--default"
      )
    };
  }
}), fw = {
  key: 0,
  class: "orq-shimmer"
}, vw = { class: "orq-shimmer__file-uploader" }, pw = { class: "orq-shimmer__file-uploader--loading-container" };
function hw(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", fw, [
    y("div", vw, [
      (v(!0), m(ce, null, Re(new Array(e.$props.rows), (u, f) => (v(), m("div", {
        key: f,
        class: "orq-shimmer__file-uploader--loading"
      }, [
        y("div", {
          class: w(`orq-shimmer__file-uploader--loading--upload-area ${e.inverseClass}`)
        }, null, 2),
        y("div", pw, [
          y("div", {
            class: w(`orq-shimmer__file-uploader--loading--icon ${e.inverseClass}`)
          }, null, 2),
          y("div", {
            class: w(`orq-shimmer__file-uploader--loading--description ${e.inverseClass}`)
          }, null, 2)
        ]),
        y("div", {
          class: w(`orq-shimmer__file-uploader--loading--file ${e.inverseClass}`)
        }, null, 2)
      ]))), 128))
    ])
  ])) : D("", !0);
}
const gw = /* @__PURE__ */ ae(dw, [["render", hw]]), mw = Oe({
  name: "ShimmerImage",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    cols: {
      type: Number,
      default: 1
    },
    sWidth: {
      type: Number,
      default: 150
    },
    sHeight: {
      type: Number,
      default: 150
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__image--loading--inverse" : "orq-shimmer__image--loading--default"
      ),
      containerStyle: B(() => ({
        width: `${e.sWidth}px`,
        height: `${e.sHeight}px`
      }))
    };
  }
}), yw = {
  key: 0,
  class: "orq-shimmer"
}, bw = { class: "orq-shimmer__image" };
function _w(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", yw, [
    y("div", bw, [
      y("div", {
        class: w(`orq-shimmer__image--loading ${e.inverseClass}`),
        style: nt(e.containerStyle)
      }, null, 6)
    ])
  ])) : D("", !0);
}
const ww = /* @__PURE__ */ ae(mw, [["render", _w]]), $w = Oe({
  name: "ShimmerBadge",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    showListAction: {
      type: Boolean,
      default: !1
    },
    showListOverline: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__list--loading--inverse" : "orq-shimmer__list--loading--default"
      )
    };
  }
}), Cw = {
  key: 0,
  class: "orq-shimmer"
}, Sw = { class: "orq-shimmer__list" }, kw = { class: "orq-shimmer__list--loading" }, qw = { class: "orq-shimmer__list--loading-container" };
function Dw(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", Cw, [
    y("div", Sw, [
      e.showListOverline ? (v(), m("div", {
        key: 0,
        class: w(`orq-shimmer__list--loading--overline ${e.inverseClass}`)
      }, null, 2)) : D("", !0),
      (v(!0), m(ce, null, Re(new Array(e.$props.rows), (u, f) => (v(), m(ce, { key: f }, [
        y("div", kw, [
          y("div", {
            class: w(`orq-shimmer__list--loading--avatar ${e.inverseClass}`)
          }, null, 2),
          y("div", qw, [
            y("div", {
              class: w(`orq-shimmer__list--loading--title ${e.inverseClass}`)
            }, null, 2),
            y("div", {
              class: w(`orq-shimmer__list--loading--subtitle ${e.inverseClass}`)
            }, null, 2)
          ]),
          e.showListAction ? (v(), m("div", {
            key: 0,
            class: w(`orq-shimmer__list--loading--action ${e.inverseClass}`)
          }, null, 2)) : D("", !0)
        ]),
        f !== new Array(e.$props.rows).length - 1 ? (v(), m("div", {
          key: 0,
          class: w(`orq-shimmer__list--loading--split ${e.inverseClass}`)
        }, null, 2)) : D("", !0)
      ], 64))), 128))
    ])
  ])) : D("", !0);
}
const Bw = /* @__PURE__ */ ae($w, [["render", Dw]]), Aw = Oe({
  name: "ShimmerButtonFoward",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__button-foward--loading--inverse" : "orq-shimmer__button-foward--loading--default"
      )
    };
  }
}), Tw = {
  key: 0,
  class: "orq-shimmer"
}, Ow = { class: "orq-shimmer__button orq-shimmer__button-foward--loading" };
function Iw(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", Tw, [
    y("div", Ow, [
      y("div", {
        class: w(`button-foward--loading ${e.inverseClass}`)
      }, null, 2)
    ])
  ])) : D("", !0);
}
const Mw = /* @__PURE__ */ ae(Aw, [["render", Iw]]), xw = Oe({
  name: "ShimmerText",
  props: {
    name: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: "small"
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(e) {
    return e = it(e), {
      inverseClass: B(
        () => e.inverse ? "orq-shimmer__text-row--inverse" : "orq-shimmer__text-row--default"
      )
    };
  }
}), Lw = {
  key: 0,
  class: "orq-shimmer"
}, Fw = { class: "orq-shimmer__text" };
function Ew(e, a, r, s, o, d) {
  return e.loading ? (v(), m("div", Lw, [
    y("div", Fw, [
      (v(!0), m(ce, null, Re(new Array(e.$props.rows), (u, f) => (v(), m("p", {
        key: f,
        class: w(`orq-shimmer__text-row orq-shimmer__text-row--${e.size} ${e.inverseClass}`)
      }, null, 2))), 128))
    ])
  ])) : D("", !0);
}
const pd = /* @__PURE__ */ ae(xw, [["render", Ew]]), Pw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  accordion: xb,
  avatar: zb,
  badge: Ub,
  banner: A_,
  button: N_,
  buttonForward: Mw,
  checkbox: a1,
  contentSwitcher: c1,
  fileUploader: gw,
  image: ww,
  imageGroup: G_,
  input: aw,
  list: Bw,
  notification: cw,
  progressBar: w1,
  progressRing: q1,
  progressTracker: I1,
  radioButton: E1,
  select: W1,
  selectInline: H1,
  slider: j1,
  switcher: L_,
  tab: g1,
  tag: j_,
  text: pd
}, Symbol.toStringTag, { value: "Module" })), Ft = {
  __name: "Shimmer",
  props: {
    type: {
      type: String,
      required: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: "small"
    },
    sizeBanner: {
      type: String,
      default: "large"
    },
    sizeAvatar: {
      type: String,
      default: "24"
    },
    showListAction: {
      type: Boolean,
      default: !1
    },
    showListOverline: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 1
    },
    tabItems: {
      type: Number,
      default: 1
    },
    typeTag: {
      type: String,
      default: "search"
    },
    tabDirection: {
      type: String,
      default: "horizontal"
    },
    checkboxPosition: {
      type: String,
      default: "left"
    },
    checkboxLabel: {
      type: Boolean,
      default: !0
    },
    radioButtonPosition: {
      type: String,
      default: "left"
    },
    typeRadioButton: {
      type: String,
      default: "label"
    },
    typeRing: {
      type: String,
      default: "image"
    },
    cols: {
      type: Number,
      default: 1
    },
    sWidth: {
      type: Number,
      default: 150
    },
    sHeight: {
      type: Number,
      default: 150
    }
  },
  setup(e) {
    const a = e, r = B(() => {
      let s = Bb.toCamelCase(a.type, "-");
      return s ? Pw[s] : pd;
    });
    return (s, o) => (v(), me(Ii(r.value), Yc(Uc(a)), null, 16));
  }
}, zw = {
  key: 1,
  class: "orq-avatar"
}, Rw = { class: "orq-avatar__block" }, Nw = { key: 1 }, Hw = { key: 3 }, hd = {
  __name: "Avatar",
  props: {
    type: {
      type: String,
      default: "initials"
    },
    src: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: ""
    },
    size: {
      type: Number,
      default: 24
    },
    notification: {
      type: String,
      default: "none"
    },
    counterValue: {
      type: Number,
      default: 2
    },
    loading: {
      type: Boolean,
      default: !1
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    outline: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = e, r = B(() => ({
      "orq-avatar__block__initials": !0,
      "orq-avatar__block__initials--default": !0,
      "orq-avatar__block__initials--inverse": a.inverse,
      "orq-avatar__block__initials--outline": a.outline,
      [`orq-avatar__block__initials--size-${a.size}`]: !0,
      [`orq-avatar__block__initials--size-${a.size}-outline-inverse`]: a.outline && a.inverse
    })), s = B(() => ({
      "orq-avatar__block__bullet": !0,
      "orq-avatar__block__bullet--default": !0,
      "orq-avatar__block__bullet--inverse": a.inverse,
      [`orq-avatar__block__bullet--notification--${a.notification === "default" || a.notification === "counter" ? "default" : ""}--size-${a.size}`]: !0,
      "orq-bullet": !0,
      [`orq-avatar__block__bullet--notification--${a.notification === "status" ? "status" : ""}--size-${a.size}`]: !0,
      [`orq-bullet--${a.notification === "default" || a.notification === "counter" && a.size <= 32 ? "info" : ""}`]: a.notification,
      [`orq-bullet--${a.notification === "default" || a.notification === "counter" && a.size <= 32 ? "info" : ""}--inverse`]: a.inverse,
      [`orq-bullet--${a.notification === "status" ? "positive" : ""}`]: a.notification,
      [`orq-bullet--${a.notification === "status" ? "positive" : ""}--inverse`]: a.inverse
    })), o = B(() => ({
      "orq-avatar__block__counter": !0,
      [`orq-avatar__block__counter--size-${a.size}`]: !0,
      "orq-avatar__block__counter--'default": !0
    }));
    return (d, u) => (v(), m(ce, null, [
      e.loading ? (v(), me(Ft, {
        key: 0,
        type: "avatar",
        "size-avatar": e.size,
        inverse: e.inverse
      }, null, 8, ["size-avatar", "inverse"])) : D("", !0),
      e.loading ? D("", !0) : (v(), m("div", zw, [
        y("div", Rw, [
          e.type === "initials" ? (v(), m("div", {
            key: 0,
            class: w(r.value),
            tabindex: 0
          }, ie(e.alt.toUpperCase().substring(0, 2)), 3)) : D("", !0),
          e.notification === "default" || e.notification === "counter" && e.size <= 32 || e.notification === "status" ? (v(), m("div", Nw, [
            re(wo, {
              size: e.size,
              inverse: e.inverse,
              outline: e.outline,
              class: w(s.value)
            }, null, 8, ["size", "inverse", "outline", "class"])
          ])) : D("", !0),
          e.notification != "none" && e.notification == "counter" && e.size > 32 ? (v(), m("div", {
            key: 2,
            class: w(o.value)
          }, [
            re(Xc, {
              value: e.counterValue,
              inverse: e.inverse,
              size: "large",
              type: "circle"
            }, null, 8, ["value", "inverse"])
          ], 2)) : D("", !0),
          e.type === "image" ? (v(), m("div", Hw, [
            re(Ta, {
              size: e.size,
              src: e.src,
              alt: e.alt,
              shape: "rounded",
              outline: e.outline,
              inverse: e.inverse
            }, null, 8, ["size", "src", "alt", "outline", "inverse"])
          ])) : D("", !0)
        ])
      ]))
    ], 64));
  }
}, Vw = {
  key: 0,
  class: "badge__icon"
}, Yw = { class: "badge__label" }, Uw = {
  __name: "Badge",
  props: {
    label: {
      type: String,
      default: "Badge"
    },
    icon: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "normal",
      validator: (e) => ["small", "normal"].includes(e)
    },
    color: {
      type: String,
      default: "blue",
      validator: (e) => [
        "blue",
        "aqua",
        "lime",
        "green",
        "orange",
        "yellow",
        "red",
        "pink",
        "violet",
        "purple",
        "brown",
        "grey"
      ].includes(e)
    }
  },
  setup(e) {
    const a = e;
    return (r, s) => (v(), m("div", {
      class: w(["badge", [a.color, a.size]])
    }, [
      e.icon ? (v(), m("span", Vw, [
        (v(), me(Te, {
          key: e.icon,
          name: e.icon,
          size: a.size === "small" ? 16 : 20
        }, null, 8, ["name", "size"]))
      ])) : D("", !0),
      y("span", Yw, ie(a.label), 1)
    ], 2));
  }
}, gd = /* @__PURE__ */ ae(Uw, [["__scopeId", "data-v-4b116cb2"]]), L3 = {
  __name: "BadgeStatus",
  props: {
    type: {
      type: String,
      default: "success",
      validator: (e) => ["success", "warning", "negative", "informative"].includes(
        e
      )
    }
  },
  setup(e) {
    const a = e, r = B(() => ({
      success: {
        color: "green",
        icon: "status-success"
      },
      warning: {
        color: "orange",
        icon: "status-warning"
      },
      negative: {
        color: "red",
        icon: "status-disapproved"
      },
      informative: {
        color: "blue",
        icon: "info-on"
      }
    })[a.type]);
    return (s, o) => (v(), me(gd, Mi({
      label: s.label,
      size: s.size
    }, r.value), null, 16, ["label", "size"]));
  }
};
var br = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function md(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Bi = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Bi.exports;
(function(e, a) {
  (function() {
    var r, s = "4.17.21", o = 200, d = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", u = "Expected a function", f = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", g = 500, h = "__lodash_placeholder__", q = 1, C = 2, O = 4, S = 1, I = 2, M = 1, F = 2, P = 4, x = 8, $ = 16, Y = 32, R = 64, T = 128, z = 256, le = 512, K = 30, se = "...", oe = 800, ve = 16, ee = 1, Q = 2, J = 3, te = 1 / 0, G = 9007199254740991, de = 17976931348623157e292, ge = NaN, N = 4294967295, ne = N - 1, ue = N >>> 1, Se = [
      ["ary", T],
      ["bind", M],
      ["bindKey", F],
      ["curry", x],
      ["curryRight", $],
      ["flip", le],
      ["partial", Y],
      ["partialRight", R],
      ["rearg", z]
    ], Me = "[object Arguments]", Ne = "[object Array]", pt = "[object AsyncFunction]", st = "[object Boolean]", ke = "[object Date]", Ie = "[object DOMException]", Je = "[object Error]", he = "[object Function]", je = "[object GeneratorFunction]", Ze = "[object Map]", wt = "[object Number]", Ot = "[object Null]", ht = "[object Object]", cn = "[object Promise]", $n = "[object Proxy]", Dt = "[object RegExp]", yt = "[object Set]", dn = "[object String]", Jt = "[object Symbol]", or = "[object Undefined]", Cn = "[object WeakMap]", Sr = "[object WeakSet]", Sn = "[object ArrayBuffer]", fn = "[object DataView]", Xr = "[object Float32Array]", Jr = "[object Float64Array]", Qr = "[object Int8Array]", jr = "[object Int16Array]", ea = "[object Int32Array]", U = "[object Uint8Array]", be = "[object Uint8ClampedArray]", De = "[object Uint16Array]", Ge = "[object Uint32Array]", Ue = /\b__p \+= '';/g, St = /\b(__p \+=) '' \+/g, Et = /(__e\(.*?\)|\b__t\)) \+\n'';/g, xn = /&(?:amp|lt|gt|quot|#39);/g, ta = /[&<>"']/g, Ln = RegExp(xn.source), na = RegExp(ta.source), kr = /<%-([\s\S]+?)%>/g, Wn = /<%([\s\S]+?)%>/g, Ma = /<%=([\s\S]+?)%>/g, ra = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, qr = /^\w*$/, Jd = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Yi = /[\\^$.*+?()[\]{}|]/g, Qd = RegExp(Yi.source), Ui = /^\s+/, jd = /\s/, ef = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, tf = /\{\n\/\* \[wrapped with (.+)\] \*/, nf = /,? & /, rf = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, af = /[()=,{}\[\]\/\s]/, sf = /\\(\\)?/g, of = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Ho = /\w*$/, lf = /^[-+]0x[0-9a-f]+$/i, uf = /^0b[01]+$/i, cf = /^\[object .+?Constructor\]$/, df = /^0o[0-7]+$/i, ff = /^(?:0|[1-9]\d*)$/, vf = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, xa = /($^)/, pf = /['\n\r\u2028\u2029\\]/g, La = "\\ud800-\\udfff", hf = "\\u0300-\\u036f", gf = "\\ufe20-\\ufe2f", mf = "\\u20d0-\\u20ff", Vo = hf + gf + mf, Yo = "\\u2700-\\u27bf", Uo = "a-z\\xdf-\\xf6\\xf8-\\xff", yf = "\\xac\\xb1\\xd7\\xf7", bf = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", _f = "\\u2000-\\u206f", wf = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Wo = "A-Z\\xc0-\\xd6\\xd8-\\xde", Go = "\\ufe0e\\ufe0f", Zo = yf + bf + _f + wf, Wi = "['’]", $f = "[" + La + "]", Ko = "[" + Zo + "]", Fa = "[" + Vo + "]", Xo = "\\d+", Cf = "[" + Yo + "]", Jo = "[" + Uo + "]", Qo = "[^" + La + Zo + Xo + Yo + Uo + Wo + "]", Gi = "\\ud83c[\\udffb-\\udfff]", Sf = "(?:" + Fa + "|" + Gi + ")", jo = "[^" + La + "]", Zi = "(?:\\ud83c[\\udde6-\\uddff]){2}", Ki = "[\\ud800-\\udbff][\\udc00-\\udfff]", Dr = "[" + Wo + "]", el = "\\u200d", tl = "(?:" + Jo + "|" + Qo + ")", kf = "(?:" + Dr + "|" + Qo + ")", nl = "(?:" + Wi + "(?:d|ll|m|re|s|t|ve))?", rl = "(?:" + Wi + "(?:D|LL|M|RE|S|T|VE))?", al = Sf + "?", il = "[" + Go + "]?", qf = "(?:" + el + "(?:" + [jo, Zi, Ki].join("|") + ")" + il + al + ")*", Df = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Bf = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", sl = il + al + qf, Af = "(?:" + [Cf, Zi, Ki].join("|") + ")" + sl, Tf = "(?:" + [jo + Fa + "?", Fa, Zi, Ki, $f].join("|") + ")", Of = RegExp(Wi, "g"), If = RegExp(Fa, "g"), Xi = RegExp(Gi + "(?=" + Gi + ")|" + Tf + sl, "g"), Mf = RegExp([
      Dr + "?" + Jo + "+" + nl + "(?=" + [Ko, Dr, "$"].join("|") + ")",
      kf + "+" + rl + "(?=" + [Ko, Dr + tl, "$"].join("|") + ")",
      Dr + "?" + tl + "+" + nl,
      Dr + "+" + rl,
      Bf,
      Df,
      Xo,
      Af
    ].join("|"), "g"), xf = RegExp("[" + el + La + Vo + Go + "]"), Lf = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Ff = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Ef = -1, lt = {};
    lt[Xr] = lt[Jr] = lt[Qr] = lt[jr] = lt[ea] = lt[U] = lt[be] = lt[De] = lt[Ge] = !0, lt[Me] = lt[Ne] = lt[Sn] = lt[st] = lt[fn] = lt[ke] = lt[Je] = lt[he] = lt[Ze] = lt[wt] = lt[ht] = lt[Dt] = lt[yt] = lt[dn] = lt[Cn] = !1;
    var ot = {};
    ot[Me] = ot[Ne] = ot[Sn] = ot[fn] = ot[st] = ot[ke] = ot[Xr] = ot[Jr] = ot[Qr] = ot[jr] = ot[ea] = ot[Ze] = ot[wt] = ot[ht] = ot[Dt] = ot[yt] = ot[dn] = ot[Jt] = ot[U] = ot[be] = ot[De] = ot[Ge] = !0, ot[Je] = ot[he] = ot[Cn] = !1;
    var Pf = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, zf = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Rf = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Nf = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Hf = parseFloat, Vf = parseInt, ol = typeof br == "object" && br && br.Object === Object && br, Yf = typeof self == "object" && self && self.Object === Object && self, kt = ol || Yf || Function("return this")(), Ji = a && !a.nodeType && a, lr = Ji && !0 && e && !e.nodeType && e, ll = lr && lr.exports === Ji, Qi = ll && ol.process, Qt = function() {
      try {
        var L = lr && lr.require && lr.require("util").types;
        return L || Qi && Qi.binding && Qi.binding("util");
      } catch {
      }
    }(), ul = Qt && Qt.isArrayBuffer, cl = Qt && Qt.isDate, dl = Qt && Qt.isMap, fl = Qt && Qt.isRegExp, vl = Qt && Qt.isSet, pl = Qt && Qt.isTypedArray;
    function Yt(L, W, H) {
      switch (H.length) {
        case 0:
          return L.call(W);
        case 1:
          return L.call(W, H[0]);
        case 2:
          return L.call(W, H[0], H[1]);
        case 3:
          return L.call(W, H[0], H[1], H[2]);
      }
      return L.apply(W, H);
    }
    function Uf(L, W, H, ye) {
      for (var xe = -1, Ke = L == null ? 0 : L.length; ++xe < Ke; ) {
        var bt = L[xe];
        W(ye, bt, H(bt), L);
      }
      return ye;
    }
    function jt(L, W) {
      for (var H = -1, ye = L == null ? 0 : L.length; ++H < ye && W(L[H], H, L) !== !1; )
        ;
      return L;
    }
    function Wf(L, W) {
      for (var H = L == null ? 0 : L.length; H-- && W(L[H], H, L) !== !1; )
        ;
      return L;
    }
    function hl(L, W) {
      for (var H = -1, ye = L == null ? 0 : L.length; ++H < ye; )
        if (!W(L[H], H, L))
          return !1;
      return !0;
    }
    function Gn(L, W) {
      for (var H = -1, ye = L == null ? 0 : L.length, xe = 0, Ke = []; ++H < ye; ) {
        var bt = L[H];
        W(bt, H, L) && (Ke[xe++] = bt);
      }
      return Ke;
    }
    function Ea(L, W) {
      var H = L == null ? 0 : L.length;
      return !!H && Br(L, W, 0) > -1;
    }
    function ji(L, W, H) {
      for (var ye = -1, xe = L == null ? 0 : L.length; ++ye < xe; )
        if (H(W, L[ye]))
          return !0;
      return !1;
    }
    function ut(L, W) {
      for (var H = -1, ye = L == null ? 0 : L.length, xe = Array(ye); ++H < ye; )
        xe[H] = W(L[H], H, L);
      return xe;
    }
    function Zn(L, W) {
      for (var H = -1, ye = W.length, xe = L.length; ++H < ye; )
        L[xe + H] = W[H];
      return L;
    }
    function es(L, W, H, ye) {
      var xe = -1, Ke = L == null ? 0 : L.length;
      for (ye && Ke && (H = L[++xe]); ++xe < Ke; )
        H = W(H, L[xe], xe, L);
      return H;
    }
    function Gf(L, W, H, ye) {
      var xe = L == null ? 0 : L.length;
      for (ye && xe && (H = L[--xe]); xe--; )
        H = W(H, L[xe], xe, L);
      return H;
    }
    function ts(L, W) {
      for (var H = -1, ye = L == null ? 0 : L.length; ++H < ye; )
        if (W(L[H], H, L))
          return !0;
      return !1;
    }
    var Zf = ns("length");
    function Kf(L) {
      return L.split("");
    }
    function Xf(L) {
      return L.match(rf) || [];
    }
    function gl(L, W, H) {
      var ye;
      return H(L, function(xe, Ke, bt) {
        if (W(xe, Ke, bt))
          return ye = Ke, !1;
      }), ye;
    }
    function Pa(L, W, H, ye) {
      for (var xe = L.length, Ke = H + (ye ? 1 : -1); ye ? Ke-- : ++Ke < xe; )
        if (W(L[Ke], Ke, L))
          return Ke;
      return -1;
    }
    function Br(L, W, H) {
      return W === W ? lv(L, W, H) : Pa(L, ml, H);
    }
    function Jf(L, W, H, ye) {
      for (var xe = H - 1, Ke = L.length; ++xe < Ke; )
        if (ye(L[xe], W))
          return xe;
      return -1;
    }
    function ml(L) {
      return L !== L;
    }
    function yl(L, W) {
      var H = L == null ? 0 : L.length;
      return H ? as(L, W) / H : ge;
    }
    function ns(L) {
      return function(W) {
        return W == null ? r : W[L];
      };
    }
    function rs(L) {
      return function(W) {
        return L == null ? r : L[W];
      };
    }
    function bl(L, W, H, ye, xe) {
      return xe(L, function(Ke, bt, rt) {
        H = ye ? (ye = !1, Ke) : W(H, Ke, bt, rt);
      }), H;
    }
    function Qf(L, W) {
      var H = L.length;
      for (L.sort(W); H--; )
        L[H] = L[H].value;
      return L;
    }
    function as(L, W) {
      for (var H, ye = -1, xe = L.length; ++ye < xe; ) {
        var Ke = W(L[ye]);
        Ke !== r && (H = H === r ? Ke : H + Ke);
      }
      return H;
    }
    function is(L, W) {
      for (var H = -1, ye = Array(L); ++H < L; )
        ye[H] = W(H);
      return ye;
    }
    function jf(L, W) {
      return ut(W, function(H) {
        return [H, L[H]];
      });
    }
    function _l(L) {
      return L && L.slice(0, Sl(L) + 1).replace(Ui, "");
    }
    function Ut(L) {
      return function(W) {
        return L(W);
      };
    }
    function ss(L, W) {
      return ut(W, function(H) {
        return L[H];
      });
    }
    function aa(L, W) {
      return L.has(W);
    }
    function wl(L, W) {
      for (var H = -1, ye = L.length; ++H < ye && Br(W, L[H], 0) > -1; )
        ;
      return H;
    }
    function $l(L, W) {
      for (var H = L.length; H-- && Br(W, L[H], 0) > -1; )
        ;
      return H;
    }
    function ev(L, W) {
      for (var H = L.length, ye = 0; H--; )
        L[H] === W && ++ye;
      return ye;
    }
    var tv = rs(Pf), nv = rs(zf);
    function rv(L) {
      return "\\" + Nf[L];
    }
    function av(L, W) {
      return L == null ? r : L[W];
    }
    function Ar(L) {
      return xf.test(L);
    }
    function iv(L) {
      return Lf.test(L);
    }
    function sv(L) {
      for (var W, H = []; !(W = L.next()).done; )
        H.push(W.value);
      return H;
    }
    function os(L) {
      var W = -1, H = Array(L.size);
      return L.forEach(function(ye, xe) {
        H[++W] = [xe, ye];
      }), H;
    }
    function Cl(L, W) {
      return function(H) {
        return L(W(H));
      };
    }
    function Kn(L, W) {
      for (var H = -1, ye = L.length, xe = 0, Ke = []; ++H < ye; ) {
        var bt = L[H];
        (bt === W || bt === h) && (L[H] = h, Ke[xe++] = H);
      }
      return Ke;
    }
    function za(L) {
      var W = -1, H = Array(L.size);
      return L.forEach(function(ye) {
        H[++W] = ye;
      }), H;
    }
    function ov(L) {
      var W = -1, H = Array(L.size);
      return L.forEach(function(ye) {
        H[++W] = [ye, ye];
      }), H;
    }
    function lv(L, W, H) {
      for (var ye = H - 1, xe = L.length; ++ye < xe; )
        if (L[ye] === W)
          return ye;
      return -1;
    }
    function uv(L, W, H) {
      for (var ye = H + 1; ye--; )
        if (L[ye] === W)
          return ye;
      return ye;
    }
    function Tr(L) {
      return Ar(L) ? dv(L) : Zf(L);
    }
    function vn(L) {
      return Ar(L) ? fv(L) : Kf(L);
    }
    function Sl(L) {
      for (var W = L.length; W-- && jd.test(L.charAt(W)); )
        ;
      return W;
    }
    var cv = rs(Rf);
    function dv(L) {
      for (var W = Xi.lastIndex = 0; Xi.test(L); )
        ++W;
      return W;
    }
    function fv(L) {
      return L.match(Xi) || [];
    }
    function vv(L) {
      return L.match(Mf) || [];
    }
    var pv = function L(W) {
      W = W == null ? kt : Or.defaults(kt.Object(), W, Or.pick(kt, Ff));
      var H = W.Array, ye = W.Date, xe = W.Error, Ke = W.Function, bt = W.Math, rt = W.Object, ls = W.RegExp, hv = W.String, en = W.TypeError, Ra = H.prototype, gv = Ke.prototype, Ir = rt.prototype, Na = W["__core-js_shared__"], Ha = gv.toString, et = Ir.hasOwnProperty, mv = 0, kl = function() {
        var t = /[^.]+$/.exec(Na && Na.keys && Na.keys.IE_PROTO || "");
        return t ? "Symbol(src)_1." + t : "";
      }(), Va = Ir.toString, yv = Ha.call(rt), bv = kt._, _v = ls(
        "^" + Ha.call(et).replace(Yi, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Ya = ll ? W.Buffer : r, Xn = W.Symbol, Ua = W.Uint8Array, ql = Ya ? Ya.allocUnsafe : r, Wa = Cl(rt.getPrototypeOf, rt), Dl = rt.create, Bl = Ir.propertyIsEnumerable, Ga = Ra.splice, Al = Xn ? Xn.isConcatSpreadable : r, ia = Xn ? Xn.iterator : r, ur = Xn ? Xn.toStringTag : r, Za = function() {
        try {
          var t = pr(rt, "defineProperty");
          return t({}, "", {}), t;
        } catch {
        }
      }(), wv = W.clearTimeout !== kt.clearTimeout && W.clearTimeout, $v = ye && ye.now !== kt.Date.now && ye.now, Cv = W.setTimeout !== kt.setTimeout && W.setTimeout, Ka = bt.ceil, Xa = bt.floor, us = rt.getOwnPropertySymbols, Sv = Ya ? Ya.isBuffer : r, Tl = W.isFinite, kv = Ra.join, qv = Cl(rt.keys, rt), _t = bt.max, Bt = bt.min, Dv = ye.now, Bv = W.parseInt, Ol = bt.random, Av = Ra.reverse, cs = pr(W, "DataView"), sa = pr(W, "Map"), ds = pr(W, "Promise"), Mr = pr(W, "Set"), oa = pr(W, "WeakMap"), la = pr(rt, "create"), Ja = oa && new oa(), xr = {}, Tv = hr(cs), Ov = hr(sa), Iv = hr(ds), Mv = hr(Mr), xv = hr(oa), Qa = Xn ? Xn.prototype : r, ua = Qa ? Qa.valueOf : r, Il = Qa ? Qa.toString : r;
      function b(t) {
        if (ft(t) && !Le(t) && !(t instanceof Ye)) {
          if (t instanceof tn)
            return t;
          if (et.call(t, "__wrapped__"))
            return Mu(t);
        }
        return new tn(t);
      }
      var Lr = /* @__PURE__ */ function() {
        function t() {
        }
        return function(n) {
          if (!ct(n))
            return {};
          if (Dl)
            return Dl(n);
          t.prototype = n;
          var i = new t();
          return t.prototype = r, i;
        };
      }();
      function ja() {
      }
      function tn(t, n) {
        this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!n, this.__index__ = 0, this.__values__ = r;
      }
      b.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: kr,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Wn,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Ma,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: b
        }
      }, b.prototype = ja.prototype, b.prototype.constructor = b, tn.prototype = Lr(ja.prototype), tn.prototype.constructor = tn;
      function Ye(t) {
        this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = N, this.__views__ = [];
      }
      function Lv() {
        var t = new Ye(this.__wrapped__);
        return t.__actions__ = Pt(this.__actions__), t.__dir__ = this.__dir__, t.__filtered__ = this.__filtered__, t.__iteratees__ = Pt(this.__iteratees__), t.__takeCount__ = this.__takeCount__, t.__views__ = Pt(this.__views__), t;
      }
      function Fv() {
        if (this.__filtered__) {
          var t = new Ye(this);
          t.__dir__ = -1, t.__filtered__ = !0;
        } else
          t = this.clone(), t.__dir__ *= -1;
        return t;
      }
      function Ev() {
        var t = this.__wrapped__.value(), n = this.__dir__, i = Le(t), l = n < 0, p = i ? t.length : 0, _ = Kp(0, p, this.__views__), k = _.start, A = _.end, E = A - k, Z = l ? A : k - 1, X = this.__iteratees__, j = X.length, pe = 0, _e = Bt(E, this.__takeCount__);
        if (!i || !l && p == E && _e == E)
          return nu(t, this.__actions__);
        var Be = [];
        e:
          for (; E-- && pe < _e; ) {
            Z += n;
            for (var Ee = -1, Ae = t[Z]; ++Ee < j; ) {
              var He = X[Ee], We = He.iteratee, Zt = He.type, xt = We(Ae);
              if (Zt == Q)
                Ae = xt;
              else if (!xt) {
                if (Zt == ee)
                  continue e;
                break e;
              }
            }
            Be[pe++] = Ae;
          }
        return Be;
      }
      Ye.prototype = Lr(ja.prototype), Ye.prototype.constructor = Ye;
      function cr(t) {
        var n = -1, i = t == null ? 0 : t.length;
        for (this.clear(); ++n < i; ) {
          var l = t[n];
          this.set(l[0], l[1]);
        }
      }
      function Pv() {
        this.__data__ = la ? la(null) : {}, this.size = 0;
      }
      function zv(t) {
        var n = this.has(t) && delete this.__data__[t];
        return this.size -= n ? 1 : 0, n;
      }
      function Rv(t) {
        var n = this.__data__;
        if (la) {
          var i = n[t];
          return i === c ? r : i;
        }
        return et.call(n, t) ? n[t] : r;
      }
      function Nv(t) {
        var n = this.__data__;
        return la ? n[t] !== r : et.call(n, t);
      }
      function Hv(t, n) {
        var i = this.__data__;
        return this.size += this.has(t) ? 0 : 1, i[t] = la && n === r ? c : n, this;
      }
      cr.prototype.clear = Pv, cr.prototype.delete = zv, cr.prototype.get = Rv, cr.prototype.has = Nv, cr.prototype.set = Hv;
      function Fn(t) {
        var n = -1, i = t == null ? 0 : t.length;
        for (this.clear(); ++n < i; ) {
          var l = t[n];
          this.set(l[0], l[1]);
        }
      }
      function Vv() {
        this.__data__ = [], this.size = 0;
      }
      function Yv(t) {
        var n = this.__data__, i = ei(n, t);
        if (i < 0)
          return !1;
        var l = n.length - 1;
        return i == l ? n.pop() : Ga.call(n, i, 1), --this.size, !0;
      }
      function Uv(t) {
        var n = this.__data__, i = ei(n, t);
        return i < 0 ? r : n[i][1];
      }
      function Wv(t) {
        return ei(this.__data__, t) > -1;
      }
      function Gv(t, n) {
        var i = this.__data__, l = ei(i, t);
        return l < 0 ? (++this.size, i.push([t, n])) : i[l][1] = n, this;
      }
      Fn.prototype.clear = Vv, Fn.prototype.delete = Yv, Fn.prototype.get = Uv, Fn.prototype.has = Wv, Fn.prototype.set = Gv;
      function En(t) {
        var n = -1, i = t == null ? 0 : t.length;
        for (this.clear(); ++n < i; ) {
          var l = t[n];
          this.set(l[0], l[1]);
        }
      }
      function Zv() {
        this.size = 0, this.__data__ = {
          hash: new cr(),
          map: new (sa || Fn)(),
          string: new cr()
        };
      }
      function Kv(t) {
        var n = fi(this, t).delete(t);
        return this.size -= n ? 1 : 0, n;
      }
      function Xv(t) {
        return fi(this, t).get(t);
      }
      function Jv(t) {
        return fi(this, t).has(t);
      }
      function Qv(t, n) {
        var i = fi(this, t), l = i.size;
        return i.set(t, n), this.size += i.size == l ? 0 : 1, this;
      }
      En.prototype.clear = Zv, En.prototype.delete = Kv, En.prototype.get = Xv, En.prototype.has = Jv, En.prototype.set = Qv;
      function dr(t) {
        var n = -1, i = t == null ? 0 : t.length;
        for (this.__data__ = new En(); ++n < i; )
          this.add(t[n]);
      }
      function jv(t) {
        return this.__data__.set(t, c), this;
      }
      function ep(t) {
        return this.__data__.has(t);
      }
      dr.prototype.add = dr.prototype.push = jv, dr.prototype.has = ep;
      function pn(t) {
        var n = this.__data__ = new Fn(t);
        this.size = n.size;
      }
      function tp() {
        this.__data__ = new Fn(), this.size = 0;
      }
      function np(t) {
        var n = this.__data__, i = n.delete(t);
        return this.size = n.size, i;
      }
      function rp(t) {
        return this.__data__.get(t);
      }
      function ap(t) {
        return this.__data__.has(t);
      }
      function ip(t, n) {
        var i = this.__data__;
        if (i instanceof Fn) {
          var l = i.__data__;
          if (!sa || l.length < o - 1)
            return l.push([t, n]), this.size = ++i.size, this;
          i = this.__data__ = new En(l);
        }
        return i.set(t, n), this.size = i.size, this;
      }
      pn.prototype.clear = tp, pn.prototype.delete = np, pn.prototype.get = rp, pn.prototype.has = ap, pn.prototype.set = ip;
      function Ml(t, n) {
        var i = Le(t), l = !i && gr(t), p = !i && !l && tr(t), _ = !i && !l && !p && zr(t), k = i || l || p || _, A = k ? is(t.length, hv) : [], E = A.length;
        for (var Z in t)
          (n || et.call(t, Z)) && !(k && // Safari 9 has enumerable `arguments.length` in strict mode.
          (Z == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          p && (Z == "offset" || Z == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          _ && (Z == "buffer" || Z == "byteLength" || Z == "byteOffset") || // Skip index properties.
          Nn(Z, E))) && A.push(Z);
        return A;
      }
      function xl(t) {
        var n = t.length;
        return n ? t[$s(0, n - 1)] : r;
      }
      function sp(t, n) {
        return vi(Pt(t), fr(n, 0, t.length));
      }
      function op(t) {
        return vi(Pt(t));
      }
      function fs(t, n, i) {
        (i !== r && !hn(t[n], i) || i === r && !(n in t)) && Pn(t, n, i);
      }
      function ca(t, n, i) {
        var l = t[n];
        (!(et.call(t, n) && hn(l, i)) || i === r && !(n in t)) && Pn(t, n, i);
      }
      function ei(t, n) {
        for (var i = t.length; i--; )
          if (hn(t[i][0], n))
            return i;
        return -1;
      }
      function lp(t, n, i, l) {
        return Jn(t, function(p, _, k) {
          n(l, p, i(p), k);
        }), l;
      }
      function Ll(t, n) {
        return t && qn(n, $t(n), t);
      }
      function up(t, n) {
        return t && qn(n, Rt(n), t);
      }
      function Pn(t, n, i) {
        n == "__proto__" && Za ? Za(t, n, {
          configurable: !0,
          enumerable: !0,
          value: i,
          writable: !0
        }) : t[n] = i;
      }
      function vs(t, n) {
        for (var i = -1, l = n.length, p = H(l), _ = t == null; ++i < l; )
          p[i] = _ ? r : Gs(t, n[i]);
        return p;
      }
      function fr(t, n, i) {
        return t === t && (i !== r && (t = t <= i ? t : i), n !== r && (t = t >= n ? t : n)), t;
      }
      function nn(t, n, i, l, p, _) {
        var k, A = n & q, E = n & C, Z = n & O;
        if (i && (k = p ? i(t, l, p, _) : i(t)), k !== r)
          return k;
        if (!ct(t))
          return t;
        var X = Le(t);
        if (X) {
          if (k = Jp(t), !A)
            return Pt(t, k);
        } else {
          var j = At(t), pe = j == he || j == je;
          if (tr(t))
            return iu(t, A);
          if (j == ht || j == Me || pe && !p) {
            if (k = E || pe ? {} : Su(t), !A)
              return E ? Rp(t, up(k, t)) : zp(t, Ll(k, t));
          } else {
            if (!ot[j])
              return p ? t : {};
            k = Qp(t, j, A);
          }
        }
        _ || (_ = new pn());
        var _e = _.get(t);
        if (_e)
          return _e;
        _.set(t, k), ju(t) ? t.forEach(function(Ae) {
          k.add(nn(Ae, n, i, Ae, t, _));
        }) : Ju(t) && t.forEach(function(Ae, He) {
          k.set(He, nn(Ae, n, i, He, t, _));
        });
        var Be = Z ? E ? Ms : Is : E ? Rt : $t, Ee = X ? r : Be(t);
        return jt(Ee || t, function(Ae, He) {
          Ee && (He = Ae, Ae = t[He]), ca(k, He, nn(Ae, n, i, He, t, _));
        }), k;
      }
      function cp(t) {
        var n = $t(t);
        return function(i) {
          return Fl(i, t, n);
        };
      }
      function Fl(t, n, i) {
        var l = i.length;
        if (t == null)
          return !l;
        for (t = rt(t); l--; ) {
          var p = i[l], _ = n[p], k = t[p];
          if (k === r && !(p in t) || !_(k))
            return !1;
        }
        return !0;
      }
      function El(t, n, i) {
        if (typeof t != "function")
          throw new en(u);
        return ma(function() {
          t.apply(r, i);
        }, n);
      }
      function da(t, n, i, l) {
        var p = -1, _ = Ea, k = !0, A = t.length, E = [], Z = n.length;
        if (!A)
          return E;
        i && (n = ut(n, Ut(i))), l ? (_ = ji, k = !1) : n.length >= o && (_ = aa, k = !1, n = new dr(n));
        e:
          for (; ++p < A; ) {
            var X = t[p], j = i == null ? X : i(X);
            if (X = l || X !== 0 ? X : 0, k && j === j) {
              for (var pe = Z; pe--; )
                if (n[pe] === j)
                  continue e;
              E.push(X);
            } else _(n, j, l) || E.push(X);
          }
        return E;
      }
      var Jn = cu(kn), Pl = cu(hs, !0);
      function dp(t, n) {
        var i = !0;
        return Jn(t, function(l, p, _) {
          return i = !!n(l, p, _), i;
        }), i;
      }
      function ti(t, n, i) {
        for (var l = -1, p = t.length; ++l < p; ) {
          var _ = t[l], k = n(_);
          if (k != null && (A === r ? k === k && !Gt(k) : i(k, A)))
            var A = k, E = _;
        }
        return E;
      }
      function fp(t, n, i, l) {
        var p = t.length;
        for (i = Fe(i), i < 0 && (i = -i > p ? 0 : p + i), l = l === r || l > p ? p : Fe(l), l < 0 && (l += p), l = i > l ? 0 : tc(l); i < l; )
          t[i++] = n;
        return t;
      }
      function zl(t, n) {
        var i = [];
        return Jn(t, function(l, p, _) {
          n(l, p, _) && i.push(l);
        }), i;
      }
      function qt(t, n, i, l, p) {
        var _ = -1, k = t.length;
        for (i || (i = eh), p || (p = []); ++_ < k; ) {
          var A = t[_];
          n > 0 && i(A) ? n > 1 ? qt(A, n - 1, i, l, p) : Zn(p, A) : l || (p[p.length] = A);
        }
        return p;
      }
      var ps = du(), Rl = du(!0);
      function kn(t, n) {
        return t && ps(t, n, $t);
      }
      function hs(t, n) {
        return t && Rl(t, n, $t);
      }
      function ni(t, n) {
        return Gn(n, function(i) {
          return Hn(t[i]);
        });
      }
      function vr(t, n) {
        n = jn(n, t);
        for (var i = 0, l = n.length; t != null && i < l; )
          t = t[Dn(n[i++])];
        return i && i == l ? t : r;
      }
      function Nl(t, n, i) {
        var l = n(t);
        return Le(t) ? l : Zn(l, i(t));
      }
      function It(t) {
        return t == null ? t === r ? or : Ot : ur && ur in rt(t) ? Zp(t) : oh(t);
      }
      function gs(t, n) {
        return t > n;
      }
      function vp(t, n) {
        return t != null && et.call(t, n);
      }
      function pp(t, n) {
        return t != null && n in rt(t);
      }
      function hp(t, n, i) {
        return t >= Bt(n, i) && t < _t(n, i);
      }
      function ms(t, n, i) {
        for (var l = i ? ji : Ea, p = t[0].length, _ = t.length, k = _, A = H(_), E = 1 / 0, Z = []; k--; ) {
          var X = t[k];
          k && n && (X = ut(X, Ut(n))), E = Bt(X.length, E), A[k] = !i && (n || p >= 120 && X.length >= 120) ? new dr(k && X) : r;
        }
        X = t[0];
        var j = -1, pe = A[0];
        e:
          for (; ++j < p && Z.length < E; ) {
            var _e = X[j], Be = n ? n(_e) : _e;
            if (_e = i || _e !== 0 ? _e : 0, !(pe ? aa(pe, Be) : l(Z, Be, i))) {
              for (k = _; --k; ) {
                var Ee = A[k];
                if (!(Ee ? aa(Ee, Be) : l(t[k], Be, i)))
                  continue e;
              }
              pe && pe.push(Be), Z.push(_e);
            }
          }
        return Z;
      }
      function gp(t, n, i, l) {
        return kn(t, function(p, _, k) {
          n(l, i(p), _, k);
        }), l;
      }
      function fa(t, n, i) {
        n = jn(n, t), t = Bu(t, n);
        var l = t == null ? t : t[Dn(an(n))];
        return l == null ? r : Yt(l, t, i);
      }
      function Hl(t) {
        return ft(t) && It(t) == Me;
      }
      function mp(t) {
        return ft(t) && It(t) == Sn;
      }
      function yp(t) {
        return ft(t) && It(t) == ke;
      }
      function va(t, n, i, l, p) {
        return t === n ? !0 : t == null || n == null || !ft(t) && !ft(n) ? t !== t && n !== n : bp(t, n, i, l, va, p);
      }
      function bp(t, n, i, l, p, _) {
        var k = Le(t), A = Le(n), E = k ? Ne : At(t), Z = A ? Ne : At(n);
        E = E == Me ? ht : E, Z = Z == Me ? ht : Z;
        var X = E == ht, j = Z == ht, pe = E == Z;
        if (pe && tr(t)) {
          if (!tr(n))
            return !1;
          k = !0, X = !1;
        }
        if (pe && !X)
          return _ || (_ = new pn()), k || zr(t) ? wu(t, n, i, l, p, _) : Wp(t, n, E, i, l, p, _);
        if (!(i & S)) {
          var _e = X && et.call(t, "__wrapped__"), Be = j && et.call(n, "__wrapped__");
          if (_e || Be) {
            var Ee = _e ? t.value() : t, Ae = Be ? n.value() : n;
            return _ || (_ = new pn()), p(Ee, Ae, i, l, _);
          }
        }
        return pe ? (_ || (_ = new pn()), Gp(t, n, i, l, p, _)) : !1;
      }
      function _p(t) {
        return ft(t) && At(t) == Ze;
      }
      function ys(t, n, i, l) {
        var p = i.length, _ = p, k = !l;
        if (t == null)
          return !_;
        for (t = rt(t); p--; ) {
          var A = i[p];
          if (k && A[2] ? A[1] !== t[A[0]] : !(A[0] in t))
            return !1;
        }
        for (; ++p < _; ) {
          A = i[p];
          var E = A[0], Z = t[E], X = A[1];
          if (k && A[2]) {
            if (Z === r && !(E in t))
              return !1;
          } else {
            var j = new pn();
            if (l)
              var pe = l(Z, X, E, t, n, j);
            if (!(pe === r ? va(X, Z, S | I, l, j) : pe))
              return !1;
          }
        }
        return !0;
      }
      function Vl(t) {
        if (!ct(t) || nh(t))
          return !1;
        var n = Hn(t) ? _v : cf;
        return n.test(hr(t));
      }
      function wp(t) {
        return ft(t) && It(t) == Dt;
      }
      function $p(t) {
        return ft(t) && At(t) == yt;
      }
      function Cp(t) {
        return ft(t) && bi(t.length) && !!lt[It(t)];
      }
      function Yl(t) {
        return typeof t == "function" ? t : t == null ? Nt : typeof t == "object" ? Le(t) ? Gl(t[0], t[1]) : Wl(t) : fc(t);
      }
      function bs(t) {
        if (!ga(t))
          return qv(t);
        var n = [];
        for (var i in rt(t))
          et.call(t, i) && i != "constructor" && n.push(i);
        return n;
      }
      function Sp(t) {
        if (!ct(t))
          return sh(t);
        var n = ga(t), i = [];
        for (var l in t)
          l == "constructor" && (n || !et.call(t, l)) || i.push(l);
        return i;
      }
      function _s(t, n) {
        return t < n;
      }
      function Ul(t, n) {
        var i = -1, l = zt(t) ? H(t.length) : [];
        return Jn(t, function(p, _, k) {
          l[++i] = n(p, _, k);
        }), l;
      }
      function Wl(t) {
        var n = Ls(t);
        return n.length == 1 && n[0][2] ? qu(n[0][0], n[0][1]) : function(i) {
          return i === t || ys(i, t, n);
        };
      }
      function Gl(t, n) {
        return Es(t) && ku(n) ? qu(Dn(t), n) : function(i) {
          var l = Gs(i, t);
          return l === r && l === n ? Zs(i, t) : va(n, l, S | I);
        };
      }
      function ri(t, n, i, l, p) {
        t !== n && ps(n, function(_, k) {
          if (p || (p = new pn()), ct(_))
            kp(t, n, k, i, ri, l, p);
          else {
            var A = l ? l(zs(t, k), _, k + "", t, n, p) : r;
            A === r && (A = _), fs(t, k, A);
          }
        }, Rt);
      }
      function kp(t, n, i, l, p, _, k) {
        var A = zs(t, i), E = zs(n, i), Z = k.get(E);
        if (Z) {
          fs(t, i, Z);
          return;
        }
        var X = _ ? _(A, E, i + "", t, n, k) : r, j = X === r;
        if (j) {
          var pe = Le(E), _e = !pe && tr(E), Be = !pe && !_e && zr(E);
          X = E, pe || _e || Be ? Le(A) ? X = A : gt(A) ? X = Pt(A) : _e ? (j = !1, X = iu(E, !0)) : Be ? (j = !1, X = su(E, !0)) : X = [] : ya(E) || gr(E) ? (X = A, gr(A) ? X = nc(A) : (!ct(A) || Hn(A)) && (X = Su(E))) : j = !1;
        }
        j && (k.set(E, X), p(X, E, l, _, k), k.delete(E)), fs(t, i, X);
      }
      function Zl(t, n) {
        var i = t.length;
        if (i)
          return n += n < 0 ? i : 0, Nn(n, i) ? t[n] : r;
      }
      function Kl(t, n, i) {
        n.length ? n = ut(n, function(_) {
          return Le(_) ? function(k) {
            return vr(k, _.length === 1 ? _[0] : _);
          } : _;
        }) : n = [Nt];
        var l = -1;
        n = ut(n, Ut(qe()));
        var p = Ul(t, function(_, k, A) {
          var E = ut(n, function(Z) {
            return Z(_);
          });
          return { criteria: E, index: ++l, value: _ };
        });
        return Qf(p, function(_, k) {
          return Pp(_, k, i);
        });
      }
      function qp(t, n) {
        return Xl(t, n, function(i, l) {
          return Zs(t, l);
        });
      }
      function Xl(t, n, i) {
        for (var l = -1, p = n.length, _ = {}; ++l < p; ) {
          var k = n[l], A = vr(t, k);
          i(A, k) && pa(_, jn(k, t), A);
        }
        return _;
      }
      function Dp(t) {
        return function(n) {
          return vr(n, t);
        };
      }
      function ws(t, n, i, l) {
        var p = l ? Jf : Br, _ = -1, k = n.length, A = t;
        for (t === n && (n = Pt(n)), i && (A = ut(t, Ut(i))); ++_ < k; )
          for (var E = 0, Z = n[_], X = i ? i(Z) : Z; (E = p(A, X, E, l)) > -1; )
            A !== t && Ga.call(A, E, 1), Ga.call(t, E, 1);
        return t;
      }
      function Jl(t, n) {
        for (var i = t ? n.length : 0, l = i - 1; i--; ) {
          var p = n[i];
          if (i == l || p !== _) {
            var _ = p;
            Nn(p) ? Ga.call(t, p, 1) : ks(t, p);
          }
        }
        return t;
      }
      function $s(t, n) {
        return t + Xa(Ol() * (n - t + 1));
      }
      function Bp(t, n, i, l) {
        for (var p = -1, _ = _t(Ka((n - t) / (i || 1)), 0), k = H(_); _--; )
          k[l ? _ : ++p] = t, t += i;
        return k;
      }
      function Cs(t, n) {
        var i = "";
        if (!t || n < 1 || n > G)
          return i;
        do
          n % 2 && (i += t), n = Xa(n / 2), n && (t += t);
        while (n);
        return i;
      }
      function Pe(t, n) {
        return Rs(Du(t, n, Nt), t + "");
      }
      function Ap(t) {
        return xl(Rr(t));
      }
      function Tp(t, n) {
        var i = Rr(t);
        return vi(i, fr(n, 0, i.length));
      }
      function pa(t, n, i, l) {
        if (!ct(t))
          return t;
        n = jn(n, t);
        for (var p = -1, _ = n.length, k = _ - 1, A = t; A != null && ++p < _; ) {
          var E = Dn(n[p]), Z = i;
          if (E === "__proto__" || E === "constructor" || E === "prototype")
            return t;
          if (p != k) {
            var X = A[E];
            Z = l ? l(X, E, A) : r, Z === r && (Z = ct(X) ? X : Nn(n[p + 1]) ? [] : {});
          }
          ca(A, E, Z), A = A[E];
        }
        return t;
      }
      var Ql = Ja ? function(t, n) {
        return Ja.set(t, n), t;
      } : Nt, Op = Za ? function(t, n) {
        return Za(t, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Xs(n),
          writable: !0
        });
      } : Nt;
      function Ip(t) {
        return vi(Rr(t));
      }
      function rn(t, n, i) {
        var l = -1, p = t.length;
        n < 0 && (n = -n > p ? 0 : p + n), i = i > p ? p : i, i < 0 && (i += p), p = n > i ? 0 : i - n >>> 0, n >>>= 0;
        for (var _ = H(p); ++l < p; )
          _[l] = t[l + n];
        return _;
      }
      function Mp(t, n) {
        var i;
        return Jn(t, function(l, p, _) {
          return i = n(l, p, _), !i;
        }), !!i;
      }
      function ai(t, n, i) {
        var l = 0, p = t == null ? l : t.length;
        if (typeof n == "number" && n === n && p <= ue) {
          for (; l < p; ) {
            var _ = l + p >>> 1, k = t[_];
            k !== null && !Gt(k) && (i ? k <= n : k < n) ? l = _ + 1 : p = _;
          }
          return p;
        }
        return Ss(t, n, Nt, i);
      }
      function Ss(t, n, i, l) {
        var p = 0, _ = t == null ? 0 : t.length;
        if (_ === 0)
          return 0;
        n = i(n);
        for (var k = n !== n, A = n === null, E = Gt(n), Z = n === r; p < _; ) {
          var X = Xa((p + _) / 2), j = i(t[X]), pe = j !== r, _e = j === null, Be = j === j, Ee = Gt(j);
          if (k)
            var Ae = l || Be;
          else Z ? Ae = Be && (l || pe) : A ? Ae = Be && pe && (l || !_e) : E ? Ae = Be && pe && !_e && (l || !Ee) : _e || Ee ? Ae = !1 : Ae = l ? j <= n : j < n;
          Ae ? p = X + 1 : _ = X;
        }
        return Bt(_, ne);
      }
      function jl(t, n) {
        for (var i = -1, l = t.length, p = 0, _ = []; ++i < l; ) {
          var k = t[i], A = n ? n(k) : k;
          if (!i || !hn(A, E)) {
            var E = A;
            _[p++] = k === 0 ? 0 : k;
          }
        }
        return _;
      }
      function eu(t) {
        return typeof t == "number" ? t : Gt(t) ? ge : +t;
      }
      function Wt(t) {
        if (typeof t == "string")
          return t;
        if (Le(t))
          return ut(t, Wt) + "";
        if (Gt(t))
          return Il ? Il.call(t) : "";
        var n = t + "";
        return n == "0" && 1 / t == -te ? "-0" : n;
      }
      function Qn(t, n, i) {
        var l = -1, p = Ea, _ = t.length, k = !0, A = [], E = A;
        if (i)
          k = !1, p = ji;
        else if (_ >= o) {
          var Z = n ? null : Yp(t);
          if (Z)
            return za(Z);
          k = !1, p = aa, E = new dr();
        } else
          E = n ? [] : A;
        e:
          for (; ++l < _; ) {
            var X = t[l], j = n ? n(X) : X;
            if (X = i || X !== 0 ? X : 0, k && j === j) {
              for (var pe = E.length; pe--; )
                if (E[pe] === j)
                  continue e;
              n && E.push(j), A.push(X);
            } else p(E, j, i) || (E !== A && E.push(j), A.push(X));
          }
        return A;
      }
      function ks(t, n) {
        return n = jn(n, t), t = Bu(t, n), t == null || delete t[Dn(an(n))];
      }
      function tu(t, n, i, l) {
        return pa(t, n, i(vr(t, n)), l);
      }
      function ii(t, n, i, l) {
        for (var p = t.length, _ = l ? p : -1; (l ? _-- : ++_ < p) && n(t[_], _, t); )
          ;
        return i ? rn(t, l ? 0 : _, l ? _ + 1 : p) : rn(t, l ? _ + 1 : 0, l ? p : _);
      }
      function nu(t, n) {
        var i = t;
        return i instanceof Ye && (i = i.value()), es(n, function(l, p) {
          return p.func.apply(p.thisArg, Zn([l], p.args));
        }, i);
      }
      function qs(t, n, i) {
        var l = t.length;
        if (l < 2)
          return l ? Qn(t[0]) : [];
        for (var p = -1, _ = H(l); ++p < l; )
          for (var k = t[p], A = -1; ++A < l; )
            A != p && (_[p] = da(_[p] || k, t[A], n, i));
        return Qn(qt(_, 1), n, i);
      }
      function ru(t, n, i) {
        for (var l = -1, p = t.length, _ = n.length, k = {}; ++l < p; ) {
          var A = l < _ ? n[l] : r;
          i(k, t[l], A);
        }
        return k;
      }
      function Ds(t) {
        return gt(t) ? t : [];
      }
      function Bs(t) {
        return typeof t == "function" ? t : Nt;
      }
      function jn(t, n) {
        return Le(t) ? t : Es(t, n) ? [t] : Iu(Qe(t));
      }
      var xp = Pe;
      function er(t, n, i) {
        var l = t.length;
        return i = i === r ? l : i, !n && i >= l ? t : rn(t, n, i);
      }
      var au = wv || function(t) {
        return kt.clearTimeout(t);
      };
      function iu(t, n) {
        if (n)
          return t.slice();
        var i = t.length, l = ql ? ql(i) : new t.constructor(i);
        return t.copy(l), l;
      }
      function As(t) {
        var n = new t.constructor(t.byteLength);
        return new Ua(n).set(new Ua(t)), n;
      }
      function Lp(t, n) {
        var i = n ? As(t.buffer) : t.buffer;
        return new t.constructor(i, t.byteOffset, t.byteLength);
      }
      function Fp(t) {
        var n = new t.constructor(t.source, Ho.exec(t));
        return n.lastIndex = t.lastIndex, n;
      }
      function Ep(t) {
        return ua ? rt(ua.call(t)) : {};
      }
      function su(t, n) {
        var i = n ? As(t.buffer) : t.buffer;
        return new t.constructor(i, t.byteOffset, t.length);
      }
      function ou(t, n) {
        if (t !== n) {
          var i = t !== r, l = t === null, p = t === t, _ = Gt(t), k = n !== r, A = n === null, E = n === n, Z = Gt(n);
          if (!A && !Z && !_ && t > n || _ && k && E && !A && !Z || l && k && E || !i && E || !p)
            return 1;
          if (!l && !_ && !Z && t < n || Z && i && p && !l && !_ || A && i && p || !k && p || !E)
            return -1;
        }
        return 0;
      }
      function Pp(t, n, i) {
        for (var l = -1, p = t.criteria, _ = n.criteria, k = p.length, A = i.length; ++l < k; ) {
          var E = ou(p[l], _[l]);
          if (E) {
            if (l >= A)
              return E;
            var Z = i[l];
            return E * (Z == "desc" ? -1 : 1);
          }
        }
        return t.index - n.index;
      }
      function lu(t, n, i, l) {
        for (var p = -1, _ = t.length, k = i.length, A = -1, E = n.length, Z = _t(_ - k, 0), X = H(E + Z), j = !l; ++A < E; )
          X[A] = n[A];
        for (; ++p < k; )
          (j || p < _) && (X[i[p]] = t[p]);
        for (; Z--; )
          X[A++] = t[p++];
        return X;
      }
      function uu(t, n, i, l) {
        for (var p = -1, _ = t.length, k = -1, A = i.length, E = -1, Z = n.length, X = _t(_ - A, 0), j = H(X + Z), pe = !l; ++p < X; )
          j[p] = t[p];
        for (var _e = p; ++E < Z; )
          j[_e + E] = n[E];
        for (; ++k < A; )
          (pe || p < _) && (j[_e + i[k]] = t[p++]);
        return j;
      }
      function Pt(t, n) {
        var i = -1, l = t.length;
        for (n || (n = H(l)); ++i < l; )
          n[i] = t[i];
        return n;
      }
      function qn(t, n, i, l) {
        var p = !i;
        i || (i = {});
        for (var _ = -1, k = n.length; ++_ < k; ) {
          var A = n[_], E = l ? l(i[A], t[A], A, i, t) : r;
          E === r && (E = t[A]), p ? Pn(i, A, E) : ca(i, A, E);
        }
        return i;
      }
      function zp(t, n) {
        return qn(t, Fs(t), n);
      }
      function Rp(t, n) {
        return qn(t, $u(t), n);
      }
      function si(t, n) {
        return function(i, l) {
          var p = Le(i) ? Uf : lp, _ = n ? n() : {};
          return p(i, t, qe(l, 2), _);
        };
      }
      function Fr(t) {
        return Pe(function(n, i) {
          var l = -1, p = i.length, _ = p > 1 ? i[p - 1] : r, k = p > 2 ? i[2] : r;
          for (_ = t.length > 3 && typeof _ == "function" ? (p--, _) : r, k && Mt(i[0], i[1], k) && (_ = p < 3 ? r : _, p = 1), n = rt(n); ++l < p; ) {
            var A = i[l];
            A && t(n, A, l, _);
          }
          return n;
        });
      }
      function cu(t, n) {
        return function(i, l) {
          if (i == null)
            return i;
          if (!zt(i))
            return t(i, l);
          for (var p = i.length, _ = n ? p : -1, k = rt(i); (n ? _-- : ++_ < p) && l(k[_], _, k) !== !1; )
            ;
          return i;
        };
      }
      function du(t) {
        return function(n, i, l) {
          for (var p = -1, _ = rt(n), k = l(n), A = k.length; A--; ) {
            var E = k[t ? A : ++p];
            if (i(_[E], E, _) === !1)
              break;
          }
          return n;
        };
      }
      function Np(t, n, i) {
        var l = n & M, p = ha(t);
        function _() {
          var k = this && this !== kt && this instanceof _ ? p : t;
          return k.apply(l ? i : this, arguments);
        }
        return _;
      }
      function fu(t) {
        return function(n) {
          n = Qe(n);
          var i = Ar(n) ? vn(n) : r, l = i ? i[0] : n.charAt(0), p = i ? er(i, 1).join("") : n.slice(1);
          return l[t]() + p;
        };
      }
      function Er(t) {
        return function(n) {
          return es(cc(uc(n).replace(Of, "")), t, "");
        };
      }
      function ha(t) {
        return function() {
          var n = arguments;
          switch (n.length) {
            case 0:
              return new t();
            case 1:
              return new t(n[0]);
            case 2:
              return new t(n[0], n[1]);
            case 3:
              return new t(n[0], n[1], n[2]);
            case 4:
              return new t(n[0], n[1], n[2], n[3]);
            case 5:
              return new t(n[0], n[1], n[2], n[3], n[4]);
            case 6:
              return new t(n[0], n[1], n[2], n[3], n[4], n[5]);
            case 7:
              return new t(n[0], n[1], n[2], n[3], n[4], n[5], n[6]);
          }
          var i = Lr(t.prototype), l = t.apply(i, n);
          return ct(l) ? l : i;
        };
      }
      function Hp(t, n, i) {
        var l = ha(t);
        function p() {
          for (var _ = arguments.length, k = H(_), A = _, E = Pr(p); A--; )
            k[A] = arguments[A];
          var Z = _ < 3 && k[0] !== E && k[_ - 1] !== E ? [] : Kn(k, E);
          if (_ -= Z.length, _ < i)
            return mu(
              t,
              n,
              oi,
              p.placeholder,
              r,
              k,
              Z,
              r,
              r,
              i - _
            );
          var X = this && this !== kt && this instanceof p ? l : t;
          return Yt(X, this, k);
        }
        return p;
      }
      function vu(t) {
        return function(n, i, l) {
          var p = rt(n);
          if (!zt(n)) {
            var _ = qe(i, 3);
            n = $t(n), i = function(A) {
              return _(p[A], A, p);
            };
          }
          var k = t(n, i, l);
          return k > -1 ? p[_ ? n[k] : k] : r;
        };
      }
      function pu(t) {
        return Rn(function(n) {
          var i = n.length, l = i, p = tn.prototype.thru;
          for (t && n.reverse(); l--; ) {
            var _ = n[l];
            if (typeof _ != "function")
              throw new en(u);
            if (p && !k && di(_) == "wrapper")
              var k = new tn([], !0);
          }
          for (l = k ? l : i; ++l < i; ) {
            _ = n[l];
            var A = di(_), E = A == "wrapper" ? xs(_) : r;
            E && Ps(E[0]) && E[1] == (T | x | Y | z) && !E[4].length && E[9] == 1 ? k = k[di(E[0])].apply(k, E[3]) : k = _.length == 1 && Ps(_) ? k[A]() : k.thru(_);
          }
          return function() {
            var Z = arguments, X = Z[0];
            if (k && Z.length == 1 && Le(X))
              return k.plant(X).value();
            for (var j = 0, pe = i ? n[j].apply(this, Z) : X; ++j < i; )
              pe = n[j].call(this, pe);
            return pe;
          };
        });
      }
      function oi(t, n, i, l, p, _, k, A, E, Z) {
        var X = n & T, j = n & M, pe = n & F, _e = n & (x | $), Be = n & le, Ee = pe ? r : ha(t);
        function Ae() {
          for (var He = arguments.length, We = H(He), Zt = He; Zt--; )
            We[Zt] = arguments[Zt];
          if (_e)
            var xt = Pr(Ae), Kt = ev(We, xt);
          if (l && (We = lu(We, l, p, _e)), _ && (We = uu(We, _, k, _e)), He -= Kt, _e && He < Z) {
            var mt = Kn(We, xt);
            return mu(
              t,
              n,
              oi,
              Ae.placeholder,
              i,
              We,
              mt,
              A,
              E,
              Z - He
            );
          }
          var gn = j ? i : this, Yn = pe ? gn[t] : t;
          return He = We.length, A ? We = lh(We, A) : Be && He > 1 && We.reverse(), X && E < He && (We.length = E), this && this !== kt && this instanceof Ae && (Yn = Ee || ha(Yn)), Yn.apply(gn, We);
        }
        return Ae;
      }
      function hu(t, n) {
        return function(i, l) {
          return gp(i, t, n(l), {});
        };
      }
      function li(t, n) {
        return function(i, l) {
          var p;
          if (i === r && l === r)
            return n;
          if (i !== r && (p = i), l !== r) {
            if (p === r)
              return l;
            typeof i == "string" || typeof l == "string" ? (i = Wt(i), l = Wt(l)) : (i = eu(i), l = eu(l)), p = t(i, l);
          }
          return p;
        };
      }
      function Ts(t) {
        return Rn(function(n) {
          return n = ut(n, Ut(qe())), Pe(function(i) {
            var l = this;
            return t(n, function(p) {
              return Yt(p, l, i);
            });
          });
        });
      }
      function ui(t, n) {
        n = n === r ? " " : Wt(n);
        var i = n.length;
        if (i < 2)
          return i ? Cs(n, t) : n;
        var l = Cs(n, Ka(t / Tr(n)));
        return Ar(n) ? er(vn(l), 0, t).join("") : l.slice(0, t);
      }
      function Vp(t, n, i, l) {
        var p = n & M, _ = ha(t);
        function k() {
          for (var A = -1, E = arguments.length, Z = -1, X = l.length, j = H(X + E), pe = this && this !== kt && this instanceof k ? _ : t; ++Z < X; )
            j[Z] = l[Z];
          for (; E--; )
            j[Z++] = arguments[++A];
          return Yt(pe, p ? i : this, j);
        }
        return k;
      }
      function gu(t) {
        return function(n, i, l) {
          return l && typeof l != "number" && Mt(n, i, l) && (i = l = r), n = Vn(n), i === r ? (i = n, n = 0) : i = Vn(i), l = l === r ? n < i ? 1 : -1 : Vn(l), Bp(n, i, l, t);
        };
      }
      function ci(t) {
        return function(n, i) {
          return typeof n == "string" && typeof i == "string" || (n = sn(n), i = sn(i)), t(n, i);
        };
      }
      function mu(t, n, i, l, p, _, k, A, E, Z) {
        var X = n & x, j = X ? k : r, pe = X ? r : k, _e = X ? _ : r, Be = X ? r : _;
        n |= X ? Y : R, n &= ~(X ? R : Y), n & P || (n &= ~(M | F));
        var Ee = [
          t,
          n,
          p,
          _e,
          j,
          Be,
          pe,
          A,
          E,
          Z
        ], Ae = i.apply(r, Ee);
        return Ps(t) && Au(Ae, Ee), Ae.placeholder = l, Tu(Ae, t, n);
      }
      function Os(t) {
        var n = bt[t];
        return function(i, l) {
          if (i = sn(i), l = l == null ? 0 : Bt(Fe(l), 292), l && Tl(i)) {
            var p = (Qe(i) + "e").split("e"), _ = n(p[0] + "e" + (+p[1] + l));
            return p = (Qe(_) + "e").split("e"), +(p[0] + "e" + (+p[1] - l));
          }
          return n(i);
        };
      }
      var Yp = Mr && 1 / za(new Mr([, -0]))[1] == te ? function(t) {
        return new Mr(t);
      } : js;
      function yu(t) {
        return function(n) {
          var i = At(n);
          return i == Ze ? os(n) : i == yt ? ov(n) : jf(n, t(n));
        };
      }
      function zn(t, n, i, l, p, _, k, A) {
        var E = n & F;
        if (!E && typeof t != "function")
          throw new en(u);
        var Z = l ? l.length : 0;
        if (Z || (n &= ~(Y | R), l = p = r), k = k === r ? k : _t(Fe(k), 0), A = A === r ? A : Fe(A), Z -= p ? p.length : 0, n & R) {
          var X = l, j = p;
          l = p = r;
        }
        var pe = E ? r : xs(t), _e = [
          t,
          n,
          i,
          l,
          p,
          X,
          j,
          _,
          k,
          A
        ];
        if (pe && ih(_e, pe), t = _e[0], n = _e[1], i = _e[2], l = _e[3], p = _e[4], A = _e[9] = _e[9] === r ? E ? 0 : t.length : _t(_e[9] - Z, 0), !A && n & (x | $) && (n &= ~(x | $)), !n || n == M)
          var Be = Np(t, n, i);
        else n == x || n == $ ? Be = Hp(t, n, A) : (n == Y || n == (M | Y)) && !p.length ? Be = Vp(t, n, i, l) : Be = oi.apply(r, _e);
        var Ee = pe ? Ql : Au;
        return Tu(Ee(Be, _e), t, n);
      }
      function bu(t, n, i, l) {
        return t === r || hn(t, Ir[i]) && !et.call(l, i) ? n : t;
      }
      function _u(t, n, i, l, p, _) {
        return ct(t) && ct(n) && (_.set(n, t), ri(t, n, r, _u, _), _.delete(n)), t;
      }
      function Up(t) {
        return ya(t) ? r : t;
      }
      function wu(t, n, i, l, p, _) {
        var k = i & S, A = t.length, E = n.length;
        if (A != E && !(k && E > A))
          return !1;
        var Z = _.get(t), X = _.get(n);
        if (Z && X)
          return Z == n && X == t;
        var j = -1, pe = !0, _e = i & I ? new dr() : r;
        for (_.set(t, n), _.set(n, t); ++j < A; ) {
          var Be = t[j], Ee = n[j];
          if (l)
            var Ae = k ? l(Ee, Be, j, n, t, _) : l(Be, Ee, j, t, n, _);
          if (Ae !== r) {
            if (Ae)
              continue;
            pe = !1;
            break;
          }
          if (_e) {
            if (!ts(n, function(He, We) {
              if (!aa(_e, We) && (Be === He || p(Be, He, i, l, _)))
                return _e.push(We);
            })) {
              pe = !1;
              break;
            }
          } else if (!(Be === Ee || p(Be, Ee, i, l, _))) {
            pe = !1;
            break;
          }
        }
        return _.delete(t), _.delete(n), pe;
      }
      function Wp(t, n, i, l, p, _, k) {
        switch (i) {
          case fn:
            if (t.byteLength != n.byteLength || t.byteOffset != n.byteOffset)
              return !1;
            t = t.buffer, n = n.buffer;
          case Sn:
            return !(t.byteLength != n.byteLength || !_(new Ua(t), new Ua(n)));
          case st:
          case ke:
          case wt:
            return hn(+t, +n);
          case Je:
            return t.name == n.name && t.message == n.message;
          case Dt:
          case dn:
            return t == n + "";
          case Ze:
            var A = os;
          case yt:
            var E = l & S;
            if (A || (A = za), t.size != n.size && !E)
              return !1;
            var Z = k.get(t);
            if (Z)
              return Z == n;
            l |= I, k.set(t, n);
            var X = wu(A(t), A(n), l, p, _, k);
            return k.delete(t), X;
          case Jt:
            if (ua)
              return ua.call(t) == ua.call(n);
        }
        return !1;
      }
      function Gp(t, n, i, l, p, _) {
        var k = i & S, A = Is(t), E = A.length, Z = Is(n), X = Z.length;
        if (E != X && !k)
          return !1;
        for (var j = E; j--; ) {
          var pe = A[j];
          if (!(k ? pe in n : et.call(n, pe)))
            return !1;
        }
        var _e = _.get(t), Be = _.get(n);
        if (_e && Be)
          return _e == n && Be == t;
        var Ee = !0;
        _.set(t, n), _.set(n, t);
        for (var Ae = k; ++j < E; ) {
          pe = A[j];
          var He = t[pe], We = n[pe];
          if (l)
            var Zt = k ? l(We, He, pe, n, t, _) : l(He, We, pe, t, n, _);
          if (!(Zt === r ? He === We || p(He, We, i, l, _) : Zt)) {
            Ee = !1;
            break;
          }
          Ae || (Ae = pe == "constructor");
        }
        if (Ee && !Ae) {
          var xt = t.constructor, Kt = n.constructor;
          xt != Kt && "constructor" in t && "constructor" in n && !(typeof xt == "function" && xt instanceof xt && typeof Kt == "function" && Kt instanceof Kt) && (Ee = !1);
        }
        return _.delete(t), _.delete(n), Ee;
      }
      function Rn(t) {
        return Rs(Du(t, r, Fu), t + "");
      }
      function Is(t) {
        return Nl(t, $t, Fs);
      }
      function Ms(t) {
        return Nl(t, Rt, $u);
      }
      var xs = Ja ? function(t) {
        return Ja.get(t);
      } : js;
      function di(t) {
        for (var n = t.name + "", i = xr[n], l = et.call(xr, n) ? i.length : 0; l--; ) {
          var p = i[l], _ = p.func;
          if (_ == null || _ == t)
            return p.name;
        }
        return n;
      }
      function Pr(t) {
        var n = et.call(b, "placeholder") ? b : t;
        return n.placeholder;
      }
      function qe() {
        var t = b.iteratee || Js;
        return t = t === Js ? Yl : t, arguments.length ? t(arguments[0], arguments[1]) : t;
      }
      function fi(t, n) {
        var i = t.__data__;
        return th(n) ? i[typeof n == "string" ? "string" : "hash"] : i.map;
      }
      function Ls(t) {
        for (var n = $t(t), i = n.length; i--; ) {
          var l = n[i], p = t[l];
          n[i] = [l, p, ku(p)];
        }
        return n;
      }
      function pr(t, n) {
        var i = av(t, n);
        return Vl(i) ? i : r;
      }
      function Zp(t) {
        var n = et.call(t, ur), i = t[ur];
        try {
          t[ur] = r;
          var l = !0;
        } catch {
        }
        var p = Va.call(t);
        return l && (n ? t[ur] = i : delete t[ur]), p;
      }
      var Fs = us ? function(t) {
        return t == null ? [] : (t = rt(t), Gn(us(t), function(n) {
          return Bl.call(t, n);
        }));
      } : eo, $u = us ? function(t) {
        for (var n = []; t; )
          Zn(n, Fs(t)), t = Wa(t);
        return n;
      } : eo, At = It;
      (cs && At(new cs(new ArrayBuffer(1))) != fn || sa && At(new sa()) != Ze || ds && At(ds.resolve()) != cn || Mr && At(new Mr()) != yt || oa && At(new oa()) != Cn) && (At = function(t) {
        var n = It(t), i = n == ht ? t.constructor : r, l = i ? hr(i) : "";
        if (l)
          switch (l) {
            case Tv:
              return fn;
            case Ov:
              return Ze;
            case Iv:
              return cn;
            case Mv:
              return yt;
            case xv:
              return Cn;
          }
        return n;
      });
      function Kp(t, n, i) {
        for (var l = -1, p = i.length; ++l < p; ) {
          var _ = i[l], k = _.size;
          switch (_.type) {
            case "drop":
              t += k;
              break;
            case "dropRight":
              n -= k;
              break;
            case "take":
              n = Bt(n, t + k);
              break;
            case "takeRight":
              t = _t(t, n - k);
              break;
          }
        }
        return { start: t, end: n };
      }
      function Xp(t) {
        var n = t.match(tf);
        return n ? n[1].split(nf) : [];
      }
      function Cu(t, n, i) {
        n = jn(n, t);
        for (var l = -1, p = n.length, _ = !1; ++l < p; ) {
          var k = Dn(n[l]);
          if (!(_ = t != null && i(t, k)))
            break;
          t = t[k];
        }
        return _ || ++l != p ? _ : (p = t == null ? 0 : t.length, !!p && bi(p) && Nn(k, p) && (Le(t) || gr(t)));
      }
      function Jp(t) {
        var n = t.length, i = new t.constructor(n);
        return n && typeof t[0] == "string" && et.call(t, "index") && (i.index = t.index, i.input = t.input), i;
      }
      function Su(t) {
        return typeof t.constructor == "function" && !ga(t) ? Lr(Wa(t)) : {};
      }
      function Qp(t, n, i) {
        var l = t.constructor;
        switch (n) {
          case Sn:
            return As(t);
          case st:
          case ke:
            return new l(+t);
          case fn:
            return Lp(t, i);
          case Xr:
          case Jr:
          case Qr:
          case jr:
          case ea:
          case U:
          case be:
          case De:
          case Ge:
            return su(t, i);
          case Ze:
            return new l();
          case wt:
          case dn:
            return new l(t);
          case Dt:
            return Fp(t);
          case yt:
            return new l();
          case Jt:
            return Ep(t);
        }
      }
      function jp(t, n) {
        var i = n.length;
        if (!i)
          return t;
        var l = i - 1;
        return n[l] = (i > 1 ? "& " : "") + n[l], n = n.join(i > 2 ? ", " : " "), t.replace(ef, `{
/* [wrapped with ` + n + `] */
`);
      }
      function eh(t) {
        return Le(t) || gr(t) || !!(Al && t && t[Al]);
      }
      function Nn(t, n) {
        var i = typeof t;
        return n = n ?? G, !!n && (i == "number" || i != "symbol" && ff.test(t)) && t > -1 && t % 1 == 0 && t < n;
      }
      function Mt(t, n, i) {
        if (!ct(i))
          return !1;
        var l = typeof n;
        return (l == "number" ? zt(i) && Nn(n, i.length) : l == "string" && n in i) ? hn(i[n], t) : !1;
      }
      function Es(t, n) {
        if (Le(t))
          return !1;
        var i = typeof t;
        return i == "number" || i == "symbol" || i == "boolean" || t == null || Gt(t) ? !0 : qr.test(t) || !ra.test(t) || n != null && t in rt(n);
      }
      function th(t) {
        var n = typeof t;
        return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
      }
      function Ps(t) {
        var n = di(t), i = b[n];
        if (typeof i != "function" || !(n in Ye.prototype))
          return !1;
        if (t === i)
          return !0;
        var l = xs(i);
        return !!l && t === l[0];
      }
      function nh(t) {
        return !!kl && kl in t;
      }
      var rh = Na ? Hn : to;
      function ga(t) {
        var n = t && t.constructor, i = typeof n == "function" && n.prototype || Ir;
        return t === i;
      }
      function ku(t) {
        return t === t && !ct(t);
      }
      function qu(t, n) {
        return function(i) {
          return i == null ? !1 : i[t] === n && (n !== r || t in rt(i));
        };
      }
      function ah(t) {
        var n = mi(t, function(l) {
          return i.size === g && i.clear(), l;
        }), i = n.cache;
        return n;
      }
      function ih(t, n) {
        var i = t[1], l = n[1], p = i | l, _ = p < (M | F | T), k = l == T && i == x || l == T && i == z && t[7].length <= n[8] || l == (T | z) && n[7].length <= n[8] && i == x;
        if (!(_ || k))
          return t;
        l & M && (t[2] = n[2], p |= i & M ? 0 : P);
        var A = n[3];
        if (A) {
          var E = t[3];
          t[3] = E ? lu(E, A, n[4]) : A, t[4] = E ? Kn(t[3], h) : n[4];
        }
        return A = n[5], A && (E = t[5], t[5] = E ? uu(E, A, n[6]) : A, t[6] = E ? Kn(t[5], h) : n[6]), A = n[7], A && (t[7] = A), l & T && (t[8] = t[8] == null ? n[8] : Bt(t[8], n[8])), t[9] == null && (t[9] = n[9]), t[0] = n[0], t[1] = p, t;
      }
      function sh(t) {
        var n = [];
        if (t != null)
          for (var i in rt(t))
            n.push(i);
        return n;
      }
      function oh(t) {
        return Va.call(t);
      }
      function Du(t, n, i) {
        return n = _t(n === r ? t.length - 1 : n, 0), function() {
          for (var l = arguments, p = -1, _ = _t(l.length - n, 0), k = H(_); ++p < _; )
            k[p] = l[n + p];
          p = -1;
          for (var A = H(n + 1); ++p < n; )
            A[p] = l[p];
          return A[n] = i(k), Yt(t, this, A);
        };
      }
      function Bu(t, n) {
        return n.length < 2 ? t : vr(t, rn(n, 0, -1));
      }
      function lh(t, n) {
        for (var i = t.length, l = Bt(n.length, i), p = Pt(t); l--; ) {
          var _ = n[l];
          t[l] = Nn(_, i) ? p[_] : r;
        }
        return t;
      }
      function zs(t, n) {
        if (!(n === "constructor" && typeof t[n] == "function") && n != "__proto__")
          return t[n];
      }
      var Au = Ou(Ql), ma = Cv || function(t, n) {
        return kt.setTimeout(t, n);
      }, Rs = Ou(Op);
      function Tu(t, n, i) {
        var l = n + "";
        return Rs(t, jp(l, uh(Xp(l), i)));
      }
      function Ou(t) {
        var n = 0, i = 0;
        return function() {
          var l = Dv(), p = ve - (l - i);
          if (i = l, p > 0) {
            if (++n >= oe)
              return arguments[0];
          } else
            n = 0;
          return t.apply(r, arguments);
        };
      }
      function vi(t, n) {
        var i = -1, l = t.length, p = l - 1;
        for (n = n === r ? l : n; ++i < n; ) {
          var _ = $s(i, p), k = t[_];
          t[_] = t[i], t[i] = k;
        }
        return t.length = n, t;
      }
      var Iu = ah(function(t) {
        var n = [];
        return t.charCodeAt(0) === 46 && n.push(""), t.replace(Jd, function(i, l, p, _) {
          n.push(p ? _.replace(sf, "$1") : l || i);
        }), n;
      });
      function Dn(t) {
        if (typeof t == "string" || Gt(t))
          return t;
        var n = t + "";
        return n == "0" && 1 / t == -te ? "-0" : n;
      }
      function hr(t) {
        if (t != null) {
          try {
            return Ha.call(t);
          } catch {
          }
          try {
            return t + "";
          } catch {
          }
        }
        return "";
      }
      function uh(t, n) {
        return jt(Se, function(i) {
          var l = "_." + i[0];
          n & i[1] && !Ea(t, l) && t.push(l);
        }), t.sort();
      }
      function Mu(t) {
        if (t instanceof Ye)
          return t.clone();
        var n = new tn(t.__wrapped__, t.__chain__);
        return n.__actions__ = Pt(t.__actions__), n.__index__ = t.__index__, n.__values__ = t.__values__, n;
      }
      function ch(t, n, i) {
        (i ? Mt(t, n, i) : n === r) ? n = 1 : n = _t(Fe(n), 0);
        var l = t == null ? 0 : t.length;
        if (!l || n < 1)
          return [];
        for (var p = 0, _ = 0, k = H(Ka(l / n)); p < l; )
          k[_++] = rn(t, p, p += n);
        return k;
      }
      function dh(t) {
        for (var n = -1, i = t == null ? 0 : t.length, l = 0, p = []; ++n < i; ) {
          var _ = t[n];
          _ && (p[l++] = _);
        }
        return p;
      }
      function fh() {
        var t = arguments.length;
        if (!t)
          return [];
        for (var n = H(t - 1), i = arguments[0], l = t; l--; )
          n[l - 1] = arguments[l];
        return Zn(Le(i) ? Pt(i) : [i], qt(n, 1));
      }
      var vh = Pe(function(t, n) {
        return gt(t) ? da(t, qt(n, 1, gt, !0)) : [];
      }), ph = Pe(function(t, n) {
        var i = an(n);
        return gt(i) && (i = r), gt(t) ? da(t, qt(n, 1, gt, !0), qe(i, 2)) : [];
      }), hh = Pe(function(t, n) {
        var i = an(n);
        return gt(i) && (i = r), gt(t) ? da(t, qt(n, 1, gt, !0), r, i) : [];
      });
      function gh(t, n, i) {
        var l = t == null ? 0 : t.length;
        return l ? (n = i || n === r ? 1 : Fe(n), rn(t, n < 0 ? 0 : n, l)) : [];
      }
      function mh(t, n, i) {
        var l = t == null ? 0 : t.length;
        return l ? (n = i || n === r ? 1 : Fe(n), n = l - n, rn(t, 0, n < 0 ? 0 : n)) : [];
      }
      function yh(t, n) {
        return t && t.length ? ii(t, qe(n, 3), !0, !0) : [];
      }
      function bh(t, n) {
        return t && t.length ? ii(t, qe(n, 3), !0) : [];
      }
      function _h(t, n, i, l) {
        var p = t == null ? 0 : t.length;
        return p ? (i && typeof i != "number" && Mt(t, n, i) && (i = 0, l = p), fp(t, n, i, l)) : [];
      }
      function xu(t, n, i) {
        var l = t == null ? 0 : t.length;
        if (!l)
          return -1;
        var p = i == null ? 0 : Fe(i);
        return p < 0 && (p = _t(l + p, 0)), Pa(t, qe(n, 3), p);
      }
      function Lu(t, n, i) {
        var l = t == null ? 0 : t.length;
        if (!l)
          return -1;
        var p = l - 1;
        return i !== r && (p = Fe(i), p = i < 0 ? _t(l + p, 0) : Bt(p, l - 1)), Pa(t, qe(n, 3), p, !0);
      }
      function Fu(t) {
        var n = t == null ? 0 : t.length;
        return n ? qt(t, 1) : [];
      }
      function wh(t) {
        var n = t == null ? 0 : t.length;
        return n ? qt(t, te) : [];
      }
      function $h(t, n) {
        var i = t == null ? 0 : t.length;
        return i ? (n = n === r ? 1 : Fe(n), qt(t, n)) : [];
      }
      function Ch(t) {
        for (var n = -1, i = t == null ? 0 : t.length, l = {}; ++n < i; ) {
          var p = t[n];
          l[p[0]] = p[1];
        }
        return l;
      }
      function Eu(t) {
        return t && t.length ? t[0] : r;
      }
      function Sh(t, n, i) {
        var l = t == null ? 0 : t.length;
        if (!l)
          return -1;
        var p = i == null ? 0 : Fe(i);
        return p < 0 && (p = _t(l + p, 0)), Br(t, n, p);
      }
      function kh(t) {
        var n = t == null ? 0 : t.length;
        return n ? rn(t, 0, -1) : [];
      }
      var qh = Pe(function(t) {
        var n = ut(t, Ds);
        return n.length && n[0] === t[0] ? ms(n) : [];
      }), Dh = Pe(function(t) {
        var n = an(t), i = ut(t, Ds);
        return n === an(i) ? n = r : i.pop(), i.length && i[0] === t[0] ? ms(i, qe(n, 2)) : [];
      }), Bh = Pe(function(t) {
        var n = an(t), i = ut(t, Ds);
        return n = typeof n == "function" ? n : r, n && i.pop(), i.length && i[0] === t[0] ? ms(i, r, n) : [];
      });
      function Ah(t, n) {
        return t == null ? "" : kv.call(t, n);
      }
      function an(t) {
        var n = t == null ? 0 : t.length;
        return n ? t[n - 1] : r;
      }
      function Th(t, n, i) {
        var l = t == null ? 0 : t.length;
        if (!l)
          return -1;
        var p = l;
        return i !== r && (p = Fe(i), p = p < 0 ? _t(l + p, 0) : Bt(p, l - 1)), n === n ? uv(t, n, p) : Pa(t, ml, p, !0);
      }
      function Oh(t, n) {
        return t && t.length ? Zl(t, Fe(n)) : r;
      }
      var Ih = Pe(Pu);
      function Pu(t, n) {
        return t && t.length && n && n.length ? ws(t, n) : t;
      }
      function Mh(t, n, i) {
        return t && t.length && n && n.length ? ws(t, n, qe(i, 2)) : t;
      }
      function xh(t, n, i) {
        return t && t.length && n && n.length ? ws(t, n, r, i) : t;
      }
      var Lh = Rn(function(t, n) {
        var i = t == null ? 0 : t.length, l = vs(t, n);
        return Jl(t, ut(n, function(p) {
          return Nn(p, i) ? +p : p;
        }).sort(ou)), l;
      });
      function Fh(t, n) {
        var i = [];
        if (!(t && t.length))
          return i;
        var l = -1, p = [], _ = t.length;
        for (n = qe(n, 3); ++l < _; ) {
          var k = t[l];
          n(k, l, t) && (i.push(k), p.push(l));
        }
        return Jl(t, p), i;
      }
      function Ns(t) {
        return t == null ? t : Av.call(t);
      }
      function Eh(t, n, i) {
        var l = t == null ? 0 : t.length;
        return l ? (i && typeof i != "number" && Mt(t, n, i) ? (n = 0, i = l) : (n = n == null ? 0 : Fe(n), i = i === r ? l : Fe(i)), rn(t, n, i)) : [];
      }
      function Ph(t, n) {
        return ai(t, n);
      }
      function zh(t, n, i) {
        return Ss(t, n, qe(i, 2));
      }
      function Rh(t, n) {
        var i = t == null ? 0 : t.length;
        if (i) {
          var l = ai(t, n);
          if (l < i && hn(t[l], n))
            return l;
        }
        return -1;
      }
      function Nh(t, n) {
        return ai(t, n, !0);
      }
      function Hh(t, n, i) {
        return Ss(t, n, qe(i, 2), !0);
      }
      function Vh(t, n) {
        var i = t == null ? 0 : t.length;
        if (i) {
          var l = ai(t, n, !0) - 1;
          if (hn(t[l], n))
            return l;
        }
        return -1;
      }
      function Yh(t) {
        return t && t.length ? jl(t) : [];
      }
      function Uh(t, n) {
        return t && t.length ? jl(t, qe(n, 2)) : [];
      }
      function Wh(t) {
        var n = t == null ? 0 : t.length;
        return n ? rn(t, 1, n) : [];
      }
      function Gh(t, n, i) {
        return t && t.length ? (n = i || n === r ? 1 : Fe(n), rn(t, 0, n < 0 ? 0 : n)) : [];
      }
      function Zh(t, n, i) {
        var l = t == null ? 0 : t.length;
        return l ? (n = i || n === r ? 1 : Fe(n), n = l - n, rn(t, n < 0 ? 0 : n, l)) : [];
      }
      function Kh(t, n) {
        return t && t.length ? ii(t, qe(n, 3), !1, !0) : [];
      }
      function Xh(t, n) {
        return t && t.length ? ii(t, qe(n, 3)) : [];
      }
      var Jh = Pe(function(t) {
        return Qn(qt(t, 1, gt, !0));
      }), Qh = Pe(function(t) {
        var n = an(t);
        return gt(n) && (n = r), Qn(qt(t, 1, gt, !0), qe(n, 2));
      }), jh = Pe(function(t) {
        var n = an(t);
        return n = typeof n == "function" ? n : r, Qn(qt(t, 1, gt, !0), r, n);
      });
      function eg(t) {
        return t && t.length ? Qn(t) : [];
      }
      function tg(t, n) {
        return t && t.length ? Qn(t, qe(n, 2)) : [];
      }
      function ng(t, n) {
        return n = typeof n == "function" ? n : r, t && t.length ? Qn(t, r, n) : [];
      }
      function Hs(t) {
        if (!(t && t.length))
          return [];
        var n = 0;
        return t = Gn(t, function(i) {
          if (gt(i))
            return n = _t(i.length, n), !0;
        }), is(n, function(i) {
          return ut(t, ns(i));
        });
      }
      function zu(t, n) {
        if (!(t && t.length))
          return [];
        var i = Hs(t);
        return n == null ? i : ut(i, function(l) {
          return Yt(n, r, l);
        });
      }
      var rg = Pe(function(t, n) {
        return gt(t) ? da(t, n) : [];
      }), ag = Pe(function(t) {
        return qs(Gn(t, gt));
      }), ig = Pe(function(t) {
        var n = an(t);
        return gt(n) && (n = r), qs(Gn(t, gt), qe(n, 2));
      }), sg = Pe(function(t) {
        var n = an(t);
        return n = typeof n == "function" ? n : r, qs(Gn(t, gt), r, n);
      }), og = Pe(Hs);
      function lg(t, n) {
        return ru(t || [], n || [], ca);
      }
      function ug(t, n) {
        return ru(t || [], n || [], pa);
      }
      var cg = Pe(function(t) {
        var n = t.length, i = n > 1 ? t[n - 1] : r;
        return i = typeof i == "function" ? (t.pop(), i) : r, zu(t, i);
      });
      function Ru(t) {
        var n = b(t);
        return n.__chain__ = !0, n;
      }
      function dg(t, n) {
        return n(t), t;
      }
      function pi(t, n) {
        return n(t);
      }
      var fg = Rn(function(t) {
        var n = t.length, i = n ? t[0] : 0, l = this.__wrapped__, p = function(_) {
          return vs(_, t);
        };
        return n > 1 || this.__actions__.length || !(l instanceof Ye) || !Nn(i) ? this.thru(p) : (l = l.slice(i, +i + (n ? 1 : 0)), l.__actions__.push({
          func: pi,
          args: [p],
          thisArg: r
        }), new tn(l, this.__chain__).thru(function(_) {
          return n && !_.length && _.push(r), _;
        }));
      });
      function vg() {
        return Ru(this);
      }
      function pg() {
        return new tn(this.value(), this.__chain__);
      }
      function hg() {
        this.__values__ === r && (this.__values__ = ec(this.value()));
        var t = this.__index__ >= this.__values__.length, n = t ? r : this.__values__[this.__index__++];
        return { done: t, value: n };
      }
      function gg() {
        return this;
      }
      function mg(t) {
        for (var n, i = this; i instanceof ja; ) {
          var l = Mu(i);
          l.__index__ = 0, l.__values__ = r, n ? p.__wrapped__ = l : n = l;
          var p = l;
          i = i.__wrapped__;
        }
        return p.__wrapped__ = t, n;
      }
      function yg() {
        var t = this.__wrapped__;
        if (t instanceof Ye) {
          var n = t;
          return this.__actions__.length && (n = new Ye(this)), n = n.reverse(), n.__actions__.push({
            func: pi,
            args: [Ns],
            thisArg: r
          }), new tn(n, this.__chain__);
        }
        return this.thru(Ns);
      }
      function bg() {
        return nu(this.__wrapped__, this.__actions__);
      }
      var _g = si(function(t, n, i) {
        et.call(t, i) ? ++t[i] : Pn(t, i, 1);
      });
      function wg(t, n, i) {
        var l = Le(t) ? hl : dp;
        return i && Mt(t, n, i) && (n = r), l(t, qe(n, 3));
      }
      function $g(t, n) {
        var i = Le(t) ? Gn : zl;
        return i(t, qe(n, 3));
      }
      var Cg = vu(xu), Sg = vu(Lu);
      function kg(t, n) {
        return qt(hi(t, n), 1);
      }
      function qg(t, n) {
        return qt(hi(t, n), te);
      }
      function Dg(t, n, i) {
        return i = i === r ? 1 : Fe(i), qt(hi(t, n), i);
      }
      function Nu(t, n) {
        var i = Le(t) ? jt : Jn;
        return i(t, qe(n, 3));
      }
      function Hu(t, n) {
        var i = Le(t) ? Wf : Pl;
        return i(t, qe(n, 3));
      }
      var Bg = si(function(t, n, i) {
        et.call(t, i) ? t[i].push(n) : Pn(t, i, [n]);
      });
      function Ag(t, n, i, l) {
        t = zt(t) ? t : Rr(t), i = i && !l ? Fe(i) : 0;
        var p = t.length;
        return i < 0 && (i = _t(p + i, 0)), _i(t) ? i <= p && t.indexOf(n, i) > -1 : !!p && Br(t, n, i) > -1;
      }
      var Tg = Pe(function(t, n, i) {
        var l = -1, p = typeof n == "function", _ = zt(t) ? H(t.length) : [];
        return Jn(t, function(k) {
          _[++l] = p ? Yt(n, k, i) : fa(k, n, i);
        }), _;
      }), Og = si(function(t, n, i) {
        Pn(t, i, n);
      });
      function hi(t, n) {
        var i = Le(t) ? ut : Ul;
        return i(t, qe(n, 3));
      }
      function Ig(t, n, i, l) {
        return t == null ? [] : (Le(n) || (n = n == null ? [] : [n]), i = l ? r : i, Le(i) || (i = i == null ? [] : [i]), Kl(t, n, i));
      }
      var Mg = si(function(t, n, i) {
        t[i ? 0 : 1].push(n);
      }, function() {
        return [[], []];
      });
      function xg(t, n, i) {
        var l = Le(t) ? es : bl, p = arguments.length < 3;
        return l(t, qe(n, 4), i, p, Jn);
      }
      function Lg(t, n, i) {
        var l = Le(t) ? Gf : bl, p = arguments.length < 3;
        return l(t, qe(n, 4), i, p, Pl);
      }
      function Fg(t, n) {
        var i = Le(t) ? Gn : zl;
        return i(t, yi(qe(n, 3)));
      }
      function Eg(t) {
        var n = Le(t) ? xl : Ap;
        return n(t);
      }
      function Pg(t, n, i) {
        (i ? Mt(t, n, i) : n === r) ? n = 1 : n = Fe(n);
        var l = Le(t) ? sp : Tp;
        return l(t, n);
      }
      function zg(t) {
        var n = Le(t) ? op : Ip;
        return n(t);
      }
      function Rg(t) {
        if (t == null)
          return 0;
        if (zt(t))
          return _i(t) ? Tr(t) : t.length;
        var n = At(t);
        return n == Ze || n == yt ? t.size : bs(t).length;
      }
      function Ng(t, n, i) {
        var l = Le(t) ? ts : Mp;
        return i && Mt(t, n, i) && (n = r), l(t, qe(n, 3));
      }
      var Hg = Pe(function(t, n) {
        if (t == null)
          return [];
        var i = n.length;
        return i > 1 && Mt(t, n[0], n[1]) ? n = [] : i > 2 && Mt(n[0], n[1], n[2]) && (n = [n[0]]), Kl(t, qt(n, 1), []);
      }), gi = $v || function() {
        return kt.Date.now();
      };
      function Vg(t, n) {
        if (typeof n != "function")
          throw new en(u);
        return t = Fe(t), function() {
          if (--t < 1)
            return n.apply(this, arguments);
        };
      }
      function Vu(t, n, i) {
        return n = i ? r : n, n = t && n == null ? t.length : n, zn(t, T, r, r, r, r, n);
      }
      function Yu(t, n) {
        var i;
        if (typeof n != "function")
          throw new en(u);
        return t = Fe(t), function() {
          return --t > 0 && (i = n.apply(this, arguments)), t <= 1 && (n = r), i;
        };
      }
      var Vs = Pe(function(t, n, i) {
        var l = M;
        if (i.length) {
          var p = Kn(i, Pr(Vs));
          l |= Y;
        }
        return zn(t, l, n, i, p);
      }), Uu = Pe(function(t, n, i) {
        var l = M | F;
        if (i.length) {
          var p = Kn(i, Pr(Uu));
          l |= Y;
        }
        return zn(n, l, t, i, p);
      });
      function Wu(t, n, i) {
        n = i ? r : n;
        var l = zn(t, x, r, r, r, r, r, n);
        return l.placeholder = Wu.placeholder, l;
      }
      function Gu(t, n, i) {
        n = i ? r : n;
        var l = zn(t, $, r, r, r, r, r, n);
        return l.placeholder = Gu.placeholder, l;
      }
      function Zu(t, n, i) {
        var l, p, _, k, A, E, Z = 0, X = !1, j = !1, pe = !0;
        if (typeof t != "function")
          throw new en(u);
        n = sn(n) || 0, ct(i) && (X = !!i.leading, j = "maxWait" in i, _ = j ? _t(sn(i.maxWait) || 0, n) : _, pe = "trailing" in i ? !!i.trailing : pe);
        function _e(mt) {
          var gn = l, Yn = p;
          return l = p = r, Z = mt, k = t.apply(Yn, gn), k;
        }
        function Be(mt) {
          return Z = mt, A = ma(He, n), X ? _e(mt) : k;
        }
        function Ee(mt) {
          var gn = mt - E, Yn = mt - Z, vc = n - gn;
          return j ? Bt(vc, _ - Yn) : vc;
        }
        function Ae(mt) {
          var gn = mt - E, Yn = mt - Z;
          return E === r || gn >= n || gn < 0 || j && Yn >= _;
        }
        function He() {
          var mt = gi();
          if (Ae(mt))
            return We(mt);
          A = ma(He, Ee(mt));
        }
        function We(mt) {
          return A = r, pe && l ? _e(mt) : (l = p = r, k);
        }
        function Zt() {
          A !== r && au(A), Z = 0, l = E = p = A = r;
        }
        function xt() {
          return A === r ? k : We(gi());
        }
        function Kt() {
          var mt = gi(), gn = Ae(mt);
          if (l = arguments, p = this, E = mt, gn) {
            if (A === r)
              return Be(E);
            if (j)
              return au(A), A = ma(He, n), _e(E);
          }
          return A === r && (A = ma(He, n)), k;
        }
        return Kt.cancel = Zt, Kt.flush = xt, Kt;
      }
      var Yg = Pe(function(t, n) {
        return El(t, 1, n);
      }), Ug = Pe(function(t, n, i) {
        return El(t, sn(n) || 0, i);
      });
      function Wg(t) {
        return zn(t, le);
      }
      function mi(t, n) {
        if (typeof t != "function" || n != null && typeof n != "function")
          throw new en(u);
        var i = function() {
          var l = arguments, p = n ? n.apply(this, l) : l[0], _ = i.cache;
          if (_.has(p))
            return _.get(p);
          var k = t.apply(this, l);
          return i.cache = _.set(p, k) || _, k;
        };
        return i.cache = new (mi.Cache || En)(), i;
      }
      mi.Cache = En;
      function yi(t) {
        if (typeof t != "function")
          throw new en(u);
        return function() {
          var n = arguments;
          switch (n.length) {
            case 0:
              return !t.call(this);
            case 1:
              return !t.call(this, n[0]);
            case 2:
              return !t.call(this, n[0], n[1]);
            case 3:
              return !t.call(this, n[0], n[1], n[2]);
          }
          return !t.apply(this, n);
        };
      }
      function Gg(t) {
        return Yu(2, t);
      }
      var Zg = xp(function(t, n) {
        n = n.length == 1 && Le(n[0]) ? ut(n[0], Ut(qe())) : ut(qt(n, 1), Ut(qe()));
        var i = n.length;
        return Pe(function(l) {
          for (var p = -1, _ = Bt(l.length, i); ++p < _; )
            l[p] = n[p].call(this, l[p]);
          return Yt(t, this, l);
        });
      }), Ys = Pe(function(t, n) {
        var i = Kn(n, Pr(Ys));
        return zn(t, Y, r, n, i);
      }), Ku = Pe(function(t, n) {
        var i = Kn(n, Pr(Ku));
        return zn(t, R, r, n, i);
      }), Kg = Rn(function(t, n) {
        return zn(t, z, r, r, r, n);
      });
      function Xg(t, n) {
        if (typeof t != "function")
          throw new en(u);
        return n = n === r ? n : Fe(n), Pe(t, n);
      }
      function Jg(t, n) {
        if (typeof t != "function")
          throw new en(u);
        return n = n == null ? 0 : _t(Fe(n), 0), Pe(function(i) {
          var l = i[n], p = er(i, 0, n);
          return l && Zn(p, l), Yt(t, this, p);
        });
      }
      function Qg(t, n, i) {
        var l = !0, p = !0;
        if (typeof t != "function")
          throw new en(u);
        return ct(i) && (l = "leading" in i ? !!i.leading : l, p = "trailing" in i ? !!i.trailing : p), Zu(t, n, {
          leading: l,
          maxWait: n,
          trailing: p
        });
      }
      function jg(t) {
        return Vu(t, 1);
      }
      function em(t, n) {
        return Ys(Bs(n), t);
      }
      function tm() {
        if (!arguments.length)
          return [];
        var t = arguments[0];
        return Le(t) ? t : [t];
      }
      function nm(t) {
        return nn(t, O);
      }
      function rm(t, n) {
        return n = typeof n == "function" ? n : r, nn(t, O, n);
      }
      function am(t) {
        return nn(t, q | O);
      }
      function im(t, n) {
        return n = typeof n == "function" ? n : r, nn(t, q | O, n);
      }
      function sm(t, n) {
        return n == null || Fl(t, n, $t(n));
      }
      function hn(t, n) {
        return t === n || t !== t && n !== n;
      }
      var om = ci(gs), lm = ci(function(t, n) {
        return t >= n;
      }), gr = Hl(/* @__PURE__ */ function() {
        return arguments;
      }()) ? Hl : function(t) {
        return ft(t) && et.call(t, "callee") && !Bl.call(t, "callee");
      }, Le = H.isArray, um = ul ? Ut(ul) : mp;
      function zt(t) {
        return t != null && bi(t.length) && !Hn(t);
      }
      function gt(t) {
        return ft(t) && zt(t);
      }
      function cm(t) {
        return t === !0 || t === !1 || ft(t) && It(t) == st;
      }
      var tr = Sv || to, dm = cl ? Ut(cl) : yp;
      function fm(t) {
        return ft(t) && t.nodeType === 1 && !ya(t);
      }
      function vm(t) {
        if (t == null)
          return !0;
        if (zt(t) && (Le(t) || typeof t == "string" || typeof t.splice == "function" || tr(t) || zr(t) || gr(t)))
          return !t.length;
        var n = At(t);
        if (n == Ze || n == yt)
          return !t.size;
        if (ga(t))
          return !bs(t).length;
        for (var i in t)
          if (et.call(t, i))
            return !1;
        return !0;
      }
      function pm(t, n) {
        return va(t, n);
      }
      function hm(t, n, i) {
        i = typeof i == "function" ? i : r;
        var l = i ? i(t, n) : r;
        return l === r ? va(t, n, r, i) : !!l;
      }
      function Us(t) {
        if (!ft(t))
          return !1;
        var n = It(t);
        return n == Je || n == Ie || typeof t.message == "string" && typeof t.name == "string" && !ya(t);
      }
      function gm(t) {
        return typeof t == "number" && Tl(t);
      }
      function Hn(t) {
        if (!ct(t))
          return !1;
        var n = It(t);
        return n == he || n == je || n == pt || n == $n;
      }
      function Xu(t) {
        return typeof t == "number" && t == Fe(t);
      }
      function bi(t) {
        return typeof t == "number" && t > -1 && t % 1 == 0 && t <= G;
      }
      function ct(t) {
        var n = typeof t;
        return t != null && (n == "object" || n == "function");
      }
      function ft(t) {
        return t != null && typeof t == "object";
      }
      var Ju = dl ? Ut(dl) : _p;
      function mm(t, n) {
        return t === n || ys(t, n, Ls(n));
      }
      function ym(t, n, i) {
        return i = typeof i == "function" ? i : r, ys(t, n, Ls(n), i);
      }
      function bm(t) {
        return Qu(t) && t != +t;
      }
      function _m(t) {
        if (rh(t))
          throw new xe(d);
        return Vl(t);
      }
      function wm(t) {
        return t === null;
      }
      function $m(t) {
        return t == null;
      }
      function Qu(t) {
        return typeof t == "number" || ft(t) && It(t) == wt;
      }
      function ya(t) {
        if (!ft(t) || It(t) != ht)
          return !1;
        var n = Wa(t);
        if (n === null)
          return !0;
        var i = et.call(n, "constructor") && n.constructor;
        return typeof i == "function" && i instanceof i && Ha.call(i) == yv;
      }
      var Ws = fl ? Ut(fl) : wp;
      function Cm(t) {
        return Xu(t) && t >= -G && t <= G;
      }
      var ju = vl ? Ut(vl) : $p;
      function _i(t) {
        return typeof t == "string" || !Le(t) && ft(t) && It(t) == dn;
      }
      function Gt(t) {
        return typeof t == "symbol" || ft(t) && It(t) == Jt;
      }
      var zr = pl ? Ut(pl) : Cp;
      function Sm(t) {
        return t === r;
      }
      function km(t) {
        return ft(t) && At(t) == Cn;
      }
      function qm(t) {
        return ft(t) && It(t) == Sr;
      }
      var Dm = ci(_s), Bm = ci(function(t, n) {
        return t <= n;
      });
      function ec(t) {
        if (!t)
          return [];
        if (zt(t))
          return _i(t) ? vn(t) : Pt(t);
        if (ia && t[ia])
          return sv(t[ia]());
        var n = At(t), i = n == Ze ? os : n == yt ? za : Rr;
        return i(t);
      }
      function Vn(t) {
        if (!t)
          return t === 0 ? t : 0;
        if (t = sn(t), t === te || t === -te) {
          var n = t < 0 ? -1 : 1;
          return n * de;
        }
        return t === t ? t : 0;
      }
      function Fe(t) {
        var n = Vn(t), i = n % 1;
        return n === n ? i ? n - i : n : 0;
      }
      function tc(t) {
        return t ? fr(Fe(t), 0, N) : 0;
      }
      function sn(t) {
        if (typeof t == "number")
          return t;
        if (Gt(t))
          return ge;
        if (ct(t)) {
          var n = typeof t.valueOf == "function" ? t.valueOf() : t;
          t = ct(n) ? n + "" : n;
        }
        if (typeof t != "string")
          return t === 0 ? t : +t;
        t = _l(t);
        var i = uf.test(t);
        return i || df.test(t) ? Vf(t.slice(2), i ? 2 : 8) : lf.test(t) ? ge : +t;
      }
      function nc(t) {
        return qn(t, Rt(t));
      }
      function Am(t) {
        return t ? fr(Fe(t), -G, G) : t === 0 ? t : 0;
      }
      function Qe(t) {
        return t == null ? "" : Wt(t);
      }
      var Tm = Fr(function(t, n) {
        if (ga(n) || zt(n)) {
          qn(n, $t(n), t);
          return;
        }
        for (var i in n)
          et.call(n, i) && ca(t, i, n[i]);
      }), rc = Fr(function(t, n) {
        qn(n, Rt(n), t);
      }), wi = Fr(function(t, n, i, l) {
        qn(n, Rt(n), t, l);
      }), Om = Fr(function(t, n, i, l) {
        qn(n, $t(n), t, l);
      }), Im = Rn(vs);
      function Mm(t, n) {
        var i = Lr(t);
        return n == null ? i : Ll(i, n);
      }
      var xm = Pe(function(t, n) {
        t = rt(t);
        var i = -1, l = n.length, p = l > 2 ? n[2] : r;
        for (p && Mt(n[0], n[1], p) && (l = 1); ++i < l; )
          for (var _ = n[i], k = Rt(_), A = -1, E = k.length; ++A < E; ) {
            var Z = k[A], X = t[Z];
            (X === r || hn(X, Ir[Z]) && !et.call(t, Z)) && (t[Z] = _[Z]);
          }
        return t;
      }), Lm = Pe(function(t) {
        return t.push(r, _u), Yt(ac, r, t);
      });
      function Fm(t, n) {
        return gl(t, qe(n, 3), kn);
      }
      function Em(t, n) {
        return gl(t, qe(n, 3), hs);
      }
      function Pm(t, n) {
        return t == null ? t : ps(t, qe(n, 3), Rt);
      }
      function zm(t, n) {
        return t == null ? t : Rl(t, qe(n, 3), Rt);
      }
      function Rm(t, n) {
        return t && kn(t, qe(n, 3));
      }
      function Nm(t, n) {
        return t && hs(t, qe(n, 3));
      }
      function Hm(t) {
        return t == null ? [] : ni(t, $t(t));
      }
      function Vm(t) {
        return t == null ? [] : ni(t, Rt(t));
      }
      function Gs(t, n, i) {
        var l = t == null ? r : vr(t, n);
        return l === r ? i : l;
      }
      function Ym(t, n) {
        return t != null && Cu(t, n, vp);
      }
      function Zs(t, n) {
        return t != null && Cu(t, n, pp);
      }
      var Um = hu(function(t, n, i) {
        n != null && typeof n.toString != "function" && (n = Va.call(n)), t[n] = i;
      }, Xs(Nt)), Wm = hu(function(t, n, i) {
        n != null && typeof n.toString != "function" && (n = Va.call(n)), et.call(t, n) ? t[n].push(i) : t[n] = [i];
      }, qe), Gm = Pe(fa);
      function $t(t) {
        return zt(t) ? Ml(t) : bs(t);
      }
      function Rt(t) {
        return zt(t) ? Ml(t, !0) : Sp(t);
      }
      function Zm(t, n) {
        var i = {};
        return n = qe(n, 3), kn(t, function(l, p, _) {
          Pn(i, n(l, p, _), l);
        }), i;
      }
      function Km(t, n) {
        var i = {};
        return n = qe(n, 3), kn(t, function(l, p, _) {
          Pn(i, p, n(l, p, _));
        }), i;
      }
      var Xm = Fr(function(t, n, i) {
        ri(t, n, i);
      }), ac = Fr(function(t, n, i, l) {
        ri(t, n, i, l);
      }), Jm = Rn(function(t, n) {
        var i = {};
        if (t == null)
          return i;
        var l = !1;
        n = ut(n, function(_) {
          return _ = jn(_, t), l || (l = _.length > 1), _;
        }), qn(t, Ms(t), i), l && (i = nn(i, q | C | O, Up));
        for (var p = n.length; p--; )
          ks(i, n[p]);
        return i;
      });
      function Qm(t, n) {
        return ic(t, yi(qe(n)));
      }
      var jm = Rn(function(t, n) {
        return t == null ? {} : qp(t, n);
      });
      function ic(t, n) {
        if (t == null)
          return {};
        var i = ut(Ms(t), function(l) {
          return [l];
        });
        return n = qe(n), Xl(t, i, function(l, p) {
          return n(l, p[0]);
        });
      }
      function ey(t, n, i) {
        n = jn(n, t);
        var l = -1, p = n.length;
        for (p || (p = 1, t = r); ++l < p; ) {
          var _ = t == null ? r : t[Dn(n[l])];
          _ === r && (l = p, _ = i), t = Hn(_) ? _.call(t) : _;
        }
        return t;
      }
      function ty(t, n, i) {
        return t == null ? t : pa(t, n, i);
      }
      function ny(t, n, i, l) {
        return l = typeof l == "function" ? l : r, t == null ? t : pa(t, n, i, l);
      }
      var sc = yu($t), oc = yu(Rt);
      function ry(t, n, i) {
        var l = Le(t), p = l || tr(t) || zr(t);
        if (n = qe(n, 4), i == null) {
          var _ = t && t.constructor;
          p ? i = l ? new _() : [] : ct(t) ? i = Hn(_) ? Lr(Wa(t)) : {} : i = {};
        }
        return (p ? jt : kn)(t, function(k, A, E) {
          return n(i, k, A, E);
        }), i;
      }
      function ay(t, n) {
        return t == null ? !0 : ks(t, n);
      }
      function iy(t, n, i) {
        return t == null ? t : tu(t, n, Bs(i));
      }
      function sy(t, n, i, l) {
        return l = typeof l == "function" ? l : r, t == null ? t : tu(t, n, Bs(i), l);
      }
      function Rr(t) {
        return t == null ? [] : ss(t, $t(t));
      }
      function oy(t) {
        return t == null ? [] : ss(t, Rt(t));
      }
      function ly(t, n, i) {
        return i === r && (i = n, n = r), i !== r && (i = sn(i), i = i === i ? i : 0), n !== r && (n = sn(n), n = n === n ? n : 0), fr(sn(t), n, i);
      }
      function uy(t, n, i) {
        return n = Vn(n), i === r ? (i = n, n = 0) : i = Vn(i), t = sn(t), hp(t, n, i);
      }
      function cy(t, n, i) {
        if (i && typeof i != "boolean" && Mt(t, n, i) && (n = i = r), i === r && (typeof n == "boolean" ? (i = n, n = r) : typeof t == "boolean" && (i = t, t = r)), t === r && n === r ? (t = 0, n = 1) : (t = Vn(t), n === r ? (n = t, t = 0) : n = Vn(n)), t > n) {
          var l = t;
          t = n, n = l;
        }
        if (i || t % 1 || n % 1) {
          var p = Ol();
          return Bt(t + p * (n - t + Hf("1e-" + ((p + "").length - 1))), n);
        }
        return $s(t, n);
      }
      var dy = Er(function(t, n, i) {
        return n = n.toLowerCase(), t + (i ? lc(n) : n);
      });
      function lc(t) {
        return Ks(Qe(t).toLowerCase());
      }
      function uc(t) {
        return t = Qe(t), t && t.replace(vf, tv).replace(If, "");
      }
      function fy(t, n, i) {
        t = Qe(t), n = Wt(n);
        var l = t.length;
        i = i === r ? l : fr(Fe(i), 0, l);
        var p = i;
        return i -= n.length, i >= 0 && t.slice(i, p) == n;
      }
      function vy(t) {
        return t = Qe(t), t && na.test(t) ? t.replace(ta, nv) : t;
      }
      function py(t) {
        return t = Qe(t), t && Qd.test(t) ? t.replace(Yi, "\\$&") : t;
      }
      var hy = Er(function(t, n, i) {
        return t + (i ? "-" : "") + n.toLowerCase();
      }), gy = Er(function(t, n, i) {
        return t + (i ? " " : "") + n.toLowerCase();
      }), my = fu("toLowerCase");
      function yy(t, n, i) {
        t = Qe(t), n = Fe(n);
        var l = n ? Tr(t) : 0;
        if (!n || l >= n)
          return t;
        var p = (n - l) / 2;
        return ui(Xa(p), i) + t + ui(Ka(p), i);
      }
      function by(t, n, i) {
        t = Qe(t), n = Fe(n);
        var l = n ? Tr(t) : 0;
        return n && l < n ? t + ui(n - l, i) : t;
      }
      function _y(t, n, i) {
        t = Qe(t), n = Fe(n);
        var l = n ? Tr(t) : 0;
        return n && l < n ? ui(n - l, i) + t : t;
      }
      function wy(t, n, i) {
        return i || n == null ? n = 0 : n && (n = +n), Bv(Qe(t).replace(Ui, ""), n || 0);
      }
      function $y(t, n, i) {
        return (i ? Mt(t, n, i) : n === r) ? n = 1 : n = Fe(n), Cs(Qe(t), n);
      }
      function Cy() {
        var t = arguments, n = Qe(t[0]);
        return t.length < 3 ? n : n.replace(t[1], t[2]);
      }
      var Sy = Er(function(t, n, i) {
        return t + (i ? "_" : "") + n.toLowerCase();
      });
      function ky(t, n, i) {
        return i && typeof i != "number" && Mt(t, n, i) && (n = i = r), i = i === r ? N : i >>> 0, i ? (t = Qe(t), t && (typeof n == "string" || n != null && !Ws(n)) && (n = Wt(n), !n && Ar(t)) ? er(vn(t), 0, i) : t.split(n, i)) : [];
      }
      var qy = Er(function(t, n, i) {
        return t + (i ? " " : "") + Ks(n);
      });
      function Dy(t, n, i) {
        return t = Qe(t), i = i == null ? 0 : fr(Fe(i), 0, t.length), n = Wt(n), t.slice(i, i + n.length) == n;
      }
      function By(t, n, i) {
        var l = b.templateSettings;
        i && Mt(t, n, i) && (n = r), t = Qe(t), n = wi({}, n, l, bu);
        var p = wi({}, n.imports, l.imports, bu), _ = $t(p), k = ss(p, _), A, E, Z = 0, X = n.interpolate || xa, j = "__p += '", pe = ls(
          (n.escape || xa).source + "|" + X.source + "|" + (X === Ma ? of : xa).source + "|" + (n.evaluate || xa).source + "|$",
          "g"
        ), _e = "//# sourceURL=" + (et.call(n, "sourceURL") ? (n.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Ef + "]") + `
`;
        t.replace(pe, function(Ae, He, We, Zt, xt, Kt) {
          return We || (We = Zt), j += t.slice(Z, Kt).replace(pf, rv), He && (A = !0, j += `' +
__e(` + He + `) +
'`), xt && (E = !0, j += `';
` + xt + `;
__p += '`), We && (j += `' +
((__t = (` + We + `)) == null ? '' : __t) +
'`), Z = Kt + Ae.length, Ae;
        }), j += `';
`;
        var Be = et.call(n, "variable") && n.variable;
        if (!Be)
          j = `with (obj) {
` + j + `
}
`;
        else if (af.test(Be))
          throw new xe(f);
        j = (E ? j.replace(Ue, "") : j).replace(St, "$1").replace(Et, "$1;"), j = "function(" + (Be || "obj") + `) {
` + (Be ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (A ? ", __e = _.escape" : "") + (E ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + j + `return __p
}`;
        var Ee = dc(function() {
          return Ke(_, _e + "return " + j).apply(r, k);
        });
        if (Ee.source = j, Us(Ee))
          throw Ee;
        return Ee;
      }
      function Ay(t) {
        return Qe(t).toLowerCase();
      }
      function Ty(t) {
        return Qe(t).toUpperCase();
      }
      function Oy(t, n, i) {
        if (t = Qe(t), t && (i || n === r))
          return _l(t);
        if (!t || !(n = Wt(n)))
          return t;
        var l = vn(t), p = vn(n), _ = wl(l, p), k = $l(l, p) + 1;
        return er(l, _, k).join("");
      }
      function Iy(t, n, i) {
        if (t = Qe(t), t && (i || n === r))
          return t.slice(0, Sl(t) + 1);
        if (!t || !(n = Wt(n)))
          return t;
        var l = vn(t), p = $l(l, vn(n)) + 1;
        return er(l, 0, p).join("");
      }
      function My(t, n, i) {
        if (t = Qe(t), t && (i || n === r))
          return t.replace(Ui, "");
        if (!t || !(n = Wt(n)))
          return t;
        var l = vn(t), p = wl(l, vn(n));
        return er(l, p).join("");
      }
      function xy(t, n) {
        var i = K, l = se;
        if (ct(n)) {
          var p = "separator" in n ? n.separator : p;
          i = "length" in n ? Fe(n.length) : i, l = "omission" in n ? Wt(n.omission) : l;
        }
        t = Qe(t);
        var _ = t.length;
        if (Ar(t)) {
          var k = vn(t);
          _ = k.length;
        }
        if (i >= _)
          return t;
        var A = i - Tr(l);
        if (A < 1)
          return l;
        var E = k ? er(k, 0, A).join("") : t.slice(0, A);
        if (p === r)
          return E + l;
        if (k && (A += E.length - A), Ws(p)) {
          if (t.slice(A).search(p)) {
            var Z, X = E;
            for (p.global || (p = ls(p.source, Qe(Ho.exec(p)) + "g")), p.lastIndex = 0; Z = p.exec(X); )
              var j = Z.index;
            E = E.slice(0, j === r ? A : j);
          }
        } else if (t.indexOf(Wt(p), A) != A) {
          var pe = E.lastIndexOf(p);
          pe > -1 && (E = E.slice(0, pe));
        }
        return E + l;
      }
      function Ly(t) {
        return t = Qe(t), t && Ln.test(t) ? t.replace(xn, cv) : t;
      }
      var Fy = Er(function(t, n, i) {
        return t + (i ? " " : "") + n.toUpperCase();
      }), Ks = fu("toUpperCase");
      function cc(t, n, i) {
        return t = Qe(t), n = i ? r : n, n === r ? iv(t) ? vv(t) : Xf(t) : t.match(n) || [];
      }
      var dc = Pe(function(t, n) {
        try {
          return Yt(t, r, n);
        } catch (i) {
          return Us(i) ? i : new xe(i);
        }
      }), Ey = Rn(function(t, n) {
        return jt(n, function(i) {
          i = Dn(i), Pn(t, i, Vs(t[i], t));
        }), t;
      });
      function Py(t) {
        var n = t == null ? 0 : t.length, i = qe();
        return t = n ? ut(t, function(l) {
          if (typeof l[1] != "function")
            throw new en(u);
          return [i(l[0]), l[1]];
        }) : [], Pe(function(l) {
          for (var p = -1; ++p < n; ) {
            var _ = t[p];
            if (Yt(_[0], this, l))
              return Yt(_[1], this, l);
          }
        });
      }
      function zy(t) {
        return cp(nn(t, q));
      }
      function Xs(t) {
        return function() {
          return t;
        };
      }
      function Ry(t, n) {
        return t == null || t !== t ? n : t;
      }
      var Ny = pu(), Hy = pu(!0);
      function Nt(t) {
        return t;
      }
      function Js(t) {
        return Yl(typeof t == "function" ? t : nn(t, q));
      }
      function Vy(t) {
        return Wl(nn(t, q));
      }
      function Yy(t, n) {
        return Gl(t, nn(n, q));
      }
      var Uy = Pe(function(t, n) {
        return function(i) {
          return fa(i, t, n);
        };
      }), Wy = Pe(function(t, n) {
        return function(i) {
          return fa(t, i, n);
        };
      });
      function Qs(t, n, i) {
        var l = $t(n), p = ni(n, l);
        i == null && !(ct(n) && (p.length || !l.length)) && (i = n, n = t, t = this, p = ni(n, $t(n)));
        var _ = !(ct(i) && "chain" in i) || !!i.chain, k = Hn(t);
        return jt(p, function(A) {
          var E = n[A];
          t[A] = E, k && (t.prototype[A] = function() {
            var Z = this.__chain__;
            if (_ || Z) {
              var X = t(this.__wrapped__), j = X.__actions__ = Pt(this.__actions__);
              return j.push({ func: E, args: arguments, thisArg: t }), X.__chain__ = Z, X;
            }
            return E.apply(t, Zn([this.value()], arguments));
          });
        }), t;
      }
      function Gy() {
        return kt._ === this && (kt._ = bv), this;
      }
      function js() {
      }
      function Zy(t) {
        return t = Fe(t), Pe(function(n) {
          return Zl(n, t);
        });
      }
      var Ky = Ts(ut), Xy = Ts(hl), Jy = Ts(ts);
      function fc(t) {
        return Es(t) ? ns(Dn(t)) : Dp(t);
      }
      function Qy(t) {
        return function(n) {
          return t == null ? r : vr(t, n);
        };
      }
      var jy = gu(), e0 = gu(!0);
      function eo() {
        return [];
      }
      function to() {
        return !1;
      }
      function t0() {
        return {};
      }
      function n0() {
        return "";
      }
      function r0() {
        return !0;
      }
      function a0(t, n) {
        if (t = Fe(t), t < 1 || t > G)
          return [];
        var i = N, l = Bt(t, N);
        n = qe(n), t -= N;
        for (var p = is(l, n); ++i < t; )
          n(i);
        return p;
      }
      function i0(t) {
        return Le(t) ? ut(t, Dn) : Gt(t) ? [t] : Pt(Iu(Qe(t)));
      }
      function s0(t) {
        var n = ++mv;
        return Qe(t) + n;
      }
      var o0 = li(function(t, n) {
        return t + n;
      }, 0), l0 = Os("ceil"), u0 = li(function(t, n) {
        return t / n;
      }, 1), c0 = Os("floor");
      function d0(t) {
        return t && t.length ? ti(t, Nt, gs) : r;
      }
      function f0(t, n) {
        return t && t.length ? ti(t, qe(n, 2), gs) : r;
      }
      function v0(t) {
        return yl(t, Nt);
      }
      function p0(t, n) {
        return yl(t, qe(n, 2));
      }
      function h0(t) {
        return t && t.length ? ti(t, Nt, _s) : r;
      }
      function g0(t, n) {
        return t && t.length ? ti(t, qe(n, 2), _s) : r;
      }
      var m0 = li(function(t, n) {
        return t * n;
      }, 1), y0 = Os("round"), b0 = li(function(t, n) {
        return t - n;
      }, 0);
      function _0(t) {
        return t && t.length ? as(t, Nt) : 0;
      }
      function w0(t, n) {
        return t && t.length ? as(t, qe(n, 2)) : 0;
      }
      return b.after = Vg, b.ary = Vu, b.assign = Tm, b.assignIn = rc, b.assignInWith = wi, b.assignWith = Om, b.at = Im, b.before = Yu, b.bind = Vs, b.bindAll = Ey, b.bindKey = Uu, b.castArray = tm, b.chain = Ru, b.chunk = ch, b.compact = dh, b.concat = fh, b.cond = Py, b.conforms = zy, b.constant = Xs, b.countBy = _g, b.create = Mm, b.curry = Wu, b.curryRight = Gu, b.debounce = Zu, b.defaults = xm, b.defaultsDeep = Lm, b.defer = Yg, b.delay = Ug, b.difference = vh, b.differenceBy = ph, b.differenceWith = hh, b.drop = gh, b.dropRight = mh, b.dropRightWhile = yh, b.dropWhile = bh, b.fill = _h, b.filter = $g, b.flatMap = kg, b.flatMapDeep = qg, b.flatMapDepth = Dg, b.flatten = Fu, b.flattenDeep = wh, b.flattenDepth = $h, b.flip = Wg, b.flow = Ny, b.flowRight = Hy, b.fromPairs = Ch, b.functions = Hm, b.functionsIn = Vm, b.groupBy = Bg, b.initial = kh, b.intersection = qh, b.intersectionBy = Dh, b.intersectionWith = Bh, b.invert = Um, b.invertBy = Wm, b.invokeMap = Tg, b.iteratee = Js, b.keyBy = Og, b.keys = $t, b.keysIn = Rt, b.map = hi, b.mapKeys = Zm, b.mapValues = Km, b.matches = Vy, b.matchesProperty = Yy, b.memoize = mi, b.merge = Xm, b.mergeWith = ac, b.method = Uy, b.methodOf = Wy, b.mixin = Qs, b.negate = yi, b.nthArg = Zy, b.omit = Jm, b.omitBy = Qm, b.once = Gg, b.orderBy = Ig, b.over = Ky, b.overArgs = Zg, b.overEvery = Xy, b.overSome = Jy, b.partial = Ys, b.partialRight = Ku, b.partition = Mg, b.pick = jm, b.pickBy = ic, b.property = fc, b.propertyOf = Qy, b.pull = Ih, b.pullAll = Pu, b.pullAllBy = Mh, b.pullAllWith = xh, b.pullAt = Lh, b.range = jy, b.rangeRight = e0, b.rearg = Kg, b.reject = Fg, b.remove = Fh, b.rest = Xg, b.reverse = Ns, b.sampleSize = Pg, b.set = ty, b.setWith = ny, b.shuffle = zg, b.slice = Eh, b.sortBy = Hg, b.sortedUniq = Yh, b.sortedUniqBy = Uh, b.split = ky, b.spread = Jg, b.tail = Wh, b.take = Gh, b.takeRight = Zh, b.takeRightWhile = Kh, b.takeWhile = Xh, b.tap = dg, b.throttle = Qg, b.thru = pi, b.toArray = ec, b.toPairs = sc, b.toPairsIn = oc, b.toPath = i0, b.toPlainObject = nc, b.transform = ry, b.unary = jg, b.union = Jh, b.unionBy = Qh, b.unionWith = jh, b.uniq = eg, b.uniqBy = tg, b.uniqWith = ng, b.unset = ay, b.unzip = Hs, b.unzipWith = zu, b.update = iy, b.updateWith = sy, b.values = Rr, b.valuesIn = oy, b.without = rg, b.words = cc, b.wrap = em, b.xor = ag, b.xorBy = ig, b.xorWith = sg, b.zip = og, b.zipObject = lg, b.zipObjectDeep = ug, b.zipWith = cg, b.entries = sc, b.entriesIn = oc, b.extend = rc, b.extendWith = wi, Qs(b, b), b.add = o0, b.attempt = dc, b.camelCase = dy, b.capitalize = lc, b.ceil = l0, b.clamp = ly, b.clone = nm, b.cloneDeep = am, b.cloneDeepWith = im, b.cloneWith = rm, b.conformsTo = sm, b.deburr = uc, b.defaultTo = Ry, b.divide = u0, b.endsWith = fy, b.eq = hn, b.escape = vy, b.escapeRegExp = py, b.every = wg, b.find = Cg, b.findIndex = xu, b.findKey = Fm, b.findLast = Sg, b.findLastIndex = Lu, b.findLastKey = Em, b.floor = c0, b.forEach = Nu, b.forEachRight = Hu, b.forIn = Pm, b.forInRight = zm, b.forOwn = Rm, b.forOwnRight = Nm, b.get = Gs, b.gt = om, b.gte = lm, b.has = Ym, b.hasIn = Zs, b.head = Eu, b.identity = Nt, b.includes = Ag, b.indexOf = Sh, b.inRange = uy, b.invoke = Gm, b.isArguments = gr, b.isArray = Le, b.isArrayBuffer = um, b.isArrayLike = zt, b.isArrayLikeObject = gt, b.isBoolean = cm, b.isBuffer = tr, b.isDate = dm, b.isElement = fm, b.isEmpty = vm, b.isEqual = pm, b.isEqualWith = hm, b.isError = Us, b.isFinite = gm, b.isFunction = Hn, b.isInteger = Xu, b.isLength = bi, b.isMap = Ju, b.isMatch = mm, b.isMatchWith = ym, b.isNaN = bm, b.isNative = _m, b.isNil = $m, b.isNull = wm, b.isNumber = Qu, b.isObject = ct, b.isObjectLike = ft, b.isPlainObject = ya, b.isRegExp = Ws, b.isSafeInteger = Cm, b.isSet = ju, b.isString = _i, b.isSymbol = Gt, b.isTypedArray = zr, b.isUndefined = Sm, b.isWeakMap = km, b.isWeakSet = qm, b.join = Ah, b.kebabCase = hy, b.last = an, b.lastIndexOf = Th, b.lowerCase = gy, b.lowerFirst = my, b.lt = Dm, b.lte = Bm, b.max = d0, b.maxBy = f0, b.mean = v0, b.meanBy = p0, b.min = h0, b.minBy = g0, b.stubArray = eo, b.stubFalse = to, b.stubObject = t0, b.stubString = n0, b.stubTrue = r0, b.multiply = m0, b.nth = Oh, b.noConflict = Gy, b.noop = js, b.now = gi, b.pad = yy, b.padEnd = by, b.padStart = _y, b.parseInt = wy, b.random = cy, b.reduce = xg, b.reduceRight = Lg, b.repeat = $y, b.replace = Cy, b.result = ey, b.round = y0, b.runInContext = L, b.sample = Eg, b.size = Rg, b.snakeCase = Sy, b.some = Ng, b.sortedIndex = Ph, b.sortedIndexBy = zh, b.sortedIndexOf = Rh, b.sortedLastIndex = Nh, b.sortedLastIndexBy = Hh, b.sortedLastIndexOf = Vh, b.startCase = qy, b.startsWith = Dy, b.subtract = b0, b.sum = _0, b.sumBy = w0, b.template = By, b.times = a0, b.toFinite = Vn, b.toInteger = Fe, b.toLength = tc, b.toLower = Ay, b.toNumber = sn, b.toSafeInteger = Am, b.toString = Qe, b.toUpper = Ty, b.trim = Oy, b.trimEnd = Iy, b.trimStart = My, b.truncate = xy, b.unescape = Ly, b.uniqueId = s0, b.upperCase = Fy, b.upperFirst = Ks, b.each = Nu, b.eachRight = Hu, b.first = Eu, Qs(b, function() {
        var t = {};
        return kn(b, function(n, i) {
          et.call(b.prototype, i) || (t[i] = n);
        }), t;
      }(), { chain: !1 }), b.VERSION = s, jt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(t) {
        b[t].placeholder = b;
      }), jt(["drop", "take"], function(t, n) {
        Ye.prototype[t] = function(i) {
          i = i === r ? 1 : _t(Fe(i), 0);
          var l = this.__filtered__ && !n ? new Ye(this) : this.clone();
          return l.__filtered__ ? l.__takeCount__ = Bt(i, l.__takeCount__) : l.__views__.push({
            size: Bt(i, N),
            type: t + (l.__dir__ < 0 ? "Right" : "")
          }), l;
        }, Ye.prototype[t + "Right"] = function(i) {
          return this.reverse()[t](i).reverse();
        };
      }), jt(["filter", "map", "takeWhile"], function(t, n) {
        var i = n + 1, l = i == ee || i == J;
        Ye.prototype[t] = function(p) {
          var _ = this.clone();
          return _.__iteratees__.push({
            iteratee: qe(p, 3),
            type: i
          }), _.__filtered__ = _.__filtered__ || l, _;
        };
      }), jt(["head", "last"], function(t, n) {
        var i = "take" + (n ? "Right" : "");
        Ye.prototype[t] = function() {
          return this[i](1).value()[0];
        };
      }), jt(["initial", "tail"], function(t, n) {
        var i = "drop" + (n ? "" : "Right");
        Ye.prototype[t] = function() {
          return this.__filtered__ ? new Ye(this) : this[i](1);
        };
      }), Ye.prototype.compact = function() {
        return this.filter(Nt);
      }, Ye.prototype.find = function(t) {
        return this.filter(t).head();
      }, Ye.prototype.findLast = function(t) {
        return this.reverse().find(t);
      }, Ye.prototype.invokeMap = Pe(function(t, n) {
        return typeof t == "function" ? new Ye(this) : this.map(function(i) {
          return fa(i, t, n);
        });
      }), Ye.prototype.reject = function(t) {
        return this.filter(yi(qe(t)));
      }, Ye.prototype.slice = function(t, n) {
        t = Fe(t);
        var i = this;
        return i.__filtered__ && (t > 0 || n < 0) ? new Ye(i) : (t < 0 ? i = i.takeRight(-t) : t && (i = i.drop(t)), n !== r && (n = Fe(n), i = n < 0 ? i.dropRight(-n) : i.take(n - t)), i);
      }, Ye.prototype.takeRightWhile = function(t) {
        return this.reverse().takeWhile(t).reverse();
      }, Ye.prototype.toArray = function() {
        return this.take(N);
      }, kn(Ye.prototype, function(t, n) {
        var i = /^(?:filter|find|map|reject)|While$/.test(n), l = /^(?:head|last)$/.test(n), p = b[l ? "take" + (n == "last" ? "Right" : "") : n], _ = l || /^find/.test(n);
        p && (b.prototype[n] = function() {
          var k = this.__wrapped__, A = l ? [1] : arguments, E = k instanceof Ye, Z = A[0], X = E || Le(k), j = function(He) {
            var We = p.apply(b, Zn([He], A));
            return l && pe ? We[0] : We;
          };
          X && i && typeof Z == "function" && Z.length != 1 && (E = X = !1);
          var pe = this.__chain__, _e = !!this.__actions__.length, Be = _ && !pe, Ee = E && !_e;
          if (!_ && X) {
            k = Ee ? k : new Ye(this);
            var Ae = t.apply(k, A);
            return Ae.__actions__.push({ func: pi, args: [j], thisArg: r }), new tn(Ae, pe);
          }
          return Be && Ee ? t.apply(this, A) : (Ae = this.thru(j), Be ? l ? Ae.value()[0] : Ae.value() : Ae);
        });
      }), jt(["pop", "push", "shift", "sort", "splice", "unshift"], function(t) {
        var n = Ra[t], i = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru", l = /^(?:pop|shift)$/.test(t);
        b.prototype[t] = function() {
          var p = arguments;
          if (l && !this.__chain__) {
            var _ = this.value();
            return n.apply(Le(_) ? _ : [], p);
          }
          return this[i](function(k) {
            return n.apply(Le(k) ? k : [], p);
          });
        };
      }), kn(Ye.prototype, function(t, n) {
        var i = b[n];
        if (i) {
          var l = i.name + "";
          et.call(xr, l) || (xr[l] = []), xr[l].push({ name: n, func: i });
        }
      }), xr[oi(r, F).name] = [{
        name: "wrapper",
        func: r
      }], Ye.prototype.clone = Lv, Ye.prototype.reverse = Fv, Ye.prototype.value = Ev, b.prototype.at = fg, b.prototype.chain = vg, b.prototype.commit = pg, b.prototype.next = hg, b.prototype.plant = mg, b.prototype.reverse = yg, b.prototype.toJSON = b.prototype.valueOf = b.prototype.value = bg, b.prototype.first = b.prototype.head, ia && (b.prototype[ia] = gg), b;
    }, Or = pv();
    lr ? ((lr.exports = Or)._ = Or, Ji._ = Or) : kt._ = Or;
  }).call(br);
})(Bi, Bi.exports);
var fo = Bi.exports;
const Ww = ["target", "href"], Gw = {
  key: 0,
  class: "orq-link--icon"
}, Zw = { class: "orq-link__span" }, Ri = {
  __name: "Link",
  props: {
    label: {
      type: String,
      default: ""
    },
    href: {
      type: String,
      default: void 0
    },
    icon: {
      type: String,
      default: ""
    },
    customIcon: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "small"
    },
    orientation: {
      type: String,
      default: "right"
    },
    type: {
      type: String,
      default: "default"
    },
    target: {
      type: String,
      default: "_blank"
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    underline: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const r = a, s = e, o = V("orq-link"), d = B(() => ({
      [`${o.value}`]: !0,
      [`${o.value}--${s.size}`]: s.size,
      [`${o.value}--${s.orientation}`]: s.icon === "external",
      [`${o.value}--underline`]: s.underline && s.icon === "none",
      [`${o.value}${s.type === "primary" ? "--primary" : ""}`]: !0,
      [`${o.value}--disabled`]: s.disabled,
      [`${o.value}--disabled--inverse`]: s.disabled && s.inverse && s.type,
      [`${o.value}--inverse--default`]: s.type === "default" && s.inverse,
      [`${o.value}--primary--inverse`]: s.type === "primary" && s.inverse
    })), u = B(() => ({
      [s.icon === "default" || s.icon === "custom" ? `orq-link--${s.orientation}` : ""]: !0
    }));
    return (f, c) => (v(), m(ce, null, [
      re(Ft, {
        type: "text",
        loading: e.loading,
        size: e.size,
        inverse: e.inverse
      }, null, 8, ["loading", "size", "inverse"]),
      e.loading ? D("", !0) : (v(), m("a", {
        key: 0,
        target: e.target,
        href: e.href,
        class: w([d.value, u.value]),
        onClick: c[0] || (c[0] = (g) => r("click", g))
      }, [
        e.icon !== "none" ? (v(), m("div", Gw, [
          e.orientation && e.icon === "default" ? (v(), me(Te, {
            key: 0,
            type: "none",
            name: `chevron-${e.orientation === "left" ? "left" : "right"}`
          }, null, 8, ["name"])) : D("", !0),
          e.orientation && e.icon === "external" ? (v(), me(Te, {
            key: 1,
            type: "none",
            name: "external-link"
          })) : D("", !0),
          e.orientation && e.icon === "custom" ? (v(), me(Te, {
            key: 2,
            type: "none",
            name: e.customIcon
          }, null, 8, ["name"])) : D("", !0)
        ])) : D("", !0),
        y("span", Zw, [
          f.$slots.default ? we(f.$slots, "default", { key: 0 }) : (v(), m(ce, { key: 1 }, [
            _n(ie(e.label), 1)
          ], 64))
        ])
      ], 10, Ww))
    ], 64));
  }
}, Kw = {
  __name: "Button",
  props: {
    href: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: "Label"
    },
    appearance: {
      type: String,
      default: "primary"
    },
    iconName: {
      type: String,
      default: ""
    },
    iconOrientation: {
      type: String,
      default: "left"
    },
    size: {
      type: String,
      default: "compact"
    },
    kind: {
      type: String,
      default: "primary"
    },
    type: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    selected: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    metricIdentify: {
      type: String,
      default: "google-tag-manager-selector"
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const r = e, s = V(Xe), o = a, d = B(() => ({
      "orq-button": !0,
      [`orq-button__appearance--${r.appearance}`]: !0,
      [`orq-button__content orq-button__size--${r.size}`]: r.appearance !== "rounded" && r.appearance !== "inline",
      [`orq-button__type--${r.type}`]: !0,
      "orq-button--inverse": r.inverse,
      [`orq-button__position--${r.iconOrientation}`]: r.appearance !== "rounded",
      "orq-button--selected": r.selected,
      [`orq-button__disabled--${r.disabled}`]: !0,
      [`orq-button__loading--${r.loading}`]: !0,
      "button--rotate": r.loading
    })), u = B(() => r.disabled ? s.value.emphasisBaseDisabled : r.appearance === "inline" || r.appearance === "line" ? r.inverse ? s.value.emphasisBaseInverseHigh : s.value.emphasisBaseHigh : r.inverse ? s.value.emphasisBaseHigh : s.value.emphasisBaseInverseHigh), f = B(() => r.loading ? "refresh" : r.iconName);
    return (c, g) => (v(), me(Ii(e.href ? "a" : "button"), {
      class: w(d.value),
      disabled: e.disabled || e.loading,
      type: e.type,
      href: e.href,
      onClick: g[0] || (g[0] = (h) => o("click", h))
    }, {
      default: dt(() => [
        we(c.$slots, "icon", {}, () => [
          f.value ? (v(), me(Te, {
            key: 0,
            name: f.value,
            color: u.value,
            size: e.appearance === "rounded" ? 24 : 16,
            inverse: e.inverse,
            loading: e.loading,
            orientation: e.iconOrientation
          }, null, 8, ["name", "color", "size", "inverse", "loading", "orientation"])) : D("", !0)
        ], !0),
        e.appearance !== "rounded" ? (v(), m(ce, { key: 0 }, [
          _n(ie(e.label), 1)
        ], 64)) : D("", !0)
      ]),
      _: 3
    }, 8, ["class", "disabled", "type", "href"]));
  }
}, wa = /* @__PURE__ */ ae(Kw, [["__scopeId", "data-v-e87e23fd"]]), Xw = {
  key: 0,
  class: "orq-banner__image"
}, Jw = ["src", "alt"], Qw = {
  key: 0,
  class: "orq-banner__badges"
}, jw = {
  key: 2,
  class: "orq-banner__actions"
}, F3 = {
  __name: "Banner",
  props: {
    src: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    },
    badge: {
      type: Object,
      default: () => {
      }
    },
    size: {
      type: String,
      default: "large"
    },
    imageSize: {
      type: String,
      default: "default"
    },
    imageAlt: {
      type: String,
      default: ""
    },
    imageAlign: {
      type: String,
      default: "left"
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    bgNeutral: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    buttonText: {
      type: String,
      default: ""
    },
    linkText: {
      type: String,
      default: ""
    },
    linkTarget: {
      type: String,
      default: "_self"
    },
    href: {
      type: String,
      default: "#"
    },
    backgroundColor: {
      type: String,
      default: ""
    },
    textColor: {
      type: String,
      default: ""
    }
  },
  emits: ["buttonAction", "linkAction"],
  setup(e, { emit: a }) {
    ir((g) => ({
      "631f7930": e.backgroundColor,
      53612509: e.textColor
    }));
    const r = a, s = e, o = B(() => s.size === "xsmall"), d = B(() => ({
      "orq-banner": !0,
      [`orq-banner--${s.size}`]: !0,
      [`orq-banner--image-${s.imageSize}`]: !0,
      "orq-banner--image-align-right": (() => {
        const h = s.imageAlign === "right", q = s.size !== "small" && s.size !== "medium";
        return h && q;
      })(),
      "orq-banner--inverse": s.inverse,
      "orq-banner--neutral": s.bgNeutral,
      "orq-banner--image-rounded": s.imageSize === "rounded",
      "orq-banner--image-large": s.imageSize === "large",
      "orq-banner--custom-background-color": s.backgroundColor,
      "orq-banner--custom-text-color": s.backgroundColor
    })), u = B(() => s.imageAlt), f = () => {
      r("buttonAction");
    }, c = () => {
      r("linkAction");
    };
    return (g, h) => {
      const q = $0("dompurify-html");
      return v(), m("div", {
        class: w(["orq-banner", d.value])
      }, [
        e.src ? (v(), m("div", Xw, [
          y("img", {
            src: e.src,
            alt: u.value || e.title
          }, null, 8, Jw)
        ])) : D("", !0),
        y("div", {
          class: w(["orq-banner__container", {
            "orq-banner--custom-background-color": e.backgroundColor
          }])
        }, [
          !tt(fo.isEmpty)(e.badge) && !o.value ? (v(), m("div", Qw, [
            re(gd, Yc(Uc(e.badge)), null, 16)
          ])) : D("", !0),
          y("p", {
            class: w(["orq-banner__title", {
              "orq-banner--custom-text-color": e.backgroundColor
            }])
          }, ie(e.title), 3),
          e.subtitle ? (v(), m("p", {
            key: 1,
            class: w(["orq-banner__subtitle", {
              "orq-banner--custom-text-color": e.backgroundColor
            }])
          }, ie(e.subtitle), 3)) : D("", !0),
          y("div", {
            class: w(["orq-banner__content", {
              "orq-banner--custom-text-color": e.backgroundColor
            }])
          }, [
            we(g.$slots, "default", {}, () => [
              Kr(y("div", null, null, 512), [
                [q, e.content]
              ])
            ])
          ], 2),
          e.buttonText || e.linkText ? (v(), m("div", jw, [
            we(g.$slots, "actions", {}, () => [
              e.buttonText ? (v(), me(wa, {
                key: 0,
                inverse: e.inverse,
                appearance: "line",
                size: "compact",
                label: e.buttonText,
                onClick: h[0] || (h[0] = Ct((C) => f(), ["stop"]))
              }, null, 8, ["inverse", "label"])) : D("", !0),
              e.linkText ? (v(), me(Ri, {
                key: 1,
                inverse: e.inverse,
                icon: "default",
                href: e.href,
                label: e.linkText,
                target: e.linkTarget,
                onClick: Ct(c, ["stop"])
              }, null, 8, ["inverse", "href", "label", "target"])) : D("", !0)
            ])
          ])) : D("", !0)
        ], 2)
      ], 2);
    };
  }
}, e$ = { class: "orq-breadcrumb" }, t$ = ["onClick"], n$ = ["href"], E3 = {
  __name: "Breadcrumb",
  props: {
    iconName: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = e, r = () => a.iconName ?? "", s = () => a.inverse ? Xe.emphasisBaseInverseHigh : Xe.emphasisBaseHigh, o = (c) => {
      window.location.href = c;
    }, d = (c) => {
      o(c);
    }, u = B(() => ({
      "orq-breadcrumb__home-icon": !0,
      "orq-breadcrumb__label": !0,
      "orq-breadcrumb__label--inverse": a.inverse
    })), f = B(() => ({
      "orq-breadcrumb__icon": !0,
      "orq-breadcrumb__icon--inverse": a.inverse
    }));
    return (c, g) => (v(), m("ul", e$, [
      (v(!0), m(ce, null, Re(e.items, (h, q) => {
        var C;
        return v(), m("li", { key: q }, [
          q === 0 && e.iconName ? (v(), m("div", {
            key: 0,
            role: "button",
            class: "orq-breadcrumb__home-icon",
            onClick: (O) => d(h.route)
          }, [
            re(Te, {
              type: "none",
              name: r(),
              size: 16,
              inverse: e.inverse,
              color: s()
            }, null, 8, ["name", "inverse", "color"])
          ], 8, t$)) : D("", !0),
          h != null && h.route && q < e.items.length - 1 ? (v(), m("a", {
            key: 1,
            style: { "text-decoration-line": "none" },
            role: "button",
            class: w(u.value),
            href: h == null ? void 0 : h.route
          }, ie(h == null ? void 0 : h.label), 11, n$)) : (v(), m("span", {
            key: 2,
            class: w(u.value)
          }, ie(h == null ? void 0 : h.label), 3)),
          q !== ((C = e.items) == null ? void 0 : C.length) - 1 ? (v(), m("div", {
            key: 3,
            role: "button",
            class: w(f.value)
          }, [
            re(Te, {
              type: "none",
              name: "chevron-right",
              size: 16,
              inverse: e.inverse,
              color: s()
            }, null, 8, ["inverse", "color"])
          ], 2)) : D("", !0)
        ]);
      }), 128))
    ]));
  }
}, r$ = { class: "orq-button-group" }, a$ = ["onClick"], i$ = {
  __name: "ButtonGroup",
  props: /* @__PURE__ */ Da({
    options: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: "small",
      validator: (e) => ["small", "large"].includes(e)
    }
  }, {
    modelValue: { type: Number, default: 0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const a = (s) => {
      r.value = s;
    }, r = Ba(e, "modelValue");
    return (s, o) => (v(), m("div", r$, [
      (v(!0), m(ce, null, Re(e.options, (d, u) => (v(), m("button", {
        key: u,
        class: w(["orq-button-group__item", { selected: u === r.value, large: e.size === "large" }]),
        onClick: (f) => a(u)
      }, ie(d), 11, a$))), 128))
    ]));
  }
}, P3 = /* @__PURE__ */ ae(i$, [["__scopeId", "data-v-d6d497d8"]]), s$ = Oe({
  name: "OrqCalendarSingleDatePickerWrapper",
  props: {
    mode: {
      type: String,
      default: ""
    }
  }
}), o$ = { class: "c-datepicker" };
function l$(e, a, r, s, o, d) {
  return v(), m("div", {
    class: w(e.mode === "calendar" ? "calendar" : "datepicker")
  }, [
    y("div", o$, [
      we(e.$slots, "default")
    ])
  ], 2);
}
const u$ = /* @__PURE__ */ ae(s$, [["render", l$]]), c$ = {
  Year: "year",
  Month: "month",
  Day: "day"
}, yd = 42, d$ = 0, f$ = [0, 7, 14, 21, 28, 35], v$ = [4, 11, 18, 25, 32, 39], wr = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre"
], p$ = (e, { index: a }, r, s, o, d, u, f, c) => {
  function g(M, F) {
    return F.find((P) => {
      const x = new Date(P);
      return h(x, M);
    });
  }
  function h(M, F) {
    return !M || !F ? !1 : M.getTime() === F.getTime();
  }
  function q(M) {
    const [F, P, x] = M.date.split("/");
    return [P, F, x].join("/");
  }
  function C(M, F) {
    return F.filter((P) => {
      const x = new Date(q(P));
      return h(x, M);
    });
  }
  function O(M, F) {
    return !!F.find((x) => {
      const $ = new Date(x);
      return h($, M);
    });
  }
  function S(M, F) {
    return !!F.find((x) => {
      const $ = new Date(x);
      return h($, M);
    });
  }
  function I(M) {
    return !!(M.getMonth() != o.getMonth() || k$() || q$());
  }
  return {
    date: e,
    index: a,
    event: C(e, r),
    selected: g(e, s),
    disabled: I(e),
    blocked: O(e, f),
    allowed: S(e, c)
  };
}, h$ = (e, a, r, s, o, d, u, f) => {
  const c = g$(e), g = b$(e), h = _$(
    e,
    c.length + g.length
  ), q = [
    ...c,
    ...g,
    ...h
  ], C = new Array(yd);
  for (let O = 0; O < C.length; O++)
    C[O] = p$(
      q[O],
      { index: O },
      a,
      r,
      s,
      o,
      d,
      u,
      f
    );
  return C;
}, g$ = (e) => {
  const a = m$(e), r = bd(a), s = y$(r == null ? void 0 : r.getDay());
  return S$(s, r);
}, m$ = (e) => new Date(e == null ? void 0 : e.getFullYear(), (e == null ? void 0 : e.getMonth()) - 1), bd = (e) => new Date(e == null ? void 0 : e.getFullYear(), (e == null ? void 0 : e.getMonth()) + 1, 0), y$ = (e) => e === d$ ? 0 : e, b$ = (e) => {
  const a = e == null ? void 0 : e.getMonth(), r = e == null ? void 0 : e.getFullYear(), s = bd(e), o = s == null ? void 0 : s.getDate(), d = new Array(s);
  for (let u = 0; u < o; u++) {
    const f = new Date(r, a, u + 1);
    d[u] = f;
  }
  return d;
}, _$ = (e, a) => {
  const r = w$(e), s = $$(a);
  return C$(s, r);
}, w$ = (e) => new Date(e == null ? void 0 : e.getFullYear(), (e == null ? void 0 : e.getMonth()) + 1, 1), $$ = (e) => yd - e, C$ = (e, a) => {
  const r = [];
  for (let s = 1; r.length < e; s++) {
    const o = new Date(
      a == null ? void 0 : a.getFullYear(),
      a == null ? void 0 : a.getMonth(),
      s
    );
    r.push(o);
  }
  return r;
}, S$ = (e, a) => {
  const r = [];
  for (let s = a == null ? void 0 : a.getDate(); r.length < e; s--) {
    const o = new Date(a == null ? void 0 : a.getFullYear(), a == null ? void 0 : a.getMonth(), s);
    r.unshift(o);
  }
  return r;
}, k$ = (e, a) => !1, q$ = (e, a) => !1;
/*!
  * vue-tippy v6.4.1
  * (c) 2023 
  * @license MIT
  */
var Ht = "top", ln = "bottom", un = "right", Vt = "left", Io = "auto", Oa = [Ht, ln, un, Vt], Vr = "start", Sa = "end", D$ = "clippingParents", _d = "viewport", ba = "popper", B$ = "reference", $c = /* @__PURE__ */ Oa.reduce(function(e, a) {
  return e.concat([a + "-" + Vr, a + "-" + Sa]);
}, []), wd = /* @__PURE__ */ [].concat(Oa, [Io]).reduce(function(e, a) {
  return e.concat([a, a + "-" + Vr, a + "-" + Sa]);
}, []), A$ = "beforeRead", T$ = "read", O$ = "afterRead", I$ = "beforeMain", M$ = "main", x$ = "afterMain", L$ = "beforeWrite", F$ = "write", E$ = "afterWrite", P$ = [A$, T$, O$, I$, M$, x$, L$, F$, E$];
function In(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function wn(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var a = e.ownerDocument;
    return a && a.defaultView || window;
  }
  return e;
}
function Yr(e) {
  var a = wn(e).Element;
  return e instanceof a || e instanceof Element;
}
function on(e) {
  var a = wn(e).HTMLElement;
  return e instanceof a || e instanceof HTMLElement;
}
function $d(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var a = wn(e).ShadowRoot;
  return e instanceof a || e instanceof ShadowRoot;
}
function z$(e) {
  var a = e.state;
  Object.keys(a.elements).forEach(function(r) {
    var s = a.styles[r] || {}, o = a.attributes[r] || {}, d = a.elements[r];
    !on(d) || !In(d) || (Object.assign(d.style, s), Object.keys(o).forEach(function(u) {
      var f = o[u];
      f === !1 ? d.removeAttribute(u) : d.setAttribute(u, f === !0 ? "" : f);
    }));
  });
}
function R$(e) {
  var a = e.state, r = {
    popper: {
      position: a.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(a.elements.popper.style, r.popper), a.styles = r, a.elements.arrow && Object.assign(a.elements.arrow.style, r.arrow), function() {
    Object.keys(a.elements).forEach(function(s) {
      var o = a.elements[s], d = a.attributes[s] || {}, u = Object.keys(a.styles.hasOwnProperty(s) ? a.styles[s] : r[s]), f = u.reduce(function(c, g) {
        return c[g] = "", c;
      }, {});
      !on(o) || !In(o) || (Object.assign(o.style, f), Object.keys(d).forEach(function(c) {
        o.removeAttribute(c);
      }));
    });
  };
}
var Cd = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: z$,
  effect: R$,
  requires: ["computeStyles"]
};
function On(e) {
  return e.split("-")[0];
}
var $r = Math.max, Ai = Math.min, Ur = Math.round;
function Wr(e, a) {
  a === void 0 && (a = !1);
  var r = e.getBoundingClientRect(), s = 1, o = 1;
  if (on(e) && a) {
    var d = e.offsetHeight, u = e.offsetWidth;
    u > 0 && (s = Ur(r.width) / u || 1), d > 0 && (o = Ur(r.height) / d || 1);
  }
  return {
    width: r.width / s,
    height: r.height / o,
    top: r.top / o,
    right: r.right / s,
    bottom: r.bottom / o,
    left: r.left / s,
    x: r.left / s,
    y: r.top / o
  };
}
function Mo(e) {
  var a = Wr(e), r = e.offsetWidth, s = e.offsetHeight;
  return Math.abs(a.width - r) <= 1 && (r = a.width), Math.abs(a.height - s) <= 1 && (s = a.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: s
  };
}
function Sd(e, a) {
  var r = a.getRootNode && a.getRootNode();
  if (e.contains(a))
    return !0;
  if (r && $d(r)) {
    var s = a;
    do {
      if (s && e.isSameNode(s))
        return !0;
      s = s.parentNode || s.host;
    } while (s);
  }
  return !1;
}
function Mn(e) {
  return wn(e).getComputedStyle(e);
}
function N$(e) {
  return ["table", "td", "th"].indexOf(In(e)) >= 0;
}
function sr(e) {
  return ((Yr(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Ni(e) {
  return In(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    ($d(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    sr(e)
  );
}
function Cc(e) {
  return !on(e) || // https://github.com/popperjs/popper-core/issues/837
  Mn(e).position === "fixed" ? null : e.offsetParent;
}
function H$(e) {
  var a = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, r = navigator.userAgent.indexOf("Trident") !== -1;
  if (r && on(e)) {
    var s = Mn(e);
    if (s.position === "fixed")
      return null;
  }
  for (var o = Ni(e); on(o) && ["html", "body"].indexOf(In(o)) < 0; ) {
    var d = Mn(o);
    if (d.transform !== "none" || d.perspective !== "none" || d.contain === "paint" || ["transform", "perspective"].indexOf(d.willChange) !== -1 || a && d.willChange === "filter" || a && d.filter && d.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Ia(e) {
  for (var a = wn(e), r = Cc(e); r && N$(r) && Mn(r).position === "static"; )
    r = Cc(r);
  return r && (In(r) === "html" || In(r) === "body" && Mn(r).position === "static") ? a : r || H$(e) || a;
}
function xo(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function $a(e, a, r) {
  return $r(e, Ai(a, r));
}
function V$(e, a, r) {
  var s = $a(e, a, r);
  return s > r ? r : s;
}
function kd() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function qd(e) {
  return Object.assign({}, kd(), e);
}
function Dd(e, a) {
  return a.reduce(function(r, s) {
    return r[s] = e, r;
  }, {});
}
var Y$ = function(a, r) {
  return a = typeof a == "function" ? a(Object.assign({}, r.rects, {
    placement: r.placement
  })) : a, qd(typeof a != "number" ? a : Dd(a, Oa));
};
function U$(e) {
  var a, r = e.state, s = e.name, o = e.options, d = r.elements.arrow, u = r.modifiersData.popperOffsets, f = On(r.placement), c = xo(f), g = [Vt, un].indexOf(f) >= 0, h = g ? "height" : "width";
  if (!(!d || !u)) {
    var q = Y$(o.padding, r), C = Mo(d), O = c === "y" ? Ht : Vt, S = c === "y" ? ln : un, I = r.rects.reference[h] + r.rects.reference[c] - u[c] - r.rects.popper[h], M = u[c] - r.rects.reference[c], F = Ia(d), P = F ? c === "y" ? F.clientHeight || 0 : F.clientWidth || 0 : 0, x = I / 2 - M / 2, $ = q[O], Y = P - C[h] - q[S], R = P / 2 - C[h] / 2 + x, T = $a($, R, Y), z = c;
    r.modifiersData[s] = (a = {}, a[z] = T, a.centerOffset = T - R, a);
  }
}
function W$(e) {
  var a = e.state, r = e.options, s = r.element, o = s === void 0 ? "[data-popper-arrow]" : s;
  o != null && (typeof o == "string" && (o = a.elements.popper.querySelector(o), !o) || Sd(a.elements.popper, o) && (a.elements.arrow = o));
}
var G$ = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: U$,
  effect: W$,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Gr(e) {
  return e.split("-")[1];
}
var Z$ = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function K$(e) {
  var a = e.x, r = e.y, s = window, o = s.devicePixelRatio || 1;
  return {
    x: Ur(a * o) / o || 0,
    y: Ur(r * o) / o || 0
  };
}
function Sc(e) {
  var a, r = e.popper, s = e.popperRect, o = e.placement, d = e.variation, u = e.offsets, f = e.position, c = e.gpuAcceleration, g = e.adaptive, h = e.roundOffsets, q = e.isFixed, C = h === !0 ? K$(u) : typeof h == "function" ? h(u) : u, O = C.x, S = O === void 0 ? 0 : O, I = C.y, M = I === void 0 ? 0 : I, F = u.hasOwnProperty("x"), P = u.hasOwnProperty("y"), x = Vt, $ = Ht, Y = window;
  if (g) {
    var R = Ia(r), T = "clientHeight", z = "clientWidth";
    if (R === wn(r) && (R = sr(r), Mn(R).position !== "static" && f === "absolute" && (T = "scrollHeight", z = "scrollWidth")), R = R, o === Ht || (o === Vt || o === un) && d === Sa) {
      $ = ln;
      var le = q && Y.visualViewport ? Y.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        R[T]
      );
      M -= le - s.height, M *= c ? 1 : -1;
    }
    if (o === Vt || (o === Ht || o === ln) && d === Sa) {
      x = un;
      var K = q && Y.visualViewport ? Y.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        R[z]
      );
      S -= K - s.width, S *= c ? 1 : -1;
    }
  }
  var se = Object.assign({
    position: f
  }, g && Z$);
  if (c) {
    var oe;
    return Object.assign({}, se, (oe = {}, oe[$] = P ? "0" : "", oe[x] = F ? "0" : "", oe.transform = (Y.devicePixelRatio || 1) <= 1 ? "translate(" + S + "px, " + M + "px)" : "translate3d(" + S + "px, " + M + "px, 0)", oe));
  }
  return Object.assign({}, se, (a = {}, a[$] = P ? M + "px" : "", a[x] = F ? S + "px" : "", a.transform = "", a));
}
function X$(e) {
  var a = e.state, r = e.options, s = r.gpuAcceleration, o = s === void 0 ? !0 : s, d = r.adaptive, u = d === void 0 ? !0 : d, f = r.roundOffsets, c = f === void 0 ? !0 : f, g = {
    placement: On(a.placement),
    variation: Gr(a.placement),
    popper: a.elements.popper,
    popperRect: a.rects.popper,
    gpuAcceleration: o,
    isFixed: a.options.strategy === "fixed"
  };
  a.modifiersData.popperOffsets != null && (a.styles.popper = Object.assign({}, a.styles.popper, Sc(Object.assign({}, g, {
    offsets: a.modifiersData.popperOffsets,
    position: a.options.strategy,
    adaptive: u,
    roundOffsets: c
  })))), a.modifiersData.arrow != null && (a.styles.arrow = Object.assign({}, a.styles.arrow, Sc(Object.assign({}, g, {
    offsets: a.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), a.attributes.popper = Object.assign({}, a.attributes.popper, {
    "data-popper-placement": a.placement
  });
}
var J$ = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: X$,
  data: {}
}, $i = {
  passive: !0
};
function Q$(e) {
  var a = e.state, r = e.instance, s = e.options, o = s.scroll, d = o === void 0 ? !0 : o, u = s.resize, f = u === void 0 ? !0 : u, c = wn(a.elements.popper), g = [].concat(a.scrollParents.reference, a.scrollParents.popper);
  return d && g.forEach(function(h) {
    h.addEventListener("scroll", r.update, $i);
  }), f && c.addEventListener("resize", r.update, $i), function() {
    d && g.forEach(function(h) {
      h.removeEventListener("scroll", r.update, $i);
    }), f && c.removeEventListener("resize", r.update, $i);
  };
}
var j$ = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Q$,
  data: {}
}, e2 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ki(e) {
  return e.replace(/left|right|bottom|top/g, function(a) {
    return e2[a];
  });
}
var t2 = {
  start: "end",
  end: "start"
};
function kc(e) {
  return e.replace(/start|end/g, function(a) {
    return t2[a];
  });
}
function Lo(e) {
  var a = wn(e), r = a.pageXOffset, s = a.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: s
  };
}
function Fo(e) {
  return Wr(sr(e)).left + Lo(e).scrollLeft;
}
function n2(e) {
  var a = wn(e), r = sr(e), s = a.visualViewport, o = r.clientWidth, d = r.clientHeight, u = 0, f = 0;
  return s && (o = s.width, d = s.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (u = s.offsetLeft, f = s.offsetTop)), {
    width: o,
    height: d,
    x: u + Fo(e),
    y: f
  };
}
function r2(e) {
  var a, r = sr(e), s = Lo(e), o = (a = e.ownerDocument) == null ? void 0 : a.body, d = $r(r.scrollWidth, r.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), u = $r(r.scrollHeight, r.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), f = -s.scrollLeft + Fo(e), c = -s.scrollTop;
  return Mn(o || r).direction === "rtl" && (f += $r(r.clientWidth, o ? o.clientWidth : 0) - d), {
    width: d,
    height: u,
    x: f,
    y: c
  };
}
function Eo(e) {
  var a = Mn(e), r = a.overflow, s = a.overflowX, o = a.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + o + s);
}
function Bd(e) {
  return ["html", "body", "#document"].indexOf(In(e)) >= 0 ? e.ownerDocument.body : on(e) && Eo(e) ? e : Bd(Ni(e));
}
function Ca(e, a) {
  var r;
  a === void 0 && (a = []);
  var s = Bd(e), o = s === ((r = e.ownerDocument) == null ? void 0 : r.body), d = wn(s), u = o ? [d].concat(d.visualViewport || [], Eo(s) ? s : []) : s, f = a.concat(u);
  return o ? f : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    f.concat(Ca(Ni(u)))
  );
}
function vo(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function a2(e) {
  var a = Wr(e);
  return a.top = a.top + e.clientTop, a.left = a.left + e.clientLeft, a.bottom = a.top + e.clientHeight, a.right = a.left + e.clientWidth, a.width = e.clientWidth, a.height = e.clientHeight, a.x = a.left, a.y = a.top, a;
}
function qc(e, a) {
  return a === _d ? vo(n2(e)) : Yr(a) ? a2(a) : vo(r2(sr(e)));
}
function i2(e) {
  var a = Ca(Ni(e)), r = ["absolute", "fixed"].indexOf(Mn(e).position) >= 0, s = r && on(e) ? Ia(e) : e;
  return Yr(s) ? a.filter(function(o) {
    return Yr(o) && Sd(o, s) && In(o) !== "body" && (r ? Mn(o).position !== "static" : !0);
  }) : [];
}
function s2(e, a, r) {
  var s = a === "clippingParents" ? i2(e) : [].concat(a), o = [].concat(s, [r]), d = o[0], u = o.reduce(function(f, c) {
    var g = qc(e, c);
    return f.top = $r(g.top, f.top), f.right = Ai(g.right, f.right), f.bottom = Ai(g.bottom, f.bottom), f.left = $r(g.left, f.left), f;
  }, qc(e, d));
  return u.width = u.right - u.left, u.height = u.bottom - u.top, u.x = u.left, u.y = u.top, u;
}
function Ad(e) {
  var a = e.reference, r = e.element, s = e.placement, o = s ? On(s) : null, d = s ? Gr(s) : null, u = a.x + a.width / 2 - r.width / 2, f = a.y + a.height / 2 - r.height / 2, c;
  switch (o) {
    case Ht:
      c = {
        x: u,
        y: a.y - r.height
      };
      break;
    case ln:
      c = {
        x: u,
        y: a.y + a.height
      };
      break;
    case un:
      c = {
        x: a.x + a.width,
        y: f
      };
      break;
    case Vt:
      c = {
        x: a.x - r.width,
        y: f
      };
      break;
    default:
      c = {
        x: a.x,
        y: a.y
      };
  }
  var g = o ? xo(o) : null;
  if (g != null) {
    var h = g === "y" ? "height" : "width";
    switch (d) {
      case Vr:
        c[g] = c[g] - (a[h] / 2 - r[h] / 2);
        break;
      case Sa:
        c[g] = c[g] + (a[h] / 2 - r[h] / 2);
        break;
    }
  }
  return c;
}
function ka(e, a) {
  a === void 0 && (a = {});
  var r = a, s = r.placement, o = s === void 0 ? e.placement : s, d = r.boundary, u = d === void 0 ? D$ : d, f = r.rootBoundary, c = f === void 0 ? _d : f, g = r.elementContext, h = g === void 0 ? ba : g, q = r.altBoundary, C = q === void 0 ? !1 : q, O = r.padding, S = O === void 0 ? 0 : O, I = qd(typeof S != "number" ? S : Dd(S, Oa)), M = h === ba ? B$ : ba, F = e.rects.popper, P = e.elements[C ? M : h], x = s2(Yr(P) ? P : P.contextElement || sr(e.elements.popper), u, c), $ = Wr(e.elements.reference), Y = Ad({
    reference: $,
    element: F,
    strategy: "absolute",
    placement: o
  }), R = vo(Object.assign({}, F, Y)), T = h === ba ? R : $, z = {
    top: x.top - T.top + I.top,
    bottom: T.bottom - x.bottom + I.bottom,
    left: x.left - T.left + I.left,
    right: T.right - x.right + I.right
  }, le = e.modifiersData.offset;
  if (h === ba && le) {
    var K = le[o];
    Object.keys(z).forEach(function(se) {
      var oe = [un, ln].indexOf(se) >= 0 ? 1 : -1, ve = [Ht, ln].indexOf(se) >= 0 ? "y" : "x";
      z[se] += K[ve] * oe;
    });
  }
  return z;
}
function o2(e, a) {
  a === void 0 && (a = {});
  var r = a, s = r.placement, o = r.boundary, d = r.rootBoundary, u = r.padding, f = r.flipVariations, c = r.allowedAutoPlacements, g = c === void 0 ? wd : c, h = Gr(s), q = h ? f ? $c : $c.filter(function(S) {
    return Gr(S) === h;
  }) : Oa, C = q.filter(function(S) {
    return g.indexOf(S) >= 0;
  });
  C.length === 0 && (C = q);
  var O = C.reduce(function(S, I) {
    return S[I] = ka(e, {
      placement: I,
      boundary: o,
      rootBoundary: d,
      padding: u
    })[On(I)], S;
  }, {});
  return Object.keys(O).sort(function(S, I) {
    return O[S] - O[I];
  });
}
function l2(e) {
  if (On(e) === Io)
    return [];
  var a = ki(e);
  return [kc(e), a, kc(a)];
}
function u2(e) {
  var a = e.state, r = e.options, s = e.name;
  if (!a.modifiersData[s]._skip) {
    for (var o = r.mainAxis, d = o === void 0 ? !0 : o, u = r.altAxis, f = u === void 0 ? !0 : u, c = r.fallbackPlacements, g = r.padding, h = r.boundary, q = r.rootBoundary, C = r.altBoundary, O = r.flipVariations, S = O === void 0 ? !0 : O, I = r.allowedAutoPlacements, M = a.options.placement, F = On(M), P = F === M, x = c || (P || !S ? [ki(M)] : l2(M)), $ = [M].concat(x).reduce(function(Se, Me) {
      return Se.concat(On(Me) === Io ? o2(a, {
        placement: Me,
        boundary: h,
        rootBoundary: q,
        padding: g,
        flipVariations: S,
        allowedAutoPlacements: I
      }) : Me);
    }, []), Y = a.rects.reference, R = a.rects.popper, T = /* @__PURE__ */ new Map(), z = !0, le = $[0], K = 0; K < $.length; K++) {
      var se = $[K], oe = On(se), ve = Gr(se) === Vr, ee = [Ht, ln].indexOf(oe) >= 0, Q = ee ? "width" : "height", J = ka(a, {
        placement: se,
        boundary: h,
        rootBoundary: q,
        altBoundary: C,
        padding: g
      }), te = ee ? ve ? un : Vt : ve ? ln : Ht;
      Y[Q] > R[Q] && (te = ki(te));
      var G = ki(te), de = [];
      if (d && de.push(J[oe] <= 0), f && de.push(J[te] <= 0, J[G] <= 0), de.every(function(Se) {
        return Se;
      })) {
        le = se, z = !1;
        break;
      }
      T.set(se, de);
    }
    if (z)
      for (var ge = S ? 3 : 1, N = function(Me) {
        var Ne = $.find(function(pt) {
          var st = T.get(pt);
          if (st)
            return st.slice(0, Me).every(function(ke) {
              return ke;
            });
        });
        if (Ne)
          return le = Ne, "break";
      }, ne = ge; ne > 0; ne--) {
        var ue = N(ne);
        if (ue === "break") break;
      }
    a.placement !== le && (a.modifiersData[s]._skip = !0, a.placement = le, a.reset = !0);
  }
}
var c2 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: u2,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Dc(e, a, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - a.height - r.y,
    right: e.right - a.width + r.x,
    bottom: e.bottom - a.height + r.y,
    left: e.left - a.width - r.x
  };
}
function Bc(e) {
  return [Ht, un, ln, Vt].some(function(a) {
    return e[a] >= 0;
  });
}
function d2(e) {
  var a = e.state, r = e.name, s = a.rects.reference, o = a.rects.popper, d = a.modifiersData.preventOverflow, u = ka(a, {
    elementContext: "reference"
  }), f = ka(a, {
    altBoundary: !0
  }), c = Dc(u, s), g = Dc(f, o, d), h = Bc(c), q = Bc(g);
  a.modifiersData[r] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: g,
    isReferenceHidden: h,
    hasPopperEscaped: q
  }, a.attributes.popper = Object.assign({}, a.attributes.popper, {
    "data-popper-reference-hidden": h,
    "data-popper-escaped": q
  });
}
var f2 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: d2
};
function v2(e, a, r) {
  var s = On(e), o = [Vt, Ht].indexOf(s) >= 0 ? -1 : 1, d = typeof r == "function" ? r(Object.assign({}, a, {
    placement: e
  })) : r, u = d[0], f = d[1];
  return u = u || 0, f = (f || 0) * o, [Vt, un].indexOf(s) >= 0 ? {
    x: f,
    y: u
  } : {
    x: u,
    y: f
  };
}
function p2(e) {
  var a = e.state, r = e.options, s = e.name, o = r.offset, d = o === void 0 ? [0, 0] : o, u = wd.reduce(function(h, q) {
    return h[q] = v2(q, a.rects, d), h;
  }, {}), f = u[a.placement], c = f.x, g = f.y;
  a.modifiersData.popperOffsets != null && (a.modifiersData.popperOffsets.x += c, a.modifiersData.popperOffsets.y += g), a.modifiersData[s] = u;
}
var h2 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: p2
};
function g2(e) {
  var a = e.state, r = e.name;
  a.modifiersData[r] = Ad({
    reference: a.rects.reference,
    element: a.rects.popper,
    strategy: "absolute",
    placement: a.placement
  });
}
var m2 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: g2,
  data: {}
};
function y2(e) {
  return e === "x" ? "y" : "x";
}
function b2(e) {
  var a = e.state, r = e.options, s = e.name, o = r.mainAxis, d = o === void 0 ? !0 : o, u = r.altAxis, f = u === void 0 ? !1 : u, c = r.boundary, g = r.rootBoundary, h = r.altBoundary, q = r.padding, C = r.tether, O = C === void 0 ? !0 : C, S = r.tetherOffset, I = S === void 0 ? 0 : S, M = ka(a, {
    boundary: c,
    rootBoundary: g,
    padding: q,
    altBoundary: h
  }), F = On(a.placement), P = Gr(a.placement), x = !P, $ = xo(F), Y = y2($), R = a.modifiersData.popperOffsets, T = a.rects.reference, z = a.rects.popper, le = typeof I == "function" ? I(Object.assign({}, a.rects, {
    placement: a.placement
  })) : I, K = typeof le == "number" ? {
    mainAxis: le,
    altAxis: le
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, le), se = a.modifiersData.offset ? a.modifiersData.offset[a.placement] : null, oe = {
    x: 0,
    y: 0
  };
  if (R) {
    if (d) {
      var ve, ee = $ === "y" ? Ht : Vt, Q = $ === "y" ? ln : un, J = $ === "y" ? "height" : "width", te = R[$], G = te + M[ee], de = te - M[Q], ge = O ? -z[J] / 2 : 0, N = P === Vr ? T[J] : z[J], ne = P === Vr ? -z[J] : -T[J], ue = a.elements.arrow, Se = O && ue ? Mo(ue) : {
        width: 0,
        height: 0
      }, Me = a.modifiersData["arrow#persistent"] ? a.modifiersData["arrow#persistent"].padding : kd(), Ne = Me[ee], pt = Me[Q], st = $a(0, T[J], Se[J]), ke = x ? T[J] / 2 - ge - st - Ne - K.mainAxis : N - st - Ne - K.mainAxis, Ie = x ? -T[J] / 2 + ge + st + pt + K.mainAxis : ne + st + pt + K.mainAxis, Je = a.elements.arrow && Ia(a.elements.arrow), he = Je ? $ === "y" ? Je.clientTop || 0 : Je.clientLeft || 0 : 0, je = (ve = se == null ? void 0 : se[$]) != null ? ve : 0, Ze = te + ke - je - he, wt = te + Ie - je, Ot = $a(O ? Ai(G, Ze) : G, te, O ? $r(de, wt) : de);
      R[$] = Ot, oe[$] = Ot - te;
    }
    if (f) {
      var ht, cn = $ === "x" ? Ht : Vt, $n = $ === "x" ? ln : un, Dt = R[Y], yt = Y === "y" ? "height" : "width", dn = Dt + M[cn], Jt = Dt - M[$n], or = [Ht, Vt].indexOf(F) !== -1, Cn = (ht = se == null ? void 0 : se[Y]) != null ? ht : 0, Sr = or ? dn : Dt - T[yt] - z[yt] - Cn + K.altAxis, Sn = or ? Dt + T[yt] + z[yt] - Cn - K.altAxis : Jt, fn = O && or ? V$(Sr, Dt, Sn) : $a(O ? Sr : dn, Dt, O ? Sn : Jt);
      R[Y] = fn, oe[Y] = fn - Dt;
    }
    a.modifiersData[s] = oe;
  }
}
var _2 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: b2,
  requiresIfExists: ["offset"]
};
function w2(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function $2(e) {
  return e === wn(e) || !on(e) ? Lo(e) : w2(e);
}
function C2(e) {
  var a = e.getBoundingClientRect(), r = Ur(a.width) / e.offsetWidth || 1, s = Ur(a.height) / e.offsetHeight || 1;
  return r !== 1 || s !== 1;
}
function S2(e, a, r) {
  r === void 0 && (r = !1);
  var s = on(a), o = on(a) && C2(a), d = sr(a), u = Wr(e, o), f = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (s || !s && !r) && ((In(a) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Eo(d)) && (f = $2(a)), on(a) ? (c = Wr(a, !0), c.x += a.clientLeft, c.y += a.clientTop) : d && (c.x = Fo(d))), {
    x: u.left + f.scrollLeft - c.x,
    y: u.top + f.scrollTop - c.y,
    width: u.width,
    height: u.height
  };
}
function k2(e) {
  var a = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), s = [];
  e.forEach(function(d) {
    a.set(d.name, d);
  });
  function o(d) {
    r.add(d.name);
    var u = [].concat(d.requires || [], d.requiresIfExists || []);
    u.forEach(function(f) {
      if (!r.has(f)) {
        var c = a.get(f);
        c && o(c);
      }
    }), s.push(d);
  }
  return e.forEach(function(d) {
    r.has(d.name) || o(d);
  }), s;
}
function q2(e) {
  var a = k2(e);
  return P$.reduce(function(r, s) {
    return r.concat(a.filter(function(o) {
      return o.phase === s;
    }));
  }, []);
}
function D2(e) {
  var a;
  return function() {
    return a || (a = new Promise(function(r) {
      Promise.resolve().then(function() {
        a = void 0, r(e());
      });
    })), a;
  };
}
function B2(e) {
  var a = e.reduce(function(r, s) {
    var o = r[s.name];
    return r[s.name] = o ? Object.assign({}, o, s, {
      options: Object.assign({}, o.options, s.options),
      data: Object.assign({}, o.data, s.data)
    }) : s, r;
  }, {});
  return Object.keys(a).map(function(r) {
    return a[r];
  });
}
var Ac = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Tc() {
  for (var e = arguments.length, a = new Array(e), r = 0; r < e; r++)
    a[r] = arguments[r];
  return !a.some(function(s) {
    return !(s && typeof s.getBoundingClientRect == "function");
  });
}
function A2(e) {
  e === void 0 && (e = {});
  var a = e, r = a.defaultModifiers, s = r === void 0 ? [] : r, o = a.defaultOptions, d = o === void 0 ? Ac : o;
  return function(f, c, g) {
    g === void 0 && (g = d);
    var h = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Ac, d),
      modifiersData: {},
      elements: {
        reference: f,
        popper: c
      },
      attributes: {},
      styles: {}
    }, q = [], C = !1, O = {
      state: h,
      setOptions: function(F) {
        var P = typeof F == "function" ? F(h.options) : F;
        I(), h.options = Object.assign({}, d, h.options, P), h.scrollParents = {
          reference: Yr(f) ? Ca(f) : f.contextElement ? Ca(f.contextElement) : [],
          popper: Ca(c)
        };
        var x = q2(B2([].concat(s, h.options.modifiers)));
        return h.orderedModifiers = x.filter(function($) {
          return $.enabled;
        }), S(), O.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!C) {
          var F = h.elements, P = F.reference, x = F.popper;
          if (Tc(P, x)) {
            h.rects = {
              reference: S2(P, Ia(x), h.options.strategy === "fixed"),
              popper: Mo(x)
            }, h.reset = !1, h.placement = h.options.placement, h.orderedModifiers.forEach(function(K) {
              return h.modifiersData[K.name] = Object.assign({}, K.data);
            });
            for (var $ = 0; $ < h.orderedModifiers.length; $++) {
              if (h.reset === !0) {
                h.reset = !1, $ = -1;
                continue;
              }
              var Y = h.orderedModifiers[$], R = Y.fn, T = Y.options, z = T === void 0 ? {} : T, le = Y.name;
              typeof R == "function" && (h = R({
                state: h,
                options: z,
                name: le,
                instance: O
              }) || h);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: D2(function() {
        return new Promise(function(M) {
          O.forceUpdate(), M(h);
        });
      }),
      destroy: function() {
        I(), C = !0;
      }
    };
    if (!Tc(f, c))
      return O;
    O.setOptions(g).then(function(M) {
      !C && g.onFirstUpdate && g.onFirstUpdate(M);
    });
    function S() {
      h.orderedModifiers.forEach(function(M) {
        var F = M.name, P = M.options, x = P === void 0 ? {} : P, $ = M.effect;
        if (typeof $ == "function") {
          var Y = $({
            state: h,
            name: F,
            instance: O,
            options: x
          }), R = function() {
          };
          q.push(Y || R);
        }
      });
    }
    function I() {
      q.forEach(function(M) {
        return M();
      }), q = [];
    }
    return O;
  };
}
var T2 = [j$, m2, J$, Cd, h2, c2, _2, G$, f2], O2 = /* @__PURE__ */ A2({
  defaultModifiers: T2
}), I2 = "tippy-box", Td = "tippy-content", Od = "tippy-backdrop", Id = "tippy-arrow", Md = "tippy-svg-arrow", yr = {
  passive: !0,
  capture: !0
}, xd = function() {
  return document.body;
};
function ro(e, a, r) {
  if (Array.isArray(e)) {
    var s = e[a];
    return s ?? (Array.isArray(r) ? r[a] : r);
  }
  return e;
}
function Po(e, a) {
  var r = {}.toString.call(e);
  return r.indexOf("[object") === 0 && r.indexOf(a + "]") > -1;
}
function Ld(e, a) {
  return typeof e == "function" ? e.apply(void 0, a) : e;
}
function Oc(e, a) {
  if (a === 0)
    return e;
  var r;
  return function(s) {
    clearTimeout(r), r = setTimeout(function() {
      e(s);
    }, a);
  };
}
function M2(e, a) {
  var r = Object.assign({}, e);
  return a.forEach(function(s) {
    delete r[s];
  }), r;
}
function x2(e) {
  return e.split(/\s+/).filter(Boolean);
}
function _r(e) {
  return [].concat(e);
}
function Ic(e, a) {
  e.indexOf(a) === -1 && e.push(a);
}
function L2(e) {
  return e.filter(function(a, r) {
    return e.indexOf(a) === r;
  });
}
function Fd(e) {
  return e.split("-")[0];
}
function Zr(e) {
  return [].slice.call(e);
}
function Mc(e) {
  return Object.keys(e).reduce(function(a, r) {
    return e[r] !== void 0 && (a[r] = e[r]), a;
  }, {});
}
function Cr() {
  return document.createElement("div");
}
function Hi(e) {
  return ["Element", "Fragment"].some(function(a) {
    return Po(e, a);
  });
}
function F2(e) {
  return Po(e, "NodeList");
}
function zo(e) {
  return Po(e, "MouseEvent");
}
function E2(e) {
  return !!(e && e._tippy && e._tippy.reference === e);
}
function P2(e) {
  return Hi(e) ? [e] : F2(e) ? Zr(e) : Array.isArray(e) ? e : Zr(document.querySelectorAll(e));
}
function ao(e, a) {
  e.forEach(function(r) {
    r && (r.style.transitionDuration = a + "ms");
  });
}
function qa(e, a) {
  e.forEach(function(r) {
    r && r.setAttribute("data-state", a);
  });
}
function Ed(e) {
  var a, r = _r(e), s = r[0];
  return s != null && (a = s.ownerDocument) != null && a.body ? s.ownerDocument : document;
}
function z2(e, a) {
  var r = a.clientX, s = a.clientY;
  return e.every(function(o) {
    var d = o.popperRect, u = o.popperState, f = o.props, c = f.interactiveBorder, g = Fd(u.placement), h = u.modifiersData.offset;
    if (!h)
      return !0;
    var q = g === "bottom" ? h.top.y : 0, C = g === "top" ? h.bottom.y : 0, O = g === "right" ? h.left.x : 0, S = g === "left" ? h.right.x : 0, I = d.top - s + q > c, M = s - d.bottom - C > c, F = d.left - r + O > c, P = r - d.right - S > c;
    return I || M || F || P;
  });
}
function io(e, a, r) {
  var s = a + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(o) {
    e[s](o, r);
  });
}
function xc(e, a) {
  for (var r = a; r; ) {
    var s;
    if (e.contains(r))
      return !0;
    r = r.getRootNode == null || (s = r.getRootNode()) == null ? void 0 : s.host;
  }
  return !1;
}
var Bn = {
  isTouch: !1
}, Lc = 0;
function R2() {
  Bn.isTouch || (Bn.isTouch = !0, window.performance && document.addEventListener("mousemove", Pd));
}
function Pd() {
  var e = performance.now();
  e - Lc < 20 && (Bn.isTouch = !1, document.removeEventListener("mousemove", Pd)), Lc = e;
}
function N2() {
  var e = document.activeElement;
  if (E2(e)) {
    var a = e._tippy;
    e.blur && !a.state.isVisible && e.blur();
  }
}
function H2() {
  document.addEventListener("touchstart", R2, yr), window.addEventListener("blur", N2);
}
var V2 = typeof window < "u" && typeof document < "u", Y2 = V2 ? (
  // @ts-ignore
  !!window.msCrypto
) : !1, U2 = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, W2 = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, bn = Object.assign({
  appendTo: xd,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, U2, W2), G2 = Object.keys(bn), Z2 = function(a) {
  var r = Object.keys(a);
  r.forEach(function(s) {
    bn[s] = a[s];
  });
};
function zd(e) {
  var a = e.plugins || [], r = a.reduce(function(s, o) {
    var d = o.name, u = o.defaultValue;
    if (d) {
      var f;
      s[d] = e[d] !== void 0 ? e[d] : (f = bn[d]) != null ? f : u;
    }
    return s;
  }, {});
  return Object.assign({}, e, r);
}
function K2(e, a) {
  var r = a ? Object.keys(zd(Object.assign({}, bn, {
    plugins: a
  }))) : G2, s = r.reduce(function(o, d) {
    var u = (e.getAttribute("data-tippy-" + d) || "").trim();
    if (!u)
      return o;
    if (d === "content")
      o[d] = u;
    else
      try {
        o[d] = JSON.parse(u);
      } catch {
        o[d] = u;
      }
    return o;
  }, {});
  return s;
}
function Fc(e, a) {
  var r = Object.assign({}, a, {
    content: Ld(a.content, [e])
  }, a.ignoreAttributes ? {} : K2(e, a.plugins));
  return r.aria = Object.assign({}, bn.aria, r.aria), r.aria = {
    expanded: r.aria.expanded === "auto" ? a.interactive : r.aria.expanded,
    content: r.aria.content === "auto" ? a.interactive ? null : "describedby" : r.aria.content
  }, r;
}
var X2 = function() {
  return "innerHTML";
};
function po(e, a) {
  e[X2()] = a;
}
function Ec(e) {
  var a = Cr();
  return e === !0 ? a.className = Id : (a.className = Md, Hi(e) ? a.appendChild(e) : po(a, e)), a;
}
function Pc(e, a) {
  Hi(a.content) ? (po(e, ""), e.appendChild(a.content)) : typeof a.content != "function" && (a.allowHTML ? po(e, a.content) : e.textContent = a.content);
}
function Ti(e) {
  var a = e.firstElementChild, r = Zr(a.children);
  return {
    box: a,
    content: r.find(function(s) {
      return s.classList.contains(Td);
    }),
    arrow: r.find(function(s) {
      return s.classList.contains(Id) || s.classList.contains(Md);
    }),
    backdrop: r.find(function(s) {
      return s.classList.contains(Od);
    })
  };
}
function Rd(e) {
  var a = Cr(), r = Cr();
  r.className = I2, r.setAttribute("data-state", "hidden"), r.setAttribute("tabindex", "-1");
  var s = Cr();
  s.className = Td, s.setAttribute("data-state", "hidden"), Pc(s, e.props), a.appendChild(r), r.appendChild(s), o(e.props, e.props);
  function o(d, u) {
    var f = Ti(a), c = f.box, g = f.content, h = f.arrow;
    u.theme ? c.setAttribute("data-theme", u.theme) : c.removeAttribute("data-theme"), typeof u.animation == "string" ? c.setAttribute("data-animation", u.animation) : c.removeAttribute("data-animation"), u.inertia ? c.setAttribute("data-inertia", "") : c.removeAttribute("data-inertia"), c.style.maxWidth = typeof u.maxWidth == "number" ? u.maxWidth + "px" : u.maxWidth, u.role ? c.setAttribute("role", u.role) : c.removeAttribute("role"), (d.content !== u.content || d.allowHTML !== u.allowHTML) && Pc(g, e.props), u.arrow ? h ? d.arrow !== u.arrow && (c.removeChild(h), c.appendChild(Ec(u.arrow))) : c.appendChild(Ec(u.arrow)) : h && c.removeChild(h);
  }
  return {
    popper: a,
    onUpdate: o
  };
}
Rd.$$tippy = !0;
var J2 = 1, Ci = [], so = [];
function Q2(e, a) {
  var r = Fc(e, Object.assign({}, bn, zd(Mc(a)))), s, o, d, u = !1, f = !1, c = !1, g = !1, h, q, C, O = [], S = Oc(Ze, r.interactiveDebounce), I, M = J2++, F = null, P = L2(r.plugins), x = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, $ = {
    // properties
    id: M,
    reference: e,
    popper: Cr(),
    popperInstance: F,
    props: r,
    state: x,
    plugins: P,
    // methods
    clearDelayTimeouts: Sr,
    setProps: Sn,
    setContent: fn,
    show: Xr,
    hide: Jr,
    hideWithInteractivity: Qr,
    enable: or,
    disable: Cn,
    unmount: jr,
    destroy: ea
  };
  if (!r.render)
    return $;
  var Y = r.render($), R = Y.popper, T = Y.onUpdate;
  R.setAttribute("data-tippy-root", ""), R.id = "tippy-" + $.id, $.popper = R, e._tippy = $, R._tippy = $;
  var z = P.map(function(U) {
    return U.fn($);
  }), le = e.hasAttribute("aria-expanded");
  return Je(), ge(), te(), G("onCreate", [$]), r.showOnCreate && dn(), R.addEventListener("mouseenter", function() {
    $.props.interactive && $.state.isVisible && $.clearDelayTimeouts();
  }), R.addEventListener("mouseleave", function() {
    $.props.interactive && $.props.trigger.indexOf("mouseenter") >= 0 && ee().addEventListener("mousemove", S);
  }), $;
  function K() {
    var U = $.props.touch;
    return Array.isArray(U) ? U : [U, 0];
  }
  function se() {
    return K()[0] === "hold";
  }
  function oe() {
    var U;
    return !!((U = $.props.render) != null && U.$$tippy);
  }
  function ve() {
    return I || e;
  }
  function ee() {
    var U = ve().parentNode;
    return U ? Ed(U) : document;
  }
  function Q() {
    return Ti(R);
  }
  function J(U) {
    return $.state.isMounted && !$.state.isVisible || Bn.isTouch || h && h.type === "focus" ? 0 : ro($.props.delay, U ? 0 : 1, bn.delay);
  }
  function te(U) {
    U === void 0 && (U = !1), R.style.pointerEvents = $.props.interactive && !U ? "" : "none", R.style.zIndex = "" + $.props.zIndex;
  }
  function G(U, be, De) {
    if (De === void 0 && (De = !0), z.forEach(function(Ue) {
      Ue[U] && Ue[U].apply(Ue, be);
    }), De) {
      var Ge;
      (Ge = $.props)[U].apply(Ge, be);
    }
  }
  function de() {
    var U = $.props.aria;
    if (U.content) {
      var be = "aria-" + U.content, De = R.id, Ge = _r($.props.triggerTarget || e);
      Ge.forEach(function(Ue) {
        var St = Ue.getAttribute(be);
        if ($.state.isVisible)
          Ue.setAttribute(be, St ? St + " " + De : De);
        else {
          var Et = St && St.replace(De, "").trim();
          Et ? Ue.setAttribute(be, Et) : Ue.removeAttribute(be);
        }
      });
    }
  }
  function ge() {
    if (!(le || !$.props.aria.expanded)) {
      var U = _r($.props.triggerTarget || e);
      U.forEach(function(be) {
        $.props.interactive ? be.setAttribute("aria-expanded", $.state.isVisible && be === ve() ? "true" : "false") : be.removeAttribute("aria-expanded");
      });
    }
  }
  function N() {
    ee().removeEventListener("mousemove", S), Ci = Ci.filter(function(U) {
      return U !== S;
    });
  }
  function ne(U) {
    if (!(Bn.isTouch && (c || U.type === "mousedown"))) {
      var be = U.composedPath && U.composedPath()[0] || U.target;
      if (!($.props.interactive && xc(R, be))) {
        if (_r($.props.triggerTarget || e).some(function(De) {
          return xc(De, be);
        })) {
          if (Bn.isTouch || $.state.isVisible && $.props.trigger.indexOf("click") >= 0)
            return;
        } else
          G("onClickOutside", [$, U]);
        $.props.hideOnClick === !0 && ($.clearDelayTimeouts(), $.hide(), f = !0, setTimeout(function() {
          f = !1;
        }), $.state.isMounted || Ne());
      }
    }
  }
  function ue() {
    c = !0;
  }
  function Se() {
    c = !1;
  }
  function Me() {
    var U = ee();
    U.addEventListener("mousedown", ne, !0), U.addEventListener("touchend", ne, yr), U.addEventListener("touchstart", Se, yr), U.addEventListener("touchmove", ue, yr);
  }
  function Ne() {
    var U = ee();
    U.removeEventListener("mousedown", ne, !0), U.removeEventListener("touchend", ne, yr), U.removeEventListener("touchstart", Se, yr), U.removeEventListener("touchmove", ue, yr);
  }
  function pt(U, be) {
    ke(U, function() {
      !$.state.isVisible && R.parentNode && R.parentNode.contains(R) && be();
    });
  }
  function st(U, be) {
    ke(U, be);
  }
  function ke(U, be) {
    var De = Q().box;
    function Ge(Ue) {
      Ue.target === De && (io(De, "remove", Ge), be());
    }
    if (U === 0)
      return be();
    io(De, "remove", q), io(De, "add", Ge), q = Ge;
  }
  function Ie(U, be, De) {
    De === void 0 && (De = !1);
    var Ge = _r($.props.triggerTarget || e);
    Ge.forEach(function(Ue) {
      Ue.addEventListener(U, be, De), O.push({
        node: Ue,
        eventType: U,
        handler: be,
        options: De
      });
    });
  }
  function Je() {
    se() && (Ie("touchstart", je, {
      passive: !0
    }), Ie("touchend", wt, {
      passive: !0
    })), x2($.props.trigger).forEach(function(U) {
      if (U !== "manual")
        switch (Ie(U, je), U) {
          case "mouseenter":
            Ie("mouseleave", wt);
            break;
          case "focus":
            Ie(Y2 ? "focusout" : "blur", Ot);
            break;
          case "focusin":
            Ie("focusout", Ot);
            break;
        }
    });
  }
  function he() {
    O.forEach(function(U) {
      var be = U.node, De = U.eventType, Ge = U.handler, Ue = U.options;
      be.removeEventListener(De, Ge, Ue);
    }), O = [];
  }
  function je(U) {
    var be, De = !1;
    if (!(!$.state.isEnabled || ht(U) || f)) {
      var Ge = ((be = h) == null ? void 0 : be.type) === "focus";
      h = U, I = U.currentTarget, ge(), !$.state.isVisible && zo(U) && Ci.forEach(function(Ue) {
        return Ue(U);
      }), U.type === "click" && ($.props.trigger.indexOf("mouseenter") < 0 || u) && $.props.hideOnClick !== !1 && $.state.isVisible ? De = !0 : dn(U), U.type === "click" && (u = !De), De && !Ge && Jt(U);
    }
  }
  function Ze(U) {
    var be = U.target, De = ve().contains(be) || R.contains(be);
    if (!(U.type === "mousemove" && De)) {
      var Ge = yt().concat(R).map(function(Ue) {
        var St, Et = Ue._tippy, xn = (St = Et.popperInstance) == null ? void 0 : St.state;
        return xn ? {
          popperRect: Ue.getBoundingClientRect(),
          popperState: xn,
          props: r
        } : null;
      }).filter(Boolean);
      z2(Ge, U) && (N(), Jt(U));
    }
  }
  function wt(U) {
    var be = ht(U) || $.props.trigger.indexOf("click") >= 0 && u;
    if (!be) {
      if ($.props.interactive) {
        $.hideWithInteractivity(U);
        return;
      }
      Jt(U);
    }
  }
  function Ot(U) {
    $.props.trigger.indexOf("focusin") < 0 && U.target !== ve() || $.props.interactive && U.relatedTarget && R.contains(U.relatedTarget) || Jt(U);
  }
  function ht(U) {
    return Bn.isTouch ? se() !== U.type.indexOf("touch") >= 0 : !1;
  }
  function cn() {
    $n();
    var U = $.props, be = U.popperOptions, De = U.placement, Ge = U.offset, Ue = U.getReferenceClientRect, St = U.moveTransition, Et = oe() ? Ti(R).arrow : null, xn = Ue ? {
      getBoundingClientRect: Ue,
      contextElement: Ue.contextElement || ve()
    } : e, ta = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(kr) {
        var Wn = kr.state;
        if (oe()) {
          var Ma = Q(), ra = Ma.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(qr) {
            qr === "placement" ? ra.setAttribute("data-placement", Wn.placement) : Wn.attributes.popper["data-popper-" + qr] ? ra.setAttribute("data-" + qr, "") : ra.removeAttribute("data-" + qr);
          }), Wn.attributes.popper = {};
        }
      }
    }, Ln = [{
      name: "offset",
      options: {
        offset: Ge
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !St
      }
    }, ta];
    oe() && Et && Ln.push({
      name: "arrow",
      options: {
        element: Et,
        padding: 3
      }
    }), Ln.push.apply(Ln, (be == null ? void 0 : be.modifiers) || []), $.popperInstance = O2(xn, R, Object.assign({}, be, {
      placement: De,
      onFirstUpdate: C,
      modifiers: Ln
    }));
  }
  function $n() {
    $.popperInstance && ($.popperInstance.destroy(), $.popperInstance = null);
  }
  function Dt() {
    var U = $.props.appendTo, be, De = ve();
    $.props.interactive && U === xd || U === "parent" ? be = De.parentNode : be = Ld(U, [De]), be.contains(R) || be.appendChild(R), $.state.isMounted = !0, cn();
  }
  function yt() {
    return Zr(R.querySelectorAll("[data-tippy-root]"));
  }
  function dn(U) {
    $.clearDelayTimeouts(), U && G("onTrigger", [$, U]), Me();
    var be = J(!0), De = K(), Ge = De[0], Ue = De[1];
    Bn.isTouch && Ge === "hold" && Ue && (be = Ue), be ? s = setTimeout(function() {
      $.show();
    }, be) : $.show();
  }
  function Jt(U) {
    if ($.clearDelayTimeouts(), G("onUntrigger", [$, U]), !$.state.isVisible) {
      Ne();
      return;
    }
    if (!($.props.trigger.indexOf("mouseenter") >= 0 && $.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(U.type) >= 0 && u)) {
      var be = J(!1);
      be ? o = setTimeout(function() {
        $.state.isVisible && $.hide();
      }, be) : d = requestAnimationFrame(function() {
        $.hide();
      });
    }
  }
  function or() {
    $.state.isEnabled = !0;
  }
  function Cn() {
    $.hide(), $.state.isEnabled = !1;
  }
  function Sr() {
    clearTimeout(s), clearTimeout(o), cancelAnimationFrame(d);
  }
  function Sn(U) {
    if (!$.state.isDestroyed) {
      G("onBeforeUpdate", [$, U]), he();
      var be = $.props, De = Fc(e, Object.assign({}, be, Mc(U), {
        ignoreAttributes: !0
      }));
      $.props = De, Je(), be.interactiveDebounce !== De.interactiveDebounce && (N(), S = Oc(Ze, De.interactiveDebounce)), be.triggerTarget && !De.triggerTarget ? _r(be.triggerTarget).forEach(function(Ge) {
        Ge.removeAttribute("aria-expanded");
      }) : De.triggerTarget && e.removeAttribute("aria-expanded"), ge(), te(), T && T(be, De), $.popperInstance && (cn(), yt().forEach(function(Ge) {
        requestAnimationFrame(Ge._tippy.popperInstance.forceUpdate);
      })), G("onAfterUpdate", [$, U]);
    }
  }
  function fn(U) {
    $.setProps({
      content: U
    });
  }
  function Xr() {
    var U = $.state.isVisible, be = $.state.isDestroyed, De = !$.state.isEnabled, Ge = Bn.isTouch && !$.props.touch, Ue = ro($.props.duration, 0, bn.duration);
    if (!(U || be || De || Ge) && !ve().hasAttribute("disabled") && (G("onShow", [$], !1), $.props.onShow($) !== !1)) {
      if ($.state.isVisible = !0, oe() && (R.style.visibility = "visible"), te(), Me(), $.state.isMounted || (R.style.transition = "none"), oe()) {
        var St = Q(), Et = St.box, xn = St.content;
        ao([Et, xn], 0);
      }
      C = function() {
        var Ln;
        if (!(!$.state.isVisible || g)) {
          if (g = !0, R.offsetHeight, R.style.transition = $.props.moveTransition, oe() && $.props.animation) {
            var na = Q(), kr = na.box, Wn = na.content;
            ao([kr, Wn], Ue), qa([kr, Wn], "visible");
          }
          de(), ge(), Ic(so, $), (Ln = $.popperInstance) == null || Ln.forceUpdate(), G("onMount", [$]), $.props.animation && oe() && st(Ue, function() {
            $.state.isShown = !0, G("onShown", [$]);
          });
        }
      }, Dt();
    }
  }
  function Jr() {
    var U = !$.state.isVisible, be = $.state.isDestroyed, De = !$.state.isEnabled, Ge = ro($.props.duration, 1, bn.duration);
    if (!(U || be || De) && (G("onHide", [$], !1), $.props.onHide($) !== !1)) {
      if ($.state.isVisible = !1, $.state.isShown = !1, g = !1, u = !1, oe() && (R.style.visibility = "hidden"), N(), Ne(), te(!0), oe()) {
        var Ue = Q(), St = Ue.box, Et = Ue.content;
        $.props.animation && (ao([St, Et], Ge), qa([St, Et], "hidden"));
      }
      de(), ge(), $.props.animation ? oe() && pt(Ge, $.unmount) : $.unmount();
    }
  }
  function Qr(U) {
    ee().addEventListener("mousemove", S), Ic(Ci, S), S(U);
  }
  function jr() {
    $.state.isVisible && $.hide(), $.state.isMounted && ($n(), yt().forEach(function(U) {
      U._tippy.unmount();
    }), R.parentNode && R.parentNode.removeChild(R), so = so.filter(function(U) {
      return U !== $;
    }), $.state.isMounted = !1, G("onHidden", [$]));
  }
  function ea() {
    $.state.isDestroyed || ($.clearDelayTimeouts(), $.unmount(), he(), delete e._tippy, $.state.isDestroyed = !0, G("onDestroy", [$]));
  }
}
function $e(e, a) {
  a === void 0 && (a = {});
  var r = bn.plugins.concat(a.plugins || []);
  H2();
  var s = Object.assign({}, a, {
    plugins: r
  }), o = P2(e), d = o.reduce(function(u, f) {
    var c = f && Q2(f, s);
    return c && u.push(c), u;
  }, []);
  return Hi(e) ? d[0] : d;
}
$e.defaultProps = bn;
$e.setDefaultProps = Z2;
$e.currentInput = Bn;
var j2 = Object.assign({}, Cd, {
  effect: function(a) {
    var r = a.state, s = {
      popper: {
        position: r.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(r.elements.popper.style, s.popper), r.styles = s, r.elements.arrow && Object.assign(r.elements.arrow.style, s.arrow);
  }
}), eC = function(a, r) {
  var s;
  r === void 0 && (r = {});
  var o = a, d = [], u = [], f, c = r.overrides, g = [], h = !1;
  function q() {
    u = o.map(function($) {
      return _r($.props.triggerTarget || $.reference);
    }).reduce(function($, Y) {
      return $.concat(Y);
    }, []);
  }
  function C() {
    d = o.map(function($) {
      return $.reference;
    });
  }
  function O($) {
    o.forEach(function(Y) {
      $ ? Y.enable() : Y.disable();
    });
  }
  function S($) {
    return o.map(function(Y) {
      var R = Y.setProps;
      return Y.setProps = function(T) {
        R(T), Y.reference === f && $.setProps(T);
      }, function() {
        Y.setProps = R;
      };
    });
  }
  function I($, Y) {
    var R = u.indexOf(Y);
    if (Y !== f) {
      f = Y;
      var T = (c || []).concat("content").reduce(function(z, le) {
        return z[le] = o[R].props[le], z;
      }, {});
      $.setProps(Object.assign({}, T, {
        getReferenceClientRect: typeof T.getReferenceClientRect == "function" ? T.getReferenceClientRect : function() {
          var z;
          return (z = d[R]) == null ? void 0 : z.getBoundingClientRect();
        }
      }));
    }
  }
  O(!1), C(), q();
  var M = {
    fn: function() {
      return {
        onDestroy: function() {
          O(!0);
        },
        onHidden: function() {
          f = null;
        },
        onClickOutside: function(R) {
          R.props.showOnCreate && !h && (h = !0, f = null);
        },
        onShow: function(R) {
          R.props.showOnCreate && !h && (h = !0, I(R, d[0]));
        },
        onTrigger: function(R, T) {
          I(R, T.currentTarget);
        }
      };
    }
  }, F = $e(Cr(), Object.assign({}, M2(r, ["overrides"]), {
    plugins: [M].concat(r.plugins || []),
    triggerTarget: u,
    popperOptions: Object.assign({}, r.popperOptions, {
      modifiers: [].concat(((s = r.popperOptions) == null ? void 0 : s.modifiers) || [], [j2])
    })
  })), P = F.show;
  F.show = function($) {
    if (P(), !f && $ == null)
      return I(F, d[0]);
    if (!(f && $ == null)) {
      if (typeof $ == "number")
        return d[$] && I(F, d[$]);
      if (o.indexOf($) >= 0) {
        var Y = $.reference;
        return I(F, Y);
      }
      if (d.indexOf($) >= 0)
        return I(F, $);
    }
  }, F.showNext = function() {
    var $ = d[0];
    if (!f)
      return F.show(0);
    var Y = d.indexOf(f);
    F.show(d[Y + 1] || $);
  }, F.showPrevious = function() {
    var $ = d[d.length - 1];
    if (!f)
      return F.show($);
    var Y = d.indexOf(f), R = d[Y - 1] || $;
    F.show(R);
  };
  var x = F.setProps;
  return F.setProps = function($) {
    c = $.overrides || c, x($);
  }, F.setInstances = function($) {
    O(!0), g.forEach(function(Y) {
      return Y();
    }), o = $, O(!1), C(), q(), g = S(F), F.setProps({
      triggerTarget: u
    });
  }, g = S(F), F;
}, tC = {
  name: "animateFill",
  defaultValue: !1,
  fn: function(a) {
    var r;
    if (!((r = a.props.render) != null && r.$$tippy))
      return {};
    var s = Ti(a.popper), o = s.box, d = s.content, u = a.props.animateFill ? nC() : null;
    return {
      onCreate: function() {
        u && (o.insertBefore(u, o.firstElementChild), o.setAttribute("data-animatefill", ""), o.style.overflow = "hidden", a.setProps({
          arrow: !1,
          animation: "shift-away"
        }));
      },
      onMount: function() {
        if (u) {
          var c = o.style.transitionDuration, g = Number(c.replace("ms", ""));
          d.style.transitionDelay = Math.round(g / 10) + "ms", u.style.transitionDuration = c, qa([u], "visible");
        }
      },
      onShow: function() {
        u && (u.style.transitionDuration = "0ms");
      },
      onHide: function() {
        u && qa([u], "hidden");
      }
    };
  }
};
function nC() {
  var e = Cr();
  return e.className = Od, qa([e], "hidden"), e;
}
var ho = {
  clientX: 0,
  clientY: 0
}, Si = [];
function Nd(e) {
  var a = e.clientX, r = e.clientY;
  ho = {
    clientX: a,
    clientY: r
  };
}
function rC(e) {
  e.addEventListener("mousemove", Nd);
}
function aC(e) {
  e.removeEventListener("mousemove", Nd);
}
var iC = {
  name: "followCursor",
  defaultValue: !1,
  fn: function(a) {
    var r = a.reference, s = Ed(a.props.triggerTarget || r), o = !1, d = !1, u = !0, f = a.props;
    function c() {
      return a.props.followCursor === "initial" && a.state.isVisible;
    }
    function g() {
      s.addEventListener("mousemove", C);
    }
    function h() {
      s.removeEventListener("mousemove", C);
    }
    function q() {
      o = !0, a.setProps({
        getReferenceClientRect: null
      }), o = !1;
    }
    function C(I) {
      var M = I.target ? r.contains(I.target) : !0, F = a.props.followCursor, P = I.clientX, x = I.clientY, $ = r.getBoundingClientRect(), Y = P - $.left, R = x - $.top;
      (M || !a.props.interactive) && a.setProps({
        // @ts-ignore - unneeded DOMRect properties
        getReferenceClientRect: function() {
          var z = r.getBoundingClientRect(), le = P, K = x;
          F === "initial" && (le = z.left + Y, K = z.top + R);
          var se = F === "horizontal" ? z.top : K, oe = F === "vertical" ? z.right : le, ve = F === "horizontal" ? z.bottom : K, ee = F === "vertical" ? z.left : le;
          return {
            width: oe - ee,
            height: ve - se,
            top: se,
            right: oe,
            bottom: ve,
            left: ee
          };
        }
      });
    }
    function O() {
      a.props.followCursor && (Si.push({
        instance: a,
        doc: s
      }), rC(s));
    }
    function S() {
      Si = Si.filter(function(I) {
        return I.instance !== a;
      }), Si.filter(function(I) {
        return I.doc === s;
      }).length === 0 && aC(s);
    }
    return {
      onCreate: O,
      onDestroy: S,
      onBeforeUpdate: function() {
        f = a.props;
      },
      onAfterUpdate: function(M, F) {
        var P = F.followCursor;
        o || P !== void 0 && f.followCursor !== P && (S(), P ? (O(), a.state.isMounted && !d && !c() && g()) : (h(), q()));
      },
      onMount: function() {
        a.props.followCursor && !d && (u && (C(ho), u = !1), c() || g());
      },
      onTrigger: function(M, F) {
        zo(F) && (ho = {
          clientX: F.clientX,
          clientY: F.clientY
        }), d = F.type === "focus";
      },
      onHidden: function() {
        a.props.followCursor && (q(), h(), u = !0);
      }
    };
  }
};
function sC(e, a) {
  var r;
  return {
    popperOptions: Object.assign({}, e.popperOptions, {
      modifiers: [].concat((((r = e.popperOptions) == null ? void 0 : r.modifiers) || []).filter(function(s) {
        var o = s.name;
        return o !== a.name;
      }), [a])
    })
  };
}
var oC = {
  name: "inlinePositioning",
  defaultValue: !1,
  fn: function(a) {
    var r = a.reference;
    function s() {
      return !!a.props.inlinePositioning;
    }
    var o, d = -1, u = !1, f = [], c = {
      name: "tippyInlinePositioning",
      enabled: !0,
      phase: "afterWrite",
      fn: function(O) {
        var S = O.state;
        s() && (f.indexOf(S.placement) !== -1 && (f = []), o !== S.placement && f.indexOf(S.placement) === -1 && (f.push(S.placement), a.setProps({
          // @ts-ignore - unneeded DOMRect properties
          getReferenceClientRect: function() {
            return g(S.placement);
          }
        })), o = S.placement);
      }
    };
    function g(C) {
      return lC(Fd(C), r.getBoundingClientRect(), Zr(r.getClientRects()), d);
    }
    function h(C) {
      u = !0, a.setProps(C), u = !1;
    }
    function q() {
      u || h(sC(a.props, c));
    }
    return {
      onCreate: q,
      onAfterUpdate: q,
      onTrigger: function(O, S) {
        if (zo(S)) {
          var I = Zr(a.reference.getClientRects()), M = I.find(function(P) {
            return P.left - 2 <= S.clientX && P.right + 2 >= S.clientX && P.top - 2 <= S.clientY && P.bottom + 2 >= S.clientY;
          }), F = I.indexOf(M);
          d = F > -1 ? F : d;
        }
      },
      onHidden: function() {
        d = -1;
      }
    };
  }
};
function lC(e, a, r, s) {
  if (r.length < 2 || e === null)
    return a;
  if (r.length === 2 && s >= 0 && r[0].left > r[1].right)
    return r[s] || a;
  switch (e) {
    case "top":
    case "bottom": {
      var o = r[0], d = r[r.length - 1], u = e === "top", f = o.top, c = d.bottom, g = u ? o.left : d.left, h = u ? o.right : d.right, q = h - g, C = c - f;
      return {
        top: f,
        bottom: c,
        left: g,
        right: h,
        width: q,
        height: C
      };
    }
    case "left":
    case "right": {
      var O = Math.min.apply(Math, r.map(function(R) {
        return R.left;
      })), S = Math.max.apply(Math, r.map(function(R) {
        return R.right;
      })), I = r.filter(function(R) {
        return e === "left" ? R.left === O : R.right === S;
      }), M = I[0].top, F = I[I.length - 1].bottom, P = O, x = S, $ = x - P, Y = F - M;
      return {
        top: M,
        bottom: F,
        left: P,
        right: x,
        width: $,
        height: Y
      };
    }
    default:
      return a;
  }
}
var uC = {
  name: "sticky",
  defaultValue: !1,
  fn: function(a) {
    var r = a.reference, s = a.popper;
    function o() {
      return a.popperInstance ? a.popperInstance.state.elements.reference : r;
    }
    function d(g) {
      return a.props.sticky === !0 || a.props.sticky === g;
    }
    var u = null, f = null;
    function c() {
      var g = d("reference") ? o().getBoundingClientRect() : null, h = d("popper") ? s.getBoundingClientRect() : null;
      (g && zc(u, g) || h && zc(f, h)) && a.popperInstance && a.popperInstance.update(), u = g, f = h, a.state.isMounted && requestAnimationFrame(c);
    }
    return {
      onMount: function() {
        a.props.sticky && c();
      }
    };
  }
};
function zc(e, a) {
  return e && a ? e.top !== a.top || e.right !== a.right || e.bottom !== a.bottom || e.left !== a.left : !0;
}
$e.setDefaultProps({
  render: Rd
});
$e.setDefaultProps({
  //@ts-ignore
  onShow: (e) => {
    if (!e.props.content)
      return !1;
  }
});
function Hd(e, a = {}, r = { mount: !0, appName: "Tippy" }) {
  r = Object.assign({ mount: !0, appName: "Tippy" }, r);
  const s = C0(), o = V(), d = V({
    isEnabled: !1,
    isVisible: !1,
    isDestroyed: !1,
    isMounted: !1,
    isShown: !1
  }), u = S0();
  let f = null;
  const c = () => f || (f = document.createDocumentFragment(), f), g = (T) => {
    let z, le = nr(T) ? T.value : T;
    return k0(le) ? (u.value || (u.value = hc({
      name: r.appName,
      setup: () => () => nr(T) ? T.value : T
    }), s && Object.assign(u.value._context, s.appContext), u.value.mount(c())), z = () => c()) : typeof le == "object" ? (u.value || (u.value = hc({
      name: r.appName,
      setup: () => () => Nr(nr(T) ? T.value : T)
    }), s && Object.assign(u.value._context, s.appContext), u.value.mount(c())), z = () => c()) : z = le, z;
  }, h = (T) => {
    let z = {};
    return nr(T) ? z = T.value || {} : pc(T) ? z = { ...T } : z = { ...T }, z.content && (z.content = g(z.content)), z.triggerTarget && (z.triggerTarget = nr(z.triggerTarget) ? z.triggerTarget.value : z.triggerTarget), (!z.plugins || !Array.isArray(z.plugins)) && (z.plugins = []), z.plugins = z.plugins.filter((le) => le.name !== "vueTippyReactiveState"), z.plugins.push({
      name: "vueTippyReactiveState",
      fn: () => ({
        onCreate() {
          d.value.isEnabled = !0;
        },
        onMount() {
          d.value.isMounted = !0;
        },
        onShow() {
          d.value.isMounted = !0, d.value.isVisible = !0;
        },
        onShown() {
          d.value.isShown = !0;
        },
        onHide() {
          d.value.isMounted = !1, d.value.isVisible = !1;
        },
        onHidden() {
          d.value.isShown = !1;
        },
        onUnmounted() {
          d.value.isMounted = !1;
        },
        onDestroy() {
          d.value.isDestroyed = !0;
        }
      })
    }), z;
  }, q = () => {
    o.value && o.value.setProps(h(a));
  }, C = () => {
    !o.value || !a.content || o.value.setContent(g(a.content));
  }, O = (T) => {
    var z;
    (z = o.value) === null || z === void 0 || z.setContent(g(T));
  }, S = (T) => {
    var z;
    (z = o.value) === null || z === void 0 || z.setProps(h(T));
  }, I = () => {
    var T;
    o.value && (o.value.destroy(), o.value = void 0), f = null, (T = u.value) === null || T === void 0 || T.unmount(), u.value = void 0;
  }, M = () => {
    var T;
    (T = o.value) === null || T === void 0 || T.show();
  }, F = () => {
    var T;
    (T = o.value) === null || T === void 0 || T.hide();
  }, P = () => {
    var T;
    (T = o.value) === null || T === void 0 || T.disable(), d.value.isEnabled = !1;
  }, x = () => {
    var T;
    (T = o.value) === null || T === void 0 || T.enable(), d.value.isEnabled = !0;
  }, $ = () => {
    var T;
    (T = o.value) === null || T === void 0 || T.unmount();
  }, Y = () => {
    if (!e)
      return;
    let T = nr(e) ? e.value : e;
    typeof T == "function" && (T = T()), T && (o.value = $e(T, h(a)), T.$tippy = R);
  }, R = {
    tippy: o,
    refresh: q,
    refreshContent: C,
    setContent: O,
    setProps: S,
    destroy: I,
    hide: F,
    show: M,
    disable: P,
    enable: x,
    unmount: $,
    mount: Y,
    state: d
  };
  return r.mount && (s ? s.isMounted ? Y() : Tt(Y) : Y()), s && xi(() => {
    I();
  }), nr(a) || pc(a) ? vt(a, q, { immediate: !1 }) : nr(a.content) && vt(a.content, C, { immediate: !1 }), R;
}
function cC(e, a) {
  const r = V();
  return Tt(() => {
    const o = (Array.isArray(e) ? e.map((d) => d.value) : typeof e == "function" ? e() : e.value).map((d) => d instanceof Element ? d._tippy : d).filter(Boolean);
    r.value = eC(o, a ? { allowHTML: !0, ...a } : { allowHTML: !0 });
  }), {
    singleton: r
  };
}
function dC(e) {
  return typeof e == "function" ? e() : tt(e);
}
function fC(e) {
  var a, r;
  const s = dC(e);
  return (r = (a = s) === null || a === void 0 ? void 0 : a.$el) !== null && r !== void 0 ? r : s;
}
Oe({
  props: {
    to: {
      type: [String, Function]
    },
    tag: {
      type: [String, Object],
      default: "span"
    },
    contentTag: {
      type: [String, Object],
      default: "span"
    },
    contentClass: {
      type: String,
      default: null
    },
    appendTo: { default: () => $e.defaultProps.appendTo },
    aria: { default: () => $e.defaultProps.aria },
    delay: { default: () => $e.defaultProps.delay },
    duration: { default: () => $e.defaultProps.duration },
    getReferenceClientRect: { default: () => $e.defaultProps.getReferenceClientRect },
    hideOnClick: { type: [Boolean, String], default: () => $e.defaultProps.hideOnClick },
    ignoreAttributes: { type: Boolean, default: () => $e.defaultProps.ignoreAttributes },
    interactive: { type: Boolean, default: () => $e.defaultProps.interactive },
    interactiveBorder: { default: () => $e.defaultProps.interactiveBorder },
    interactiveDebounce: { default: () => $e.defaultProps.interactiveDebounce },
    moveTransition: { default: () => $e.defaultProps.moveTransition },
    offset: { default: () => $e.defaultProps.offset },
    onAfterUpdate: { default: () => $e.defaultProps.onAfterUpdate },
    onBeforeUpdate: { default: () => $e.defaultProps.onBeforeUpdate },
    onCreate: { default: () => $e.defaultProps.onCreate },
    onDestroy: { default: () => $e.defaultProps.onDestroy },
    onHidden: { default: () => $e.defaultProps.onHidden },
    onHide: { default: () => $e.defaultProps.onHide },
    onMount: { default: () => $e.defaultProps.onMount },
    onShow: { default: () => $e.defaultProps.onShow },
    onShown: { default: () => $e.defaultProps.onShown },
    onTrigger: { default: () => $e.defaultProps.onTrigger },
    onUntrigger: { default: () => $e.defaultProps.onUntrigger },
    onClickOutside: { default: () => $e.defaultProps.onClickOutside },
    placement: { default: () => $e.defaultProps.placement },
    plugins: { default: () => $e.defaultProps.plugins },
    popperOptions: { default: () => $e.defaultProps.popperOptions },
    render: { default: () => $e.defaultProps.render },
    showOnCreate: { type: Boolean, default: () => $e.defaultProps.showOnCreate },
    touch: { type: [Boolean, String, Array], default: () => $e.defaultProps.touch },
    trigger: { default: () => $e.defaultProps.trigger },
    triggerTarget: { default: () => $e.defaultProps.triggerTarget },
    animateFill: { type: Boolean, default: () => $e.defaultProps.animateFill },
    followCursor: { type: [Boolean, String], default: () => $e.defaultProps.followCursor },
    inlinePositioning: { type: Boolean, default: () => $e.defaultProps.inlinePositioning },
    sticky: { type: [Boolean, String], default: () => $e.defaultProps.sticky },
    allowHTML: { type: Boolean, default: () => $e.defaultProps.allowHTML },
    animation: { default: () => $e.defaultProps.animation },
    arrow: { default: () => $e.defaultProps.arrow },
    content: { default: () => $e.defaultProps.content },
    inertia: { default: () => $e.defaultProps.inertia },
    maxWidth: { default: () => $e.defaultProps.maxWidth },
    role: { default: () => $e.defaultProps.role },
    theme: { default: () => $e.defaultProps.theme },
    zIndex: { default: () => $e.defaultProps.zIndex }
  },
  emits: ["state"],
  setup(e, { slots: a, emit: r, expose: s }) {
    const o = V(), d = V(), u = V(), f = V(!1), c = () => {
      let O = { ...e };
      for (const S of ["to", "tag", "contentTag", "contentClass"])
        O.hasOwnProperty(S) && delete O[S];
      return O;
    };
    let g = () => fC(o);
    e.to && (typeof Element < "u" && e.to instanceof Element ? g = () => e.to : e.to === "parent" ? g = () => {
      let O = o.value;
      return O || (O = o.value = d.value.parentElement), O;
    } : (typeof e.to == "string" || e.to instanceof String) && (g = () => document.querySelector(e.to)));
    const h = Hd(g, c());
    let q = a.content;
    !q && e.to === "parent" && (q = a.default), Tt(() => {
      f.value = !0, Li(() => {
        q && h.setContent(() => u.value);
      });
    }), vt(h.state, () => {
      r("state", tt(h.state));
    }, { immediate: !0, deep: !0 }), vt(() => e, () => {
      h.setProps(c()), q && h.setContent(() => u.value);
    }, { deep: !0 });
    let C = it({
      elem: o,
      contentElem: u,
      mounted: f,
      ...h
    });
    return s(C), () => {
      const O = (typeof e.contentTag == "string", e.contentTag), S = q ? Nr(O, {
        ref: u,
        style: { display: f.value ? "inherit" : "none" },
        class: e.contentClass
      }, q(C)) : null;
      if (e.to === "parent") {
        const F = [];
        if (!o.value) {
          const P = Nr("span", {
            ref: d,
            "data-v-tippy": "",
            style: { display: "none" }
          });
          F.push(P);
        }
        return S && F.push(S), F;
      }
      const I = a.default ? a.default(C) : [];
      if (!e.tag) {
        const F = Nr(I[0], {
          ref: o,
          "data-v-tippy": ""
        });
        return S ? [F, S] : F;
      }
      const M = (typeof e.tag == "string", e.tag);
      return Nr(M, { ref: o, "data-v-tippy": "" }, S ? [I, S] : I);
    };
  }
});
const vC = [
  "a11y",
  "allowHTML",
  "arrow",
  "flip",
  "flipOnUpdate",
  "hideOnClick",
  "ignoreAttributes",
  "inertia",
  "interactive",
  "lazy",
  "multiple",
  "showOnInit",
  "touch",
  "touchHold"
];
let go = {};
Object.keys($e.defaultProps).forEach((e) => {
  vC.includes(e) ? go[e] = {
    type: Boolean,
    default: function() {
      return $e.defaultProps[e];
    }
  } : go[e] = {
    default: function() {
      return $e.defaultProps[e];
    }
  };
});
Oe({
  props: go,
  setup(e) {
    const a = V([]), { singleton: r } = cC(a, e);
    return { instances: a, singleton: r };
  },
  mounted() {
    var e;
    const r = this.$el.parentElement.querySelectorAll("[data-v-tippy]");
    this.instances = Array.from(r).map((s) => s._tippy).filter(Boolean), (e = this.singleton) === null || e === void 0 || e.setInstances(this.instances);
  },
  render() {
    let e = this.$slots.default ? this.$slots.default() : [];
    return Nr(() => e);
  }
});
const pC = $e.setDefaultProps;
pC({
  ignoreAttributes: !0,
  plugins: [uC, oC, iC, tC]
});
const Vd = {
  __name: "Tooltip",
  props: {
    label: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = V(), r = e;
    return Hd(a, {
      content: r.label,
      interactive: !0,
      inertia: !0,
      allowHTML: !0,
      theme: r.inverse ? "inverse" : "light-border",
      appendTo: () => document.body
    }), (s, o) => (v(), m("div", {
      ref_key: "btn",
      ref: a,
      class: "orq-tippy-container"
    }, [
      we(s.$slots, "default")
    ], 512));
  }
}, hC = Oe({
  name: "OrqDays",
  components: {
    OrqBullet: wo,
    OrqTooltip: Vd
  },
  props: {
    days: {
      type: Array,
      default: () => []
    },
    changeSelectedDay: {
      type: Function,
      default: () => {
      }
    },
    selectedDays: {
      type: Array,
      default: () => []
    },
    range: {
      type: Boolean,
      default: !1
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    weekendAvailable: {
      type: Boolean,
      default: !1
    },
    withBlockList: {
      type: Boolean,
      default: !1
    },
    withAllowedList: {
      type: Boolean,
      default: !1
    },
    showToday: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["selectDay"],
  setup(e, { emit: a }) {
    const r = ["Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Dom"], s = V(e.selectedDays), o = 1, d = e.weekendAvailable ? 0 : 5;
    vt(
      () => e.selectedDays,
      (S) => {
        s.value = S;
      }
    );
    function u(S) {
      if (e.range === !1)
        return "";
      if (S.date > s.value[0] && S.date < s.value[1])
        switch (S.date.getDay()) {
          case o:
            return "c-datepicker__days__grid__day--between-left";
          case d:
            return "c-datepicker__days__grid__day--between-right";
          default:
            return "c-datepicker__days__grid__day--between-middle";
        }
      return "";
    }
    function f(S) {
      var I, M;
      return e.range && s.value[0] && S.date.getTime() === ((I = s.value[0]) == null ? void 0 : I.getTime()) ? s.value[0].getTime() === s.value[1].getTime() ? "" : "c-datepicker__days__grid__day--between-left" : s.value[1] && S.date.getTime() === ((M = s.value[1]) == null ? void 0 : M.getTime()) ? "c-datepicker__days__grid__day--between-right" : "";
    }
    const c = "c-datepicker__days__grid__day c-datepicker__days__grid__day--disabled";
    function g(S) {
      const I = ["c-datepicker__days__grid__day"];
      return S.disabled ? c : (S.selected && I.push("c-datepicker__days__grid__day--selected"), s.value.length === 2 && (I.push(f(S)), I.push(u(S)), !e.weekendAvailable && (f$.includes(S.index) && !I.includes(
        "c-datepicker__days__grid__day--between-left"
      ) || v$.includes(S.index) && !I.includes(
        "c-datepicker__days__grid__day--between-right"
      )) && I.push("clear-bg")), I);
    }
    return {
      selectedDaysRef: s,
      WEEKDAYS: r,
      applyStyle: g,
      getBlockedClass: (S) => S && e.withBlockList ? c : "",
      getAllowedClass: (S) => !S && e.withAllowedList ? c : "",
      handleClick: (S, I) => {
        a("selectDay", S, I);
      },
      handleDay: (S) => {
        const I = (M) => M.getDay();
        e.weekendAvailable || (I(S.date) == 0 || I(S.date) == 6) && (S.disabled = !0);
      }
    };
  }
}), gC = { class: "" }, mC = { class: "c-datepicker__days__grid c-datepicker__days__week-days grid" }, yC = { class: "c-datepicker__days__week-day" }, bC = ["onClick"], _C = { class: "tooltip" }, wC = { class: "event-day" };
function $C(e, a, r, s, o, d) {
  const u = ze("OrqBullet"), f = ze("OrqTooltip");
  return v(), m("div", gC, [
    y("div", mC, [
      (v(!0), m(ce, null, Re(e.WEEKDAYS, (c, g) => (v(), m("div", { key: g }, [
        y("span", yC, ie(c), 1)
      ]))), 128))
    ]),
    y("div", {
      class: w(["c-datepicker__days__grid c-datepicker__days__month-days grid", { showToday: e.showToday }])
    }, [
      (v(!0), m(ce, null, Re(e.days, (c, g) => {
        var h, q;
        return v(), m(ce, { key: g }, [
          _n(ie(e.handleDay(c)) + " ", 1),
          y("div", {
            class: w([
              e.applyStyle(c),
              e.getBlockedClass(c.blocked),
              e.getAllowedClass(c.allowed)
            ]),
            role: "button",
            onClick: Ct((C) => e.handleClick(c, g), ["stop"])
          }, [
            y("span", {
              class: w({
                "orq-today": (/* @__PURE__ */ new Date()).toLocaleDateString() === ((h = c.date) == null ? void 0 : h.toLocaleDateString())
              })
            }, ie((q = c.date) == null ? void 0 : q.getDate()), 3),
            y("div", _C, [
              (v(!0), m(ce, null, Re(c.event.slice(0, 4), (C, O) => {
                var S, I;
                return v(), m(ce, { key: O }, [
                  (S = c.event) != null && S.length ? (v(), me(f, {
                    key: 0,
                    label: (I = c.event[O]) == null ? void 0 : I.message,
                    type: "hover",
                    direction: "right",
                    inverse: e.inverse
                  }, {
                    default: dt(() => {
                      var M;
                      return [
                        y("div", wC, [
                          re(u, {
                            inverse: e.inverse,
                            appearance: (M = c.event[O]) == null ? void 0 : M.type,
                            value: g
                          }, null, 8, ["inverse", "appearance", "value"])
                        ])
                      ];
                    }),
                    _: 2
                  }, 1032, ["label", "inverse"])) : D("", !0)
                ], 64);
              }), 128))
            ])
          ], 10, bC)
        ], 64);
      }), 128))
    ], 2)
  ]);
}
const CC = /* @__PURE__ */ ae(hC, [["render", $C]]), SC = Oe({
  name: "OrqHeader",
  components: {
    OrqIconContainer: Te
  },
  props: {
    setView: {
      type: Function,
      default: () => {
      }
    },
    view: {
      type: String,
      default: "day"
    },
    currentDate: {
      type: Date,
      default: /* @__PURE__ */ new Date()
    },
    setCurrentDate: {
      type: Function,
      default: () => {
      }
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["handleclickmonth", "goToNextMonth", "goToPrevMonth"],
  setup(e, { emit: a }) {
    const r = V(wr), s = V(e.currentDate), o = () => e.inverse ? Xe.emphasisBaseInverseHigh : Xe.emphasisBaseHigh, d = (g) => {
      a("handleclickmonth", g);
    };
    function u() {
      var g, h;
      if (s.value.getMonth() === 11) {
        r.value = 0, (h = s.value) == null || h.setFullYear(
          ((g = s.value) == null ? void 0 : g.getFullYear()) + 1
        ), a("goToNextMonth", r.value);
        return;
      }
      r.value = s.value.getMonth() + 1, a("goToNextMonth", r.value);
    }
    function f() {
      var g, h, q;
      if (((g = s.value) == null ? void 0 : g.getMonth()) === 0) {
        r.value = 11, s.value.setFullYear(
          ((h = s.value) == null ? void 0 : h.getFullYear()) - 1
        ), a("goToPrevMonth", r.value);
        return;
      }
      r.value = ((q = s.value) == null ? void 0 : q.getMonth()) - 1, a("goToPrevMonth", r.value);
    }
    const c = (g) => {
      g.currentTarget.classList.toggle("pressed");
    };
    return Tt(() => {
      var g;
      r.value = (g = s.value) == null ? void 0 : g.getMonth();
    }), Lt(() => {
      var g;
      r.value = (g = e.currentDate) == null ? void 0 : g.getMonth(), s.value = e.currentDate;
    }), {
      setIconColor: o,
      handleClick: d,
      goToNextMonth: u,
      goToPrevMonth: f,
      onMousePressedHandler: c,
      MONTHS: wr,
      currentDateRef: s,
      monthsRef: r
    };
  }
}), kC = { class: "c-datepicker__header c-datepicker__days-header" };
function qC(e, a, r, s, o, d) {
  var f;
  const u = ze("OrqIconContainer");
  return v(), m("div", kC, [
    y("span", {
      class: "arrow-icon pointer",
      onClick: a[0] || (a[0] = Ct((...c) => e.goToPrevMonth && e.goToPrevMonth(...c), ["stop"]))
    }, [
      re(u, {
        color: e.setIconColor(),
        inverse: e.inverse,
        type: "none",
        name: "chevron-left",
        size: 24
      }, null, 8, ["color", "inverse"])
    ]),
    y("div", {
      style: { width: "135px" },
      class: "c-datepicker__days__header-center pointer",
      onMousedown: a[2] || (a[2] = (...c) => e.onMousePressedHandler && e.onMousePressedHandler(...c)),
      onMouseup: a[3] || (a[3] = (...c) => e.onMousePressedHandler && e.onMousePressedHandler(...c))
    }, [
      y("div", {
        onClick: a[1] || (a[1] = Ct((c) => e.handleClick("month"), ["stop"]))
      }, ie(`${e.MONTHS[e.monthsRef]} ${(f = e.currentDateRef) == null ? void 0 : f.getFullYear()}`), 1)
    ], 32),
    y("span", {
      class: "arrow-icon pointer",
      onClick: a[4] || (a[4] = Ct((c) => e.goToNextMonth(), ["stop"]))
    }, [
      re(u, {
        color: e.setIconColor(),
        inverse: e.inverse,
        type: "none",
        name: "chevron-right",
        size: 24
      }, null, 8, ["color", "inverse"])
    ])
  ]);
}
const DC = /* @__PURE__ */ ae(SC, [["render", qC]]), BC = Oe({
  name: "DayLayout",
  components: {
    OrqDays: CC,
    OrqHeader: DC
  },
  props: {
    events: {
      type: Array,
      default: () => []
    },
    setView: {
      type: Function,
      default: () => {
      }
    },
    view: {
      type: String,
      default: "day"
    },
    daysToShow: {
      type: Array,
      default: () => []
    },
    setCurrentDate: {
      type: Function,
      default: () => {
      }
    },
    selectedDays: {
      type: Array,
      default: () => []
    },
    currentDate: {
      type: Date,
      default: /* @__PURE__ */ new Date()
    },
    range: {
      type: Boolean,
      default: !1
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    weekendAvailable: {
      type: Boolean,
      default: !1
    },
    blockDateList: {
      type: Array,
      default: () => []
    },
    withBlockList: {
      type: Boolean,
      default: !1
    },
    allowedDateList: {
      type: Array,
      default: () => []
    },
    withAllowedList: {
      type: Boolean,
      default: !1
    },
    startDateValue: {
      type: String,
      default: ""
    },
    endDateValue: {
      type: String,
      default: ""
    },
    showToday: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["goToPrevMonth", "goToNextMonth", "selectDay", "handleclickmonth"],
  setup(e, { emit: a }) {
    const r = V(e.view), s = V(e.currentDate), o = (g) => {
      s.value.setMonth(g), a("goToPrevMonth", g);
    }, d = (g) => {
      s.value.setMonth(g), a("goToNextMonth", g);
    }, u = (g) => !(g.disabled || g.blocked && e.withBlockList || !g.allowed && e.withAllowedList), f = (g, h) => {
      u(g) && a("selectDay", g, h);
    }, c = (g) => {
      a("handleclickmonth", g);
    };
    return Lt(() => {
      s.value = e.currentDate;
    }), {
      goToNextMonth: d,
      goToPrevMonth: o,
      currentDateRef: s,
      viewRef: r,
      handleClick: f,
      handleClickMonth: c
    };
  }
}), AC = {
  id: "days-view",
  class: "c-datepicker__days"
};
function TC(e, a, r, s, o, d) {
  const u = ze("OrqHeader"), f = ze("OrqDays");
  return v(), m("div", AC, [
    re(u, {
      view: e.view,
      "set-view": e.setView,
      "current-date": e.currentDateRef,
      inverse: e.inverse,
      onGoToNextMonth: e.goToNextMonth,
      onGoToPrevMonth: e.goToPrevMonth,
      onHandleclickmonth: a[0] || (a[0] = (c) => e.handleClickMonth("month"))
    }, null, 8, ["view", "set-view", "current-date", "inverse", "onGoToNextMonth", "onGoToPrevMonth"]),
    re(f, {
      days: e.daysToShow,
      "selected-days": e.selectedDays,
      range: e.range,
      "weekend-available": e.weekendAvailable,
      "with-block-list": e.withBlockList,
      "with-allowed-list": e.withAllowedList,
      "start-date-value": e.startDateValue,
      "end-date-value": e.endDateValue,
      inverse: e.inverse,
      "show-today": e.showToday,
      onSelectDay: e.handleClick
    }, null, 8, ["days", "selected-days", "range", "weekend-available", "with-block-list", "with-allowed-list", "start-date-value", "end-date-value", "inverse", "show-today", "onSelectDay"])
  ]);
}
const OC = /* @__PURE__ */ ae(BC, [["render", TC]]), IC = Oe({
  name: "HeaderMonth",
  components: {
    OrqIconContainer: Te
  },
  props: {
    setView: {
      type: Function,
      default: () => {
      }
    },
    view: {
      type: String,
      default: "day"
    },
    currentDate: {
      type: Date,
      default: /* @__PURE__ */ new Date()
    },
    setCurrentDate: {
      type: Function,
      default: () => {
      }
    },
    setDate: {
      type: Function,
      default: () => {
      }
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["handleclickyear"],
  setup(e, { emit: a }) {
    const r = V(e.currentDate), s = V(e.view), o = V(e.setDate), d = () => e.inverse ? Xe.emphasisBaseInverseHigh : Xe.emphasisBaseHigh, u = (g) => {
      a("handleclickyear", g);
    };
    function f() {
      r.value && (r.value = new Date(
        r.value.getFullYear() + 1,
        r.value.getMonth(),
        r.value.getDate()
      ), o.value(r.value));
    }
    function c() {
      r.value && (r.value = new Date(
        r.value.getFullYear() - 1,
        r.value.getMonth(),
        r.value.getDate()
      ), o.value(r.value));
    }
    return {
      MONTHS: wr,
      viewRef: s,
      setIconColor: d,
      handleClick: u,
      goToNextYear: f,
      goToPrevYear: c,
      currentDateRef: r
    };
  }
}), MC = { class: "c-datepicker__header c-datepicker__months__header" };
function xC(e, a, r, s, o, d) {
  var f;
  const u = ze("OrqIconContainer");
  return v(), m("div", MC, [
    y("span", {
      class: "arrow-icon pointer",
      onClick: a[0] || (a[0] = Ct((...c) => e.goToPrevYear && e.goToPrevYear(...c), ["stop"]))
    }, [
      re(u, {
        color: e.setIconColor(),
        inverse: e.inverse,
        type: "none",
        name: "chevron-left",
        size: 24
      }, null, 8, ["color", "inverse"])
    ]),
    y("span", {
      id: "year-button",
      class: "pointer",
      onClick: a[1] || (a[1] = Ct((c) => e.handleClick("year"), ["stop"]))
    }, ie((f = e.currentDateRef) == null ? void 0 : f.getFullYear()), 1),
    y("span", {
      class: "arrow-icon pointer",
      onClick: a[2] || (a[2] = Ct((...c) => e.goToNextYear && e.goToNextYear(...c), ["stop"]))
    }, [
      re(u, {
        color: e.setIconColor(),
        inverse: e.inverse,
        type: "none",
        name: "chevron-right",
        size: 24
      }, null, 8, ["color", "inverse"])
    ])
  ]);
}
const LC = /* @__PURE__ */ ae(IC, [["render", xC]]), FC = Oe({
  name: "OrqMonths",
  components: {},
  props: {
    setView: {
      type: Function,
      default: () => {
      }
    },
    view: {
      type: String,
      default: "day"
    },
    currentDate: {
      type: Date,
      default: /* @__PURE__ */ new Date()
    },
    setCurrentDate: {
      type: Function,
      default: () => {
      }
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["changeselectedmonth"],
  setup(e, { emit: a }) {
    const r = V(e.setCurrentDate);
    function s(d) {
      var u, f;
      r.value = new Date(
        (u = e.currentDate) == null ? void 0 : u.getFullYear(),
        wr == null ? void 0 : wr.indexOf(d),
        (f = e.currentDate) == null ? void 0 : f.getDate()
      ), a("changeselectedmonth", r.value);
    }
    return { currentMonth: B(() => {
      var d;
      return (d = e.currentDate) == null ? void 0 : d.getMonth();
    }), MONTHS: wr, changeSelectedMonth: s };
  }
}), EC = ["onClick"];
function PC(e, a, r, s, o, d) {
  return v(), m("div", {
    key: e.currentMonth,
    class: w(["c-datepicker__months__grid grid", { inverse: e.inverse }])
  }, [
    (v(!0), m(ce, null, Re(e.MONTHS, (u) => (v(), m("div", {
      key: e.MONTHS.indexOf(u),
      class: "c-datepicker__month--button-container"
    }, [
      y("span", {
        class: w(["pointer c-datepicker__month--button", {
          "c-datepicker__month--selected": e.currentMonth === e.MONTHS.indexOf(u)
        }]),
        onClick: Ct((f) => e.changeSelectedMonth(u), ["stop"])
      }, ie(u), 11, EC)
    ]))), 128))
  ], 2);
}
const zC = /* @__PURE__ */ ae(FC, [["render", PC], ["__scopeId", "data-v-86f1f9e2"]]), RC = Oe({
  name: "MonthLayout",
  components: {
    OrqMonthsHeader: LC,
    OrqMonths: zC
  },
  props: {
    setView: {
      type: Function,
      default: () => {
      }
    },
    view: {
      type: String,
      default: "day"
    },
    currentDate: {
      type: Date,
      default: /* @__PURE__ */ new Date()
    },
    setCurrentDate: {
      type: Function,
      default: () => {
      }
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["handleclickyear", "handleselectedmonth"],
  setup(e, { emit: a }) {
    const r = V(e.view), s = V(e.currentDate);
    return {
      handleClickYear: (f) => {
        a("handleclickyear", f);
      },
      viewRef: r,
      setDate: (f) => {
        s.value = f;
      },
      currentDateRef: s,
      handleSelectedMonth: (f) => {
        a("handleselectedmonth", f);
      }
    };
  }
}), NC = {
  id: "months-view",
  class: "c-datepicker__months"
};
function HC(e, a, r, s, o, d) {
  const u = ze("OrqMonthsHeader"), f = ze("OrqMonths");
  return v(), m("div", NC, [
    re(u, {
      view: e.viewRef,
      "set-view": e.setView,
      "current-date": e.currentDate,
      "set-current-date": e.setCurrentDate,
      "set-date": e.setDate,
      inverse: e.inverse,
      onHandleclickyear: a[0] || (a[0] = (c) => e.handleClickYear("year"))
    }, null, 8, ["view", "set-view", "current-date", "set-current-date", "set-date", "inverse"]),
    re(f, {
      view: e.view,
      inverse: e.inverse,
      "set-view": e.setView,
      "current-date": e.currentDateRef,
      "set-current-date": e.setCurrentDate,
      onChangeselectedmonth: e.handleSelectedMonth
    }, null, 8, ["view", "inverse", "set-view", "current-date", "set-current-date", "onChangeselectedmonth"])
  ]);
}
const VC = /* @__PURE__ */ ae(RC, [["render", HC]]), YC = Oe({
  name: "OrqYears",
  props: {
    setView: {
      type: Function,
      default: () => {
      }
    },
    rangeDate: {
      type: Array,
      default: () => []
    },
    setCurrentDate: {
      type: Function,
      default: () => {
      }
    }
  },
  emits: ["changeselectedyear"],
  setup(e, { emit: a }) {
    const r = V(e.rangeDate), s = V([]);
    function o() {
      s.value = [];
      for (let u = r.value[0].getFullYear(); u <= r.value[1].getFullYear(); u++)
        s.value.push(u);
    }
    Tt(() => {
      o();
    }), vt(
      () => e.rangeDate,
      (u) => {
        r.value = u, o();
      }
    );
    function d(u) {
      a("changeselectedyear", u);
    }
    return {
      changeSelectedYear: d,
      getYears: o,
      years: s
    };
  }
}), UC = { class: "c-datepicker__years__grid grid" }, WC = ["onClick"], GC = { class: "pointer" };
function ZC(e, a, r, s, o, d) {
  return v(), m("div", UC, [
    (v(!0), m(ce, null, Re(e.years, (u, f) => (v(), m("span", {
      key: f,
      onClick: Ct((c) => e.changeSelectedYear(u), ["stop"])
    }, [
      y("span", GC, ie(u), 1)
    ], 8, WC))), 128))
  ]);
}
const KC = /* @__PURE__ */ ae(YC, [["render", ZC]]), XC = Oe({
  name: "HeaderYear",
  components: {
    OrqIconContainer: Te
  },
  props: {
    rangeDate: {
      type: Array,
      default: () => []
    },
    setCurrentDate: {
      type: Function,
      default: () => {
      }
    },
    startRangeDate: {
      type: Number,
      default: 0
    },
    endRangeDate: {
      type: Number,
      default: 0
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["yearrange"],
  setup(e, { emit: a }) {
    const r = V(e.rangeDate), s = () => e.inverse ? Xe.emphasisBaseInverseHigh : Xe.emphasisBaseHigh;
    vt(
      () => e.rangeDate,
      (u) => {
        r.value = u;
      }
    );
    function o() {
      a("yearrange", "next");
    }
    function d() {
      a("yearrange", "prev");
    }
    return {
      renderYears: B(() => r.value[0].getFullYear() + "-" + r.value[1].getFullYear()),
      rangeDateRef: r,
      setIconColor: s,
      goToNextYearRange: o,
      goToPrevYearRange: d
    };
  }
}), JC = { class: "c-datepicker__header datepicker__years__header" }, QC = { id: "month-button" };
function jC(e, a, r, s, o, d) {
  const u = ze("OrqIconContainer");
  return v(), m("div", JC, [
    y("span", {
      class: "arrow-icon pointer",
      onClick: a[0] || (a[0] = Ct((...f) => e.goToPrevYearRange && e.goToPrevYearRange(...f), ["stop"]))
    }, [
      re(u, {
        color: e.setIconColor(),
        inverse: e.inverse,
        type: "none",
        name: "chevron-left",
        size: 24
      }, null, 8, ["color", "inverse"])
    ]),
    y("span", QC, ie(e.renderYears), 1),
    y("span", {
      class: "arrow-icon pointer",
      onClick: a[1] || (a[1] = Ct((...f) => e.goToNextYearRange && e.goToNextYearRange(...f), ["stop"]))
    }, [
      re(u, {
        color: e.setIconColor(),
        inverse: e.inverse,
        type: "none",
        name: "chevron-right",
        size: 24
      }, null, 8, ["color", "inverse"])
    ])
  ]);
}
const eS = /* @__PURE__ */ ae(XC, [["render", jC]]), tS = Oe({
  name: "YearLayout",
  components: {
    Years: KC,
    HeaderYear: eS
  },
  props: {
    setView: {
      type: Function,
      default: () => {
      }
    },
    currentDate: {
      type: Date,
      default: /* @__PURE__ */ new Date()
    },
    setCurrentDate: {
      type: Function,
      default: () => {
      }
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["changeselectedyear"],
  setup(e, { emit: a }) {
    const r = V([
      new Date(e.currentDate.getFullYear() - 9, 0),
      new Date(e.currentDate.getFullYear() + 10, 0)
    ]);
    function s(u) {
      let f = r.value;
      switch (u) {
        case "prev":
          r.value = [
            new Date(f[0].getFullYear() - 10, 0),
            new Date(f[1].getFullYear() - 10, 0)
          ];
          break;
        case "next":
          r.value = [
            new Date(f[0].getFullYear() + 10, 0),
            new Date(f[1].getFullYear() + 10, 0)
          ];
          break;
      }
    }
    function o(u) {
      s(u);
    }
    function d(u) {
      a("changeselectedyear", u);
    }
    return {
      changeSelectedYear: d,
      getYearRange: o,
      yearRangeRef: r
    };
  }
}), nS = {
  id: "years-view",
  class: "c-datepicker__years"
};
function rS(e, a, r, s, o, d) {
  const u = ze("HeaderYear"), f = ze("Years");
  return v(), m("div", nS, [
    re(u, {
      "set-view": e.setView,
      "range-date": e.yearRangeRef,
      "set-current-date": e.setCurrentDate,
      inverse: e.inverse,
      onYearrange: e.getYearRange
    }, null, 8, ["set-view", "range-date", "set-current-date", "inverse", "onYearrange"]),
    re(f, {
      "set-view": e.setView,
      "range-date": e.yearRangeRef,
      "set-current-date": e.setCurrentDate,
      onChangeselectedyear: e.changeSelectedYear
    }, null, 8, ["set-view", "range-date", "set-current-date", "onChangeselectedyear"])
  ]);
}
const aS = /* @__PURE__ */ ae(tS, [["render", rS]]), iS = Oe({
  name: "OrqDatepicker",
  components: {
    DayLayout: OC,
    MonthLayout: VC,
    YearLayout: aS
  },
  props: {
    daysToShow: {
      type: Array,
      default: () => []
    },
    events: {
      type: Array,
      default: () => []
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    range: {
      type: Boolean,
      default: !1
    },
    weekendAvailable: {
      type: Boolean,
      default: !1
    },
    blockDateList: {
      type: Array,
      default: () => []
    },
    withBlockList: {
      type: Boolean,
      default: !1
    },
    allowedDateList: {
      type: Array,
      default: () => []
    },
    withAllowedList: {
      type: Boolean,
      default: !1
    },
    view: {
      type: String,
      default: "day"
    },
    setView: {
      type: Function,
      default: () => {
      }
    },
    setCurrentDate: {
      type: Function,
      default: () => {
      }
    },
    currentDate: {
      type: Date,
      default: /* @__PURE__ */ new Date()
    },
    selectedDays: {
      type: Array,
      default: () => []
    },
    startDateValue: {
      type: String,
      default: ""
    },
    endDateValue: {
      type: String,
      default: ""
    },
    showToday: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "day"
    }
  },
  emits: [
    "goToPrevMonth",
    "goToNextMonth",
    "selectDay",
    "handleswitchview",
    "handleselectedmonth",
    "handlerendermonth"
  ],
  setup(e, { emit: a }) {
    const r = V(e.view), s = V(e.selectedDays);
    return vt(
      () => e.selectedDays,
      (h) => {
        s.value = h;
      }
    ), {
      selectedDaysRef: s,
      selectDay: (h, q) => {
        a("selectDay", h, q);
      },
      goToPrevMonth: (h) => {
        a("goToPrevMonth", h);
      },
      goToNextMonth: (h) => {
        a("goToNextMonth", h);
      },
      handleSwitchView: (h) => {
        a("handleswitchview", h);
      },
      viewRef: r,
      handleRenderMonth: (h) => {
        a("handlerendermonth", h);
      },
      handleSelectedMonth: (h) => {
        a("handleselectedmonth", h);
      }
    };
  },
  data() {
    return {
      OrquestraDatePickerViewEnum: c$
    };
  }
});
function sS(e, a, r, s, o, d) {
  const u = ze("DayLayout"), f = ze("MonthLayout"), c = ze("YearLayout");
  return v(), m(ce, null, [
    e.view === e.OrquestraDatePickerViewEnum.Day ? (v(), me(u, {
      key: 0,
      events: e.events,
      "set-view": e.setView,
      "current-date": e.currentDate,
      "set-current-date": e.setCurrentDate,
      "selected-days": e.selectedDaysRef,
      range: e.range,
      "start-date-value": e.startDateValue,
      "end-date-value": e.endDateValue,
      "weekend-available": e.weekendAvailable,
      "block-date-list": e.blockDateList,
      "with-block-list": e.withBlockList,
      "allowed-date-list": e.allowedDateList,
      "with-allowed-list": e.withAllowedList,
      "days-to-show": e.daysToShow,
      inverse: e.inverse,
      "show-today": e.showToday,
      onHandleclickmonth: a[0] || (a[0] = (g) => e.handleSwitchView("month")),
      onGoToPrevMonth: e.goToPrevMonth,
      onGoToNextMonth: e.goToNextMonth,
      onSelectDay: e.selectDay
    }, null, 8, ["events", "set-view", "current-date", "set-current-date", "selected-days", "range", "start-date-value", "end-date-value", "weekend-available", "block-date-list", "with-block-list", "allowed-date-list", "with-allowed-list", "days-to-show", "inverse", "show-today", "onGoToPrevMonth", "onGoToNextMonth", "onSelectDay"])) : D("", !0),
    e.view === e.OrquestraDatePickerViewEnum.Month ? (v(), me(f, {
      key: e.currentDate,
      "set-view": e.setView,
      "current-date": e.currentDate,
      inverse: e.inverse,
      onHandleclickyear: a[1] || (a[1] = (g) => e.handleSwitchView("year")),
      onHandleselectedmonth: e.handleSelectedMonth
    }, null, 8, ["set-view", "current-date", "inverse", "onHandleselectedmonth"])) : D("", !0),
    e.view === e.OrquestraDatePickerViewEnum.Year ? (v(), me(c, {
      key: 2,
      "set-view": e.setView,
      "current-date": e.currentDate,
      "set-current-date": e.setCurrentDate,
      inverse: e.inverse,
      onChangeselectedyear: e.handleRenderMonth
    }, null, 8, ["set-view", "current-date", "set-current-date", "inverse", "onChangeselectedyear"])) : D("", !0)
  ], 64);
}
const oS = /* @__PURE__ */ ae(iS, [["render", sS]]), lS = Oe({
  name: "SingleDatePicker",
  components: {
    SingleDatePickerWrapper: u$,
    Datepicker: oS
  },
  props: {
    daysToShow: {
      type: Array,
      default: () => []
    },
    events: {
      type: Array,
      default: () => []
    },
    range: {
      type: Boolean,
      default: !1
    },
    mode: {
      type: String,
      default: "datepicker"
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    todayText: {
      type: String,
      default: "Hoy"
    },
    value: {
      type: Array,
      default: () => []
    },
    weekendAvailable: {
      type: Boolean,
      default: !1
    },
    blockDateList: {
      type: Array,
      default: () => []
    },
    withBlockList: {
      type: Boolean,
      default: !1
    },
    allowedDateList: {
      type: Array,
      default: () => []
    },
    withAllowedList: {
      type: Boolean,
      default: !1
    },
    setSelectedDays: {
      type: Function,
      default: () => {
      }
    },
    selectedDays: {
      type: Array,
      default: () => []
    },
    startDateValue: {
      type: String,
      default: ""
    },
    endDateValue: {
      type: String,
      default: ""
    },
    currentDate: {
      type: Date,
      default: /* @__PURE__ */ new Date()
    },
    showToday: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "day"
    }
  },
  emits: [
    "handleselectedmonth",
    "goToPrevMonth",
    "goToNextMonth",
    "selectDay",
    "handleToday",
    "handleselectedyear"
  ],
  setup(e, { emit: a, slots: r }) {
    let s = V(e.type);
    const o = V(e.selectedDays), d = V(e.currentDate);
    vt(
      () => e.selectedDays,
      (S) => {
        o.value = S;
      }
    );
    const u = B(() => {
      var S, I;
      return Array.isArray(r.default()[0].children) && ((I = (S = r.default()[0]) == null ? void 0 : S.children) == null ? void 0 : I.length) > 0;
    }), f = (S) => {
      a("goToPrevMonth", S);
    }, c = (S) => {
      a("goToNextMonth", S);
    }, g = (S, I) => {
      a("selectDay", S, I);
    };
    function h() {
      var I, M, F;
      const S = new Date(
        (I = /* @__PURE__ */ new Date()) == null ? void 0 : I.getFullYear(),
        (M = /* @__PURE__ */ new Date()) == null ? void 0 : M.getMonth(),
        (F = /* @__PURE__ */ new Date()) == null ? void 0 : F.getDate()
      );
      d.value = S, (s.value === "year" || s.value === "month") && (s.value = "day"), a("handleToday", S);
    }
    const q = (S) => {
      s.value = S;
    }, C = (S) => {
      var I;
      if (e.type === "month" ? d.value = new Date(
        S.getFullYear(),
        S.getMonth(),
        (I = e.currentDate) == null ? void 0 : I.getDate()
      ) : (d.value.setMonth(S.getMonth()), d.value.setFullYear(S.getFullYear())), e.type === "month") {
        a("handleToday", d.value);
        return;
      }
      s.value = "day", a("handleselectedmonth", S);
    }, O = (S) => {
      d.value.setFullYear(S), s.value = "month", a("handleselectedyear", d.value);
    };
    return Lt(() => {
      d.value = e.currentDate;
    }), {
      setToday: h,
      view: s,
      selectDay: g,
      currentDateRef: d,
      selectedDaysRef: o,
      goToNextMonth: c,
      goToPrevMonth: f,
      handleSelectedMonth: C,
      handleSelectedYear: O,
      renderclickMonth: q,
      hasSlots: u
    };
  }
}), uS = {
  key: 1,
  class: "single-datepicker__buttons"
};
function cS(e, a, r, s, o, d) {
  const u = ze("Datepicker"), f = ze("SingleDatePickerWrapper");
  return v(), me(f, { mode: e.mode }, {
    default: dt(() => [
      re(u, {
        events: e.events,
        range: e.range,
        "selected-days": e.selectedDaysRef,
        view: e.view,
        "start-date-value": e.startDateValue,
        "end-date-value": e.endDateValue,
        "current-date": e.currentDateRef,
        "weekend-available": e.weekendAvailable,
        "block-date-list": e.blockDateList,
        "with-block-list": e.withBlockList,
        "allowed-date-list": e.allowedDateList,
        "with-allowed-list": e.withAllowedList,
        "days-to-show": e.daysToShow,
        inverse: e.inverse,
        "show-today": e.showToday,
        type: e.type,
        onGoToNextMonth: e.goToNextMonth,
        onGoToPrevMonth: e.goToPrevMonth,
        onSelectDay: e.selectDay,
        onHandleswitchview: e.renderclickMonth,
        onHandleselectedmonth: e.handleSelectedMonth,
        onHandlerendermonth: e.handleSelectedYear
      }, null, 8, ["events", "range", "selected-days", "view", "start-date-value", "end-date-value", "current-date", "weekend-available", "block-date-list", "with-block-list", "allowed-date-list", "with-allowed-list", "days-to-show", "inverse", "show-today", "type", "onGoToNextMonth", "onGoToPrevMonth", "onSelectDay", "onHandleswitchview", "onHandleselectedmonth", "onHandlerendermonth"]),
      e.showToday ? (v(), m("div", {
        key: 0,
        class: "c-datepicker__today pointer",
        onClick: a[0] || (a[0] = (...c) => e.setToday && e.setToday(...c))
      }, [
        y("span", null, ie(e.todayText), 1)
      ])) : D("", !0),
      e.mode === "datepicker" && e.hasSlots ? (v(), m("div", uS, [
        we(e.$slots, "default")
      ])) : D("", !0)
    ]),
    _: 3
  }, 8, ["mode"]);
}
const dS = /* @__PURE__ */ ae(lS, [["render", cS]]);
var Yd = { exports: {} };
(function(e, a) {
  (function(r, s) {
    e.exports = s();
  })(br, function() {
    var r = 1e3, s = 6e4, o = 36e5, d = "millisecond", u = "second", f = "minute", c = "hour", g = "day", h = "week", q = "month", C = "quarter", O = "year", S = "date", I = "Invalid Date", M = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, F = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, P = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(ee) {
      var Q = ["th", "st", "nd", "rd"], J = ee % 100;
      return "[" + ee + (Q[(J - 20) % 10] || Q[J] || Q[0]) + "]";
    } }, x = function(ee, Q, J) {
      var te = String(ee);
      return !te || te.length >= Q ? ee : "" + Array(Q + 1 - te.length).join(J) + ee;
    }, $ = { s: x, z: function(ee) {
      var Q = -ee.utcOffset(), J = Math.abs(Q), te = Math.floor(J / 60), G = J % 60;
      return (Q <= 0 ? "+" : "-") + x(te, 2, "0") + ":" + x(G, 2, "0");
    }, m: function ee(Q, J) {
      if (Q.date() < J.date()) return -ee(J, Q);
      var te = 12 * (J.year() - Q.year()) + (J.month() - Q.month()), G = Q.clone().add(te, q), de = J - G < 0, ge = Q.clone().add(te + (de ? -1 : 1), q);
      return +(-(te + (J - G) / (de ? G - ge : ge - G)) || 0);
    }, a: function(ee) {
      return ee < 0 ? Math.ceil(ee) || 0 : Math.floor(ee);
    }, p: function(ee) {
      return { M: q, y: O, w: h, d: g, D: S, h: c, m: f, s: u, ms: d, Q: C }[ee] || String(ee || "").toLowerCase().replace(/s$/, "");
    }, u: function(ee) {
      return ee === void 0;
    } }, Y = "en", R = {};
    R[Y] = P;
    var T = "$isDayjsObject", z = function(ee) {
      return ee instanceof oe || !(!ee || !ee[T]);
    }, le = function ee(Q, J, te) {
      var G;
      if (!Q) return Y;
      if (typeof Q == "string") {
        var de = Q.toLowerCase();
        R[de] && (G = de), J && (R[de] = J, G = de);
        var ge = Q.split("-");
        if (!G && ge.length > 1) return ee(ge[0]);
      } else {
        var N = Q.name;
        R[N] = Q, G = N;
      }
      return !te && G && (Y = G), G || !te && Y;
    }, K = function(ee, Q) {
      if (z(ee)) return ee.clone();
      var J = typeof Q == "object" ? Q : {};
      return J.date = ee, J.args = arguments, new oe(J);
    }, se = $;
    se.l = le, se.i = z, se.w = function(ee, Q) {
      return K(ee, { locale: Q.$L, utc: Q.$u, x: Q.$x, $offset: Q.$offset });
    };
    var oe = function() {
      function ee(J) {
        this.$L = le(J.locale, null, !0), this.parse(J), this.$x = this.$x || J.x || {}, this[T] = !0;
      }
      var Q = ee.prototype;
      return Q.parse = function(J) {
        this.$d = function(te) {
          var G = te.date, de = te.utc;
          if (G === null) return /* @__PURE__ */ new Date(NaN);
          if (se.u(G)) return /* @__PURE__ */ new Date();
          if (G instanceof Date) return new Date(G);
          if (typeof G == "string" && !/Z$/i.test(G)) {
            var ge = G.match(M);
            if (ge) {
              var N = ge[2] - 1 || 0, ne = (ge[7] || "0").substring(0, 3);
              return de ? new Date(Date.UTC(ge[1], N, ge[3] || 1, ge[4] || 0, ge[5] || 0, ge[6] || 0, ne)) : new Date(ge[1], N, ge[3] || 1, ge[4] || 0, ge[5] || 0, ge[6] || 0, ne);
            }
          }
          return new Date(G);
        }(J), this.init();
      }, Q.init = function() {
        var J = this.$d;
        this.$y = J.getFullYear(), this.$M = J.getMonth(), this.$D = J.getDate(), this.$W = J.getDay(), this.$H = J.getHours(), this.$m = J.getMinutes(), this.$s = J.getSeconds(), this.$ms = J.getMilliseconds();
      }, Q.$utils = function() {
        return se;
      }, Q.isValid = function() {
        return this.$d.toString() !== I;
      }, Q.isSame = function(J, te) {
        var G = K(J);
        return this.startOf(te) <= G && G <= this.endOf(te);
      }, Q.isAfter = function(J, te) {
        return K(J) < this.startOf(te);
      }, Q.isBefore = function(J, te) {
        return this.endOf(te) < K(J);
      }, Q.$g = function(J, te, G) {
        return se.u(J) ? this[te] : this.set(G, J);
      }, Q.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, Q.valueOf = function() {
        return this.$d.getTime();
      }, Q.startOf = function(J, te) {
        var G = this, de = !!se.u(te) || te, ge = se.p(J), N = function(ke, Ie) {
          var Je = se.w(G.$u ? Date.UTC(G.$y, Ie, ke) : new Date(G.$y, Ie, ke), G);
          return de ? Je : Je.endOf(g);
        }, ne = function(ke, Ie) {
          return se.w(G.toDate()[ke].apply(G.toDate("s"), (de ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Ie)), G);
        }, ue = this.$W, Se = this.$M, Me = this.$D, Ne = "set" + (this.$u ? "UTC" : "");
        switch (ge) {
          case O:
            return de ? N(1, 0) : N(31, 11);
          case q:
            return de ? N(1, Se) : N(0, Se + 1);
          case h:
            var pt = this.$locale().weekStart || 0, st = (ue < pt ? ue + 7 : ue) - pt;
            return N(de ? Me - st : Me + (6 - st), Se);
          case g:
          case S:
            return ne(Ne + "Hours", 0);
          case c:
            return ne(Ne + "Minutes", 1);
          case f:
            return ne(Ne + "Seconds", 2);
          case u:
            return ne(Ne + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, Q.endOf = function(J) {
        return this.startOf(J, !1);
      }, Q.$set = function(J, te) {
        var G, de = se.p(J), ge = "set" + (this.$u ? "UTC" : ""), N = (G = {}, G[g] = ge + "Date", G[S] = ge + "Date", G[q] = ge + "Month", G[O] = ge + "FullYear", G[c] = ge + "Hours", G[f] = ge + "Minutes", G[u] = ge + "Seconds", G[d] = ge + "Milliseconds", G)[de], ne = de === g ? this.$D + (te - this.$W) : te;
        if (de === q || de === O) {
          var ue = this.clone().set(S, 1);
          ue.$d[N](ne), ue.init(), this.$d = ue.set(S, Math.min(this.$D, ue.daysInMonth())).$d;
        } else N && this.$d[N](ne);
        return this.init(), this;
      }, Q.set = function(J, te) {
        return this.clone().$set(J, te);
      }, Q.get = function(J) {
        return this[se.p(J)]();
      }, Q.add = function(J, te) {
        var G, de = this;
        J = Number(J);
        var ge = se.p(te), N = function(Se) {
          var Me = K(de);
          return se.w(Me.date(Me.date() + Math.round(Se * J)), de);
        };
        if (ge === q) return this.set(q, this.$M + J);
        if (ge === O) return this.set(O, this.$y + J);
        if (ge === g) return N(1);
        if (ge === h) return N(7);
        var ne = (G = {}, G[f] = s, G[c] = o, G[u] = r, G)[ge] || 1, ue = this.$d.getTime() + J * ne;
        return se.w(ue, this);
      }, Q.subtract = function(J, te) {
        return this.add(-1 * J, te);
      }, Q.format = function(J) {
        var te = this, G = this.$locale();
        if (!this.isValid()) return G.invalidDate || I;
        var de = J || "YYYY-MM-DDTHH:mm:ssZ", ge = se.z(this), N = this.$H, ne = this.$m, ue = this.$M, Se = G.weekdays, Me = G.months, Ne = G.meridiem, pt = function(Ie, Je, he, je) {
          return Ie && (Ie[Je] || Ie(te, de)) || he[Je].slice(0, je);
        }, st = function(Ie) {
          return se.s(N % 12 || 12, Ie, "0");
        }, ke = Ne || function(Ie, Je, he) {
          var je = Ie < 12 ? "AM" : "PM";
          return he ? je.toLowerCase() : je;
        };
        return de.replace(F, function(Ie, Je) {
          return Je || function(he) {
            switch (he) {
              case "YY":
                return String(te.$y).slice(-2);
              case "YYYY":
                return se.s(te.$y, 4, "0");
              case "M":
                return ue + 1;
              case "MM":
                return se.s(ue + 1, 2, "0");
              case "MMM":
                return pt(G.monthsShort, ue, Me, 3);
              case "MMMM":
                return pt(Me, ue);
              case "D":
                return te.$D;
              case "DD":
                return se.s(te.$D, 2, "0");
              case "d":
                return String(te.$W);
              case "dd":
                return pt(G.weekdaysMin, te.$W, Se, 2);
              case "ddd":
                return pt(G.weekdaysShort, te.$W, Se, 3);
              case "dddd":
                return Se[te.$W];
              case "H":
                return String(N);
              case "HH":
                return se.s(N, 2, "0");
              case "h":
                return st(1);
              case "hh":
                return st(2);
              case "a":
                return ke(N, ne, !0);
              case "A":
                return ke(N, ne, !1);
              case "m":
                return String(ne);
              case "mm":
                return se.s(ne, 2, "0");
              case "s":
                return String(te.$s);
              case "ss":
                return se.s(te.$s, 2, "0");
              case "SSS":
                return se.s(te.$ms, 3, "0");
              case "Z":
                return ge;
            }
            return null;
          }(Ie) || ge.replace(":", "");
        });
      }, Q.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, Q.diff = function(J, te, G) {
        var de, ge = this, N = se.p(te), ne = K(J), ue = (ne.utcOffset() - this.utcOffset()) * s, Se = this - ne, Me = function() {
          return se.m(ge, ne);
        };
        switch (N) {
          case O:
            de = Me() / 12;
            break;
          case q:
            de = Me();
            break;
          case C:
            de = Me() / 3;
            break;
          case h:
            de = (Se - ue) / 6048e5;
            break;
          case g:
            de = (Se - ue) / 864e5;
            break;
          case c:
            de = Se / o;
            break;
          case f:
            de = Se / s;
            break;
          case u:
            de = Se / r;
            break;
          default:
            de = Se;
        }
        return G ? de : se.a(de);
      }, Q.daysInMonth = function() {
        return this.endOf(q).$D;
      }, Q.$locale = function() {
        return R[this.$L];
      }, Q.locale = function(J, te) {
        if (!J) return this.$L;
        var G = this.clone(), de = le(J, te, !0);
        return de && (G.$L = de), G;
      }, Q.clone = function() {
        return se.w(this.$d, this);
      }, Q.toDate = function() {
        return new Date(this.valueOf());
      }, Q.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, Q.toISOString = function() {
        return this.$d.toISOString();
      }, Q.toString = function() {
        return this.$d.toUTCString();
      }, ee;
    }(), ve = oe.prototype;
    return K.prototype = ve, [["$ms", d], ["$s", u], ["$m", f], ["$H", c], ["$W", g], ["$M", q], ["$y", O], ["$D", S]].forEach(function(ee) {
      ve[ee[1]] = function(Q) {
        return this.$g(Q, ee[0], ee[1]);
      };
    }), K.extend = function(ee, Q) {
      return ee.$i || (ee(Q, oe, K), ee.$i = !0), K;
    }, K.locale = le, K.isDayjs = z, K.unix = function(ee) {
      return K(1e3 * ee);
    }, K.en = R[Y], K.Ls = R, K.p = {}, K;
  });
})(Yd);
var fS = Yd.exports;
const mn = /* @__PURE__ */ md(fS), vS = Oe({
  name: "OrqCalendar",
  components: {
    SingleDatePicker: dS
  },
  props: {
    isModal: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    eventIndication: {
      type: Array,
      default: () => []
    },
    range: {
      type: Boolean,
      default: !1
    },
    startDateValue: {
      type: String,
      default: ""
    },
    endDateValue: {
      type: String,
      default: ""
    },
    onChange: {
      type: Function,
      default: () => []
    },
    mode: {
      type: String,
      default: "calendar"
    },
    todayText: {
      type: String,
      default: "Hoy"
    },
    textStartCalendar: {
      type: String,
      default: ""
    },
    placeStartCalendar: {
      type: String,
      default: ""
    },
    textEndCalendar: {
      type: String,
      default: ""
    },
    placeEndCalendar: {
      type: String,
      default: ""
    },
    inputErrorMessage: {
      type: String,
      default: ""
    },
    value: {
      type: Array,
      default: () => []
    },
    hasError: {
      type: Boolean,
      default: !1
    },
    weekendAvailable: {
      type: Boolean,
      default: !1
    },
    blockDateList: {
      type: Array,
      default: () => []
    },
    withBlockList: {
      type: Boolean,
      default: !1
    },
    allowedDateList: {
      type: Array,
      default: () => (
        // defaults to 5YTD
        Array.from(
          {
            length: mn().diff(mn().subtract(5, "year"), "d")
          },
          (e, a) => mn().subtract(a, "d").format("MM/DD/YYYY")
        )
      )
    },
    withAllowedList: {
      type: Boolean,
      default: !1
    },
    selectedDays: {
      type: Array,
      default: () => []
    },
    showToday: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "day"
    }
  },
  emits: [
    "selectDaySingle",
    "selectDayRange",
    "selectDay",
    "close",
    "change",
    "handleToday",
    "selectedDays"
  ],
  setup(e, { emit: a }) {
    const r = (N) => {
      const [ne, ue, Se] = (N == null ? void 0 : N.split("/")) || "";
      return new Date(+Se, +ue - 1, +ne);
    }, s = V(e.startDateValue), o = V(e.endDateValue), d = V(/* @__PURE__ */ new Date()), u = V([]), f = V(e.value), c = V(null), g = V(null), h = V(!0), q = e.eventIndication ? e.eventIndication.map((N) => ({
      date: N.date || "",
      message: N.message
    })) : [], C = e.blockDateList ? e.blockDateList.map((N) => N || "") : [], O = e.allowedDateList ? e.allowedDateList.map((N) => N || "") : [], S = V(
      Array.isArray(f) ? f : []
    ), I = (N) => {
      var ne;
      r(s.value).getMonth() !== d.value.getMonth() ? z() : u.value.map((ue) => {
        var Se;
        ((Se = r(
          s.value
        )) == null ? void 0 : Se.getTime()) === ue.date.getTime() && (ue.selected = !0);
      }), (ne = d.value) == null || ne.setMonth(N), x(d.value);
    }, M = (N) => {
      var ne;
      r(s.value).getMonth() !== d.value.getMonth() ? z() : u.value.map((ue) => {
        var Se;
        ((Se = r(
          s.value
        )) == null ? void 0 : Se.getTime()) === ue.date.getTime() && (ue.selected = !0);
      }), (ne = d.value) == null || ne.setMonth(N), x(d.value);
    };
    function F(N) {
      let ne = N.getDate(), ue = N.getMonth() + 1, Se = N.getFullYear(), Me = ne < 10 ? "0" + ne : ne, Ne = ue < 10 ? "0" + ue : ue;
      return Me + "/" + Ne + "/" + Se;
    }
    const P = (N) => {
      e.range ? ((S.value[0] > N.date || S.value.length >= 2) && (S.value = [], S.value.length = 0, se()), S.value.length === 0 ? s.value = F(N.date) : o.value = F(N.date), K(N, S.value.length)) : T(N), a("selectDay", S.value);
    }, x = (N) => {
      u.value = h$(
        N,
        e.eventIndication,
        S.value,
        N,
        void 0,
        void 0,
        e.blockDateList,
        e.allowedDateList
      );
    }, $ = (N) => {
      x(N);
    }, Y = (N) => {
      x(N), d.value = N;
      const ne = u.value.find(
        (ue) => new Date(ue.date).getTime() === new Date(N).getTime()
      );
      P(ne), a("handleToday", N);
    }, R = (N) => N.toISOString(), T = (N) => {
      s.value = F(N.date), S.value[0] = N.date, u.value.forEach((ne) => {
        var ue;
        ((ue = S.value[0]) == null ? void 0 : ue.getTime()) === ne.date.getTime() ? ne.selected = !0 : ne.selected = !1;
      }), a("selectDaySingle", N.date.toISOString()), a("selectedDays", R(N.date));
    }, z = () => {
      u.value.map((N) => {
        N.selected = !1;
      });
    }, le = () => {
      u.value.map((N) => {
        var ne, ue;
        ((ne = S.value[0]) == null ? void 0 : ne.getTime()) === N.date.getTime() || ((ue = S.value[1]) == null ? void 0 : ue.getTime()) === N.date.getTime() ? N.selected = !0 : N.selected = !1;
      });
    }, K = (N, ne) => {
      S.value[ne] = N.date, s.value === o.value && e.range && (s.value = F(N.date), o.value = "", S.value = [N.date]), le(), a("selectDayRange", S.value);
    }, se = () => {
      S.value = [], le(), o.value = "";
    }, oe = (N) => {
      x(N);
    };
    Fi(() => {
      var ne, ue, Se, Me;
      if (s.value && (d.value = r(
        s.value
      )), e.range) {
        if (s.value !== null && typeof s.value == "string" && s.value.split("/").length === 3 && ((ne = s.value) == null ? void 0 : ne.length) === 10) {
          const Ne = {
            disabled: !1,
            date: r(s.value),
            selected: !0,
            blocked: !1,
            allowed: !1
          };
          K(Ne, 0);
        }
        if (o.value !== null && typeof o.value == "string" && o.value.split("/").length === 3 && ((ue = o.value) == null ? void 0 : ue.length) === 10) {
          const Ne = {
            disabled: !1,
            date: r(o.value),
            selected: !0,
            blocked: !1,
            allowed: !1
          };
          K(Ne, 1);
        }
      } else {
        if (s.value !== null && typeof s.value == "string" && s.value.split("/").length === 3 && ((Se = s.value) == null ? void 0 : Se.length) === 10) {
          const Ne = {
            disabled: !1,
            date: r(s.value),
            selected: !0,
            blocked: !1,
            allowed: !1
          };
          T(Ne);
        }
        if (o.value !== null && typeof o.value == "string" && o.value.split("/").length === 3 && ((Me = o.value) == null ? void 0 : Me.length) === 10 && !s.value) {
          const Ne = {
            disabled: !1,
            date: r(o.value),
            selected: !0,
            blocked: !1,
            allowed: !1
          };
          T(Ne);
        }
      }
      $(s.value ? r(s.value) : /* @__PURE__ */ new Date()), le();
    });
    const ve = (N) => {
      let ne = N.replace(
        /^(\d{4})\/(\d{2})\/(\d{2})$/,
        "$3/$2/$1"
      );
      s.value = ne, d.value = r(ne), x(r(ne));
      const ue = {
        disabled: !1,
        date: r(ne),
        selected: !0,
        blocked: !1,
        allowed: !1
      };
      e.range ? K(ue, 0) : P(ue);
    }, ee = (N) => /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/.test(N), Q = (N) => {
      let ne = N.replace(
        /^(\d{4})\/(\d{2})\/(\d{2})$/,
        "$3/$2/$1"
      );
      o.value = ne;
      const ue = {
        disabled: !1,
        date: r(ne),
        selected: !0,
        blocked: !1,
        allowed: !1
      };
      K(ue, 1);
    }, J = (N) => {
      const ne = N.target.value;
      ee(ne) && ve(ne), a("change", ne);
    }, te = (N) => {
      const ne = N.target.value;
      ee(ne) && Q(ne), a("change", ne);
    }, G = B(() => [
      s.value,
      o.value
    ]);
    vt(
      () => e.startDateValue,
      (N) => {
        N == null ? s.value = mn().format("DD/MM/YYYY") : s.value = N, a("change", G.value[0]);
      },
      { immediate: !0 }
    ), vt(
      () => e.endDateValue,
      (N) => {
        N == null ? o.value = mn().format("DD/MM/YYYY") : o.value = N, a(
          "change",
          e.range ? G.value : G.value[0]
        );
      },
      { immediate: !0 }
    ), Lt(() => {
      var N, ne;
      if (e.range) {
        if (s.value !== void 0 && typeof s.value == "string" && s.value.split("/").length === 3 && ((N = s.value) == null ? void 0 : N.length) === 10) {
          const ue = {
            disabled: !1,
            date: r(s.value),
            selected: !0,
            blocked: !1,
            allowed: !1
          };
          K(ue, 0);
        }
        if (o.value !== void 0 && typeof o.value == "string" && o.value.split("/").length === 3 && ((ne = o.value) == null ? void 0 : ne.length) === 10)
          if (o.value && s.value && r(o.value) < r(s.value)) {
            const ue = {
              disabled: !1,
              date: r(
                o.value
              ),
              selected: !0,
              blocked: !1,
              allowed: !1
            };
            K(ue, 0), s.value = o.value, o.value = "";
          } else {
            const ue = {
              disabled: !1,
              date: r(
                o.value
              ),
              selected: !0,
              blocked: !1,
              allowed: !1
            };
            K(ue, 1);
          }
      } else
        K({
          disabled: !1,
          selected: !0,
          blocked: !1,
          allowed: !1
        }, 1);
    });
    const de = V(!1), ge = (N = 100) => {
      let ne = c.value.getBoundingClientRect(), ue = window.innerHeight || document.documentElement.clientHeight;
      const Se = !(Math.floor(
        100 - (ne.top >= 0 ? 0 : ne.top) / +-ne.height * 100
      ) < N || Math.floor(
        100 - (ne.bottom - ue) / ne.height * 100
      ) < N);
      if (Se)
        de.value = !1;
      else {
        if (!Se && ne.height + 170 > ue) {
          de.value = !1;
          return;
        }
        de.value = !0;
      }
    };
    return Tt(() => {
      ge();
    }), {
      calendarClasses: B(() => ({
        "orq-calendar": e.mode === "calendar",
        "orq-calendar--inverse": e.inverse,
        "orq-datepicker--inverse": e.inverse,
        "orq-datepicker": e.mode === "datepicker",
        "orq-datepicker--shown": e.isModal && e.mode === "datepicker"
      })),
      isDate: ee,
      showSingleDatePicker: h,
      handleEndDate: Q,
      handleEndDateChange: te,
      calendar: c,
      singleDatePicker: g,
      handleDateClick: ve,
      handleStartDateChange: J,
      clearSelectedDays: se,
      innerValue: f,
      daysToShowLeftRef: u,
      parsedEvents: q,
      parsedBlockedDates: C,
      parsedAllowedDates: O,
      selectedDaysRef: S,
      goToNextMonth: M,
      goToPrevMonth: I,
      selectDay: P,
      handleSelectedView: oe,
      handleToday: Y,
      startDateValueRef: s,
      endDateValueRef: o,
      currentDateLeftRef: d,
      isUp: de
    };
  }
}), pS = {
  key: 0,
  class: "orq-datepicker__lockscreen"
}, hS = {
  key: 0,
  ref: "singleDatePicker",
  class: "orq-datepicker--content"
};
function gS(e, a, r, s, o, d) {
  const u = ze("SingleDatePicker");
  return v(), m(ce, null, [
    e.isModal && e.mode === "datepicker" ? (v(), m("div", pS)) : D("", !0),
    y("div", {
      ref: "calendar",
      class: w([{
        ...e.calendarClasses,
        directionUp: e.isUp,
        directionDown: !e.isUp
      }, "calendar-container"])
    }, [
      e.showSingleDatePicker ? (v(), m("div", hS, [
        re(u, {
          "current-date": e.currentDateLeftRef,
          range: e.range,
          "selected-days": e.selectedDaysRef,
          "days-to-show": e.daysToShowLeftRef,
          value: e.selectedDaysRef,
          mode: e.mode,
          "today-text": e.todayText,
          "start-date-value": e.startDateValueRef,
          "end-date-value": e.endDateValueRef,
          "weekend-available": e.weekendAvailable,
          type: e.type,
          "block-date-list": e.parsedBlockedDates,
          "with-block-list": e.withBlockList,
          "allowed-date-list": e.parsedAllowedDates,
          "with-allowed-list": e.withAllowedList,
          inverse: e.inverse,
          "show-today": e.showToday,
          onGoToNextMonth: e.goToNextMonth,
          onGoToPrevMonth: e.goToPrevMonth,
          onSelectDay: e.selectDay,
          onHandleselectedmonth: e.handleSelectedView,
          onHandleselectedyear: e.handleSelectedView,
          onHandleToday: e.handleToday,
          "onUpdate:selectedDays": a[0] || (a[0] = (f) => e.selectedDaysRef = f)
        }, {
          default: dt(() => [
            we(e.$slots, "default")
          ]),
          _: 3
        }, 8, ["current-date", "range", "selected-days", "days-to-show", "value", "mode", "today-text", "start-date-value", "end-date-value", "weekend-available", "type", "block-date-list", "with-block-list", "allowed-date-list", "with-allowed-list", "inverse", "show-today", "onGoToNextMonth", "onGoToPrevMonth", "onSelectDay", "onHandleselectedmonth", "onHandleselectedyear", "onHandleToday"])
      ], 512)) : D("", !0)
    ], 2)
  ], 64);
}
const mS = /* @__PURE__ */ ae(vS, [["render", gS]]), yS = {
  __name: "Card",
  props: {
    borderless: {
      type: Boolean,
      default: !1
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    href: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const a = e;
    return (r, s) => (v(), me(Ii(e.href !== "" ? "a" : "div"), {
      class: w(["card", {
        "card--borderless": a.borderless,
        "card--inverse": e.inverse,
        "card--link": e.href !== ""
      }]),
      href: e.href
    }, {
      default: dt(() => [
        we(r.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class", "href"]));
  }
}, z3 = /* @__PURE__ */ ae(yS, [["__scopeId", "data-v-dc22259c"]]), bS = {
  __name: "CardBody",
  props: {
    compact: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = e;
    return (r, s) => (v(), m("div", {
      class: w(["card-body", { "card-body--compact": a.compact }])
    }, [
      we(r.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}, R3 = /* @__PURE__ */ ae(bS, [["__scopeId", "data-v-1b5e234c"]]), _S = ["id"], wS = ["onClick"], $S = {
  __name: "ProgressIndicator",
  props: {
    id: {
      type: String,
      default: null
    },
    appearance: {
      type: String,
      default: "bar"
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    items: {
      type: Object,
      default: () => {
      }
    }
  },
  emits: ["clickProgress"],
  setup(e, { emit: a }) {
    const r = e, s = a, o = B(
      () => r.appearance ? `orq-progress-indicator__${r.appearance}` : ""
    ), d = B(
      () => r.inverse ? `orq-progress-indicator__${r.appearance}__item--inverse` : ""
    ), u = B(
      () => r.inverse ? `orq-progress-indicator__${r.appearance}__item--active--inverse` : ""
    );
    return (f, c) => (v(), m("div", {
      id: e.id,
      class: "orq-progress-indicator"
    }, [
      y("div", {
        class: w(`${o.value}`)
      }, [
        (v(!0), m(ce, null, Re(e.items, ({ active: g, i: h }, q) => (v(), m("div", {
          key: h,
          class: w(`
                    ${o.value}__item
                    ${g && o.value + "__item--active"}
                    ${e.inverse && g ? u.value : d.value}
                `),
          onClick: (C) => s("clickProgress", q)
        }, null, 10, wS))), 128))
      ], 2)
    ], 8, _S));
  }
}, CS = /* @__PURE__ */ ae($S, [["__scopeId", "data-v-a37bf9a4"]]), SS = { class: "carousel" }, kS = {
  class: "carousel__items",
  style: {}
}, qS = {
  key: 0,
  class: "carousel__item"
}, DS = {
  key: 0,
  class: "carousel__controls"
}, BS = {
  __name: "Carousel",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    infinite: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const a = {
      next: "carousel-next",
      prev: "carousel-prev"
    }, r = e, s = V(0), o = V(a.next), d = B(() => r.items.map((g, h) => (g.active = s.value === h, g))), u = (g) => {
      s.value = g;
    }, f = fo.debounce(() => {
      o.value = a.next, s.value++, s.value === d.value.length && r.infinite && (s.value = 0);
    }, 200), c = fo.debounce(() => {
      o.value = a.prev, s.value === 0 && r.infinite && (s.value = d.value.length), s.value--;
    }, 200);
    return (g, h) => (v(), m("div", SS, [
      y("div", kS, [
        (v(!0), m(ce, null, Re(d.value, (q, C) => (v(), me(Aa, {
          key: C,
          name: o.value
        }, {
          default: dt(() => [
            q.active ? (v(), m("div", qS, [
              we(g.$slots, "default", {
                item: q,
                index: C
              }, void 0, !0)
            ])) : D("", !0)
          ]),
          _: 2
        }, 1032, ["name"]))), 128))
      ]),
      d.value.length > 1 ? (v(), m("div", DS, [
        re(Te, {
          class: "carousel__control",
          name: "chevron-left",
          onClick: tt(c)
        }, null, 8, ["onClick"]),
        re(CS, {
          class: "carousel__progress",
          appearance: "dot",
          items: d.value,
          onClickProgress: u
        }, null, 8, ["items"]),
        re(Te, {
          class: "carousel__control",
          name: "chevron-right",
          onClick: tt(f)
        }, null, 8, ["onClick"])
      ])) : D("", !0)
    ]));
  }
}, N3 = /* @__PURE__ */ ae(BS, [["__scopeId", "data-v-3f3b13a3"]]);
var Ud = /* @__PURE__ */ ((e) => (e.none = "none", e.qualitative = "qualitative", e.sequencial = "sequencial", e.divergent = "divergent", e))(Ud || {});
const AS = {
  key: 0,
  class: "chart-area"
}, TS = {
  key: 1,
  class: "text-container"
}, OS = {
  __name: "ChartArea",
  props: {
    format: {
      type: String,
      default: Hr.PLAIN
    },
    dateFormat: {
      type: String,
      default: "short",
      validator: (e) => ["long", "short", "none"].includes(e)
    },
    palette: {
      type: String,
      default: Ud.divergent
    },
    marginTop: {
      type: Number,
      default: 0
    },
    plotOptionsPointStart: {
      type: Number,
      default: 0
    },
    titleCard: {
      type: String,
      default: ""
    },
    titleYaxis: {
      type: String,
      default: ""
    },
    tooltipPointFormat: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    legendEnabled: {
      type: Boolean,
      default: !1
    },
    reversed: {
      type: Boolean,
      default: !1
    },
    xAxisLabels: {
      type: Boolean,
      default: !1
    },
    isTimeScale: {
      type: Boolean,
      default: !1
    },
    series: {
      type: Array,
      default: () => []
    },
    scaledSeries: {
      type: Array,
      default: () => []
    },
    areaColor: {
      type: String,
      default: "#307AE0"
    },
    seriesColors: {
      type: Array,
      default: () => [
        "--support-blue-60",
        "--support-red-60",
        "--support-lime-40",
        "--support-pink-50",
        "--support-aqua-60"
      ]
    },
    height: {
      type: Number,
      default: 185
    },
    tickAmount: {
      type: Number,
      default: 5
    },
    hiddenAmounts: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    gc.setOptions({
      lang: {
        shortMonths: [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sep",
          "Oct",
          "Nov",
          "Dic"
        ],
        thousandsSep: ".",
        decimalPoint: ","
      }
    });
    const a = e, r = V(null), s = V(null), o = (C) => {
      r.value = C, setTimeout(() => {
        C.setSize();
      }, 100);
    }, d = B(() => {
      const C = a.series.flatMap(
        (S) => S.data.map((I) => I.y).filter((I) => I !== null)
      );
      return Math.min(...C);
    });
    vt(
      d,
      (C) => {
        Li(() => {
          var O;
          (O = r.value) == null || O.yAxis[0].setExtremes(C, null);
        });
      },
      { immediate: !0 }
    );
    const u = B(() => a.inverse ? "var(--action-neutral-enabled-inverse)" : "var(--action-neutral-enabled)"), f = B(() => a.inverse ? "var(--on-color-emphasis-medium-inverse)" : "var(--on-color-emphasis-medium)"), c = V({
      chart: {
        type: "area",
        marginTop: 10,
        height: a.height,
        backgroundColor: "transparent",
        //panning is the "line" animation, while animation is the chart's general animation
        panning: !0,
        animation: !1
      },
      title: { text: "", style: { color: "var(--emphasis-base-high)" } },
      subtitle: { style: { color: "var(--emphasis-base-low)" } },
      legend: { enabled: !1 },
      time: { useUTC: !1 },
      lang: {
        months: [
          "01",
          "02",
          "03",
          "04",
          "05",
          "06",
          "07",
          "08",
          "09",
          "10",
          "11",
          "12"
        ]
      },
      yAxis: {
        title: {
          enabled: !1
        },
        labels: {
          style: {
            color: f,
            fontFamily: "Moderat",
            fontSize: "10px"
          },
          formatter: function() {
            return a.hiddenAmounts ? " • • • • • • " : this.value.toLocaleString("es-CL", {
              minimumFractionDigits: 2
            });
          }
        },
        gridLineWidth: 1,
        gridLineColor: a.inverse === !1 ? "#00000020" : "#FFFFFF20",
        tickLength: 0,
        allowDecimals: !0,
        tickAmount: a.tickAmount
      },
      xAxis: {
        minPadding: 0,
        maxPadding: 0,
        labels: {
          enabled: !1
        },
        tickLength: 0,
        tickWidth: 0,
        gridLineWidth: 0,
        lineWidth: 0
      },
      tooltip: {
        useHTML: !0,
        valueDecimals: 2,
        backgroundColor: u,
        formatter: function() {
          var S, I;
          const C = (S = this.point.options) == null ? void 0 : S.label, O = a.dateFormat === "none" ? this.x : gc.dateFormat(
            h.value,
            new Date(
              a.isTimeScale ? (I = a.series[0].data[this.key]) == null ? void 0 : I.x : this.x
            )
          );
          return `
					<div class="chart-tooltip--container"">
						<div class="chart-tooltip--header" style="color:${a.inverse ? "var(--on-color-emphasis-medium-inverse)" : "var(--on-color-emphasis-medium)"}">
							${C !== void 0 ? C : O}
						</div>
						<div class="chart-tooltip--body" style="color:${a.inverse ? "var(--on-color-emphasis-high-inverse)" : "var(--on-color-emphasis-high)"}">
							${g.value.preffix || ""}
							${a.hiddenAmounts ? " • • • • • • " : q(this.y)}
							${g.value.suffix || ""}
						</div>
					</div>
					`;
        },
        style: {
          color: f,
          fontSize: 12,
          fontFamily: "Moderat"
        }
      },
      plotOptions: {
        series: {
          turboThreshold: 1e4,
          lineWidth: 1,
          states: {
            hover: { enabled: !0, lineWidth: 1 },
            selected: { enabled: !1 },
            inactive: {
              opacity: 1
            }
          },
          point: {
            events: {
              mouseOver: function() {
                var C = this.series.chart, O = C.renderer, S = C.plotLeft, I = C.plotTop, M = C.plotHeight, F = this.plotX, P = this.plotY;
                s.value = O.path([
                  "M",
                  S,
                  P,
                  "M",
                  S + F,
                  I,
                  "L",
                  S + F,
                  I + M
                ]).attr({
                  "stroke-width": 1,
                  stroke: "var(--support-blue-60)"
                }).add();
              },
              mouseOut: function() {
                s.value.d !== void 0 && s.value.destroy();
              }
            }
          }
        },
        area: {
          marker: { enabled: !1, symbol: "circle", radius: 1 }
          // tooltip: { pointFormat: "{point.y}" },
        }
      },
      series: [
        {
          name: "Browsers",
          data: []
        }
      ],
      credits: { enabled: !1 }
    });
    Lt(() => {
      c.value.series = a.series.map((C, O) => {
        const S = a.seriesColors[O] || a.seriesColors[0], I = C.color ? C.color : S;
        let M = a.isTimeScale ? a.scaledSeries : C.data, F = `var(${I})`, P = {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, `color-mix(in srgb, var(${I}) 90%, transparent)`],
            [1, `color-mix(in srgb, var(${I}) 20%, transparent)`]
          ]
        };
        return { ...C, data: M, linecolor: F, fillColor: P };
      });
    });
    const g = B(() => {
      const C = Object.keys(Hr).includes(a.format) ? a.format : "NONE";
      return Hr[C];
    }), h = B(() => ({
      short: "%d/%m/%Y",
      long: "%d/%m/%Y %I:%M:%S %P"
    })[a.dateFormat]), q = (C) => Math.abs(parseFloat(C || 0)).toLocaleString("nl-NL", {
      minimumFractionDigits: "minDecimalDigits" in g.value ? g.value.minDecimalDigits : 2,
      maximumFractionDigits: "maxDecimalDigits" in g.value ? g.value.maxDecimalDigits : 2
    });
    return (C, O) => (v(), m("div", null, [
      e.series.length > 0 ? (v(), m("div", AS, [
        (v(), me(tt(Kc), {
          key: e.series.length,
          options: c.value,
          callback: o
        }, null, 8, ["options"]))
      ])) : (v(), m("div", TS, "Sin datos"))
    ]));
  }
}, H3 = /* @__PURE__ */ ae(OS, [["__scopeId", "data-v-392019e5"]]), IS = {
  __name: "ChartGauge",
  props: {
    series: {
      type: Array,
      default: () => []
    },
    highlight: {
      type: Number,
      default: null
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    innerSize: {
      type: String,
      default: "80%"
    },
    chartWidth: {
      type: Number,
      default: 0
    },
    responsive: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["hover"],
  setup(e, { emit: a }) {
    const r = e, { highlight: s, series: o } = Wc(r), d = a, u = (q) => {
      d("hover", q.target.x);
    }, f = V(null), c = V(null);
    vt(s, (q) => {
      let C = f.value.chart;
      if (Number(q) === q) {
        C.series[0].data.forEach((S) => S.setState("inactive"));
        let O = C.series[0].data[q];
        O.setState("hover"), C.tooltip.refresh(O);
      } else
        C.series[0].data.forEach((O) => O.setState("normal")), C.tooltip.hide();
    });
    const g = () => {
      var O;
      if (!r.responsive)
        return;
      let q = f.value;
      var C = (O = c.value) == null ? void 0 : O.clientWidth;
      q == null || q.chart.setSize(C, C, !1);
    };
    window.addEventListener("resize", g), Tt(() => {
      Li(() => {
        g();
      });
    }), xi(() => {
      window.removeEventListener("resize", g);
    });
    const h = B(() => ({
      chart: {
        backgroundColor: "transparent",
        width: r.chartWidth
      },
      tooltip: {
        outside: !0,
        backgroundColor: r.inverse ? "#1F2023" : "#FFFFFF",
        // se dejan colores en HEX ya que queda fuera de la instancia de vue (fuera de app)
        style: {
          color: r.inverse ? "#FFFFFFB3" : "#000000b3"
        },
        pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: !1
          },
          startAngle: -90,
          endAngle: 90,
          center: ["50%", "50%"],
          innerSize: r.innerSize,
          borderRadius: 0,
          borderColor: "transparent"
        },
        series: {
          enableMouseTracking: !r.loading,
          animation: !1
        }
      },
      title: null,
      series: [
        {
          type: "pie",
          name: "Porcentaje",
          data: [
            {
              y: 1,
              isZero: !0,
              color: r.inverse ? "var(--neutral-extended-80)" : "var(--neutral-extended-30)"
            }
          ],
          point: {
            events: {
              mouseOver: u
            }
          },
          events: {
            mouseOut: u
          },
          ...o.value
        }
      ],
      credits: {
        enabled: !1
      }
    }));
    return (q, C) => (v(), m("div", {
      ref_key: "wrapper",
      ref: c,
      class: "chart-gauge-contianer"
    }, [
      re(tt(Kc), {
        ref_key: "chartRef",
        ref: f,
        class: "chart",
        options: h.value
      }, null, 8, ["options"])
    ], 512));
  }
}, V3 = /* @__PURE__ */ ae(IS, [["__scopeId", "data-v-024fd458"]]), MS = ["id"], xS = ["id", "name", "value", "checked", "disabled"], LS = ["for"], FS = {
  __name: "Checkbox",
  props: {
    size: {
      type: String,
      default: "large"
    },
    label: {
      type: String,
      default: ""
    },
    indeterminate: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: "left"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    checked: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: "normal",
      validator: (e) => ["normal", "box"].includes(e)
    }
  },
  emits: ["input", "changed", "update:modelValue"],
  setup(e, { emit: a }) {
    const r = e, s = V({
      inputId: r.id,
      value: r.value,
      name: r.name,
      checked: r.checked,
      disabled: r.disabled,
      indeterminate: r.indeterminate
    }), o = B(() => r.name ? r.name : `checkbox-${(Math.random() + 1).toString(36).substring(7)}`), d = B(() => r.modelValue.includes(r.value)), u = a, f = B(() => ({
      "orq-checkbox__content": !0,
      "orq-checkbox__content--inverse": r.inverse,
      [`orq-checkbox__content--${r.position}`]: r.position,
      "orq-checkbox__content--small": !r.checkboxLabel && r.size === "small"
    })), c = B(() => ({
      "orq-checkbox__input": !0,
      "orq-checkbox__input--inverse": r.inverse,
      "orq-checkbox__input--small": !r.checkboxLabel && r.size === "small"
    })), g = B(() => ({
      "orq-checkbox__checkmark": !0,
      "orq-checkbox__checkmark--indeterminate": r.indeterminate,
      "orq-checkbox__checkmark--inverse": r.inverse,
      "orq-checkbox__checkmark--small": !r.checkboxLabel && r.size === "small"
    })), h = B(() => ({
      "orq-checkbox__label": !0,
      "orq-checkbox__label--disabled": r.disabled,
      "orq-checkbox__label--inverse": r.inverse
    }));
    vt(
      () => r.checked,
      (O) => {
        s.value.checked = O;
      }
    );
    const q = (O) => {
      const { name: S, value: I, checked: M, indeterminate: F } = O.target;
      s.value.checked = M, s.value.indeterminate = F, u("input", { name: S, checked: M }), C({ checked: M }), u("changed", S, M, F, I);
    }, C = ({ checked: O }) => {
      O ? u("update:modelValue", [...r.modelValue, s.value.value]) : u(
        "update:modelValue",
        r.modelValue.filter((S) => S !== s.value.value)
      );
    };
    return (O, S) => (v(), m("div", {
      id: s.value.inputId,
      class: w(["orq-checkbox", { "orq-checkbox--box": r.type === "box", checked: d.value, inverse: e.inverse }])
    }, [
      y("div", {
        class: w(f.value)
      }, [
        y("input", {
          id: o.value,
          class: w(c.value),
          type: "checkbox",
          name: o.value,
          value: s.value.value,
          checked: d.value,
          disabled: s.value.disabled,
          onInput: q
        }, null, 42, xS),
        y("span", {
          class: w(g.value)
        }, null, 2)
      ], 2),
      e.label ? (v(), m("label", {
        key: 0,
        for: o.value,
        class: w(h.value)
      }, ie(e.label), 11, LS)) : D("", !0)
    ], 10, MS));
  }
}, Ro = /* @__PURE__ */ ae(FS, [["__scopeId", "data-v-9dd6dbc2"]]), ES = { class: "column" }, PS = {
  __name: "Column",
  props: {
    gap: {
      type: Number,
      default: 24,
      validator: (e) => [0, 4, 8, 16, 24, 32, 48].includes(e)
    }
  },
  setup(e) {
    ir((s) => ({
      "9620b684": r.value
    }));
    const a = e, r = B(() => `${a.gap}px`);
    return (s, o) => (v(), m("div", ES, [
      we(s.$slots, "default", {}, void 0, !0)
    ]));
  }
}, mo = /* @__PURE__ */ ae(PS, [["__scopeId", "data-v-00432555"]]), zS = ["onClick"], RS = { class: "orq-content-switcher__item__text" }, NS = {
  __name: "ContentSwitcher",
  props: {
    size: {
      type: String,
      default: "small"
    },
    options: {
      type: Array,
      default: () => []
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    fullwidth: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["selected"],
  setup(e, { emit: a }) {
    const r = e, s = a, o = (g) => g.selected ? "orq-content-switcher__item--selected" : "", d = (g) => g.disabled ? "orq-content-switcher__item--disabled" : "", u = (g, h) => {
      s("selected", g, h);
    }, f = V(`orq-content-switcher--${r.size}`), c = V("orq-content-switcher--inverse");
    return (g, h) => (v(), m(ce, null, [
      e.loading ? D("", !0) : (v(), m("div", {
        key: 0,
        class: w(`orq-content-switcher ${f.value} ${e.inverse ? c.value : ""}  ${e.fullwidth ? "orq-content-switcher--fullwidth" : ""}`)
      }, [
        (v(!0), m(ce, null, Re(e.options, (q, C) => (v(), m("div", {
          key: C,
          class: w(`orq-content-switcher__item ${o(
            q
          )} ${d(q)}`),
          onClick: (O) => !q.disabled && u(O, q)
        }, [
          y("span", RS, ie(q.label), 1)
        ], 10, zS))), 128))
      ], 2)),
      e.loading ? (v(), me(Ft, {
        key: 1,
        type: "content-switcher",
        loading: e.loading,
        inverse: e.inverse,
        rows: 1,
        cols: 1
      }, null, 8, ["loading", "inverse"])) : D("", !0)
    ], 64));
  }
}, Y3 = /* @__PURE__ */ ae(NS, [["__scopeId", "data-v-498629dc"]]), No = {
  __name: "Divider",
  props: {
    verticalSize: {
      type: Number,
      require: !0,
      default: 10
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    orientation: {
      type: String,
      default: "horizontal"
    },
    size: {
      type: String,
      default: "thin"
    }
  },
  setup(e) {
    const a = e, r = B(() => ({
      "orq-divider": !0,
      "orq-divider__inverse": a.inverse,
      [`orq-divider--size-${a.size}`]: a.size,
      [`orq-divider--orientation-${a.orientation}`]: a.orientation
    })), s = B(() => ({
      height: a.orientation === "vertical" ? `${a.verticalSize}px` : ""
    }));
    return (o, d) => (v(), m("div", {
      class: w(r.value),
      style: nt(s.value)
    }, null, 6));
  }
}, HS = {
  __name: "Lockscreen",
  props: {
    zIndex: {
      type: Number,
      default: 0
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (a, r) => (v(), m("div", {
      class: w(["orq-lockscreen", { inverse: e.inverse }]),
      style: nt({ zIndex: e.zIndex === 0 ? null : e.zIndex })
    }, null, 6));
  }
}, VS = {
  __name: "DrawerBody",
  props: {
    compact: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = Gc();
    return (r, s) => (v(), m(ce, null, [
      tt(a).header ? (v(), m("div", {
        key: 0,
        class: w(["drawer__header", { "drawer__header--compact": e.compact }])
      }, [
        we(r.$slots, "header", {}, void 0, !0)
      ], 2)) : D("", !0),
      y("div", {
        class: w(["drawer__body", { "drawer__body--compact": e.compact }])
      }, [
        we(r.$slots, "body", {}, void 0, !0)
      ], 2),
      tt(a).footer ? (v(), m("div", {
        key: 1,
        class: w(["drawer__footer", { "drawer__footer--compact": e.compact }])
      }, [
        we(r.$slots, "footer", {}, void 0, !0)
      ], 2)) : D("", !0)
    ], 64));
  }
}, YS = /* @__PURE__ */ ae(VS, [["__scopeId", "data-v-503e7d31"]]), US = { class: "drawer-header" }, WS = { class: "heading-md" }, GS = { class: "drawer-header__button" }, ZS = {
  __name: "DrawerHeader",
  props: {
    title: {
      type: String,
      default: "title"
    }
  },
  emits: ["close"],
  setup(e, { emit: a }) {
    const r = a;
    return (s, o) => (v(), m("div", US, [
      y("div", WS, [
        we(s.$slots, "default", {}, () => [
          _n(ie(e.title), 1)
        ], !0)
      ]),
      y("button", GS, [
        re(Te, {
          name: "close",
          size: 24,
          onClick: o[0] || (o[0] = (d) => r("close"))
        })
      ])
    ]));
  }
}, KS = /* @__PURE__ */ ae(ZS, [["__scopeId", "data-v-9d4d1ef8"]]), XS = { class: "drawer" }, JS = {
  __name: "Drawer",
  props: {
    title: {
      type: String,
      default: ""
    },
    isOpen: {
      type: Boolean,
      default: !1
    },
    maxWidth: {
      type: Number,
      default: 460
    },
    position: {
      type: String,
      default: "right",
      validator: (e) => ["left", "right"].includes(e)
    },
    lockScreen: {
      type: [Boolean, String],
      default: !0,
      validator: (e) => [!0, !1, "static"].includes(e)
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    compact: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["closed", "open", "close"],
  setup(e, { emit: a }) {
    ir((O) => ({
      "319c69f5": f.value
    }));
    const r = Gc(), s = a, o = e, d = V(null), u = V(null), f = B(() => `${o.maxWidth}px` || 0), c = B(() => !!["static", !0].includes(o.lockScreen)), g = () => {
      o.lockScreen !== "static" && s("close");
    };
    vt(
      () => o.isOpen,
      (O) => {
        document.body.style.overflow = O ? "hidden" : "auto";
      },
      {
        immediate: !0
      }
    ), xi(() => {
      document.body.style.overflow = "auto";
    });
    const h = () => {
      d.value.style.transform = o.position === "right" ? "translateX(100%)" : "translateX(-100%)", u.value.$el.style.opacity = 0;
    }, q = (O, S) => {
      at({
        targets: d.value,
        translateX: 0,
        duration: 300,
        easing: "easeOutExpo",
        complete: () => {
          s("open"), S();
        }
      }), at({
        targets: u.value.$el,
        opacity: 0.3,
        duration: 500
      });
    }, C = (O, S) => {
      at({
        targets: d.value,
        translateX: o.position === "right" ? "100%" : "-100%",
        duration: 300,
        easing: "easeOutExpo",
        complete: () => {
          s("closed"), S();
        }
      }), at({
        targets: u.value.$el,
        opacity: 0
      });
    };
    return (O, S) => (v(), me(Aa, {
      css: !1,
      onBeforeEnter: h,
      onEnter: q,
      onLeave: C
    }, {
      default: dt(() => [
        Kr(y("div", XS, [
          c.value ? (v(), me(HS, {
            key: 0,
            ref_key: "drawerLockScreen",
            ref: u,
            onClick: g
          }, null, 512)) : D("", !0),
          y("div", {
            ref_key: "drawerMain",
            ref: d,
            class: w(["drawer__main", {
              [`drawer__main--${e.position}`]: !0,
              "drawer__main--inverse": e.inverse
            }])
          }, [
            we(O.$slots, "default", {}, () => [
              re(YS, { compact: e.compact }, Zc({
                body: dt(() => [
                  we(O.$slots, "body", {}, void 0, !0)
                ]),
                _: 2
              }, [
                tt(r).footer || e.title ? {
                  name: "header",
                  fn: dt(() => [
                    we(O.$slots, "header", {}, () => [
                      e.title ? (v(), me(KS, {
                        key: 0,
                        title: e.title,
                        onClose: g
                      }, null, 8, ["title"])) : D("", !0)
                    ], !0)
                  ]),
                  key: "0"
                } : void 0,
                tt(r).footer ? {
                  name: "footer",
                  fn: dt(() => [
                    we(O.$slots, "footer", {}, void 0, !0)
                  ]),
                  key: "1"
                } : void 0
              ]), 1032, ["compact"])
            ], !0)
          ], 2)
        ], 512), [
          [bo, e.isOpen]
        ])
      ]),
      _: 3
    }));
  }
}, U3 = /* @__PURE__ */ ae(JS, [["__scopeId", "data-v-f5dee541"]]), QS = {}, jS = { class: "drawer-footer" };
function ek(e, a) {
  return v(), m("div", jS, [
    we(e.$slots, "default", {}, void 0, !0)
  ]);
}
const W3 = /* @__PURE__ */ ae(QS, [["render", ek], ["__scopeId", "data-v-faf50e8e"]]);
var Wd = /* @__PURE__ */ ((e) => (e.default = "default", e.avatar = "avatar", e.icon = "icon", e))(Wd || {});
const tk = Oe({
  name: "OrqDropdownItem",
  components: {
    OrqImageContainer: Ta,
    OrqIconContainer: Te,
    OrqCheckbox: Ro
  },
  props: {
    type: {
      type: String,
      default: Wd.default
    },
    value: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    iconName: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    imgSrc: {
      type: String,
      default: ""
    },
    imgAlt: {
      type: String,
      default: ""
    },
    selected: {
      type: Boolean,
      default: !1
    },
    multiple: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["onSelect"],
  setup(e, { emit: a }) {
    const r = V(Xe), s = V(null), o = () => e.disabled && e.inverse ? r.value.emphasisBaseInverseDisabled : e.inverse && e.selected || e.selected ? r.value.emphasisBaseInverseHigh : e.disabled ? r.value.emphasisBaseDisabled : r.value.emphasisBaseHigh, d = (c) => {
      a("onSelect", c);
    }, u = () => {
      s.value.classList.add("orq-droplist__item--clicking");
    }, f = () => {
      s.value.classList.remove("orq-droplist__item--clicking");
    };
    return {
      iconColor: B(() => e.inverse ? r.value.emphasisBaseHigh : r.value.emphasisBaseInverseHigh),
      dropdownItemClasses: B(() => ({
        "orq-droplist__item": !0,
        "orq-droplist__item--selected": e.selected,
        "orq-droplist__item--disabled": e.disabled
      })),
      onSelect: d,
      dropdownItem: s,
      setIconColor: o,
      onMouseUpHandler: f,
      onMouseDownHandler: u
    };
  }
}), nk = { ref: "dropdownItem" }, rk = { class: "orq-droplist__item__data" }, ak = {
  key: 0,
  class: "orq-droplist__item__text"
}, ik = {
  key: 1,
  class: "orq-droplist__item__checkbox"
}, sk = {
  key: 0,
  class: "orq-droplist__item__iconContainer"
}, ok = { class: "orq-droplist__item__data" }, lk = {
  key: 0,
  class: "orq-droplist__item__text"
}, uk = {
  key: 1,
  class: "orq-droplist__item__subtext"
}, ck = {
  key: 2,
  class: "orq-droplist__item__checkbox"
}, dk = {
  key: 0,
  class: "orq-droplist__item__avatar"
}, fk = { class: "orq-droplist__item__data" }, vk = {
  key: 0,
  class: "orq-droplist__item__text"
}, pk = {
  key: 1,
  class: "orq-droplist__item__subtext"
}, hk = {
  key: 2,
  class: "orq-droplist__item__checkbox"
};
function gk(e, a, r, s, o, d) {
  const u = ze("OrqIconContainer"), f = ze("OrqCheckbox"), c = ze("OrqImageContainer");
  return v(), m("div", nk, [
    e.type === "default" ? (v(), m("div", {
      key: 0,
      tabindex: 0,
      class: w(e.dropdownItemClasses),
      onMousedown: a[0] || (a[0] = (...g) => e.onMouseDownHandler && e.onMouseDownHandler(...g)),
      onMouseup: a[1] || (a[1] = (...g) => e.onMouseUpHandler && e.onMouseUpHandler(...g)),
      onClick: a[2] || (a[2] = (g) => e.onSelect(g))
    }, [
      y("div", rk, [
        e.title ? (v(), m("span", ak, ie(e.title), 1)) : D("", !0)
      ]),
      !e.multiple && !e.disabled && e.selected ? (v(), me(u, {
        key: 0,
        type: "none",
        name: "check",
        size: 16,
        color: e.iconColor
      }, null, 8, ["color"])) : D("", !0),
      e.multiple ? (v(), m("div", ik, [
        re(f, {
          type: "label",
          size: "large",
          checked: e.selected,
          value: e.value,
          disabled: e.disabled
        }, null, 8, ["checked", "value", "disabled"])
      ])) : D("", !0)
    ], 34)) : D("", !0),
    e.type === "icon" ? (v(), m("div", {
      key: 1,
      tabindex: 0,
      class: w(e.dropdownItemClasses),
      onMousedown: a[3] || (a[3] = (...g) => e.onMouseDownHandler && e.onMouseDownHandler(...g)),
      onMouseup: a[4] || (a[4] = (...g) => e.onMouseUpHandler && e.onMouseUpHandler(...g)),
      onClick: a[5] || (a[5] = (g) => e.onSelect(g))
    }, [
      e.iconName ? (v(), m("div", sk, [
        re(u, {
          type: "none",
          name: e.iconName,
          size: 24,
          color: e.setIconColor()
        }, null, 8, ["name", "color"])
      ])) : D("", !0),
      y("div", ok, [
        e.title ? (v(), m("span", lk, ie(e.title), 1)) : D("", !0),
        e.subtitle ? (v(), m("span", uk, ie(e.subtitle), 1)) : D("", !0)
      ]),
      !e.multiple && !e.disabled && e.selected ? (v(), me(u, {
        key: 1,
        type: "none",
        name: "check",
        size: 16,
        color: e.iconColor
      }, null, 8, ["color"])) : D("", !0),
      e.multiple ? (v(), m("div", ck, [
        re(f, {
          type: "label",
          size: "large",
          checked: e.selected,
          value: e.value
        }, null, 8, ["checked", "value"])
      ])) : D("", !0)
    ], 34)) : D("", !0),
    e.type === "avatar" ? (v(), m("div", {
      key: 2,
      tabindex: 0,
      class: w(e.dropdownItemClasses),
      onMousedown: a[6] || (a[6] = (...g) => e.onMouseDownHandler && e.onMouseDownHandler(...g)),
      onMouseup: a[7] || (a[7] = (...g) => e.onMouseUpHandler && e.onMouseUpHandler(...g)),
      onClick: a[8] || (a[8] = (g) => e.onSelect(g))
    }, [
      e.imgSrc ? (v(), m("div", dk, [
        re(c, {
          src: e.imgSrc,
          alt: e.imgAlt
        }, null, 8, ["src", "alt"])
      ])) : D("", !0),
      y("div", fk, [
        e.title ? (v(), m("span", vk, ie(e.title), 1)) : D("", !0),
        e.subtitle ? (v(), m("span", pk, ie(e.subtitle), 1)) : D("", !0)
      ]),
      !e.multiple && !e.disabled && e.selected ? (v(), me(u, {
        key: 1,
        type: "none",
        name: "check",
        size: 16,
        color: e.iconColor
      }, null, 8, ["color"])) : D("", !0),
      e.multiple && !e.disabled ? (v(), m("div", hk, [
        re(f, {
          type: "label",
          size: "large",
          checked: e.selected,
          value: e.value
        }, null, 8, ["checked", "value"])
      ])) : D("", !0)
    ], 34)) : D("", !0)
  ], 512);
}
const mk = /* @__PURE__ */ ae(tk, [["render", gk]]), yk = Oe({
  name: "OrqDropdown",
  components: {
    OrqIconContainer: Te,
    OrqDropdownItem: mk,
    OrqCheckbox: Ro,
    OrqDivider: No
  },
  props: {
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    isOpen: {
      type: Boolean,
      default: !0
    },
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    selectAllText: {
      type: String,
      default: ""
    },
    showSelectAll: {
      type: Boolean,
      default: !1
    },
    selectAllCheck: {
      type: Boolean,
      default: !1
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    searchEmpty: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "default"
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    search: {
      type: Boolean,
      default: !1
    },
    options: {
      type: Array,
      default: () => []
    },
    showEmptySearch: {
      type: Boolean,
      default: !1
    },
    selected: {
      type: Boolean,
      default: !1
    },
    categorized: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["onSelect", "onSelectAll"],
  setup(e, { emit: a }) {
    const r = V(null), s = V([]), o = V(e.selectAllCheck);
    let d = V(!1), u = V(""), f = V(e.options);
    const c = V(1), g = 1e3, h = B(() => g * c.value), q = V(), C = V();
    Tt(() => {
      q.value = new IntersectionObserver((T) => {
        T.forEach((z) => {
          (z.intersectionRatio > 0 || z.isIntersecting) && (c.value = c.value + 1);
        });
      }), C.value && q.value.observe(C.value);
    }), Fi(() => {
      f.value = e.options, s.value = e.options, o.value = e.selectAllCheck;
    }), xi(() => {
      var T;
      (T = q.value) != null && T.disconnect && q.value.disconnect();
    });
    const O = (T) => {
      d.value = T;
    }, S = (T) => {
      const z = u.value.toLocaleLowerCase(), le = T.filter((K) => {
        const se = K.title ? K.title.toLocaleLowerCase() : "", oe = K.subtitle ? K.subtitle.toLocaleLowerCase() : "", ve = K.iconName ? K.iconName.toLocaleLowerCase() : "";
        return se.includes(z) || oe.includes(z) || ve.includes(z);
      });
      f.value = le;
    }, I = () => e.inverse && !o.value || !e.inverse && o.value, M = () => {
      u.value = "", S(e.options || []);
    };
    Lt(() => {
      S(e.options || []);
    });
    const F = (T) => {
      e.multiple ? (T.selected = !T.selected, f.value.forEach((z) => {
        e.showSelectAll && z.selected === !1 && (o.value = !1);
      })) : (f.value.forEach((z) => {
        z.selected = !1;
      }), T.selected = !0), S(s.value);
    }, P = (T) => {
      o.value = !o.value, f.value.forEach((z) => {
        o.value ? z.selected = !0 : z.selected = !1;
      }), a("onSelectAll", T);
    }, x = (T) => {
      F(T), a("onSelect", T);
    }, $ = () => {
      r.value.classList.add("orq-droplist__item--clicking");
    }, Y = () => {
      r.value.classList.remove("orq-droplist__item--clicking");
    }, R = B(() => {
      let T = f.value.map((z) => z.title[0]);
      return [...new Set(T)].sort();
    });
    return {
      setIconColor: B(
        () => e.inverse ? Xe.emphasisBaseInverseHigh : Xe.emphasisBaseHigh
      ),
      dropdownClass: B(() => ({
        "orq-droplist": !0,
        "is-open": e.isOpen,
        "orq-droplist--inverse": e.inverse
      })),
      dropdownItemClasses: B(() => ({
        "orq-droplist__item": !0,
        "orq-droplist__item--selected": o.value
      })),
      onFocus: O,
      newArray: f,
      dataItems: s,
      selectItem: x,
      innerValue: u,
      clearSearch: M,
      onSelectAll: P,
      isSelectAll: o,
      dropdownItem: r,
      onMouseUpHandler: Y,
      onMouseDownHandler: $,
      setCheckboxInverseMode: I,
      scrollRef: C,
      pageOffset: h,
      categorizedList: R
    };
  }
}), bk = ["id"], _k = {
  key: 0,
  class: "orq-droplist__search"
}, wk = { class: "orq-droplist__search__icon" }, $k = ["name", "placeholder"], Ck = ["name"], Sk = { class: "orq-droplist__wrapper" }, kk = { class: "orq-droplist__item__data" }, qk = {
  key: 0,
  class: "orq-droplist__item__text"
}, Dk = { class: "orq-droplist__item__checkbox" }, Bk = { class: "orq-droplist--categorized-category" }, Ak = {
  key: 3,
  class: "orq-droplist__item"
}, Tk = { class: "orq-droplist__item__text" }, Ok = {
  ref: "scrollRef",
  class: "orq-droplist__scroll"
};
function Ik(e, a, r, s, o, d) {
  const u = ze("OrqIconContainer"), f = ze("OrqCheckbox"), c = ze("OrqDropdownItem"), g = ze("OrqDivider");
  return v(), m("div", {
    id: e.id,
    ref: "dropdownContainer",
    class: w(e.dropdownClass),
    tabindex: 0
  }, [
    e.search ? (v(), m("div", _k, [
      y("div", wk, [
        re(u, {
          type: "none",
          name: "tools-search",
          size: 24,
          color: e.setIconColor
        }, null, 8, ["color"])
      ]),
      Kr(y("input", Mi({
        "onUpdate:modelValue": a[0] || (a[0] = (h) => e.innerValue = h),
        class: "orq-droplist__search__input",
        type: "text",
        autoComplete: "off",
        name: e.name,
        placeholder: e.searchPlaceholder
      }, e.$attrs, {
        onFocus: a[1] || (a[1] = (h) => e.onFocus(!0)),
        onBlur: a[2] || (a[2] = (h) => e.onFocus(!1))
      }), null, 16, $k), [
        [q0, e.innerValue]
      ]),
      e.innerValue != "" ? (v(), m("button", {
        key: 0,
        name: e.name,
        class: "orq-droplist__search__clear-button",
        onClick: a[3] || (a[3] = (...h) => e.clearSearch && e.clearSearch(...h))
      }, [
        re(u, {
          type: "none",
          name: "close",
          size: 24,
          color: e.setIconColor
        }, null, 8, ["color"])
      ], 8, Ck)) : D("", !0)
    ])) : D("", !0),
    y("div", Sk, [
      e.showSelectAll && e.multiple && e.newArray.length > 1 ? (v(), m("div", {
        key: 0,
        ref: "dropdownItem",
        class: w(e.dropdownItemClasses),
        onMousedown: a[4] || (a[4] = (...h) => e.onMouseDownHandler && e.onMouseDownHandler(...h)),
        onMouseup: a[5] || (a[5] = (...h) => e.onMouseUpHandler && e.onMouseUpHandler(...h)),
        onClick: a[6] || (a[6] = (h) => e.onSelectAll(h))
      }, [
        y("div", kk, [
          e.selectAllText ? (v(), m("span", qk, ie(e.selectAllText), 1)) : D("", !0)
        ]),
        _n(" asdad "),
        y("div", Dk, [
          re(f, {
            type: "label",
            size: "large",
            checked: e.isSelectAll,
            value: e.value
          }, null, 8, ["checked", "value"])
        ])
      ], 34)) : D("", !0),
      e.categorized ? (v(!0), m(ce, { key: 1 }, Re(e.categorizedList, (h, q) => (v(), m("div", {
        key: q,
        class: "orq-droplist--categorized"
      }, [
        y("div", Bk, [
          re(c, {
            title: h,
            type: e.type,
            inverse: e.inverse
          }, null, 8, ["title", "type", "inverse"]),
          re(g, {
            inverse: e.inverse,
            size: "heavy"
          }, null, 8, ["inverse"])
        ]),
        (v(!0), m(ce, null, Re(e.newArray.slice(
          0,
          e.pageOffset + 100
        ), (C, O) => (v(), m(ce, { key: O }, [
          C.title[0] === h ? (v(), me(c, {
            key: 0,
            class: "orq-droplist--categorized-item",
            title: C.title,
            subtitle: C.subtitle,
            selected: C.selected,
            disabled: C.disabled,
            "img-src": C.imgSrc,
            "img-alt": C.imgAlt,
            "icon-name": C.iconName,
            multiple: e.multiple,
            type: e.type,
            inverse: e.inverse,
            onOnSelect: (S) => e.selectItem(C)
          }, null, 8, ["title", "subtitle", "selected", "disabled", "img-src", "img-alt", "icon-name", "multiple", "type", "inverse", "onOnSelect"])) : D("", !0)
        ], 64))), 128))
      ]))), 128)) : (v(!0), m(ce, { key: 2 }, Re(e.newArray.slice(0, e.pageOffset), (h, q) => (v(), me(c, {
        key: q,
        title: h.title,
        subtitle: h.subtitle,
        selected: h.selected,
        disabled: h.disabled,
        "img-src": h.imgSrc,
        "img-alt": h.imgAlt,
        "icon-name": h.iconName,
        multiple: e.multiple,
        type: e.type,
        inverse: e.inverse,
        onOnSelect: (C) => e.selectItem(h)
      }, null, 8, ["title", "subtitle", "selected", "disabled", "img-src", "img-alt", "icon-name", "multiple", "type", "inverse", "onOnSelect"]))), 128)),
      e.newArray.length === 0 && e.showEmptySearch ? (v(), m("div", Ak, [
        y("span", Tk, ie(e.searchEmpty), 1)
      ])) : D("", !0),
      y("div", Ok, null, 512)
    ])
  ], 10, bk);
}
const Gd = /* @__PURE__ */ ae(yk, [["render", Ik]]), Mk = { class: "empty-state" }, xk = {
  __name: "EmptyState",
  props: {
    title: {
      type: String,
      default: "Sin datos"
    },
    description: {
      type: String,
      default: "No hay información disponible."
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (a, r) => (v(), m("div", Mk, [
      y("div", null, [
        re(Te, {
          color: e.inverse ? "emphasis-base-high-inverse" : "emphasis-base-high",
          size: 40,
          name: "empty",
          inverse: e.inverse
        }, null, 8, ["color", "inverse"])
      ]),
      y("div", {
        class: w({
          "text--on-color-emphasis-high": !e.inverse,
          "text--on-color-emphasis-high-inverse": e.inverse
        })
      }, ie(e.title), 3),
      y("div", {
        class: w(["body-sm", {
          "text--on-color-emphasis-medium": !e.inverse,
          "text--on-color-emphasis-medium-inverse": e.inverse
        }])
      }, ie(e.description), 3),
      we(a.$slots, "default", {}, void 0, !0)
    ]));
  }
}, G3 = /* @__PURE__ */ ae(xk, [["__scopeId", "data-v-a01a5865"]]), Lk = { class: "empty-state-table" }, Fk = {
  __name: "EmptyStateTable",
  props: {
    title: {
      type: String,
      default: "Sin datos"
    },
    description: {
      type: String,
      default: "No hay información disponible."
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (a, r) => (v(), m("div", Lk, [
      y("div", null, [
        re(Te, {
          circle: "",
          color: e.inverse ? "emphasis-base-high-inverse" : "emphasis-base-high",
          "custom-circle-background-color": e.inverse ? "var(--neutral-state-enabled-inverse)" : "var(--neutral-extended-30)",
          size: 40,
          name: "empty",
          inverse: e.inverse
        }, null, 8, ["color", "custom-circle-background-color", "inverse"])
      ]),
      y("div", null, [
        y("div", {
          class: w({
            "text--on-color-emphasis-high": !e.inverse,
            "text--on-color-emphasis-high-inverse": e.inverse
          })
        }, ie(e.title), 3),
        y("div", {
          class: w(["body-sm", {
            "text--on-color-emphasis-medium": !e.inverse,
            "text--on-color-emphasis-medium-inverse": e.inverse
          }])
        }, ie(e.description), 3)
      ])
    ]));
  }
}, Z3 = /* @__PURE__ */ ae(Fk, [["__scopeId", "data-v-8606db70"]]), Ek = (e) => (D0("data-v-f2bfda0d"), e = e(), B0(), e), Pk = /* @__PURE__ */ Ek(() => /* @__PURE__ */ y("div", { class: "progress-bar--background" }, null, -1)), zk = {
  __name: "ProgressBar",
  props: /* @__PURE__ */ Da({
    size: {
      type: String,
      default: "small",
      validator: (e) => ["small", "large"].includes(e)
    },
    rounded: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    max: {
      type: Number,
      default: 100
    }
  }, {
    modelValue: { type: Number, default: 40 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    ir((u) => ({
      "445e1a00": o.value
    }));
    const a = Ba(e, "modelValue"), r = e, s = B(() => a.value * 100 / r.max), o = V(s.value + "%"), d = B(() => ({
      "progress-bar--rounded": r.rounded,
      "progress-bar--container-large": r.size === "large",
      "progress-bar--inverse": r.inverse,
      "progress-bar--disabled": r.disabled
    }));
    return (u, f) => e.loading ? (v(), me(Ft, {
      key: 0,
      type: "text",
      inverse: e.inverse
    }, null, 8, ["inverse"])) : (v(), m("div", {
      key: 1,
      class: w(["progress-bar progress-bar--container", d.value])
    }, [
      Pk,
      y("div", {
        ref: "progressBar",
        class: "progress-bar--determinate",
        style: nt(`width: ${s.value}%`)
      }, null, 4)
    ], 2));
  }
}, Rc = /* @__PURE__ */ ae(zk, [["__scopeId", "data-v-f2bfda0d"]]), Rk = ["disabled"], Nk = ["for"], Hk = ["name", "multiple", "accept", "disabled"], Vk = { class: "icon-container__notification" }, Yk = { class: "icon-container__notification" }, Ve = "orq-file-uploader", Uk = {
  __name: "FileUploader",
  props: {
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    accept: {
      type: String,
      default: ".jpg, .jpeg, .gif, .bmp, .pdf, .doc, .docx"
    },
    infoText: {
      type: String,
      default: ""
    },
    uploadButtonText: {
      type: String,
      default: "Seleccionar documento"
    },
    acceptFileTypes: {
      type: Array,
      default: () => [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ]
    },
    maxFiles: {
      type: Number,
      default: 5
    },
    maxFileSize: {
      type: Number,
      default: 5e3
    },
    dragLabel: {
      type: String,
      default: "Arrastra y suelta los archivos en esta area"
    },
    numberRequiredFile: {
      type: Number,
      default: 0
    },
    allowDownload: {
      type: Boolean
    },
    requiredFile: {
      type: Boolean
    },
    loadingProgressBar: {
      type: Boolean,
      default: !0
    },
    errorFileType: {
      type: String,
      default: "Tipo de archivo inválido."
    },
    errorMaxFile: {
      type: String,
      default: "Tamaño máximo del archivo excedido."
    },
    requiredLabel: {
      type: String,
      default: "Documento(s) solicitado(s) son necesario(s) para continuar."
    },
    fileItemList: {
      type: Array,
      default: () => []
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["onSelectClick", "onChange", "onDownloadFile"],
  setup(e, { emit: a }) {
    const r = e, s = a;
    let o = V([]), d = V(r.fileItemList);
    const u = V(r.acceptFileTypes), f = V(r.maxFileSize), c = V(r.maxFiles), g = (r.maxFileSize / 1e3).toFixed(1).toString() + "mb", h = V("."), q = V(""), C = V(!1), O = V(r.disabled);
    Tt(() => {
      S();
    }), vt(r, () => {
      S();
    });
    const S = () => {
      h.value = r.accept && r.accept.length ? `, y formato ${r.accept}` : ".", q.value = `Documentos con un máximo de ${g}${h.value}`;
    }, I = () => {
      C.value = !0, O.value = !0;
    }, M = () => r.inverse && (C.value || r.disabled || o.value.length === c.value) ? "emphasis-base-disabled-inverse" : r.disabled || C.value || o.value.length === c.value ? "emphasis-base-disabled" : r.inverse ? "status-informative-inverse" : "status-informative", F = () => r.inverse && (C.value || r.disabled || o.value.length === c.value) ? "emphasis-base-disabled-inverse" : r.disabled || C.value || o.value.length === c.value ? "emphasis-base-disabled" : r.inverse ? "emphasis-base-high-inverse" : "emphasis-base-high", P = () => r.inverse ? "emphasis-base-high-inverse" : "emphasis-base-high", x = () => {
      var ke;
      (ke = document.getElementById("input-file")) == null || ke.click(), s("onSelectClick");
    };
    let $ = V(r.uploadButtonText);
    const Y = (ke) => {
      var Je;
      ke.preventDefault();
      let Ie;
      if (!r.disabled)
        if ((Je = ke == null ? void 0 : ke.dataTransfer) != null && Je.types) {
          $.value = r.dragLabel;
          const he = document.getElementById("file");
          he == null || he.classList.add("orq-file-uploader__drag"), r.requiredFile && o.value.length < r.numberRequiredFile && (he == null || he.classList.add("orq-file-uploader__drag"), he == null || he.classList.add("orq-file-uploader__drag--required-file")), r.inverse && (he == null || he.classList.add("orq-file-uploader__drag"), he == null || he.classList.add("orq-file-uploader__drag--inverse")), r.requiredFile && r.inverse && o.value.length < r.numberRequiredFile && (he == null || he.classList.add("orq-file-uploader__drag"), he == null || he.classList.add(
            "orq-file-uploader__drag--inverse--required-file"
          )), Ie = [...ke.dataTransfer.files];
        } else
          Ie = ke.target.files;
      if (Ie)
        for (let he = 0; he < Ie.length; he++) {
          const je = Ie[he], Ze = V({
            file: je,
            progress: 0,
            type: "." + je.type.split("/").pop()
          });
          u.value.includes(je.type) || (Ze.value.errorMessage = r.errorFileType, I()), je.size / 1e3 > f.value && (Ze.value.errorMessage = r.errorMaxFile, I()), o.value.push(Ze.value);
          const wt = new FileReader();
          wt.readAsDataURL(je), wt.onprogress = (Ot) => {
            if (Ot.lengthComputable) {
              const ht = Ot.loaded / Ot.total * 100;
              Ze.value.progress = ht;
            }
          };
        }
      s("onChange", ke);
    }, R = (ke) => {
      Y(ke), $.value = r.uploadButtonText;
      const Ie = document.getElementById("file");
      Ie == null || Ie.classList.remove("orq-file-uploader__drag");
    }, T = (ke) => {
      o.value.splice(ke, 1), d.value.splice(ke, 1), z();
    }, z = () => {
      (o == null ? void 0 : o.value.some(le)) || (C.value = !1, O.value = !1);
    };
    function le(ke) {
      return "errorMessage" in ke;
    }
    const K = () => {
      s("onDownloadFile");
    }, se = (ke) => ke.length > 30 ? ke.substring(0, 30) + "..." : ke, oe = () => {
      $.value = r.uploadButtonText;
      const ke = document.getElementById("file");
      ke == null || ke.classList.remove("orq-file-uploader__drag");
    }, ve = B(
      () => o.value.length === c.value || C.value || r.disabled ? `${Ve}__content--disabled` : ""
    ), ee = B(
      () => o.value.length === c.value && r.inverse || r.disabled && r.inverse ? `${Ve}__content--disabled--inverse` : ""
    ), Q = B(
      () => r.inverse ? `${Ve}__content--inverse` : ""
    ), J = B(
      () => r.requiredFile && !r.disabled && r.inverse && o.value.length < r.numberRequiredFile ? `${Ve}__content--inverse--required-file ` : ""
    ), te = B(
      () => r.disabled ? `${Ve}__content--disabled` : ""
    ), G = B(
      () => r.requiredFile && !r.disabled && o.value.length < r.numberRequiredFile ? `${Ve}__content--required-file ` : ""
    ), de = B(
      () => r.inverse ? `${Ve}__content__paragraph--inverse` : ""
    ), ge = B(
      () => C.value || r.disabled || o.value.length === c.value ? `${Ve}__content__paragraph--disabled` : ""
    ), N = B(
      () => r.inverse && (C.value || r.disabled || o.value.length === c.value) ? `${Ve}__content__paragraph--disabled--inverse` : ""
    ), ne = B(
      () => r.inverse ? `${Ve}__notification__paragraph--inverse` : ""
    ), ue = B(
      () => o.value.length === c.value || r.disabled || C.value ? `${Ve}__notification__paragraph--disabled` : ""
    ), Se = B(
      () => r.inverse && (C.value || r.disabled || o.value.length === c.value) ? `${Ve}__notification__paragraph--disabled--inverse` : ""
    ), Me = B(
      () => r.inverse ? `${Ve}__file-display--inverse` : ""
    ), Ne = B(
      () => r.inverse ? `${Ve}__file-display__content__paragraph--inverse` : ""
    ), pt = B(
      () => r.inverse ? `${Ve}__error-notification__paragraph--inverse` : ""
    ), st = B(
      () => r.requiredFile && r.inverse && o.value.length < r.numberRequiredFile ? `${Ve}__error-notification__paragraph--inverse` : ""
    );
    return (ke, Ie) => {
      var Je;
      return v(), m(ce, null, [
        e.loading ? D("", !0) : (v(), m("div", {
          key: 0,
          class: w(Ve)
        }, [
          y("div", {
            id: "file",
            disabled: O.value,
            tabindex: 0,
            class: w(`
          ${Ve}__content
          ${Q.value}
          ${ve.value}
          ${ee.value}
          ${G.value}
          ${J.value} 
          ${te.value}                
        `),
            "on:drop": Ie[1] || (Ie[1] = Ct((he) => R(he), ["prevent"])),
            "on:dragover": Ie[2] || (Ie[2] = Ct((he) => Y(he), ["prevent"])),
            "on:dragleave": Ie[3] || (Ie[3] = Ct((he) => oe(), ["prevent"])),
            onClick: x
          }, [
            y("label", {
              for: e.id,
              class: w(`         
            ${Ve}__content__paragraph
            ${de.value}
            ${ge.value}
            ${N.value}
          `)
            }, [
              !e.disabled && ((Je = tt(o)) == null ? void 0 : Je.length) < c.value ? (v(), m("input", {
                key: 0,
                id: "input-file",
                type: "file",
                name: e.name,
                multiple: e.maxFiles > 1,
                accept: e.accept ? e.accept : "*",
                disabled: O.value,
                class: "input",
                onChange: Ie[0] || (Ie[0] = (he) => Y(he))
              }, null, 40, Hk)) : D("", !0),
              _n(" " + ie(tt($)) + "  ", 1)
            ], 10, Nk),
            re(Te, {
              type: "none",
              color: F(),
              size: 16,
              name: "upload"
            }, null, 8, ["color"])
          ], 42, Rk),
          !e.requiredFile || tt(o).length > 0 ? (v(), m("div", {
            key: 0,
            class: w(`${Ve}__notification`)
          }, [
            y("div", Vk, [
              re(Te, {
                type: "none",
                color: M(),
                size: 16,
                name: "info-on"
              }, null, 8, ["color"])
            ]),
            y("p", {
              class: w(`
          ${Ve}__notification__paragraph
          ${ne.value}
          ${ue.value}
          ${Se.value}
        `)
            }, ie(e.infoText ? e.infoText : q.value), 3)
          ], 2)) : D("", !0),
          e.requiredFile && tt(o).length === 0 ? (v(), m("div", {
            key: 1,
            class: w(`${Ve}__notification requiredFile__notification ${e.inverse ? "requiredFile__notification--inverse" : ""}`)
          }, [
            y("div", Yk, [
              re(Te, {
                type: "none",
                size: 16,
                name: "status-error",
                color: e.inverse ? "status-error-inverse" : "status-error"
              }, null, 8, ["color"])
            ]),
            y("p", {
              class: w(`
          ${Ve}__notification__paragraph
          ${ne.value}
          ${ue.value}
          ${Se.value}
        `)
            }, ie(e.requiredLabel), 3)
          ], 2)) : D("", !0),
          (v(!0), m(ce, null, Re(tt(o), (he, je) => (v(), m("div", {
            key: je,
            class: w(`
          ${Ve}__file-display
          ${he.errorMessage ? Ve + "__file-display--error" : ""}
          ${Me.value}
        `)
          }, [
            he.file ? (v(), m("div", {
              key: 0,
              class: w(`${Ve}__file-display__content`)
            }, [
              re(Te, {
                type: "none",
                class: "icon-container",
                color: P(),
                size: 24,
                name: "file"
              }, null, 8, ["color"]),
              y("p", {
                class: w(`${Ve}__file-display__content__paragraph ${Ne.value}`)
              }, ie(se(he.file.name)), 3),
              e.allowDownload ? (v(), me(Te, {
                key: 0,
                type: "none",
                class: "icon-container",
                color: P(),
                size: 24,
                name: "download",
                onClick: K
              }, null, 8, ["color"])) : D("", !0),
              re(Te, {
                type: "none",
                class: "icon-container",
                color: P(),
                size: 24,
                name: "edit-trash",
                onClick: (Ze) => T(je)
              }, null, 8, ["color", "onClick"])
            ], 2)) : D("", !0),
            !he.errorMessage && e.loadingProgressBar ? (v(), m("div", {
              key: 1,
              class: w(`${Ve}__file-display__progress-bar`)
            }, [
              re(Rc, {
                modelValue: he.progress,
                "onUpdate:modelValue": (Ze) => he.progress = Ze,
                inverse: e.inverse,
                rounded: !1
              }, null, 8, ["modelValue", "onUpdate:modelValue", "inverse"])
            ], 2)) : D("", !0),
            he.errorMessage ? (v(), m("div", {
              key: 2,
              class: w(`${Ve}__error-notification`)
            }, [
              re(Te, {
                type: "none",
                name: "status-error",
                size: 16
              }),
              y("p", {
                class: w(`${Ve}__error-notification__paragraph ${pt.value} ${st.value}`)
              }, ie(he.errorMessage), 3)
            ], 2)) : D("", !0)
          ], 2))), 128)),
          (v(!0), m(ce, null, Re(tt(d), (he, je) => (v(), m("div", {
            key: je,
            class: w(`
          ${Ve}__file-display
          ${he.errorMessage ? Ve + "__file-display--error" : ""}
          ${Me.value}
        `)
          }, [
            he.file ? (v(), m("div", {
              key: 0,
              class: w(`${Ve}__file-display__content`)
            }, [
              re(Te, {
                type: "none",
                class: "icon-container",
                color: P(),
                size: 24,
                name: "file"
              }, null, 8, ["color"]),
              y("p", {
                class: w(`${Ve}__file-display__content__paragraph ${Ne.value}`)
              }, ie(se(he.file.name)), 3),
              re(Te, {
                type: "none",
                class: "icon-container",
                color: P(),
                size: 24,
                name: "edit-trash",
                onClick: (Ze) => T(je)
              }, null, 8, ["color", "onClick"])
            ], 2)) : D("", !0),
            he.errorMessage ? D("", !0) : (v(), m("div", {
              key: 1,
              class: w(`${Ve}__file-display__progress-bar`)
            }, [
              re(Rc, {
                modelValue: he.progress,
                "onUpdate:modelValue": (Ze) => he.progress = Ze,
                rounded: !1,
                inverse: e.inverse
              }, null, 8, ["modelValue", "onUpdate:modelValue", "inverse"])
            ], 2)),
            he.errorMessage ? (v(), m("div", {
              key: 2,
              class: w(`${Ve}__error-notification`)
            }, [
              re(Te, {
                type: "none",
                name: "status-error",
                size: 16,
                color: he.errorMessage && !e.inverse ? "status-error" : he.errorMessage && e.inverse ? "status-error-inverse" : "status-error"
              }, null, 8, ["color"]),
              y("p", {
                class: w(`${Ve}__error-notification__paragraph ${pt.value} ${st.value}`)
              }, ie(he.errorMessage), 3)
            ], 2)) : D("", !0)
          ], 2))), 128))
        ])),
        e.loading ? (v(), me(Ft, {
          key: 1,
          type: "file-uploader",
          loading: e.loading,
          inverse: e.inverse
        }, null, 8, ["loading", "inverse"])) : D("", !0)
      ], 64);
    };
  }
}, K3 = /* @__PURE__ */ ae(Uk, [["__scopeId", "data-v-77721f43"]]), Wk = { class: "flex" }, Gk = {
  __name: "Flex",
  props: {
    gap: {
      type: Number,
      default: 24,
      validator: (e) => [0, 8, 16, 24, 32, 48].includes(e)
    },
    wrap: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    ir((o) => ({
      "998eb312": r.value,
      "9838a66e": s.value
    }));
    const a = e, r = B(() => `${a.gap}px`), s = B(() => a.wrap ? "wrap" : "nowrap");
    return (o, d) => (v(), m("div", Wk, [
      we(o.$slots, "default", {}, void 0, !0)
    ]));
  }
}, Zk = /* @__PURE__ */ ae(Gk, [["__scopeId", "data-v-65eceff1"]]), Kk = {
  __name: "FloatingAction",
  props: {
    isOpen: {
      type: Boolean,
      default: !0
    },
    direction: {
      type: String,
      default: "left"
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    selected: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "large"
    }
  },
  setup(e) {
    const a = e;
    let r = V(null), s = V(a.isOpen);
    Lt(() => {
      s.value = a.isOpen;
    });
    const o = B(() => ({
      "orq-floating-action": !0,
      "orq-floating-action--inverse": a.inverse,
      "is-open": s.value,
      "orq-floating-action--small": a.size === "small",
      [`orq-floating-action--${a.direction === "right" ? "right" : "left"}`]: a.direction
    }));
    return (d, u) => (v(), m("div", {
      ref_key: "floatingActionRef",
      ref: r,
      class: w(o.value)
    }, [
      we(d.$slots, "default")
    ], 2));
  }
}, Xk = ["tabindex"], Jk = {
  key: 0,
  class: "orq-floating-action-item__icon"
}, Qk = { class: "orq-floating-action-item__text" }, jk = 24, eq = 16, tq = {
  __name: "FloatingActionItem",
  props: {
    iconName: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "large"
    },
    selected: {
      type: Boolean,
      default: !1
    },
    active: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const a = e, r = V(Xe), s = V(), o = V(0), d = () => a.size === "small" ? eq : jk, u = () => o.value = 1, f = () => o.value = 0, c = () => {
      var C;
      return (C = s.value) == null ? void 0 : C.classList.remove("orq-floating-action-item--clicking");
    }, g = () => {
      var C;
      return (C = s.value) == null ? void 0 : C.classList.add("orq-floating-action-item--clicking");
    }, h = () => a.inverse && a.selected ? r.value.emphasisBaseHigh : a.inverse || a.selected ? r.value.emphasisBaseInverseHigh : r.value.emphasisBaseHigh, q = B(() => ({
      "orq-floating-action-item": !0,
      "orq-floating-action-item--active": a.selected
    }));
    return (C, O) => (v(), m("div", {
      ref_key: "elRef",
      ref: s,
      role: "button",
      tabindex: o.value,
      class: w(q.value),
      onMousedown: g,
      onMouseup: c,
      onFocus: u,
      onBlur: f
    }, [
      e.iconName ? (v(), m("div", Jk, [
        e.iconName ? (v(), me(Te, {
          key: 0,
          class: "orq-floating-action-item__icon",
          type: "none",
          name: e.iconName ? e.iconName : "",
          size: d(),
          color: h(),
          inverse: e.inverse
        }, null, 8, ["name", "size", "color", "inverse"])) : D("", !0)
      ])) : D("", !0),
      y("span", Qk, ie(e.label), 1)
    ], 42, Xk));
  }
}, nq = {
  class: "floating-summary__container",
  slyte: "outline: solid 1px red"
}, rq = {
  key: 0,
  class: "floating-summary"
}, aq = { class: "floating-summary__number" }, iq = { class: "floating-summary__actions" }, sq = { class: "floating-summary__content" }, oq = {
  __name: "FloatingSummary",
  props: {
    number: {
      type: Number,
      default: 0
    },
    maxHeight: {
      type: Number,
      default: 0
    }
  },
  emits: "close",
  setup(e, { emit: a }) {
    ir((u) => ({
      "5fb757ae": o.value
    }));
    const r = e, s = B(() => r.number > 999 ? "999+" : r.number), o = B(() => r.maxHeight === 0 ? null : `${r.maxHeight}px`), d = a;
    return (u, f) => (v(), m("div", nq, [
      re(Aa, { name: "fade" }, {
        default: dt(() => [
          r.number > 0 ? (v(), m("div", rq, [
            y("a", {
              href: "#",
              class: "floating-summary__close",
              onClick: f[0] || (f[0] = Ct((c) => d("close"), ["prevent", "stop"]))
            }, [
              re(Te, {
                name: "close",
                size: 24
              })
            ]),
            y("span", aq, ie(s.value), 1),
            y("div", null, ie(s.value === 1 ? "Seleccionado" : "Seleccionadas"), 1),
            y("div", iq, [
              we(u.$slots, "actions", {}, void 0, !0)
            ])
          ])) : D("", !0)
        ]),
        _: 3
      }),
      y("div", sq, [
        we(u.$slots, "default", {}, void 0, !0)
      ])
    ]));
  }
}, X3 = /* @__PURE__ */ ae(oq, [["__scopeId", "data-v-a1887ad6"]]), lq = { class: "orq-grid" }, uq = {
  __name: "Grid",
  props: {
    cols: {
      type: Number,
      default: 6,
      validator: (e) => e <= 12
    },
    gap: {
      type: Number,
      default: 24,
      validator: (e) => [0, 8, 16, 24, 32, 48].includes(e)
    }
  },
  setup(e) {
    ir((s) => ({
      e268da5e: e.cols,
      "3e69b738": r.value
    }));
    const a = e, r = B(() => `${a.gap}px`);
    return (s, o) => (v(), m("div", lq, [
      we(s.$slots, "default", {}, void 0, !0)
    ]));
  }
}, J3 = /* @__PURE__ */ ae(uq, [["__scopeId", "data-v-e67592dd"]]), cq = { class: "hero" }, dq = { class: "hero__background" }, fq = ["src"], vq = { class: "hero__container" }, pq = { class: "hero__content" }, hq = { class: "headline" }, gq = {
  __name: "Hero",
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: ""
    },
    backgroundImage: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    backgroundColor: {
      type: String,
      default: "var(--support-blue-20)"
    },
    position: {
      type: String,
      default: "left"
    },
    offsetTop: {
      type: Number,
      default: 0
    }
  },
  setup(e) {
    ir((f) => ({
      "98c4f750": r.value,
      "8ad638f6": u.value,
      "981e0360": d.value,
      f7bfe4c2: s.value
    }));
    const a = e, r = B(() => a.backgroundColor), s = B(() => a.position === "left" ? "flex-start" : "flex-end"), o = B(() => ({
      "text--on-color-emphasis-high": !a.inverse,
      "text--on-color-emphasis-high-inverse": a.inverse
    })), d = B(() => a.backgroundImage ? `url(${a.backgroundImage}) no-repeat right top` : ""), u = B(() => `${a.offsetTop}px`);
    return (f, c) => (v(), m("div", cq, [
      y("div", dq, [
        e.image ? (v(), m("img", {
          key: 0,
          src: e.image,
          alt: "",
          class: "hero__img"
        }, null, 8, fq)) : D("", !0),
        y("div", vq, [
          y("div", pq, [
            we(f.$slots, "default", {}, () => [
              re(mo, { gap: 32 }, {
                default: dt(() => [
                  re(mo, { gap: 16 }, {
                    default: dt(() => [
                      e.title ? (v(), m("h1", {
                        key: 0,
                        class: w(["hero__title", o.value])
                      }, ie(e.title), 3)) : D("", !0),
                      e.description ? (v(), m("h2", {
                        key: 1,
                        class: w(["hero__description body-baseline", o.value])
                      }, ie(e.description), 3)) : D("", !0)
                    ]),
                    _: 1
                  }),
                  f.$slots.actions ? (v(), me(Zk, { key: 0 }, {
                    default: dt(() => [
                      we(f.$slots, "actions", {}, void 0, !0)
                    ]),
                    _: 3
                  })) : D("", !0)
                ]),
                _: 3
              })
            ], !0)
          ])
        ])
      ]),
      y("div", hq, [
        (v(), m(ce, null, Re(5, (g) => y("div", { key: g })), 64))
      ])
    ]));
  }
}, Q3 = /* @__PURE__ */ ae(gq, [["__scopeId", "data-v-f84766b4"]]);
var qi = /* @__PURE__ */ ((e) => (e.number = "number", e.text = "text", e.password = "password", e))(qi || {}), yo = /* @__PURE__ */ ((e) => (e.none = "none", e.prefix = "prefix", e.suffix = "suffix", e))(yo || {});
const mq = Oe({
  name: "OrqInput",
  components: {
    OrqShimmer: Ft,
    OrqIconContainer: Te
  },
  inheritAttrs: !1,
  props: {
    label: {
      type: String,
      default: ""
    },
    defaultValue: {
      type: String,
      default: ""
    },
    modelValue: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "small"
    },
    name: {
      type: String,
      default: ""
    },
    autoFocus: {
      type: Boolean,
      default: !1
    },
    ariaLabel: {
      type: String,
      default: "Aria label"
    },
    id: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    placeholder: {
      type: String,
      default: "Placeholder"
    },
    maxLength: {
      type: Number,
      default: 100
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    readOnly: {
      type: Boolean,
      default: !1
    },
    startIcon: {
      type: String,
      default: ""
    },
    endIcon: {
      type: String,
      default: ""
    },
    prefixSuffixOptions: {
      type: String,
      default: "none"
    },
    prefix: {
      type: String,
      default: "R$"
    },
    suffix: {
      type: String,
      default: "%"
    },
    animation: {
      type: Boolean,
      default: !1
    },
    disableErrorAnimation: {
      type: Boolean,
      default: !1
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:modelValue",
    "focus",
    "blur",
    "onChange",
    "inputchange",
    "clear"
  ],
  setup(e, { emit: a }) {
    const r = V(null), s = V(), o = 16, d = 24;
    let u = V(e.type), f = V(0), c = V(e.defaultValue), g = V(!1);
    Tt(() => {
      var T;
      (T = document.getElementsByClassName("orq-input__input")[0]) == null || T.setAttribute("value", ""), h();
    }), vt(e, () => {
      h();
    }), Lt(() => {
      c.value = e.defaultValue || e.modelValue;
    });
    const h = () => {
      f.value = M(
        c.value ? c.value : e.placeholder
      ) + 2;
    }, q = (T) => {
      g.value = !0, a("focus", T);
    }, C = (T) => {
      var z;
      ((z = c.value) == null ? void 0 : z.length) > 0 ? document.getElementsByClassName("orq-input__input")[0].setAttribute("value", c.value) : document.getElementsByClassName("orq-input__input")[0].setAttribute("value", ""), g.value = !1, a("blur", T);
    }, O = () => e.error && e.inverse && e.disabled || e.disabled && e.inverse ? Xe.emphasisBaseInverseDisabled : e.error && e.inverse ? Xe.statusErrorInverse : e.error && e.disabled || e.disabled ? Xe.emphasisBaseDisabled : e.inverse ? Xe.emphasisBaseInverseHigh : e.error ? Xe.statusError : Xe.emphasisBaseHigh, S = () => {
      var T, z, le, K;
      e.inverse && !e.disabled ? (T = s.value) == null || T.style.setProperty(
        "color",
        "var(--emphasis-base-low-inverse)"
      ) : e.inverse && e.disabled ? (z = s.value) == null || z.style.setProperty(
        "color",
        "var(--emphasis-base-disabled-inverse)"
      ) : e.disabled && !e.inverse ? (le = s.value) == null || le.style.setProperty(
        "color",
        "var(--emphasis-base-disabled)"
      ) : (K = s.value) == null || K.style.setProperty(
        "color",
        "var(--on-color-emphasis-medium)"
      );
    }, I = () => e.size === "small" ? o : d, M = (T) => {
      const le = document.createElement("canvas").getContext("2d");
      if (e.size === "small")
        return le.font = "16px Moderat", e.startIcon ? le.measureText(T).width + 30 : le.measureText(T).width + 4;
      if (e.size === "large")
        return le.font = "24px Moderat", e.startIcon ? le.measureText(T).width + 40 : le.measureText(T).width + 7;
    }, F = (T) => {
      a("onChange", T);
    }, P = (T) => {
      if (T.target.value === "") {
        f.value = M(e.placeholder) + 2;
        return;
      }
      e.suffix && (f.value = M(T.target.value) + 2);
    }, x = (T) => {
      P(T), a("update:modelValue", T.target.value), a("inputchange", T);
    }, $ = () => {
      const T = M(e.prefix), z = {
        left: `${T + 6}px`
      };
      return (g.value || r != null && r.value) && e.size === "small" && Object.assign(z, {
        transform: `translateY(-18px) translateX(-${T + 6}px)`,
        "font-size": "10px",
        "font-weight": "500",
        "line-height": "15px"
      }), (g.value || r != null && r.value) && e.size === "large" && Object.assign(z, {
        transform: `translateY(-20px) translateX(-${T + 6}px)`,
        "font-size": "12px",
        "font-weight": "500",
        "line-height": "18px"
      }), z;
    }, Y = () => {
      u.value === qi.password ? u.value = qi.text : u.value = qi.password;
    }, R = (T) => {
      var z;
      c.value = "", (z = r.value) == null || z.focus(), a("clear", T);
    };
    return {
      fieldsetClasses: B(() => ({
        "orq-input": !0,
        "orq-input--disabled": e.disabled,
        "orq-input--inverse": e.inverse,
        "orq-input--focused": g.value,
        [`orq-input--${e.size}`]: e.size,
        "orq-input--error": e.error && !e.disabled,
        "orq-input--inverse--error": e.error && e.inverse,
        [`orq-input--${e.size}--prefix`]: e.prefix && e.prefixSuffixOptions === yo.prefix,
        [`orq-input--${e.size}--suffix`]: e.suffix && e.prefixSuffixOptions === yo.suffix,
        "orq-input--error-no-animate": e.error && e.disableErrorAnimation,
        [`orq-input--${e.size}--start-icon`]: e.startIcon,
        [`orq-input--${e.size}--end-icon`]: e.endIcon
      })),
      labelClasses: B(() => ({
        "orq-input__label": !0,
        "orq-input--disabled__label": e.disabled,
        "orq-input--inverse__label": e.inverse,
        [`orq-input--${e.size}__label`]: e.size
      })),
      paragraphPrefixClasses: B(() => ({
        "orq-input__prefix-suffix": !0,
        "orq-input--inverse__prefix-suffix": e.inverse,
        "orq-input__prefix-suffix--disabled": e.disabled,
        "orq-input--inverse__prefix-suffix--disabled": e.inverse && e.disabled
      })),
      inputClasses: B(() => ({
        "orq-input__input": !0,
        "orq-input--inverse--error__input": e.error && e.inverse,
        "orq-input--inverse__input": e.inverse,
        "orq-input--error__input": e.error && !e.inverse && !e.disabled,
        [`orq-input--${e.size}__input`]: e.size
      })),
      placeholderAnimatedClasses: B(() => ({
        "orq-input__placeholder--animated": e.animation,
        "orq-input__placeholder--animated--with-icon": e.animation && e.startIcon
      })),
      spanSuffixClasses: B(() => ({
        "orq-input__suffix": !0,
        "orq-input--inverse__suffix": e.inverse,
        [`orq-input--${e.size}__suffix`]: e.size
      })),
      endIconClasses: B(() => ({
        "end-icon": !0,
        "orq-input__icon": !0,
        [`orq-input--${e.size}__end-icon`]: e.size
      })),
      lineClasses: B(() => ({
        "orq-input__line": !0,
        "orq-input--inverse__line": e.inverse,
        "orq-input--disabled__line": e.disabled,
        "orq-input--error__line": e.error && !e.disabled,
        "orq-input--error__line--disabled": e.inverse && e.disabled,
        "orq-input--inverse--error__line": e.inverse && e.error
      })),
      defaultSizeIcon: I,
      fontSmall: o,
      fontLarge: d,
      onFocus: q,
      onBlur: C,
      getIconColor: O,
      getDescriptionColor: S,
      getTextWidth: M,
      inputEvents: P,
      onChangeEvent: F,
      handleInputChange: x,
      animatePlaceholderWithPrefix: $,
      showPassword: Y,
      onClear: R,
      typeInput: u,
      suffixPosition: f,
      innerValue: c,
      isFocus: g,
      inputRef: r,
      refSpan: s
    };
  }
}), yq = ["aria-label", "for"], bq = { class: "orq-input__container" }, _q = { class: "orq-input__icon" }, wq = { class: "orq-input__input-wrapper" }, $q = ["id", "name", "autofocus", "aria-label", "type", "placeholder", "disabled", "maxLength", "required", "readonly"], Cq = { class: "orq-input__description-wrapper" }, Sq = { class: "orq-input__icon end-icon" }, kq = {
  key: 1,
  class: "description"
};
function qq(e, a, r, s, o, d) {
  const u = ze("OrqIconContainer"), f = ze("OrqShimmer");
  return v(), m(ce, null, [
    e.loading ? D("", !0) : (v(), m("fieldset", {
      key: 0,
      class: w(e.fieldsetClasses)
    }, [
      e.label && !e.animation ? (v(), m("label", {
        key: 0,
        class: w(e.labelClasses),
        "aria-label": e.ariaLabel,
        for: e.id
      }, [
        we(e.$slots, "label", {}, () => [
          _n(ie(e.label), 1)
        ])
      ], 10, yq)) : D("", !0),
      y("div", bq, [
        y("div", _q, [
          e.startIcon ? (v(), me(u, {
            key: 0,
            name: e.startIcon ? e.startIcon : "",
            class: "start-icon",
            color: e.getIconColor(),
            size: e.defaultSizeIcon()
          }, null, 8, ["name", "color", "size"])) : D("", !0),
          e.prefixSuffixOptions === "prefix" ? (v(), m("p", {
            key: 1,
            class: w(e.paragraphPrefixClasses)
          }, ie(e.prefix), 3)) : D("", !0)
        ]),
        y("div", wq, [
          Kr(y("input", Mi({
            id: e.id,
            ref: "inputRef",
            "onUpdate:modelValue": a[0] || (a[0] = (c) => e.innerValue = c),
            class: ["input", e.inputClasses],
            name: e.name,
            autofocus: e.autoFocus,
            "aria-label": e.ariaLabel,
            type: e.typeInput,
            placeholder: e.animation ? "" : e.placeholder,
            disabled: e.disabled,
            maxLength: e.maxLength,
            required: e.required,
            readonly: e.readOnly
          }, e.$attrs, {
            onFocus: a[1] || (a[1] = (c) => e.onFocus(c)),
            onBlur: a[2] || (a[2] = (c) => e.onBlur(c)),
            onInput: a[3] || (a[3] = (c) => e.handleInputChange(c))
          }), null, 16, $q), [
            [A0, e.innerValue]
          ]),
          e.animation ? (v(), m("span", {
            key: 0,
            style: nt(
              e.prefixSuffixOptions === "prefix" ? e.animatePlaceholderWithPrefix() : ""
            ),
            class: w(e.placeholderAnimatedClasses)
          }, ie(e.placeholder), 7)) : D("", !0),
          e.innerValue && e.suffix && e.prefixSuffixOptions === "suffix" ? (v(), m("span", {
            key: 1,
            class: w(e.spanSuffixClasses),
            style: nt({ left: e.suffixPosition + "px" })
          }, ie(e.suffix), 7)) : D("", !0)
        ]),
        y("div", {
          class: w(e.endIconClasses)
        }, [
          e.endIcon ? D("", !0) : we(e.$slots, "default", { key: 0 }),
          e.type !== "password" && e.endIcon !== "close" ? (v(), me(u, {
            key: 1,
            name: e.endIcon ? e.endIcon : "",
            color: e.getIconColor(),
            size: e.defaultSizeIcon()
          }, null, 8, ["name", "color", "size"])) : D("", !0),
          e.type !== "password" && e.endIcon === "close" ? (v(), me(u, {
            key: 2,
            name: "close",
            color: e.getIconColor(),
            size: e.defaultSizeIcon(),
            onClick: a[4] || (a[4] = (c) => e.onClear(c))
          }, null, 8, ["color", "size"])) : D("", !0),
          e.type === "password" ? (v(), me(u, {
            key: 3,
            name: e.typeInput === "password" ? "visibility-off" : "visibility-on",
            color: e.getIconColor(),
            size: e.defaultSizeIcon(),
            onClick: a[5] || (a[5] = (c) => e.showPassword())
          }, null, 8, ["name", "color", "size"])) : D("", !0)
        ], 2)
      ]),
      y("div", {
        id: "line",
        class: w(e.lineClasses)
      }, null, 2),
      y("div", Cq, [
        e.error && e.description ? (v(), m(ce, { key: 0 }, [
          y("div", Sq, [
            re(u, {
              name: "status-error",
              size: 16,
              color: e.getIconColor()
            }, null, 8, ["color"])
          ]),
          y("span", {
            ref: "refSpan",
            class: "description",
            style: nt(e.getDescriptionColor())
          }, ie(e.description), 5)
        ], 64)) : (v(), m("span", kq, ie(e.description || " "), 1))
      ]),
      we(e.$slots, "default")
    ], 2)),
    e.loading ? (v(), me(f, {
      key: 1,
      type: "input",
      size: e.size,
      loading: e.loading,
      inverse: e.inverse
    }, null, 8, ["size", "loading", "inverse"])) : D("", !0)
  ], 64);
}
const Dq = /* @__PURE__ */ ae(mq, [["render", qq]]);
function Bq(e, a) {
  const r = (s) => {
    !e.value || e.value.contains(s.target) || a(s);
  };
  Tt(() => {
    document.addEventListener("mousedown", r), document.addEventListener("touchstart", r);
  }), _o(() => {
    document.removeEventListener("mousedown", r), document.removeEventListener("touchstart", r);
  });
}
var Zd = { exports: {} };
(function(e, a) {
  (function(r, s) {
    e.exports = s();
  })(br, function() {
    var r = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, s = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, o = /\d/, d = /\d\d/, u = /\d\d?/, f = /\d*[^-_:/,()\s\d]+/, c = {}, g = function(M) {
      return (M = +M) + (M > 68 ? 1900 : 2e3);
    }, h = function(M) {
      return function(F) {
        this[M] = +F;
      };
    }, q = [/[+-]\d\d:?(\d\d)?|Z/, function(M) {
      (this.zone || (this.zone = {})).offset = function(F) {
        if (!F || F === "Z") return 0;
        var P = F.match(/([+-]|\d\d)/g), x = 60 * P[1] + (+P[2] || 0);
        return x === 0 ? 0 : P[0] === "+" ? -x : x;
      }(M);
    }], C = function(M) {
      var F = c[M];
      return F && (F.indexOf ? F : F.s.concat(F.f));
    }, O = function(M, F) {
      var P, x = c.meridiem;
      if (x) {
        for (var $ = 1; $ <= 24; $ += 1) if (M.indexOf(x($, 0, F)) > -1) {
          P = $ > 12;
          break;
        }
      } else P = M === (F ? "pm" : "PM");
      return P;
    }, S = { A: [f, function(M) {
      this.afternoon = O(M, !1);
    }], a: [f, function(M) {
      this.afternoon = O(M, !0);
    }], Q: [o, function(M) {
      this.month = 3 * (M - 1) + 1;
    }], S: [o, function(M) {
      this.milliseconds = 100 * +M;
    }], SS: [d, function(M) {
      this.milliseconds = 10 * +M;
    }], SSS: [/\d{3}/, function(M) {
      this.milliseconds = +M;
    }], s: [u, h("seconds")], ss: [u, h("seconds")], m: [u, h("minutes")], mm: [u, h("minutes")], H: [u, h("hours")], h: [u, h("hours")], HH: [u, h("hours")], hh: [u, h("hours")], D: [u, h("day")], DD: [d, h("day")], Do: [f, function(M) {
      var F = c.ordinal, P = M.match(/\d+/);
      if (this.day = P[0], F) for (var x = 1; x <= 31; x += 1) F(x).replace(/\[|\]/g, "") === M && (this.day = x);
    }], w: [u, h("week")], ww: [d, h("week")], M: [u, h("month")], MM: [d, h("month")], MMM: [f, function(M) {
      var F = C("months"), P = (C("monthsShort") || F.map(function(x) {
        return x.slice(0, 3);
      })).indexOf(M) + 1;
      if (P < 1) throw new Error();
      this.month = P % 12 || P;
    }], MMMM: [f, function(M) {
      var F = C("months").indexOf(M) + 1;
      if (F < 1) throw new Error();
      this.month = F % 12 || F;
    }], Y: [/[+-]?\d+/, h("year")], YY: [d, function(M) {
      this.year = g(M);
    }], YYYY: [/\d{4}/, h("year")], Z: q, ZZ: q };
    function I(M) {
      var F, P;
      F = M, P = c && c.formats;
      for (var x = (M = F.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(K, se, oe) {
        var ve = oe && oe.toUpperCase();
        return se || P[oe] || r[oe] || P[ve].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(ee, Q, J) {
          return Q || J.slice(1);
        });
      })).match(s), $ = x.length, Y = 0; Y < $; Y += 1) {
        var R = x[Y], T = S[R], z = T && T[0], le = T && T[1];
        x[Y] = le ? { regex: z, parser: le } : R.replace(/^\[|\]$/g, "");
      }
      return function(K) {
        for (var se = {}, oe = 0, ve = 0; oe < $; oe += 1) {
          var ee = x[oe];
          if (typeof ee == "string") ve += ee.length;
          else {
            var Q = ee.regex, J = ee.parser, te = K.slice(ve), G = Q.exec(te)[0];
            J.call(se, G), K = K.replace(G, "");
          }
        }
        return function(de) {
          var ge = de.afternoon;
          if (ge !== void 0) {
            var N = de.hours;
            ge ? N < 12 && (de.hours += 12) : N === 12 && (de.hours = 0), delete de.afternoon;
          }
        }(se), se;
      };
    }
    return function(M, F, P) {
      P.p.customParseFormat = !0, M && M.parseTwoDigitYear && (g = M.parseTwoDigitYear);
      var x = F.prototype, $ = x.parse;
      x.parse = function(Y) {
        var R = Y.date, T = Y.utc, z = Y.args;
        this.$u = T;
        var le = z[1];
        if (typeof le == "string") {
          var K = z[2] === !0, se = z[3] === !0, oe = K || se, ve = z[2];
          se && (ve = z[2]), c = this.$locale(), !K && ve && (c = P.Ls[ve]), this.$d = function(te, G, de, ge) {
            try {
              if (["x", "X"].indexOf(G) > -1) return new Date((G === "X" ? 1e3 : 1) * te);
              var N = I(G)(te), ne = N.year, ue = N.month, Se = N.day, Me = N.hours, Ne = N.minutes, pt = N.seconds, st = N.milliseconds, ke = N.zone, Ie = N.week, Je = /* @__PURE__ */ new Date(), he = Se || (ne || ue ? 1 : Je.getDate()), je = ne || Je.getFullYear(), Ze = 0;
              ne && !ue || (Ze = ue > 0 ? ue - 1 : Je.getMonth());
              var wt, Ot = Me || 0, ht = Ne || 0, cn = pt || 0, $n = st || 0;
              return ke ? new Date(Date.UTC(je, Ze, he, Ot, ht, cn, $n + 60 * ke.offset * 1e3)) : de ? new Date(Date.UTC(je, Ze, he, Ot, ht, cn, $n)) : (wt = new Date(je, Ze, he, Ot, ht, cn, $n), Ie && (wt = ge(wt).week(Ie).toDate()), wt);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(R, le, T, P), this.init(), ve && ve !== !0 && (this.$L = this.locale(ve).$L), oe && R != this.format(le) && (this.$d = /* @__PURE__ */ new Date("")), c = {};
        } else if (le instanceof Array) for (var ee = le.length, Q = 1; Q <= ee; Q += 1) {
          z[1] = le[Q - 1];
          var J = P.apply(this, z);
          if (J.isValid()) {
            this.$d = J.$d, this.$L = J.$L, this.init();
            break;
          }
          Q === ee && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else $.call(this, Y);
      };
    };
  });
})(Zd);
var Aq = Zd.exports;
const Tq = /* @__PURE__ */ md(Aq), Oq = { key: 0 }, Iq = {
  __name: "InputDate",
  props: /* @__PURE__ */ Da({
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: !1
    },
    format: {
      type: String,
      default: "DD/MM/YYYY"
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    readOnly: {
      type: Boolean,
      default: !0
    },
    weekendAvailable: {
      type: Boolean,
      default: !0
    }
  }, {
    modelValue: { type: String, default: "22/08/1990" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    mn.extend(Tq);
    const a = V(!1), r = Ba(e, "modelValue"), s = e, o = B(() => {
      const c = r.value || mn(/* @__PURE__ */ new Date()).format("DD/MM/YYYY");
      return mn(c, s.format).format("DD/MM/YYYY") === "Invalid Date" ? mn(/* @__PURE__ */ new Date()).format("DD/MM/YYYY") : mn(c, s.format).format("DD/MM/YYYY");
    }), d = (c) => {
      r.value = mn(c).format(s.format);
    }, u = () => {
      a.value = !0;
    }, f = V(null);
    return Bq(f, () => {
      a.value && (a.value = !1);
    }), (c, g) => (v(), m("div", {
      ref_key: "calendarRef",
      ref: f,
      class: "calendar--container inputDate"
    }, [
      y("div", {
        onClick: Ct(u, ["prevent"])
      }, [
        re(Dq, {
          modelValue: r.value,
          "onUpdate:modelValue": g[0] || (g[0] = (h) => r.value = h),
          "end-icon": "schedule",
          label: e.label,
          placeholder: e.placeholder,
          tabindex: "-1",
          error: e.error,
          inverse: e.inverse,
          description: e.description,
          "read-only": e.readOnly,
          disabled: e.disabled,
          loading: e.loading,
          onInputchange: g[1] || (g[1] = (h) => a.value = !1)
        }, null, 8, ["modelValue", "label", "placeholder", "error", "inverse", "description", "read-only", "disabled", "loading"])
      ]),
      a.value && !e.disabled && !e.loading ? (v(), m("div", Oq, [
        re(mS, {
          class: "calendar",
          mode: "datepicker",
          type: "day",
          inverse: e.inverse,
          range: !1,
          "weekend-available": e.weekendAvailable,
          "start-date-value": o.value,
          onSelectDaySingle: d
        }, null, 8, ["inverse", "weekend-available", "start-date-value"])
      ])) : D("", !0)
    ], 512));
  }
}, j3 = /* @__PURE__ */ ae(Iq, [["__scopeId", "data-v-99319f0e"]]), Mq = {
  __name: "Layout",
  props: {
    inverse: {
      type: Boolean,
      default: !1
    },
    full: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (a, r) => (v(), m("div", {
      class: w(["layout", { "layout--inverse": e.inverse, "full-width": e.full }])
    }, [
      we(a.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}, e4 = /* @__PURE__ */ ae(Mq, [["__scopeId", "data-v-ab89189a"]]), xq = { class: "orq-list__container__content__box" }, Lq = {
  key: 0,
  class: "orq-list__container__content__image"
}, Fq = {
  key: 1,
  class: "orq-list__container__content__image"
}, Nc = "orq-title--box", mr = "orq-list__container__content__box__text-info", oo = "--inverse", Eq = {
  __name: "ListMeta",
  props: {
    avatar: {
      type: String,
      default: ""
    },
    avatarSize: {
      type: Number,
      default: 40
    },
    icon: {
      type: String,
      default: ""
    },
    iconColor: {
      type: String,
      default: "primary-base"
    },
    iconSize: {
      type: Number,
      default: 16
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = e, r = B(() => ({
      [`${Nc}`]: !0,
      [`${Nc}__text--left`]: !0
    })), s = B(() => ({
      [`${mr}__title`]: !0,
      [`${mr}__title${oo}`]: a.inverse
    })), o = B(() => ({
      [`${mr}__subtitle`]: !0,
      [`${mr}__subtitle${oo}`]: a.inverse
    })), d = B(() => ({
      [`${mr}__label`]: !0,
      [`${mr}__label${oo}`]: a.inverse
    }));
    return (u, f) => (v(), m("div", xq, [
      e.avatar ? (v(), m("div", Lq, [
        re(hd, {
          type: "image",
          src: e.avatar,
          alt: e.title,
          size: e.avatarSize,
          inverse: e.inverse,
          loading: e.loading
        }, null, 8, ["src", "alt", "size", "inverse", "loading"])
      ])) : D("", !0),
      e.icon ? (v(), m("div", Fq, [
        re(Te, {
          size: e.iconSize,
          name: e.icon,
          color: e.iconColor
        }, null, 8, ["size", "name", "color"])
      ])) : D("", !0),
      y("div", {
        class: w(mr)
      }, [
        y("div", {
          class: w(r.value)
        }, [
          y("h1", {
            class: w(s.value)
          }, ie(e.title), 3)
        ], 2),
        e.subtitle ? (v(), m("h2", {
          key: 0,
          class: w(o.value)
        }, ie(e.subtitle), 3)) : D("", !0),
        e.description ? (v(), m("h3", {
          key: 1,
          class: w(d.value)
        }, ie(e.description), 3)) : D("", !0)
      ])
    ]));
  }
}, Pq = /* @__PURE__ */ ae(Eq, [["__scopeId", "data-v-5db6360d"]]), zq = { class: "orq-list__container__content__box" }, ar = "orq-list__container__content__box", Hc = "orq-list__title__box", lo = "--inverse", Rq = {
  __name: "ListExtra",
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = e, r = B(() => ({
      [`${ar}__text-info`]: !0,
      [`${ar}__text-info--duplicated`]: !0
    })), s = B(() => ({
      [`${Hc}`]: !0,
      [`${Hc}__text--left`]: !0
    })), o = B(() => ({
      [`${ar}__text-info__title`]: !0,
      [`${ar}__text-info__title${lo}`]: a.inverse
    })), d = B(() => ({
      [`${ar}__text-info__subtitle`]: !0,
      [`${ar}__text-info__subtitle${lo}`]: a.inverse
    })), u = B(() => ({
      [`${ar}__text-info__label`]: !0,
      [`${ar}__text-info__label${lo}`]: a.inverse
    }));
    return (f, c) => (v(), m("div", zq, [
      y("div", {
        class: w(r.value)
      }, [
        y("div", {
          class: w(s.value)
        }, [
          y("h1", {
            class: w(o.value)
          }, ie(e.title), 3)
        ], 2),
        y("h2", {
          class: w(d.value)
        }, ie(e.subtitle), 3),
        e.description ? (v(), m("h3", {
          key: 0,
          class: w(u.value)
        }, ie(e.description), 3)) : D("", !0)
      ], 2)
    ]));
  }
}, Nq = /* @__PURE__ */ ae(Rq, [["__scopeId", "data-v-f35ef072"]]), Hq = {
  key: 0,
  class: "orq-switcher"
}, Vq = ["tab-index", "disabled", "checked", "required", "autofocus"], Yq = {
  __name: "Switcher",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    checked: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "small"
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: 0
    },
    switcherLabel: {
      type: Boolean,
      default: !0
    },
    label: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["change"],
  setup(e, { emit: a }) {
    const r = e, s = a, o = V("orq-switcher"), d = V("orq-switcher__content__input"), u = B(() => ({
      [`${d.value}`]: !0,
      [`${d.value}--${r.size}`]: r.size,
      [r.inverse ? `${d.value}--inverse` : `${d.value}--default`]: !0
    })), f = B(() => ({
      [`${o.value}__label`]: r.label,
      [`${o.value}__label--inverse`]: r.inverse,
      [`${o.value}__label--disabled`]: r.disabled
    }));
    return (c, g) => (v(), m(ce, null, [
      re(Ft, {
        type: "switcher",
        inverse: e.inverse,
        loading: e.loading,
        size: e.size
      }, null, 8, ["inverse", "loading", "size"]),
      e.loading ? D("", !0) : (v(), m("div", Hq, [
        y("div", {
          class: w(["orq-switcher__content", `orq-switcher__content--${e.size}`])
        }, [
          y("input", {
            id: "check",
            type: "checkbox",
            "tab-index": e.tabindex,
            disabled: e.disabled,
            checked: e.checked,
            required: e.required,
            autofocus: e.autofocus,
            class: w(u.value),
            onChange: g[0] || (g[0] = (h) => s("change", h))
          }, null, 42, Vq)
        ], 2),
        e.switcherLabel && e.label ? (v(), m("label", {
          key: 0,
          class: w(f.value),
          htmlFor: "check"
        }, ie(e.label), 3)) : D("", !0)
      ]))
    ], 64));
  }
}, Uq = ["tabindex"], Wq = { class: "radio-button--content-container" }, Gq = { class: "image-slot-container" }, Zq = { key: 0 }, Kq = ["innerHTML"], Xq = ["id", "checked", "value", "disabled"], Kd = {
  __name: "RadioButton",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "",
      validator: (e) => ["small", ""].includes(e)
    },
    index: {
      type: Number,
      default: 0
    },
    image: {
      type: String,
      default: ""
    },
    alignLabel: {
      type: String,
      default: "left",
      validator: (e) => ["left", "right"].includes(e)
    },
    type: {
      type: String,
      default: "label",
      validator: (e) => ["label", "box", "box-alt"].includes(e)
    },
    alignTop: {
      type: Boolean,
      default: !1
    },
    selected: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["select"],
  setup(e, { emit: a }) {
    const r = e, s = a, o = V(r.modelValue), d = V(null), u = () => {
      r.disabled || s("select");
    }, f = (g) => {
      Li(() => {
        (g.key === " " || g.key === "Enter") && (o.value = g.target.querySelector("input").value, u(o.value));
      });
    }, c = B(() => ({
      "radio-button--inverse": r.inverse,
      "radio-button--small": r.size === "small",
      "radio-button--align-right": r.alignLabel === "right",
      "radio-button--align-left": r.alignLabel === "left",
      "radio-button--box": r.type === "box",
      "radio-button--box-alt": r.type === "box-alt",
      "radio-button--align-top": r.alignTop,
      "radio-button--selected": r.selected,
      "radio-button--disabled": r.disabled
    }));
    return (g, h) => (v(), m("div", {
      ref_key: "radioButton",
      ref: d,
      class: w(["radio-button", c.value]),
      tabindex: e.index,
      onClick: h[1] || (h[1] = (q) => u(e.label)),
      onKeydown: f
    }, [
      y("div", Wq, [
        y("div", Gq, [
          we(g.$slots, "image", { index: e.index }, () => [
            e.image ? (v(), me(Ta, {
              key: 0,
              src: e.image,
              alt: e.image,
              outline: "",
              inverse: e.inverse
            }, null, 8, ["src", "alt", "inverse"])) : D("", !0)
          ])
        ]),
        re(mo, { gap: 8 }, {
          default: dt(() => [
            e.label ? (v(), m("label", Zq, ie(e.label), 1)) : D("", !0),
            e.description ? (v(), m("div", {
              key: 1,
              class: "body-sm description",
              innerHTML: e.description
            }, null, 8, Kq)) : D("", !0),
            g.$slots.extra ? we(g.$slots, "extra", {
              key: 2,
              index: e.index
            }) : D("", !0)
          ]),
          _: 3
        })
      ]),
      e.type === "box" ? (v(), m(ce, { key: 0 }, [
        e.selected ? (v(), me(Te, {
          key: 0,
          name: "check",
          color: "white"
        })) : D("", !0)
      ], 64)) : (v(), m("input", {
        key: 1,
        id: e.label,
        type: "radio",
        checked: e.selected,
        value: e.label,
        disabled: e.disabled,
        onInput: h[0] || (h[0] = (q) => d.value.focus())
      }, null, 40, Xq))
    ], 42, Uq));
  }
}, Jq = { class: "orq-list__container__content__box" }, Qq = {
  __name: "ListAction",
  props: {
    type: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    link: {
      type: String,
      default: ""
    },
    selected: {
      type: Boolean,
      default: !1
    },
    radioButtonGroupName: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  emits: ["onAction"],
  setup(e, { emit: a }) {
    const r = e, s = a, o = () => {
      s("onAction", r.value);
    };
    return (d, u) => (v(), m("div", Jq, [
      e.type === "checkbox" ? (v(), me(Ro, {
        key: 0,
        size: "large",
        checked: e.selected,
        value: e.value,
        inverse: e.inverse,
        name: e.value,
        onInput: o
      }, null, 8, ["checked", "value", "inverse", "name"])) : D("", !0),
      e.type === "switcher" ? (v(), me(Yq, {
        key: 1,
        checked: e.selected,
        value: e.value,
        inverse: e.inverse,
        onChange: o
      }, null, 8, ["checked", "value", "inverse"])) : D("", !0),
      e.type === "radio" ? (v(), me(Kd, {
        key: 2,
        options: e.options,
        "group-name": e.radioButtonGroupName,
        value: e.value,
        inverse: e.inverse,
        onChange: o
      }, null, 8, ["options", "group-name", "value", "inverse"])) : D("", !0),
      e.type === "button" ? (v(), me(wa, {
        key: 3,
        label: e.value,
        inverse: e.inverse,
        onClick: o
      }, null, 8, ["label", "inverse"])) : D("", !0),
      e.type === "link" ? (v(), me(Ri, {
        key: 4,
        link: e.link,
        inverse: e.inverse,
        size: "small",
        icon: "default"
      }, {
        default: dt(() => [
          re(Te, {
            name: e.icon ? e.icon : "",
            size: 24,
            inverse: e.inverse
          }, null, 8, ["name", "inverse"])
        ]),
        _: 1
      }, 8, ["link", "inverse"])) : D("", !0)
    ]));
  }
}, jq = { key: 0 }, eD = {
  key: 1,
  class: "orq-list"
}, tD = {
  __name: "List",
  props: {
    fullWidth: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    overline: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    link: {
      type: String,
      default: ""
    },
    href: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "radio"
    },
    options: {
      type: Array,
      default: () => []
    },
    minHeight: {
      type: Number,
      default: 110
    }
  },
  emits: ["actionClick"],
  setup(e, { emit: a }) {
    const r = e, s = a, o = V(r.options);
    vt(
      () => r.options,
      (h) => {
        o.value = h;
      },
      {
        deep: !0,
        immediate: !0
      }
    );
    const d = (h) => {
      const q = o.value[h].action;
      (r.type === "checkbox" || r.type === "switcher") && q && (q.selected = !q.selected), s("actionClick", q);
    }, u = B(() => ({
      "orq-list__container": !0,
      "orq-list__container--full-width": r.fullWidth
    })), f = B(() => ({
      "orq-list__overline": !0,
      "orq-list__overline--inverse": r.overline && r.inverse
    })), c = B(() => ({
      "orq-list__overline__title": !0,
      "orq-list__overline__title--inverse": r.overline && r.inverse
    })), g = B(() => ({
      "orq-list__container__divider": !0,
      "orq-list__container__divider--spacing-between": !0
    }));
    return (h, q) => (v(), m(ce, null, [
      e.loading ? (v(), m("div", jq, [
        re(Ft, {
          type: "list",
          loading: e.loading,
          inverse: e.inverse,
          rows: o.value ? o.value.length : 0,
          "show-list-overline": e.overline,
          "show-list-action": e.type !== "null"
        }, null, 8, ["loading", "inverse", "rows", "show-list-overline", "show-list-action"])
      ])) : D("", !0),
      e.loading ? D("", !0) : (v(), m("div", eD, [
        y("div", {
          class: w(u.value)
        }, [
          e.overline ? (v(), m("div", {
            key: 0,
            class: w(f.value)
          }, [
            y("p", {
              class: w(c.value)
            }, ie(e.overline), 3)
          ], 2)) : D("", !0),
          (v(!0), m(ce, null, Re(o.value, (C, O) => {
            var S, I;
            return v(), m(ce, { key: O }, [
              (v(), me(Ii((S = C.action) != null && S.href ? "a" : "div"), {
                href: (I = C.action) == null ? void 0 : I.href,
                class: "orq-list__container__content",
                style: nt({ "min-height": `${e.minHeight}px` })
              }, {
                default: dt(() => [
                  we(h.$slots, "default", {
                    meta: C.meta,
                    extra: C.extra,
                    action: C.action,
                    index: O
                  }, () => [
                    C.meta ? (v(), me(Pq, {
                      key: 0,
                      inverse: e.inverse,
                      avatar: C.meta.avatar,
                      "avatar-size": C.meta.avatarSize,
                      title: C.meta.title,
                      subtitle: C.meta.subtitle,
                      description: C.meta.description,
                      icon: C.meta.icon,
                      "icon-color": C.meta.iconColor,
                      "icon-size": C.meta.iconSize
                    }, null, 8, ["inverse", "avatar", "avatar-size", "title", "subtitle", "description", "icon", "icon-color", "icon-size"])) : D("", !0),
                    C.extra ? (v(), me(Nq, {
                      key: 1,
                      inverse: e.inverse,
                      title: C.extra.title,
                      subtitle: C.extra.subtitle,
                      description: C.extra.description
                    }, null, 8, ["inverse", "title", "subtitle", "description"])) : D("", !0),
                    C.action ? (v(), me(Qq, {
                      key: 2,
                      icon: C.action.icon,
                      link: C.action.link,
                      inverse: e.inverse,
                      type: C.action.type,
                      value: C.action ? C.action.value : null,
                      selected: C.action ? C.action.selected : !1,
                      options: C.action ? C.action.options : [],
                      "radio-button-group-name": "radio-button",
                      onOnAction: () => d(O)
                    }, null, 8, ["icon", "link", "inverse", "type", "value", "selected", "options", "onOnAction"])) : D("", !0)
                  ], !0)
                ]),
                _: 2
              }, 1032, ["href", "style"])),
              o.value.length > 0 && O < o.value.length - 1 ? (v(), m("div", {
                key: 0,
                class: w(g.value)
              }, [
                re(No, {
                  inverse: e.inverse,
                  orientation: "horizontal",
                  class: "list-divider",
                  size: "thin"
                }, null, 8, ["inverse"])
              ], 2)) : D("", !0)
            ], 64);
          }), 128))
        ], 2)
      ]))
    ], 64));
  }
}, t4 = /* @__PURE__ */ ae(tD, [["__scopeId", "data-v-d61bd420"]]), nD = ["viewBox"], rD = ["cx", "cy", "r", "stroke", "stroke-width"], aD = {
  __name: "SpinnerLoader",
  props: {
    width: { type: Number, default: 50 },
    // Ancho del spinner
    height: { type: Number, default: 50 },
    // Alto del spinner
    color: { type: String, default: "var(--neutral-extended-90)" },
    // Color del spinner
    circleSize: { type: Number, default: 15 },
    // Tamaño del círculo interno
    circleRadius: { type: Number, default: 7 },
    // Tamaño del radio
    strokeWidth: { type: Number, default: 0.5 }
    // Ancho de la línea del círculo
  },
  setup(e) {
    return (a, r) => (v(), m("div", {
      class: "spinner",
      style: nt({ width: `${e.width}px`, height: `${e.height}px` })
    }, [
      (v(), m("svg", {
        class: "spinner__circle",
        viewBox: `0  0 ${e.circleSize} ${e.circleSize}`
      }, [
        y("circle", {
          class: "spinner__path",
          cx: e.circleSize / 2,
          cy: e.circleSize / 2,
          r: e.circleRadius,
          stroke: e.color,
          "stroke-width": e.strokeWidth,
          fill: "none",
          "stroke-linecap": "round"
        }, null, 8, rD)
      ], 8, nD))
    ], 4));
  }
}, iD = /* @__PURE__ */ ae(aD, [["__scopeId", "data-v-79f90119"]]), sD = {
  __name: "Loader",
  props: {
    zIndex: {
      type: Number,
      default: 999
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (a, r) => (v(), m("div", {
      "data-testid": "orq-loader",
      class: w(["orq-loader", { inverse: e.inverse }]),
      style: nt({ zIndex: e.zIndex })
    }, [
      re(iD, {
        width: 70,
        height: 70,
        color: e.inverse ? "#87baff" : "#10408d"
      }, null, 8, ["color"])
    ], 6));
  }
}, n4 = /* @__PURE__ */ ae(sD, [["__scopeId", "data-v-303fcd3f"]]), oD = ["width", "height"], lD = ["fill"], uD = ["fill"], r4 = {
  __name: "Logo",
  props: {
    inverse: {
      type: Boolean,
      default: !1
    },
    width: {
      type: Number,
      default: 80
    },
    height: {
      type: Number,
      default: 32
    }
  },
  setup(e) {
    const a = e, r = B(() => a.inverse ? "white" : "#001E62");
    return (s, o) => (v(), m("svg", {
      width: e.width,
      height: e.height,
      viewBox: "0 0 83 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      y("path", {
        d: "M31.9834 12.792C28.8804 12.792 27.456 14.1019 27.456 17.0961V17.5563C27.456 20.3975 28.6944 21.7758 31.6103 21.7758C32.5437 21.7758 33.476 21.6054 34.138 21.0779V21.4187C34.138 23.0173 33.4425 23.5447 31.8147 23.5447H30.8413C30.2832 23.5556 30.0301 23.6533 29.6937 24.2067C28.3157 26.3998 26.4059 28.2062 24.1428 29.4572C21.8797 30.7082 19.3375 31.3627 16.7537 31.3597C8.31738 31.3597 1.4461 24.4694 1.4461 16C1.4461 7.53063 8.31306 0.640306 16.7537 0.640306C19.6555 0.6426 22.4971 1.47147 24.9479 3.03052C27.3986 4.58957 29.358 6.81472 30.5979 9.4472H31.301C30.04 6.6341 27.9964 4.24617 25.4156 2.5703C22.8348 0.894437 19.8267 0.00192441 16.7526 0C7.96046 0 0.806885 7.17792 0.806885 16C0.806885 24.8221 7.96046 32 16.7526 32C19.2745 32.0024 21.7608 31.4034 24.0066 30.2524C26.2525 29.1014 28.1936 27.4314 29.6699 25.3799H31.951C34.9524 25.3799 36.4936 24.2393 36.4936 21.3297V16.9431C36.4947 14.0509 35.0194 12.792 31.9834 12.792ZM34.1542 17.8439C34.1542 19.4435 33.595 19.9373 31.9834 19.9373C30.1696 19.9373 29.8138 19.3079 29.8138 17.4532V17.1634C29.8138 15.326 30.1383 14.6673 31.9834 14.6673C33.7983 14.6673 34.1542 15.3185 34.1542 17.1862V17.8439ZM10.0923 9.57634V17.9328C10.0923 21.0291 11.5167 22.3227 14.6198 22.3227C17.8418 22.3227 19.2706 21.0627 19.2706 17.9491V17.1493C19.2706 14.2191 17.9478 12.7941 15.0643 12.7941C14.1493 12.7941 13.1488 12.9808 12.4685 13.5082V9.20192L10.0923 9.57634ZM14.7041 14.663C16.3319 14.663 16.9084 15.3141 16.9084 17.2329V17.9524C16.9084 19.8245 16.3319 20.4713 14.6706 20.4713C13.0093 20.4713 12.4317 19.8201 12.4317 17.9361V16.9659C12.4317 15.2392 13.0082 14.663 14.7041 14.663ZM26.2857 14.9885L26.6761 13.0828H23.3232V10.4782L20.9654 10.8352V18.6111C20.9654 21.2993 22.0178 22.0992 24.8829 22.0992H26.1375L26.528 20.2108H25.0484C23.7429 20.2108 23.3178 19.8852 23.3178 18.4581V14.9853L26.2857 14.9885Z",
        fill: r.value
      }, null, 8, lD),
      y("path", {
        d: "M43.0393 13.4637C40.7248 13.4637 39.6432 14.613 39.6432 17.0842V23.7987H40.3754V20.3475C40.9043 21.0378 41.8896 21.4426 43.0794 21.4426C45.3874 21.4426 46.4171 20.3258 46.4171 17.8243V17.0646C46.4182 14.5729 45.3755 13.4637 43.0393 13.4637ZM45.6654 17.8243C45.6654 19.9416 44.9656 20.7285 43.0804 20.7285C41.2958 20.7285 40.3905 19.8602 40.3905 18.1336V17.0842C40.3905 15.0222 41.1585 14.18 43.0393 14.18C44.9202 14.18 45.6654 14.9885 45.6654 17.0635V17.8243ZM77.2065 13.5918H75.2272L75.0628 14.3048H77.2108C79.1749 14.3048 79.838 14.829 79.838 16.3842V17.1352C79.3502 16.6468 78.4892 16.3983 77.2724 16.3983C75.3256 16.3983 74.3868 17.2241 74.3868 18.9226V19.0376C74.3868 20.6297 75.3159 21.4382 77.1491 21.4382H77.6423C79.5892 21.4382 80.5691 20.6297 80.5691 19.0376V16.3798C80.5648 14.396 79.5914 13.5874 77.2065 13.5874V13.5918ZM79.8336 19.1461C79.8336 20.2857 79.2117 20.7295 77.6175 20.7295H77.3092C75.7701 20.7295 75.1136 20.2249 75.1136 19.043V18.9182C75.1136 17.6344 75.7399 17.0874 77.2065 17.0874H77.3298C79.0841 17.0874 79.8336 17.6159 79.8336 18.8564V19.1461ZM82.0757 10.6366V21.4436H82.8069V10.6355L82.0757 10.6366ZM65.5925 14.3015L65.7558 13.5885H62.484V11.5493L61.7269 11.6839V18.673C61.7269 20.6633 62.4699 21.4035 64.4687 21.4035H65.5503L65.6876 20.6894H64.4698C62.9631 20.6894 62.4807 20.2097 62.4807 18.7142V14.3005L65.5925 14.3015ZM72.3664 18.3409C72.3664 20.1804 71.7932 20.7708 70.0064 20.7708C68.2759 20.7708 67.6875 20.1576 67.6875 18.3409V13.5874H66.9304V18.3398C66.9304 20.6026 67.7956 21.4871 70.001 21.4871C72.2063 21.4871 73.0921 20.5765 73.0921 18.3398V13.5874H72.361L72.3664 18.3409ZM50.4027 13.5885H48.4202L48.2558 14.3015H50.4027C52.3496 14.3015 53.0093 14.8257 53.0093 16.3809V17.1319C52.5226 16.6435 51.6617 16.395 50.4438 16.395C48.5024 16.395 47.5582 17.2209 47.5582 18.9193V19.0376C47.5582 20.6297 48.4948 21.4382 50.3411 21.4382H50.8354C52.7638 21.4382 53.7416 20.6297 53.7416 19.0376V16.3798C53.7416 14.396 52.7746 13.5874 50.4027 13.5874V13.5885ZM53.0093 19.1461C53.0093 20.3009 52.4145 20.7295 50.8148 20.7295H50.5055C48.9523 20.7295 48.2904 20.2249 48.2904 19.043V18.9182C48.2904 17.6344 48.9156 17.0874 50.3822 17.0874H50.5055C52.2609 17.0874 53.0093 17.6159 53.0093 18.8564V19.1461ZM55.8214 17.8254V17.1645C55.8214 15.0504 56.5418 14.3015 58.573 14.3015H60.2884L60.4517 13.5885H58.5708C56.1481 13.5885 55.0676 14.6911 55.0676 17.1699V17.8308C55.0676 20.3041 56.1492 21.4122 58.5708 21.4122H60.3014L60.4658 20.6981H58.5708C56.5894 20.6872 55.8182 19.8852 55.8182 17.8243L55.8214 17.8254Z",
        fill: r.value
      }, null, 8, uD)
    ], 8, oD));
  }
}, cD = { class: "orq-modal__container" }, dD = { class: "orq-modal__container__header" }, fD = { class: "title--box orq-title--box__text--left" }, vD = { class: "orq-modal__container__content" }, pD = { class: "orq-modal__container__footer__button-div" }, hD = { class: "orq-modal__container__footer__button-div" }, a4 = {
  __name: "Modal",
  props: {
    type: {
      type: String,
      default: "modal"
    },
    size: {
      type: String,
      default: ""
    },
    showActions: {
      type: Boolean,
      default: !1
    },
    showOneAction: {
      type: Boolean,
      default: !0
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    visible: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: ""
    },
    actions: {
      type: Object,
      default: () => {
      }
    },
    primaryButtonText: {
      type: String,
      default: "Label"
    },
    primaryButtonIconName: {
      type: String,
      default: ""
    },
    primaryButtonDisabled: {
      type: Boolean,
      default: !1
    },
    secondaryButtonText: {
      type: String,
      default: "Label"
    },
    secondaryButtonIconName: {
      type: String,
      default: ""
    },
    secondaryButtonDisabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["onClose", "onPrimaryClick", "onSecondaryClick"],
  setup(e, { emit: a }) {
    const r = a, s = e, o = B(
      () => s.type === "dialog" ? "orq-modal--dialog" : `orq-modal--${s.size}`
    ), d = B(
      () => s.inverse ? "orq-modal--inverse" : ""
    ), u = B(
      () => s.inverse ? "title--box--inverse" : ""
    ), f = B(
      () => s.inverse ? "orq-modal__container__content__paragraph--inverse" : ""
    ), c = B(() => ({
      "orq-modal__container__footer": !0,
      "orq-modal__container__footer--inverse": s.inverse
    }));
    return (g, h) => e.visible ? (v(), m("div", {
      key: 0,
      class: w(`orq-modal ${o.value} ${d.value}`)
    }, [
      y("div", cD, [
        y("div", dD, [
          y("div", fD, [
            y("h1", {
              class: w(`title--title-md ${u.value}`)
            }, ie(e.title), 3)
          ]),
          re(Te, {
            name: "close",
            color: `emphasis-base-high${e.inverse ? "-inverse" : ""}`,
            size: 24,
            onClick: h[0] || (h[0] = (q) => r("onClose", q))
          }, null, 8, ["color"])
        ]),
        y("div", vD, [
          g.$slots.default ? we(g.$slots, "default", { key: 0 }) : g.$slots.wrapper ? we(g.$slots, "wrapper", { key: 1 }) : (v(), m(ce, { key: 2 }, [
            e.description ? (v(), m("p", {
              key: 0,
              class: w(`orq-modal__container__content__paragraph ${f.value}`),
              style: { padding: "0", margin: "0" }
            }, ie(e.description), 3)) : D("", !0)
          ], 64))
        ]),
        e.showActions && e.type !== "dialog-variation" ? (v(), m("div", {
          key: 0,
          class: w(c.value)
        }, [
          y("div", pD, [
            re(wa, {
              appearance: "line",
              size: "compact",
              "icon-name": e.secondaryButtonIconName,
              disabled: e.secondaryButtonDisabled,
              label: e.secondaryButtonText,
              inverse: e.inverse,
              onClick: h[1] || (h[1] = (q) => r("onSecondaryClick", q))
            }, null, 8, ["icon-name", "disabled", "label", "inverse"]),
            re(wa, {
              appearance: "primary",
              size: "compact",
              "icon-name": e.primaryButtonIconName,
              disabled: e.primaryButtonDisabled,
              label: e.primaryButtonText,
              inverse: e.inverse,
              onClick: h[2] || (h[2] = (q) => r("onPrimaryClick", q))
            }, null, 8, ["icon-name", "disabled", "label", "inverse"])
          ])
        ], 2)) : D("", !0),
        !e.showActions && e.showOneAction && e.type !== "dialog-variation" ? (v(), m("div", {
          key: 1,
          class: w(c.value)
        }, [
          y("div", hD, [
            re(wa, {
              style: { margin: "0" },
              appearance: "primary",
              size: "compact",
              label: e.primaryButtonText,
              "icon-name": e.primaryButtonIconName,
              disabled: e.primaryButtonDisabled,
              inverse: e.inverse,
              onClick: h[3] || (h[3] = (q) => r("onPrimaryClick", q))
            }, null, 8, ["label", "icon-name", "disabled", "inverse"])
          ])
        ], 2)) : D("", !0)
      ])
    ], 2)) : D("", !0);
  }
}, gD = {
  __name: "Navbar",
  props: {
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (a, r) => (v(), m("nav", {
      class: w(["navbar", { "navbar--inverse": e.inverse }])
    }, [
      we(a.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}, i4 = /* @__PURE__ */ ae(gD, [["__scopeId", "data-v-79fdcc9a"]]), mD = ["href", "title", "target"], yD = {
  __name: "NavbarItem",
  props: {
    label: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    href: {
      type: String,
      default: ""
    },
    active: {
      type: Boolean,
      default: !1
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    target: {
      type: String,
      default: "_self"
    }
  },
  setup(e) {
    return (a, r) => (v(), m("a", {
      href: e.href,
      title: e.title,
      target: e.target,
      class: w(["navbar-item", {
        "navbar-item--inverse": e.inverse,
        "navbar-item--active": e.active
      }])
    }, ie(e.label), 11, mD));
  }
}, s4 = /* @__PURE__ */ ae(yD, [["__scopeId", "data-v-ef0eee16"]]), bD = {
  __name: "NavigationDrawer",
  props: {
    open: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    full: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (a, r) => (v(), m("div", {
      class: w(["navigation-drawer", {
        "navigation-drawer--open": e.open,
        "navigation-drawer--inverse": e.inverse,
        "full-width": e.full
      }])
    }, [
      we(a.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}, o4 = /* @__PURE__ */ ae(bD, [["__scopeId", "data-v-1287b175"]]), Vc = {
  dp12: 12,
  dp16: 16
}, Oi = {
  success: {
    icon: {
      name: "status-success",
      color: "orq-notification__status-success--inverted",
      invertedColor: "orq-notification__status-success--base"
    },
    background: {
      color: "orq-notification__status-success--base",
      invertedColor: "orq-notification__status-success--inverted"
    }
  },
  error: {
    icon: {
      name: "status-error",
      color: "orq-notification__status-error--inverted",
      invertedColor: "orq-notification__status-error--base"
    },
    background: {
      color: "orq-notification__status-error--base",
      invertedColor: "orq-notification__status-error--inverted"
    }
  },
  warning: {
    icon: {
      name: "status-warning",
      color: "orq-notification__status-warning--inverted",
      invertedColor: "orq-notification__status-warning--base"
    },
    background: {
      color: "orq-notification__status-warning--base",
      invertedColor: "orq-notification__status-warning--inverted"
    }
  },
  info: {
    icon: {
      name: "info-on",
      color: "orq-notification__status-info--inverted",
      invertedColor: "orq-notification__status-info--base"
    },
    background: {
      color: "orq-notification__status-info--base",
      invertedColor: "orq-notification__status-info--inverted"
    }
  },
  placeholder: {
    icon: {
      name: "",
      color: "",
      invertedColor: "emphasis-base-high-inverse"
    },
    background: {
      color: "",
      invertedColor: "orq-notification--fixed--inverse"
    }
  }
}, _D = {
  key: 0,
  class: "orq-notification__wrapper"
}, wD = {
  key: 0,
  class: "orq-notification__link no-outline"
}, $D = {
  __name: "NotificationFixed",
  props: {
    label: {
      type: String,
      default: ""
    },
    iconName: {
      type: String,
      default: ""
    },
    kind: {
      type: String,
      default: "",
      validator: (e) => Object.keys(Oi).includes(e)
    },
    iconSize: {
      type: Number,
      default: Vc.dp24
    },
    labelSize: {
      type: Number,
      default: Vc.dp12
    },
    inverse: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    notificationType: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean
    },
    link: {
      type: Boolean
    },
    linkOptions: {
      type: Object,
      default: () => {
      }
    },
    full: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["onClick"],
  setup(e, { emit: a }) {
    const r = a, s = e, o = V(`orq-notification--${s.notificationType}`), d = V(
      `orq-notification__label--${s.notificationType}`
    ), u = V(
      "orq-notification__content--" + s.notificationType
    ), f = V(Oi), c = B(
      () => s.inverse ? `orq-notification--${s.notificationType}--inverse` : ""
    ), g = B(
      () => s.inverse ? "orq-notification__label--inverse" : ""
    ), h = B(
      () => s.disabled ? "orq-notification__label--default--disabled" : ""
    ), q = B(
      () => s.disabled && s.inverse ? "orq-notification__label--default--disabled--inverse" : ""
    ), C = B(() => s.kind ? f.value[s.kind] : null), O = B(
      () => s.inverse ? C.value.background.invertedColor : C.value.background.color
    ), S = B(
      () => s.inverse ? C.value.icon.invertedColor : C.value.icon.color
    ), I = B(
      () => s.iconName ? s.iconName : C.value.icon.name
    );
    return (M, F) => (v(), m("div", {
      class: w([
        "orq-notification",
        e.kind,
        O.value,
        o.value,
        c.value,
        e.full ? "orq-notification--full" : ""
      ])
    }, [
      e.loading ? D("", !0) : (v(), m("div", _D, [
        y("div", {
          class: w(`orq-notification__icon${I.value}`)
        }, [
          re(Te, {
            type: "none",
            style: { marginRight: "1rem" },
            name: I.value,
            size: e.iconSize,
            color: S.value
          }, null, 8, ["name", "size", "color"])
        ], 2),
        y("div", {
          class: w(`orq-notification__content ${u.value}`)
        }, [
          y("div", {
            class: w(`
						orq-notification__label
						${d.value}
						${h.value}
						${g.value}
						${q.value}`)
          }, [
            we(M.$slots, "default", {}, () => {
              var P, x, $;
              return [
                y("div", {
                  style: nt({ fontSize: `${e.labelSize}px` })
                }, ie(e.label), 5),
                e.link && e.notificationType === "fixed" ? (v(), m("div", wD, [
                  re(Ri, {
                    class: w(`${g.value} ${q.value}`),
                    icon: "default",
                    label: ((P = e.linkOptions) == null ? void 0 : P.linkLabel) || "",
                    href: (x = e.linkOptions) == null ? void 0 : x.href,
                    underline: !(($ = e.linkOptions) != null && $.hasIcon),
                    inverse: e.inverse,
                    loading: e.loading,
                    disabled: e.disabled,
                    onClick: F[0] || (F[0] = (Y) => e.disabled ? "" : r("onClick", Y))
                  }, null, 8, ["class", "label", "href", "underline", "inverse", "loading", "disabled"])
                ])) : D("", !0)
              ];
            }, !0)
          ], 2)
        ], 2)
      ])),
      e.loading ? (v(), me(Ft, {
        key: 1,
        type: "notification",
        loading: e.loading,
        inverse: e.inverse,
        rows: 1,
        cols: 1
      }, null, 8, ["loading", "inverse"])) : D("", !0)
    ], 2));
  }
}, l4 = /* @__PURE__ */ ae($D, [["__scopeId", "data-v-706dae0f"]]), CD = {
  key: 0,
  class: "orq-progress-ring"
}, SD = { class: "orq-progress-ring__track__image-container" }, u4 = {
  __name: "ProgressRing",
  props: {
    type: {
      type: String,
      default: "percentage"
    },
    size: {
      type: String,
      default: "medium"
    },
    value: {
      type: Number,
      default: 0
    },
    src: {
      type: String,
      default: "image.png"
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    currentValueStep: {
      type: Number,
      default: 0
    },
    totalValueStep: {
      type: Number,
      default: 0
    },
    typeAvatar: {
      type: String,
      default: "image"
    },
    alt: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const a = e, r = V(null), s = V(a.value), o = V(a.currentValueStep), d = V(48), u = V(64), f = B(
      () => a.inverse ? "orq-progress-ring__track--inverse" : "orq-progress-ring__track--default"
    ), c = B(
      () => a.inverse ? "orq-progress-ring__track__value-step-small--inverse" : ""
    ), g = B(
      () => a.size === "large" ? u.value : d.value
    ), h = B(
      () => a.type === "step" ? "percentage" : a.type
    ), q = B(() => ({
      "orq-progress-ring__track": !0,
      [`orq-progress-ring__track--${a.type}--${a.size}`]: a.type,
      [`${f.value}`]: !0
    })), C = B(() => ({
      "orq-progress-ring__track__value-step-small": !0,
      [`${c.value}`]: !0
    })), O = B(() => ({
      "orq-progress-ring__track": !0,
      [a.type === "image" || a.type === "avatar" ? "orq-progress-ring__track--image" : ""]: a.type,
      [`orq-progress-ring__track--image--${a.size}`]: a.size,
      [`${f.value}`]: !0
    })), S = B(() => ({
      "orq-progress-ring__track--image__image-container": !0,
      [`orq-progress-ring__track--image__image-container--${a.size}`]: a.size,
      [a.inverse ? "orq-progress-ring__track--image__image-container--inverse" : ""]: !0
    })), I = B(() => ({
      "orq-progress-ring__track--image__image-container": !0,
      [`orq-progress-ring__track--image__image-container--${a.size}`]: a.size,
      [a.inverse ? "orq-progress-ring__track--image__image-container--inverse" : ""]: a.inverse
    })), M = () => {
      a.type === "step" ? a.currentValueStep > o.value ? o.value = o.value + 1 : o.value = a.currentValueStep : a.value > s.value ? s.value = s.value + 1 : s.value = a.value;
    }, F = () => {
      a.type === "step" && (Y(), setTimeout(() => {
        o.value < a.currentValueStep && o.value <= 100 ? o.value = o.value + 1 : o.value > a.currentValueStep && (o.value = a.currentValueStep);
      }, 10));
    }, P = () => {
      a.type !== "step" && (setTimeout(() => {
        s.value < a.value && s.value <= 100 ? s.value = a.value + 1 : s.value > a.value && (s.value = a.value);
      }, 10), $());
    }, x = (T, z) => {
      r.value && (r.value.style.setProperty("--progress", `${T}%`), r.value.setAttribute("progress", z));
    }, $ = () => {
      x(s.value, `${s.value}%`);
    }, Y = () => {
      const T = o.value / a.totalValueStep * 100, z = `${o.value}/${a.totalValueStep}`;
      x(T, `${z}`);
    }, R = () => {
      a.type !== "step" ? s.value = 0 : o.value = 0;
    };
    return Lt(() => {
      M(), a.value, a.currentValueStep;
    }), Lt(() => {
      P(), s.value;
    }), Lt(() => {
      F(), o.value, s.value;
    }), (T, z) => (v(), m(ce, null, [
      e.loading ? D("", !0) : (v(), m("div", CD, [
        e.type === "percentage" ? (v(), m("div", {
          key: 0,
          id: "progress",
          ref_key: "progressRing",
          ref: r,
          class: w(q.value),
          onClick: R
        }, null, 2)) : D("", !0),
        e.type === "step" ? (v(), m("div", {
          key: 1,
          id: "progress",
          ref_key: "progressRing",
          ref: r,
          class: w(q.value),
          onClick: R
        }, null, 2)) : D("", !0),
        e.size === "small" && e.type === "step" ? (v(), m("span", {
          key: 2,
          class: w(C.value)
        }, null, 2)) : D("", !0),
        e.type === "image" ? (v(), m("div", {
          key: 3,
          id: "progress",
          ref_key: "progressRing",
          ref: r,
          class: w(O.value),
          onClick: R
        }, [
          y("div", {
            class: w(I.value)
          }, [
            re(Ta, {
              class: "orq-progress-ring__track__image-container",
              src: e.src,
              shape: "rounded",
              alt: e.alt,
              size: g.value,
              inverse: e.inverse
            }, null, 8, ["src", "alt", "size", "inverse"])
          ], 2)
        ], 2)) : D("", !0),
        e.type === "avatar" ? (v(), m("div", {
          key: 4,
          id: "progress",
          ref_key: "progressRing",
          ref: r,
          class: w(O.value),
          onClick: R
        }, [
          y("div", {
            class: w(S.value)
          }, [
            y("div", SD, [
              re(hd, {
                type: e.typeAvatar,
                inverse: e.inverse,
                src: e.src,
                alt: e.alt,
                size: g.value
              }, null, 8, ["type", "inverse", "src", "alt", "size"])
            ])
          ], 2)
        ], 2)) : D("", !0)
      ])),
      e.type !== "avatar" && e.loading ? (v(), me(Ft, {
        key: 1,
        type: "progress-ring",
        "type-ring": h.value,
        loading: e.loading,
        inverse: e.inverse,
        size: e.size
      }, null, 8, ["type-ring", "loading", "inverse", "size"])) : D("", !0),
      e.type === "avatar" && e.loading ? (v(), me(Ft, {
        key: 2,
        type: "progress-ring",
        "type-ring": e.type === "avatar" ? "image" : e.type,
        loading: e.loading,
        inverse: e.inverse,
        size: e.size
      }, null, 8, ["type-ring", "loading", "inverse", "size"])) : D("", !0)
    ], 64));
  }
}, kD = { class: "orq-progress-tracker__step--wrapper" }, qD = {
  __name: "ProgressTracker",
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    setCurrentStep: {
      type: Number,
      default: 1
    }
  },
  emits: ["stepChanged", "completed"],
  setup(e, { expose: a, emit: r }) {
    const s = r, o = e, d = V(o.steps), u = V(o.setCurrentStep), f = d.value[u.value - 1], c = (T, z) => d.value.length > T ? `orq-progress-tracker__${z}--show` : "", g = (T, z) => !T.current && !T.completed ? `orq-progress-tracker__${z}--pending` : "", h = (T) => T.current ? "orq-progress-tracker__step--current" : "", q = (T) => T.completed ? "orq-progress-tracker__step--completed" : "", C = (T) => T.current ? "orq-progress-tracker__label--active" : "", O = (T) => T.completed ? "orq-progress-tracker__track--active" : "orq-progress-tracker__track--pending", S = (T) => T.completed ? "orq-progress-tracker__status__icon--show" : "", I = () => {
      let T = [];
      d.value.forEach((z, le) => {
        var se, oe;
        let K = u.value;
        K == ((se = d.value) == null ? void 0 : se.length) ? (z.completed = !0, z.current = !1) : K <= ((oe = d.value) == null ? void 0 : oe.length) && K >= 1 && (le + 1 < K ? (z.completed = !0, z.current = !1) : le + 1 === K ? (z.completed = !1, z.current = !0) : (z.completed = !1, z.current = !1)), T.push(z);
      }), d.value = T;
    };
    vt(u, () => {
      I();
    }), Tt(() => {
      I();
    });
    const M = () => {
      u.value < d.value.length && (u.value++, s("stepChanged", f));
    }, F = () => {
      u.value > 1 && (u.value--, s("stepChanged", f));
    }, P = () => {
      u.value = d.value.length, s("completed", d.value);
    }, x = () => {
      u.value = 1, s("stepChanged", f);
    }, $ = (T) => {
      u.value = T, s("stepChanged", f);
    }, Y = B(
      () => o.inverse ? "orq-progress-tracker--inverse" : "orq-progress-tracker--default"
    ), R = B(
      () => o.inverse ? "emphasis-base-high" : "emphasis-base-high--inverse"
    );
    return a({
      nextStep: M,
      previousStep: F,
      completeSteps: P,
      resetSteps: x,
      setCurrentSteps: $
    }), (T, z) => {
      var le;
      return v(), m(ce, null, [
        e.loading ? D("", !0) : (v(), m("div", {
          key: 0,
          class: w(`orq-progress-tracker ${Y.value}`)
        }, [
          (v(!0), m(ce, null, Re(d.value, (K, se) => {
            var oe;
            return v(), m(ce, { key: se }, [
              y("div", kD, [
                y("div", {
                  class: w(`orq-progress-tracker__step ${h(
                    K
                  )} ${q(K)} ${g(
                    K,
                    "step"
                  )} ${c(se, "step")}`)
                }, [
                  y("div", {
                    class: w(`orq-progress-tracker__status ${c(
                      se,
                      "status"
                    )}`)
                  }, [
                    re(Te, {
                      ref_for: !0,
                      ref: "elRef",
                      type: "none",
                      name: "check",
                      class: w(`orq-progress-tracker__status__icon ${S(
                        K
                      )}`),
                      color: R.value
                    }, null, 8, ["class", "color"])
                  ], 2),
                  y("div", {
                    class: w(`orq-progress-tracker__label ${C(
                      K
                    )} ${c(se, "label")}`)
                  }, ie(K.label), 3)
                ], 2)
              ]),
              se + 1 !== ((oe = e.steps) == null ? void 0 : oe.length) ? (v(), m("div", {
                key: 0,
                class: w(`orq-progress-tracker__track ${O(
                  K
                )} ${c(se, "track")} ${g(
                  K,
                  "track"
                )}`)
              }, null, 2)) : D("", !0)
            ], 64);
          }), 128))
        ], 2)),
        e.loading ? (v(), me(Ft, {
          key: 1,
          type: "progress-tracker",
          loading: e.loading,
          inverse: e.inverse,
          rows: 1,
          cols: (le = e.steps) == null ? void 0 : le.length
        }, null, 8, ["loading", "inverse", "cols"])) : D("", !0)
      ], 64);
    };
  }
}, c4 = /* @__PURE__ */ ae(qD, [["__scopeId", "data-v-fa66c5e8"]]), DD = /* @__PURE__ */ Object.assign({
  inheritAttrs: !1
}, {
  __name: "RadioButtonGroup",
  props: {
    modelValue: {
      type: Number,
      default: null
    },
    items: {
      type: Array,
      default: () => []
    },
    showDivider: {
      type: Boolean,
      default: !0
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "label",
      validator: (e) => ["label", "box", "box-alt"].includes(e)
    },
    direction: {
      type: String,
      default: "vertical",
      validator: (e) => ["vertical", "horizontal"].includes(e)
    },
    alignLabel: {
      type: String,
      default: "left",
      validator: (e) => ["right", "left"].includes(e)
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const r = a, s = e, o = B(() => ({
      [`radio-buton-group--${s.direction}`]: !0
    }));
    return (d, u) => (v(), m("div", {
      class: w(["radio-buton-group", o.value])
    }, [
      (v(!0), m(ce, null, Re(e.items, (f, c) => (v(), m(ce, { key: c }, [
        re(Kd, Mi({
          selected: c === e.modelValue,
          label: typeof f == "string" ? f : f == null ? void 0 : f.label,
          description: typeof f != "string" ? f == null ? void 0 : f.description : "",
          inverse: e.inverse,
          image: f == null ? void 0 : f.image,
          disabled: f == null ? void 0 : f.disabled,
          type: e.type,
          "align-label": e.alignLabel
        }, d.$attrs, {
          onSelect: (g) => r("update:modelValue", c)
        }), Zc({
          image: dt(() => [
            we(d.$slots, "image", { index: c }, void 0, !0)
          ]),
          _: 2
        }, [
          d.$slots.extra ? {
            name: "extra",
            fn: dt(() => [
              we(d.$slots, "extra", { index: c }, void 0, !0)
            ]),
            key: "0"
          } : void 0
        ]), 1040, ["selected", "label", "description", "inverse", "image", "disabled", "type", "align-label", "onSelect"]),
        e.direction !== "horizontal" && e.showDivider && e.items.length !== c - 1 && !e.type.includes("box") ? (v(), me(No, {
          key: 0,
          inverse: e.inverse
        }, null, 8, ["inverse"])) : D("", !0)
      ], 64))), 128))
    ], 2));
  }
}), d4 = /* @__PURE__ */ ae(DD, [["__scopeId", "data-v-c199b7e4"]]);
function Xd(e, a) {
  const r = (s) => {
    !e.value || e.value.contains(s.target) || a(s);
  };
  Tt(() => {
    document.addEventListener("mousedown", r), document.addEventListener("touchstart", r);
  }), _o(() => {
    document.removeEventListener("mousedown", r), document.removeEventListener("touchstart", r);
  });
}
const BD = ["id"], AD = {
  class: "orq-select__field__content",
  role: "button"
}, TD = {
  key: 0,
  class: "orq-select__field__content__text"
}, OD = {
  key: 1,
  class: "orq-select__field__content__text"
}, ID = {
  key: 2,
  class: "orq-select__field__content__text"
}, MD = {
  role: "button",
  class: "orq-select__icon",
  "tab-index": 0
}, xD = { class: "orq-select__icon-expand" }, LD = {
  key: 0,
  class: "orq-select__error"
}, f4 = {
  __name: "Select",
  props: {
    modelValue: {
      type: [String, Array],
      default: ""
    },
    titleModel: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: null
    },
    variation: {
      type: String,
      default: "default"
    },
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    focus: {
      type: Boolean,
      default: !1
    },
    innerSearch: {
      type: Boolean,
      default: !1
    },
    categorizedSearch: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "small"
    },
    selectMode: {
      type: String,
      default: "single"
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: "Selecciona"
    },
    disableTopDropdown: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "onFocus",
    "onClick",
    "onClose",
    "update:modelValue"
  ],
  setup(e, { emit: a }) {
    const r = e, s = a, o = V(), d = V(null), u = V(null), f = V(!1), c = V(r.focus), g = V([]), h = (oe) => r.titleModel ? oe.title : oe.id, q = B(() => r.selectMode === "multi"), C = () => r.variation === "image" ? "avatar" : "default", O = (oe) => {
      var G, de;
      if (r.disabled || (c.value = !c.value), (G = d.value.$el.querySelector("input[type=text]")) == null || G.focus(), s("onFocus", oe), r.disableTopDropdown)
        return;
      const ve = ((de = u.value) == null ? void 0 : de.getBoundingClientRect().y) + window.scrollY + 450, ee = window.innerHeight > document.body.scrollHeight ? window.innerHeight : document.body.scrollHeight, Q = ve - ee, J = 400 - Q, te = J > 300 ? 300 : J;
      if (Q < 200) {
        d.value.$el.style.maxHeight = `${te}px`;
        return;
      }
      ee > ve ? f.value = !1 : f.value = !0;
    }, S = () => r.variation === "image" ? "orq-select--image" : r.variation === "twoLines" ? "orq-select--two-lines" : "", I = () => r.inverse && !r.disabled ? Xe.emphasisBaseInverseHigh : r.disabled && !r.inverse ? Xe.emphasisBaseDisabled : r.inverse && r.disabled ? Xe.emphasisBaseInverseDisabled : Xe.emphasisBaseHigh, M = () => r.error && r.inverse && r.disabled || r.disabled && r.inverse ? Xe.emphasisBaseInverseDisabled : r.error && r.inverse ? Xe.statusErrorInverse : r.error && r.disabled || r.disabled ? Xe.emphasisBaseDisabled : r.inverse ? Xe.emphasisBaseInverseHigh : r.error ? Xe.statusError : Xe.emphasisBaseHigh, F = () => {
      var oe, ve, ee, Q;
      r.inverse && !r.disabled ? (oe = o.value) == null || oe.style.setProperty(
        "color",
        "var(--emphasis-base-low-inverse)"
      ) : r.inverse && r.disabled ? (ve = o.value) == null || ve.style.setProperty(
        "color",
        "var(--emphasis-base-disabled-inverse)"
      ) : r.disabled && !r.inverse ? (ee = o.value) == null || ee.style.setProperty(
        "color",
        "var(--emphasis-base-disabled)"
      ) : (Q = o.value) == null || Q.style.setProperty(
        "color",
        "var(--emphasis-base-medium)"
      );
    }, P = (oe) => {
      if (r.modelValue.includes(h(oe))) {
        const ve = r.modelValue.findIndex(
          (Q) => Q === h(oe)
        ), ee = [...r.modelValue];
        ee.splice(ve, 1), s("update:modelValue", ee);
      } else {
        const ve = [...r.modelValue, h(oe)];
        s("update:modelValue", ve);
      }
    }, x = (oe) => {
      q.value ? P(oe) : (g.value = [oe], s("update:modelValue", h(oe)), c.value = !1), s("onClick", oe);
    }, $ = B(() => r.options.map((oe) => {
      var ve;
      return q.value ? oe.selected = (ve = r.modelValue) == null ? void 0 : ve.includes(h(oe)) : oe.selected = h(oe) === r.modelValue, oe;
    })), Y = B(() => $.value.filter((ve) => {
      var ee;
      return q.value ? ve.selected = (ee = r.modelValue) == null ? void 0 : ee.includes(
        h(ve)
      ) : ve.selected = h(ve) === r.modelValue;
    }));
    Lt(() => {
      c.value = r.focus;
    }), Xd(u, () => {
      c.value && (c.value = !1, s("onClose"));
    });
    const R = B(() => ({
      "orq-select": !0,
      "orq-select--inverse": r.inverse,
      "orq-select--disabled": r.disabled,
      "orq-select--two-lines": r.variation !== "default",
      "orq-select--small": r.size === "small" && r.variation === "default",
      "orq-select--has-value": !0,
      "orq-select--error": r.error
    })), T = B(() => ({
      "orq-select__field__label": !0,
      "orq-select__field__label--small": r.size === "small",
      "orq-select__field__label--error": r.error,
      "orq-select__field__label--focus": c.value,
      "orq-select__field__label--disabled": r.disabled
    })), z = B(() => ({
      "orq-select__description__message": !0,
      "orq-select__field__label--error": r.error && !r.disabled
    })), le = B(() => ({
      "orq-select__field__line": !0,
      "orq-select__field__line--error": r.error,
      "orq-select__field__line--disabled": r.disabled,
      "orq-select__field__line--focus": c.value
    })), K = B(() => ({
      "orq-select__description": !0,
      "orq-select__field__label--error": r.error && !r.disabled,
      "orq-select__description--inverse": r.inverse,
      "orq-select__description--disabled": r.disabled,
      "orq-select__description--inverse-disabled": r.inverse && r.disabled
    })), se = B(() => ({
      "orq-select__description__message": !0,
      "orq-select__description__message--small": r.size === "small"
    }));
    return (oe, ve) => {
      var ee, Q;
      return v(), m("div", {
        class: w({ topDropdown: f.value })
      }, [
        e.loading ? D("", !0) : (v(), m("div", {
          key: 0,
          id: e.id,
          ref_key: "selectRef",
          ref: u,
          class: w([R.value, S()])
        }, [
          y("div", {
            class: "orq-select__field",
            role: "button",
            onClick: ve[0] || (ve[0] = (J) => O(J))
          }, [
            y("label", {
              class: w(T.value)
            }, [
              we(oe.$slots, "label", {}, () => [
                _n(ie(e.label), 1)
              ])
            ], 2),
            y("div", AD, [
              Y.value.length === 0 ? (v(), m("span", TD, ie(e.placeholder), 1)) : e.selectMode === "single" ? (v(), m("span", OD, ie((ee = Y.value[0]) == null ? void 0 : ee.title), 1)) : (v(), m("span", ID, [
                Y.value.length > 1 ? (v(), m(ce, { key: 0 }, [
                  _n(ie(Y.value.length + " Seleccionados"), 1)
                ], 64)) : (v(), m(ce, { key: 1 }, [
                  _n(ie((Q = Y.value[0]) == null ? void 0 : Q.title), 1)
                ], 64))
              ]))
            ]),
            y("div", MD, [
              y("div", xD, [
                re(Te, {
                  name: "chevron-down",
                  type: "none",
                  size: e.size === "large" || e.variation !== "default" ? 24 : 16,
                  color: I()
                }, null, 8, ["size", "color"])
              ])
            ])
          ]),
          y("div", {
            class: w(le.value)
          }, null, 2),
          e.error && e.description ? (v(), m("div", LD, [
            y("div", {
              class: w(K.value)
            }, [
              re(Te, {
                class: "orq-select__error__message__icon",
                name: "status-error",
                type: "none",
                size: 16,
                color: M()
              }, null, 8, ["color"]),
              y("label", {
                ref_key: "refLabel",
                ref: o,
                class: w(z.value),
                style: nt(F())
              }, ie(e.description), 7)
            ], 2)
          ])) : D("", !0),
          e.error ? D("", !0) : (v(), m("div", {
            key: 1,
            class: w(K.value)
          }, [
            y("span", {
              class: w(se.value)
            }, ie(e.description || " "), 3)
          ], 2)),
          re(Gd, {
            ref_key: "dropdownRef",
            ref: d,
            type: C(),
            multiple: q.value,
            "is-open": c.value,
            inverse: e.inverse,
            search: e.innerSearch,
            categorized: e.categorizedSearch,
            "search-placeholder": e.searchPlaceholder,
            disabled: e.disabled,
            options: $.value,
            style: nt({ height: c.value ? "auto" : "" }),
            onOnSelect: x
          }, null, 8, ["type", "multiple", "is-open", "inverse", "search", "categorized", "search-placeholder", "disabled", "options", "style"])
        ], 10, BD)),
        e.loading ? (v(), me(Ft, {
          key: 1,
          inverse: e.inverse,
          type: "select"
        }, null, 8, ["inverse"])) : D("", !0)
      ], 2);
    };
  }
}, FD = Oe({
  name: "OrqSelectInline",
  components: {
    OrqIconContainer: Te,
    OrqDropdown: Gd,
    OrqShimmer: Ft
  },
  props: {
    labelPosition: {
      type: String,
      default: "left"
    },
    label: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    search: {
      type: Boolean,
      default: !1
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "default"
    },
    isOpen: {
      type: Boolean,
      default: !1
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    items: {
      type: Array,
      default: () => [],
      required: !0
    }
  },
  emits: ["onClick", "onClose"],
  setup(e, { emit: a }) {
    var M, F, P;
    const r = V(e.items), s = V(
      ((M = r.value.filter((x) => x == null ? void 0 : x.selected)) == null ? void 0 : M.length) === 1
    ), o = V(
      ((F = r.value.filter((x) => x == null ? void 0 : x.selected)) == null ? void 0 : F.length) > 1
    ), d = V(
      ((P = r.value.filter((x) => x == null ? void 0 : x.selected)) == null ? void 0 : P.length) + " Selecionados"
    ), u = V(Xe), f = V(e.isOpen), c = V(e.title), g = V(null), h = V([]);
    Tt(() => {
      r.value.map((x) => {
        x.selected && (c.value = x.title, h.value.push({ ...x }));
      });
    });
    const q = (x) => {
      var Y;
      const $ = r.value.findIndex((R) => R === x);
      r.value[$].selected = !1, r.value[0].selected = !0, h.value = [r.value[0]], c.value = x.title, c.value = (Y = h.value[0]) == null ? void 0 : Y.title, f.value = !1;
    }, C = (x) => {
      x !== r.value[0] && x === h.value[0] ? q(x) : (c.value = x.title, h.value = [x], f.value = !1);
    }, O = (x) => {
      var $;
      if (x.selected)
        c.value = x.title, h.value.push(x);
      else {
        const Y = h.value.findIndex(
          (R) => R.title === x.title
        );
        h.value.splice(Y, 1), c.value = ($ = h.value[0]) == null ? void 0 : $.title;
      }
    }, S = (x) => {
      e.multiple ? O(x) : C(x), a("onClick", x);
    }, I = () => {
      f.value = !f.value;
    };
    return Lt(() => {
      s.value = h.value.length === 1, o.value = h.value.length > 1, d.value = h.value.length + " Selecionados";
    }), Lt(() => {
      f.value = e.isOpen;
    }), Lt(() => {
      r.value = e.items;
    }), Xd(g, () => {
      f.value = !1, a("onClose");
    }), {
      selectInlineClass: B(() => ({
        "orq-select-inline": !0,
        "orq-select-inline--expanded": f.value,
        "orq-select-inline--inverse": e.inverse
      })),
      selectInlinePositionLabelclass: B(() => ({
        "orq-select-inline__field__label": !0,
        "orq-select-inline__field__label--right": e.labelPosition === "right"
      })),
      iconColor: B(() => e.inverse ? u.value.emphasisBaseInverseHigh : u.value.emphasisBaseHigh),
      isSingle: s,
      isMulti: o,
      selectedItems: d,
      handleSetIsOpened: I,
      currentTitle: c,
      isOpened: f,
      dataItems: r,
      clickHandler: S,
      options: h,
      selectInlineRef: g
    };
  }
}), ED = {
  key: 0,
  class: "orq-select-inline__field__text"
}, PD = {
  key: 1,
  class: "orq-select-inline__field__text"
}, zD = { class: "orq-select-inline__field__icon" }, RD = { id: "orq-select-inline-floating-action" };
function ND(e, a, r, s, o, d) {
  const u = ze("OrqShimmer"), f = ze("OrqIconContainer"), c = ze("OrqDropdown");
  return e.loading ? (v(), me(u, {
    key: 0,
    inverse: e.inverse,
    type: "select-inline"
  }, null, 8, ["inverse"])) : (v(), m("div", {
    key: 1,
    ref: "selectInlineRef",
    class: w(e.selectInlineClass)
  }, [
    y("div", {
      class: "orq-select-inline__field",
      role: "button",
      onClick: a[0] || (a[0] = (...g) => e.handleSetIsOpened && e.handleSetIsOpened(...g))
    }, [
      y("label", {
        class: w(e.selectInlinePositionLabelclass),
        htmlFor: "orq-select-inline-floating-action"
      }, ie(e.label), 3),
      e.isSingle ? (v(), m("p", ED, ie(e.currentTitle), 1)) : D("", !0),
      e.isMulti ? (v(), m("p", PD, ie(e.selectedItems), 1)) : D("", !0),
      y("div", zD, [
        re(f, {
          name: "chevron-down",
          type: "none",
          color: e.iconColor,
          size: 24
        }, null, 8, ["color"])
      ])
    ]),
    y("div", RD, [
      re(c, {
        "is-open": e.isOpened,
        type: e.type,
        inverse: e.inverse,
        search: e.search,
        options: e.dataItems,
        "search-placeholder": e.searchPlaceholder,
        multiple: e.multiple,
        style: nt({ height: e.isOpened ? "auto" : "" }),
        onOnSelect: e.clickHandler
      }, null, 8, ["is-open", "type", "inverse", "search", "options", "search-placeholder", "multiple", "style", "onOnSelect"])
    ])
  ], 2));
}
const v4 = /* @__PURE__ */ ae(FD, [["render", ND]]), Xt = {
  small: "small",
  large: "large",
  full: "full"
}, HD = ["href"], VD = { class: "shortcut__top" }, YD = { class: "shortcut__badges" }, UD = { class: "shortcut__icon" }, WD = {
  __name: "Shortcut",
  props: {
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "pix"
    },
    dashed: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: Xt.small,
      validator: (e) => Object.keys(Xt).includes(e)
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    href: {
      type: String,
      default: "#"
    }
  },
  setup(e) {
    const a = e;
    return (r, s) => (v(), m("a", {
      href: e.href,
      class: w(["shortcut", {
        "shortcut--dashed": e.dashed,
        "shortcut--disabled": e.disabled,
        "shortcut--large": e.size === tt(Xt).large,
        "shortcut--full": e.size === tt(Xt).full,
        "shortcut--inverse": e.inverse === !0
      }])
    }, [
      y("div", VD, [
        y("div", YD, [
          we(r.$slots, "badges", {}, void 0, !0)
        ]),
        y("div", UD, [
          we(r.$slots, "icon", {}, () => [
            re(Te, {
              name: a.icon,
              color: "primary-base",
              size: e.size === tt(Xt).small ? 24 : 32
            }, null, 8, ["name", "size"])
          ], !0)
        ])
      ]),
      y("div", {
        class: w(["shortcut__content", {
          "shortcut__content--large": [
            tt(Xt).large,
            tt(Xt).full
          ].includes(e.size)
        }])
      }, [
        e.label ? (v(), m("div", {
          key: 0,
          class: w([{
            "body-sm": e.size === tt(Xt).small,
            "heading-md": [
              tt(Xt).large,
              tt(Xt).full
            ].includes(e.size)
          }, "shortcut__label"])
        }, ie(e.label), 3)) : D("", !0),
        e.description ? (v(), m("div", {
          key: 1,
          class: w(["shortcut__description", {
            "caption-xs": e.size === tt(Xt).small,
            "body-sm": [
              tt(Xt).large,
              tt(Xt).full
            ].includes(e.size)
          }])
        }, ie(e.description), 3)) : D("", !0)
      ], 2)
    ], 10, HD));
  }
}, p4 = /* @__PURE__ */ ae(WD, [["__scopeId", "data-v-31887973"]]), GD = { class: "single-accordion" }, ZD = { class: "single-accordion__header" }, KD = { class: "single-accordion__icon" }, XD = { key: 0 }, JD = {
  __name: "SingleAccordion",
  props: {
    title: {
      type: String,
      default: "Default title"
    },
    startOpen: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = V(!1), r = e;
    return vt(
      () => r.startOpen,
      () => {
        a.value = r.startOpen;
      },
      {
        immediate: !0
      }
    ), (s, o) => (v(), m("div", GD, [
      y("div", {
        onClick: o[0] || (o[0] = (d) => a.value = !a.value)
      }, [
        we(s.$slots, "header", { isOpen: a.value }, () => [
          y("div", ZD, [
            y("div", null, ie(e.title), 1),
            y("div", KD, [
              re(Te, {
                size: 24,
                name: a.value ? "chevron-up" : "chevron-down"
              }, null, 8, ["name"])
            ])
          ])
        ], !0)
      ]),
      re(Aa, { name: "slide" }, {
        default: dt(() => [
          a.value ? (v(), m("div", XD, [
            we(s.$slots, "default", {}, void 0, !0)
          ])) : D("", !0)
        ]),
        _: 3
      })
    ]));
  }
}, h4 = /* @__PURE__ */ ae(JD, [["__scopeId", "data-v-1b1e5136"]]);
var Vi = /* @__PURE__ */ ((e) => (e.emphasisBaseLow = "emphasis-base-low", e.emphasisBaseMedium = "emphasis-base-medium", e.emphasisBaseHigh = "emphasis-base-high", e.emphasisBaseDisabled = "emphasis-base-disabled", e.emphasisBaseInverseLow = "emphasis-base-low-inverse", e.emphasisBaseInverseMedium = "emphasis-base-medium-inverse", e.emphasisBaseInverseHigh = "emphasis-base-high-inverse", e.emphasisBaseInverseDisabled = "emphasis-base-disabled-inverse", e.emphasisBaseMedium70 = "emphasis-base-medium-70", e.primaryBase = "primary-base", e.primaryBaseInverse = "primary-base-inverse", e.statusError = "status-error", e.statusErrorInverse = "status-error-inverse", e.statusSuccess = "status-success", e.statusSuccessInverse = "status-success-inverse", e.statusInformative = "status-informative", e.statusInformativeInverse = "status-informative-inverse", e.statusWarning = "status-warning", e.statusWarningInverse = "status-warning-inverse", e))(Vi || {});
const QD = Oe({
  name: "OrqTabHeader",
  components: {
    OrqIconContainer: Te,
    OrqImageContainer: Ta,
    OrqTooltip: Vd
  },
  props: {
    inverse: {
      type: Boolean,
      default: !1
    },
    active: {
      type: Boolean,
      default: !0
    },
    iconName: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    value: {
      type: Number,
      default: 0
    },
    imagePath: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: ""
    },
    labelTootip: {
      type: String,
      default: ""
    },
    tooltipIconColor: {
      type: String,
      default: ""
    },
    orientation: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const a = V(Vi);
    return {
      orqTabsActive: B(() => ({
        "orq-tabs__tab": !0,
        "orq-tabs__tab--active": e.active,
        [`orq-tabs__tab--${e.orientation}`]: e.orientation,
        "orq-tabs--inverse": e.inverse
      })),
      iconColor: B(() => ({
        iconInverseColor: e.inverse ? a.value.emphasisBaseHigh : a.value.emphasisBaseInverseHigh
      }))
    };
  }
}), jD = {
  key: 0,
  class: "orq-tabs__tab__image"
}, e3 = {
  key: 1,
  class: "orq-tabs__tab__icon"
}, t3 = { class: "orq-tabs__tab__text" }, n3 = {
  key: 2,
  class: "orq-tabs__tab__tooltip"
}, r3 = { class: "orq-tabs__tab__icon" };
function a3(e, a, r, s, o, d) {
  const u = ze("OrqImageContainer"), f = ze("OrqIconContainer"), c = ze("OrqTooltip");
  return v(), m("div", {
    class: w(e.orqTabsActive)
  }, [
    e.imagePath ? (v(), m("div", jD, [
      re(u, {
        src: e.imagePath,
        size: 24,
        inverse: e.inverse,
        alt: e.alt
      }, null, 8, ["src", "inverse", "alt"])
    ])) : D("", !0),
    e.iconName ? (v(), m("div", e3, [
      re(f, {
        name: e.iconName,
        size: 24,
        color: e.iconColor,
        inverse: e.inverse
      }, null, 8, ["name", "color", "inverse"])
    ])) : D("", !0),
    y("span", t3, ie(e.label), 1),
    e.labelTootip && e.orientation === "horizontal" ? (v(), m("div", n3, [
      re(c, {
        inverse: e.inverse,
        trigger: "hover",
        placement: "right",
        label: e.labelTootip
      }, {
        default: dt(() => [
          y("div", r3, [
            e.labelTootip ? (v(), me(f, {
              key: 0,
              inverse: e.inverse,
              name: "info",
              size: 24,
              color: e.tooltipIconColor
            }, null, 8, ["inverse", "color"])) : D("", !0)
          ])
        ]),
        _: 1
      }, 8, ["inverse", "label"])
    ])) : D("", !0)
  ], 2);
}
const i3 = /* @__PURE__ */ ae(QD, [["render", a3]]);
function s3(e, a) {
  if (!e) return;
  const r = (s) => {
    s.target !== e.value && s.composedPath().includes(e.value) || typeof a == "function" && a(s);
  };
  return Tt(() => {
    window.addEventListener("click", r);
  }), _o(() => {
    window.removeEventListener("click", r);
  }), { listener: r };
}
const o3 = Oe({
  name: "OrqTabShowMore",
  components: {
    OrqFloatingAction: Kk,
    OrqFloatingActionItem: tq
  },
  props: {
    tabItems: {
      type: Array,
      default: () => []
    },
    inverse: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["onSelected"],
  setup(e, { emit: a }) {
    const r = V(!1);
    let s = V();
    s3(s, () => {
      r.value, r.value = !1;
    });
    const o = () => {
      r.value = !r.value;
    }, d = (f, c) => {
      a("onSelected", { item: f, index: c });
    }, u = V(Vi);
    return {
      tabActionRef: s,
      elRef: r,
      onClick: d,
      showMore: o,
      showmoreClass: B(() => ({
        "orq-tabs__tab": !1,
        "orq-tabs--inverse": e.inverse
      })),
      iconColor: B(() => ({
        iconInverseColor: e.inverse ? u.value.emphasisBaseHigh : u.value.emphasisBaseInverseHigh
      }))
    };
  }
}), l3 = /* @__PURE__ */ y("span", { class: "orq-tabs__tab__text" }, "...Ver mais ", -1), u3 = /* @__PURE__ */ y("span", { class: "orq-tabs__line" }, null, -1), c3 = /* @__PURE__ */ y("span", { class: "orq-tabs__line--selected" }, null, -1);
function d3(e, a, r, s, o, d) {
  const u = ze("OrqFloatingActionItem"), f = ze("OrqFloatingAction");
  return v(), m("div", {
    class: w(e.showmoreClass),
    onClick: a[0] || (a[0] = (...c) => e.showMore && e.showMore(...c))
  }, [
    l3,
    y("div", null, [
      re(f, {
        ref: "tabActionRef",
        "is-open": e.elRef,
        inverse: e.inverse
      }, {
        default: dt(() => [
          (v(!0), m(ce, null, Re(e.tabItems, (c, g) => (v(), me(u, {
            key: g,
            selected: c.active,
            inverse: e.inverse,
            "icon-name": c.iconName || c.imagePath,
            label: c.label,
            "tab-index": g,
            onClick: (h) => e.onClick(c, g)
          }, null, 8, ["selected", "inverse", "icon-name", "label", "tab-index", "onClick"]))), 128))
        ]),
        _: 1
      }, 8, ["is-open", "inverse"])
    ]),
    u3,
    c3
  ], 2);
}
const f3 = /* @__PURE__ */ ae(o3, [["render", d3]]), v3 = Oe({
  name: "OrqTab",
  components: {
    OrqTabHeader: i3,
    OrqTabShowMore: f3,
    OrqShimmer: Ft
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    orientation: {
      type: String,
      default: ""
    },
    maxShowingTabs: {
      type: Number,
      default: 5
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    orqTabItem: {
      type: Array,
      default: () => []
    },
    noPadding: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["changeTab"],
  setup(e, { slots: a, emit: r }) {
    const s = it({
      selectedIndex: 0,
      tabs: [],
      count: 0
    });
    T0("TabsProvider", s);
    const o = (q) => {
      s.selectedIndex = q;
      const C = s.tabs.map((O, S) => ({
        ...O,
        props: { ...O.props, active: q === S }
      }));
      s.tabs = [...C], r("changeTab", s);
    }, d = () => s.tabs.slice(
      e.maxShowingTabs,
      s.tabs.length - 1
    ).map((O) => ({
      ...O.props
    }));
    Fi(() => {
      a.default && (a.default()[0].children.default ? s.tabs = a.default().filter(
        (q) => q.type.name === "OrqTabItem"
      ) : s.tabs = a.default()[0].children.filter(
        (q) => q.type.name === "OrqTabItem"
      ));
    }), Tt(() => {
      s.selectedIndex = 0;
    });
    const u = V(e.maxShowingTabs), f = V(Vi), c = B(() => ({
      "orq-tabs__tab": !0,
      "orq-tabs__tab--active": s.selectedIndex >= u.value,
      "orq-tabs--inverse": e.inverse
    })), g = B(() => ({
      "orq-tabs": !0,
      "orq-tabs--inverse": e.inverse
    })), h = B(() => ({
      iconInverseColor: e.inverse ? f.value.emphasisBaseHigh : f.value.emphasisBaseInverseHigh
    }));
    return {
      ...Wc(s),
      selectTab: o,
      showMore: d,
      orqTabsActive: c,
      orqTabClass: g,
      iconColor: h
    };
  }
}), p3 = { class: "orq-tabs__header tab" };
function h3(e, a, r, s, o, d) {
  const u = ze("OrqShimmer"), f = ze("OrqTabHeader"), c = ze("OrqTabShowMore");
  return v(), m(ce, null, [
    e.loading ? (v(), me(u, {
      key: 0,
      type: "tab",
      inverse: e.inverse,
      "tab-items": e.maxShowingTabs
    }, null, 8, ["inverse", "tab-items"])) : D("", !0),
    e.loading ? D("", !0) : (v(), m("div", {
      key: 1,
      class: w(e.orqTabClass)
    }, [
      y("div", p3, [
        (v(!0), m(ce, null, Re(e.tabs.slice(0, e.maxShowingTabs), (g, h) => (v(), me(f, {
          key: h,
          class: "orq-tabs__tab--active-bar",
          label: g.props.label,
          value: 0,
          active: g.props.active,
          alt: g.props.alt,
          "image-path": g.props.imagePath ?? g.props.imagePath,
          "icon-name": g.props.iconName ?? g.props.iconName,
          "label-tootip": g.props.labelTootip ?? g.props.labelTootip,
          "tooltip-icon-color": g.props.tooltipIconColor ?? g.props.tooltipIconColor,
          inverse: e.inverse,
          orientation: e.orientation,
          onClick: (q) => e.selectTab(h),
          onIsSelect: g.props.active
        }, null, 8, ["label", "active", "alt", "image-path", "icon-name", "label-tootip", "tooltip-icon-color", "inverse", "orientation", "onClick", "onIsSelect"]))), 128)),
        e.maxShowingTabs < e.tabs.length ? (v(), m("div", {
          key: 0,
          class: w(["orq-tabs__tab--active-bar", e.orqTabsActive]),
          onClick: a[1] || (a[1] = (...g) => e.showMore && e.showMore(...g))
        }, [
          re(c, {
            inverse: e.inverse,
            "tab-items": e.showMore(),
            onOnSelected: a[0] || (a[0] = (g) => e.selectTab(g.index + e.maxShowingTabs))
          }, null, 8, ["inverse", "tab-items"])
        ], 2)) : D("", !0)
      ]),
      e.loading ? D("", !0) : (v(), m("div", {
        key: 0,
        class: w(["orq-tabs__body", { "orq-tabs__body--no-padding": e.noPadding }])
      }, [
        we(e.$slots, "default")
      ], 2))
    ], 2))
  ], 64);
}
const g4 = /* @__PURE__ */ ae(v3, [["render", h3]]), g3 = Oe({
  name: "OrqTabItem",
  setup() {
    const e = V(0), a = V(!1), r = O0("TabsProvider");
    return vt(
      () => r.selectedIndex,
      () => {
        a.value = e.value === r.selectedIndex;
      }
    ), Fi(() => {
      e.value = r.count, r.count++, a.value = e.value === r.selectedIndex;
    }), { index: e, isActive: a };
  }
});
function m3(e, a, r, s, o, d) {
  return Kr((v(), m("div", null, [
    we(e.$slots, "default")
  ], 512)), [
    [bo, e.isActive]
  ]);
}
const m4 = /* @__PURE__ */ ae(g3, [["render", m3]]), y3 = {
  __name: "TabsItem",
  props: {
    label: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    active: {
      type: Boolean,
      default: !1
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "",
      validator: (e) => ["full", ""].includes(e)
    },
    compact: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = e, r = B(
      () => a.inverse ? "secondary-base-inverse" : "secondary-base"
    );
    return (s, o) => (v(), m("div", {
      class: w([{ active: e.active, inverse: e.inverse, compact: e.compact, "full-width": e.size === "full" }, "tab-item pointer"])
    }, [
      e.icon !== null ? (v(), m("div", {
        key: 0,
        style: nt({ color: `var(--${r.value})` })
      }, [
        re(Te, {
          inverse: e.inverse,
          name: e.icon,
          size: 24
        }, null, 8, ["inverse", "name"])
      ], 4)) : D("", !0),
      _n(" " + ie(e.label), 1)
    ], 2));
  }
}, b3 = /* @__PURE__ */ ae(y3, [["__scopeId", "data-v-47f0fd48"]]), _3 = { class: "tab" }, w3 = ["onClick"], $3 = {
  __name: "TabsMain",
  props: {
    modelValue: {
      type: Number,
      default: 0
    },
    items: {
      type: Array,
      default: () => []
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "",
      validator: (e) => ["full", ""].includes(e)
    },
    compact: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const r = a, s = e, o = B(() => [...s.items]), d = B(() => o.value[s.modelValue]);
    return vt(
      () => s.modelValue,
      (u, f) => {
        o.value[f] = {
          ...o.value[f],
          active: !1
        }, o.value[u] = {
          ...d.value,
          active: !0
        };
      },
      { immediate: !0 }
    ), (u, f) => (v(), m("div", _3, [
      y("div", {
        class: w(["tab--item-container", { inverse: e.inverse, "full-width": e.size === "full" }])
      }, [
        (v(!0), m(ce, null, Re(o.value, (c, g) => (v(), m("div", {
          key: c.id,
          style: nt({ width: e.size === "full" ? "inherit" : "" }),
          onClick: (h) => r("update:modelValue", g)
        }, [
          we(u.$slots, "default", {
            item: c,
            index: g,
            active: c.active,
            inverse: e.inverse
          }, () => [
            re(b3, {
              active: c.active,
              label: c.label,
              icon: c.icon,
              inverse: e.inverse,
              size: e.size,
              compact: e.compact
            }, null, 8, ["active", "label", "icon", "inverse", "size", "compact"])
          ], !0)
        ], 12, w3))), 128))
      ], 2)
    ]));
  }
}, y4 = /* @__PURE__ */ ae($3, [["__scopeId", "data-v-537a796e"]]), C3 = {
  name: "Light Btg Theme",
  properties: {
    // Colors in Figma
    "--primary-base": "#195AB4",
    "--primary-base-inverse": "#195AB4",
    "--primary-extended-10": "#D2E5FF",
    "--primary-extended-20": "#B1D2FF",
    "--primary-extended-30": "#87BAFF",
    "--primary-extended-40": "#6BAAFF",
    "--primary-extended-50": "#549CFF",
    "--primary-extended-60": "#307AE0",
    "--primary-extended-70": "#195AB4",
    "--primary-extended-80": "#10408D",
    "--primary-extended-90": "#0B2859",
    "--primary-extended-100": "#05132A",
    "--secondary-base": "#10408D",
    "--secondary-base-inverse": "#87BAFF",
    "--neutral-base": "#FFFFFF",
    "--neutral-base-inverse": "#1F2023",
    "--neutral-extended-10": "#FFFFFF",
    "--neutral-extended-20": "#F5F6F9",
    "--neutral-extended-30": "#D7DBDF",
    "--neutral-extended-40": "#B8BEC4",
    "--neutral-extended-50": "#959CA2",
    "--neutral-extended-60": "#61686E",
    "--neutral-extended-70": "#464C51",
    "--neutral-extended-80": "#34383C",
    "--neutral-extended-90": "#272A2E",
    "--neutral-extended-100": "#1B1E20",
    "--action-main-enabled": "#195AB4",
    "--action-main-hover": "#3E75C0",
    "--action-main-focus": "#195AB4",
    "--action-main-pressed": "#134489",
    "--action-main-selected": "#307AE0",
    "--action-main-enabled-inverse": "#195AB4",
    "--action-main-hover-inverse": "#3E75C0",
    "--action-main-focus-inverse": "#195AB4",
    "--action-main-pressed-inverse": "#134489",
    "--action-main-selected-inverse": "#307AE0",
    "--action-secondary-enabled": "#10408D",
    "--action-secondary-hover": "#234F96",
    "--action-secondary-focus": "#10408D",
    "--action-secondary-pressed": "#0C316B",
    "--action-secondary-selected": "#307AE0",
    "--action-secondary-enabled-inverse": "#87BAFF",
    "--action-secondary-hover-inverse": "#90BFFF",
    "--action-secondary-focus-inverse": "#87BAFF",
    "--action-secondary-pressed-inverse": "#719CD6",
    "--action-secondary-selected-inverse": "#549CFF",
    "--action-neutral-enabled": "#FFFFFF",
    "--action-neutral-hover": "#D6D6D6",
    "--action-neutral-focus": "#FFFFFF",
    "--action-neutral-pressed": "#C2C2C2",
    "--action-neutral-selected": "#FFFFFF",
    "--action-neutral-disabled": "#FFFFFF",
    "--action-neutral-enabled-inverse": "#1F2023",
    "--action-neutral-hover-inverse": "#373737",
    "--action-neutral-focus-inverse": "#1F2023",
    "--action-neutral-pressed-inverse": "#292929",
    "--action-neutral-selected-inverse": "#404040",
    "--action-neutral-disabled-inverse": "#1F2023",
    "--action-base-disabled": "#E2E2E3",
    "--action-base-outline-disabled": "#BEBEBF",
    "--action-base-disabled-inverse": "",
    "--action-base-outline-disabled-inverse": "#FFFFFF4D",
    "--on-color-emphasis-high": "#000000",
    "--on-color-emphasis-medium": "#000000b3",
    "--on-color-emphasis-low": "#00000080",
    "--on-color-emphasis-disabled": "#0000004D",
    "--on-color-emphasis-high-inverse": "#FFFFFF",
    "--on-color-emphasis-medium-inverse": "#FFFFFFB3",
    "--on-color-emphasis-low-inverse": "#FFFFFF80",
    "--on-color-emphasis-disabled-inverse": "#FFFFFF4D",
    "--on-color-emphasis-indicator-highlight-surface": "#D2E5FF",
    "--on-color-emphasis-indicator-highlight-text": "#0B2859",
    "--on-color-emphasis-indicator-highlight-inverse": "#0B2859",
    "--on-color-emphasis-indicator-highlight-text-inverse": "#D2E5FF",
    "--on-color-emphasis-indicator-positive-surface": "#62C395",
    "--on-color-emphasis-indicator-positive-text": "#128850",
    "--on-color-emphasis-indicator-positive-inverse": "#128850",
    "--on-color-emphasis-indicator-positive-text-inverse": "#62C395",
    "--on-color-emphasis-indicator-negative-surface": "#F2757C",
    "--on-color-emphasis-indicator-negative-text": "#CE363F",
    "--on-color-emphasis-indicator-negative-inverse": "#CE363F",
    "--on-color-emphasis-indicator-negative-text-inverse": "#F2757C",
    "--status-success-base": "#159E5C",
    "--status-success-base-surface": "#DAECE5",
    "--status-success-base-inverse": "#62C395",
    "--status-success-base-surface-inverse": "#106A40",
    "--status-warning-base": "#F05800",
    "--status-warning-base-surface": "#FFE7CC",
    "--status-warning-base-inverse": "#FF8752",
    "--status-warning-base-surface-inverse": "#884426",
    "--status-error-base": "#EB3D47",
    "--status-error-base-surface": "#FFDBDD",
    "--status-error-base-inverse": "#F76970",
    "--status-error-base-surface-inverse": "#8B2328",
    "--status-informative-base": "#1F7DFF",
    "--status-informative-base-surface": "#D2E5FF",
    "--status-informative-base-inverse": "#4795FF",
    "--status-informative-base-surface-inverse": "#113D88",
    "--outline-base": "#00000029",
    "--outline-base-inverse": "#FFFFFF29",
    "--outline-base-focus": "#A02795",
    "--outline-base-focus-inverse": "#F217DE",
    "--background-base": "#F5F5F6",
    "--background-base-inverse": "#101010",
    "--support-blue-10": "#D2E5FF",
    "--support-blue-20": "#B1D2FF",
    "--support-blue-30": "#87BAFF",
    "--support-blue-40": "#6BAAFF",
    "--support-blue-50": "#549CFF",
    "--support-blue-60": "#307AE0",
    "--support-blue-70": "#195AB4",
    "--support-blue-80": "#174E9F",
    "--support-blue-90": "#123570",
    "--support-blue-100": "#0B2859",
    "--support-aqua-10": "#D8F0F5",
    "--support-aqua-20": "#BEE6EE",
    "--support-aqua-30": "#87D0DF",
    "--support-aqua-40": "#5ABED3",
    "--support-aqua-50": "#45B6CD",
    "--support-aqua-60": "#329FB5",
    "--support-aqua-70": "#328495",
    "--support-aqua-80": "#2F7482",
    "--support-aqua-90": "#29636E",
    "--support-aqua-100": "#22515A",
    "--support-lime-10": "#EEFBE0",
    "--support-lime-20": "#DAEFC3",
    "--support-lime-30": "#BCDC98",
    "--support-lime-40": "#9BC868",
    "--support-lime-50": "#7EB63E",
    "--support-lime-60": "#6BAA23",
    "--support-lime-70": "#629C20",
    "--support-lime-80": "#53821B",
    "--support-lime-90": "#416616",
    "--support-lime-100": "#395913",
    "--support-green-10": "#E7F3EE",
    "--support-green-20": "#D0EBDF",
    "--support-green-30": "#9DD8BC",
    "--support-green-40": "#62C395",
    "--support-green-50": "#2DB071",
    "--support-green-60": "#149A5A",
    "--support-green-70": "#128850",
    "--support-green-80": "#107444",
    "--support-green-90": "#0E613A",
    "--support-green-100": "#0D5734",
    "--support-orange-10": "#FFD8C7",
    "--support-orange-20": "#FFC7AE",
    "--support-orange-30": "#FFAB86",
    "--support-orange-40": "#FF905E",
    "--support-orange-50": "#FF7E44",
    "--support-orange-60": "#EF7640",
    "--support-orange-70": "#C46135",
    "--support-orange-80": "#9F4F2B",
    "--support-orange-90": "#783C21",
    "--support-orange-100": "#5D2F1A",
    "--support-yellow-10": "#FFF5DA",
    "--support-yellow-20": "#FFEAB5",
    "--support-yellow-30": "#FFDF8C",
    "--support-yellow-40": "#FFD15B",
    "--support-yellow-50": "#FFCA43",
    "--support-yellow-60": "#E8B73D",
    "--support-yellow-70": "#C79C34",
    "--support-yellow-80": "#A37E2B",
    "--support-yellow-90": "#795C20",
    "--support-yellow-100": "#674D1B",
    "--support-red-10": "#FFE5E6",
    "--support-red-20": "#FCCACC",
    "--support-red-30": "#F79EA3",
    "--support-red-40": "#F2757C",
    "--support-red-50": "#ED515A",
    "--support-red-60": "#EB3E48",
    "--support-red-70": "#CE363F",
    "--support-red-80": "#A92C33",
    "--support-red-90": "#7A1F24",
    "--support-red-100": "#60181C",
    "--support-pink-10": "#F1E5ED",
    "--support-pink-20": "#EBD4E3",
    "--support-pink-30": "#DEABCD",
    "--support-pink-40": "#D289BA",
    "--support-pink-50": "#C768A7",
    "--support-pink-60": "#C0549C",
    "--support-pink-70": "#A94A89",
    "--support-pink-80": "#853B6C",
    "--support-pink-90": "#5E2A4D",
    "--support-pink-100": "#49213C",
    "--support-violet-10": "#E6E2F0",
    "--support-violet-20": "#D6CDEA",
    "--support-violet-30": "#BCABE0",
    "--support-violet-40": "#9B80D4",
    "--support-violet-50": "#8562CB",
    "--support-violet-60": "#754CC5",
    "--support-violet-70": "#6A46B2",
    "--support-violet-80": "#563B90",
    "--support-violet-90": "#3D2D66",
    "--support-violet-100": "#322652",
    "--support-purple-10": "#D2D7F0",
    "--support-purple-20": "#C0C6EB",
    "--support-purple-30": "#9BA3E0",
    "--support-purple-40": "#7B84D6",
    "--support-purple-50": "#5B66CD",
    "--support-purple-60": "#4854C7",
    "--support-purple-70": "#3B46AF",
    "--support-purple-80": "#232D84",
    "--support-purple-90": "#111962",
    "--support-purple-100": "#091051",
    "--support-brown-10": "#EDE7E4",
    "--support-brown-20": "#E4D9D3",
    "--support-brown-30": "#D0B8AD",
    "--support-brown-40": "#BE9989",
    "--support-brown-50": "#AA7A64",
    "--support-brown-60": "#9E664D",
    "--support-brown-70": "#8D5A43",
    "--support-brown-80": "#714733",
    "--support-brown-90": "#533122",
    "--support-brown-100": "#3A2014",
    "--support-grey-10": "#F2F2F2",
    "--support-grey-20": "#E5E5E5",
    "--support-grey-30": "#CACACA",
    "--support-grey-40": "#B2B2B2",
    "--support-grey-50": "#9A9A9A",
    "--support-grey-60": "#909090",
    "--support-grey-70": "#808080",
    "--support-grey-80": "#626262",
    "--support-grey-90": "#484848",
    "--support-grey-100": "#373737",
    "--special-colors-fixed-white": "#FFFFFF",
    "--special-fixed-black": "#000000",
    //// Not In Figma
    "--main-state-enabled": "#195ab4ff",
    "--main-state-hover": "#5081c6ff",
    "--main-state-focus": "#195ab4ff",
    "--main-state-pressed": "#134489ff",
    "--main-state-selected": "#195ab4ff",
    "--main-state-disabled": "#ebebebff",
    "--main-state-enabled-inverse": "#b1d2ffff",
    "--main-state-hover-inverse": "#c4ddffff",
    "--main-state-focus-inverse": "#b1d2ffff",
    "--main-state-pressed-inverse": "#87a0c2ff",
    "--main-state-selected-inverse": "#b1d2ffff",
    "--main-state-disabled-inverse": "#1e3966ff",
    "--secondary-state-enabled": "#0fa5adff",
    "--secondary-state-hover": "#48bbc1ff",
    "--secondary-state-focus": "#0fa5adff",
    "--secondary-state-pressed": "#0b7e84ff",
    "--secondary-state-selected": "#0fa5adff",
    "--secondary-state-disabled": "#ebebebff",
    "--secondary-state-enabled-inverse": "#8cedf2ff",
    "--secondary-state-hover-inverse": "#a8f1f5ff",
    "--secondary-state-focus-inverse": "#8cedf2ff",
    "--secondary-state-pressed-inverse": "#6bb4b8ff",
    "--secondary-state-selected-inverse": "#8cedf2ff",
    "--secondary-state-disabled-inverse": "#1e3966ff",
    "--neutral-state-enabled": "#ffffffff",
    "--neutral-state-hover": "#ebebebff",
    "--neutral-state-focus": "#ffffffff",
    "--neutral-state-pressed": "#c2c2c2ff",
    "--neutral-state-selected": "#ffffffff",
    "--neutral-state-disabled": "#ebebebff",
    "--neutral-state-enabled-inverse": "#0b2859ff",
    "--neutral-state-hover-inverse": "#1e3966ff",
    "--neutral-state-focus-inverse": "#0b2859ff",
    "--neutral-state-pressed-inverse": "#071b3cff",
    "--neutral-state-selected-inverse": "#0b2859ff",
    "--neutral-state-disabled-inverse": "#1e3966ff",
    "--emphasis-base-high": "#000000ff",
    "--emphasis-base-medium": "#000000b3",
    "--emphasis-base-low": "#00000080",
    "--emphasis-base-disabled": "#0000004d",
    "--emphasis-base-high-inverse": "#ffffffff",
    "--emphasis-base-medium-inverse": "#ffffffb3",
    "--emphasis-base-low-inverse": "#ffffff80",
    "--emphasis-base-disabled-inverse": "#ffffff4d",
    "--neutral-base-selected": "#307AE0",
    "--neutral-base-selected-hover": "#2e65ad",
    "--neutral-base-disabled": "#E2E2E3",
    "--neutral-base-hover": "#D6D6D6",
    "--neutral-base-inverse-light": "#549CFF",
    "--neutral-base-inverse-hover-light": "#72afff",
    "--outline": "#0000001a",
    "--outline-inverse": "#ffffff1a",
    "--outline-focus": "#a02795ff",
    "--outline-focus-inverse": "#f217deff",
    "--success": "var(--status-success-base)",
    "--success-surface": "var(--status-success-base-surface)",
    "--success-inverse": "var(--status-success-base-inverse)",
    "--success-surface-inverse": "var(--status-success-base-surface-inverse)",
    "--warning": "var(--status-warning-base)",
    "--warning-surface": "var(--status-warning-base-surface)",
    "--warning-inverse": "var(--status-warning-base-inverse)",
    "--warning-surface-inverse": "var(--status-warning-base-surface-inverse)",
    "--error": "var(--status-error-base-surface-inverse)",
    "--error-surface": "var(--status-error-base-surface-inverse)",
    "--error-inverse": "var(--status-error-base-surface-inverse)",
    "--error-surface-inverse": "var(--status-error-base-surface-inverse)",
    "--informative": "var(--status-informative-base-surface-inverse)",
    "--informative-surface": "var(--status-informative-base-surface-inverse)",
    "--informative-inverse": "var(--status-informative-base-surface-inverse)",
    "--informative-surface-inverse": "var(--status-informative-base-surface-inverse)",
    "--fixed-white": "#ffffffff",
    "--fixed-black": "#000000ff"
  }
}, b4 = {
  __name: "Theme",
  setup(e) {
    const a = B(() => C3.properties);
    return (r, s) => (v(), m("div", {
      style: nt(a.value)
    }, [
      we(r.$slots, "default")
    ], 4));
  }
}, S3 = { class: "toast__body" }, k3 = { class: "body-baseline" }, q3 = { class: "toast__close-button" }, D3 = { class: "toast__message" }, B3 = { class: "toast__message__content" }, A3 = {
  __name: "Toast",
  props: {
    title: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    link: {
      type: String,
      default: ""
    },
    href: {
      type: String,
      default: ""
    },
    kind: {
      type: String,
      default: "placeholder",
      validator: (e) => Object.keys(Oi).includes(e)
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    show: {
      type: Boolean,
      default: !0
    },
    zIndex: {
      type: Number,
      default: 9999
    },
    offsetTop: {
      type: Number,
      default: 10
    },
    position: {
      type: String,
      default: "center",
      validator: (e) => ["left", "right", "center"].includes(e)
    }
  },
  emits: ["close", "callback"],
  setup(e, { emit: a }) {
    const r = e, s = a, o = V(Oi), d = B(() => r.kind ? o.value[r.kind] : o.value.placeholder), u = B(() => r.kind === "info" ? "informative" : r.kind), f = B(() => `bg--status-${u.value}-base-surface${r.inverse ? "-inverse" : ""}`), c = B(() => `text--status-${u.value}-base${r.inverse ? "-inverse" : ""}`), g = B(
      () => r.iconName ? r.iconName : d.value.icon.name
    ), h = B(() => `toast--${r.position}`);
    return (q, C) => (v(), m("div", {
      class: w(["toast", [f.value, h.value]]),
      style: nt({ zIndex: e.zIndex, top: `${e.offsetTop}px` })
    }, [
      g.value ? (v(), m("div", {
        key: 0,
        class: w(c.value)
      }, [
        re(Te, {
          name: g.value,
          size: 24
        }, null, 8, ["name"])
      ], 2)) : D("", !0),
      y("div", S3, [
        e.title ? (v(), m("div", {
          key: 0,
          class: w(["toast__header", {
            "text--emphasis-base-high": !e.inverse,
            "text--emphasis-base-high-inverse": e.inverse
          }])
        }, [
          y("h1", k3, ie(e.title), 1),
          y("div", q3, [
            re(Te, {
              name: "close",
              size: 24,
              onClick: C[0] || (C[0] = (O) => s("close"))
            })
          ])
        ], 2)) : D("", !0),
        y("div", D3, [
          y("div", B3, [
            e.message ? (v(), m("div", {
              key: 0,
              class: w(["body-sm", {
                "text--emphasis-base-medium": !e.inverse,
                "text--emphasis-base-medium-inverse": e.inverse
              }])
            }, ie(e.message), 3)) : D("", !0),
            e.link ? (v(), me(Ri, {
              key: 1,
              href: e.href,
              label: e.link,
              inverse: e.inverse,
              icon: "default",
              onClick: C[1] || (C[1] = () => {
                s("close"), s("callback");
              })
            }, null, 8, ["href", "label", "inverse"])) : D("", !0)
          ]),
          y("div", {
            class: w(["toast__close-button", {
              "text--emphasis-base-high": !e.inverse,
              "text--emphasis-base-high-inverse": e.inverse
            }])
          }, [
            e.title ? D("", !0) : (v(), me(Te, {
              key: 0,
              name: "close",
              size: 24,
              onClick: C[2] || (C[2] = (O) => s("close"))
            }))
          ], 2)
        ])
      ])
    ], 6));
  }
}, _4 = /* @__PURE__ */ ae(A3, [["__scopeId", "data-v-4b8ba7f1"]]);
export {
  Hr as FORMAT_PRESETS,
  M3 as OrqAccordion,
  N0 as OrqAccordionHeader,
  x3 as OrqAmount,
  hd as OrqAvatar,
  gd as OrqBadge,
  L3 as OrqBadgeStatus,
  F3 as OrqBanner,
  E3 as OrqBreadcrumb,
  wo as OrqBullet,
  wa as OrqButton,
  P3 as OrqButtonGroup,
  mS as OrqCalendar,
  z3 as OrqCard,
  R3 as OrqCardBody,
  N3 as OrqCarousel,
  H3 as OrqChartArea,
  V3 as OrqChartGauge,
  Ro as OrqCheckbox,
  mo as OrqColumn,
  Y3 as OrqContentSwitcher,
  Xc as OrqCounter,
  No as OrqDivider,
  U3 as OrqDrawer,
  YS as OrqDrawerBody,
  W3 as OrqDrawerFooter,
  KS as OrqDrawerHeader,
  Gd as OrqDropdown,
  G3 as OrqEmptyState,
  Z3 as OrqEmptyStateTable,
  K3 as OrqFileUploader,
  Zk as OrqFlex,
  Kk as OrqFloatingAction,
  tq as OrqFloatingActionItem,
  X3 as OrqFloatingSummary,
  J3 as OrqGrid,
  Q3 as OrqHero,
  Te as OrqIconContainer,
  Ta as OrqImageContainer,
  Dq as OrqInput,
  j3 as OrqInputDate,
  e4 as OrqLayout,
  Ri as OrqLink,
  t4 as OrqList,
  Qq as OrqListAction,
  Nq as OrqListExtra,
  Pq as OrqListMeta,
  n4 as OrqLoader,
  HS as OrqLockscreen,
  r4 as OrqLogo,
  a4 as OrqModal,
  i4 as OrqNavbar,
  s4 as OrqNavbarItem,
  o4 as OrqNavigationDrawer,
  l4 as OrqNotificationFixed,
  Rc as OrqProgressBar,
  CS as OrqProgressIndicator,
  u4 as OrqProgressRing,
  c4 as OrqProgressTracker,
  Kd as OrqRadioButton,
  d4 as OrqRadioButtonGroup,
  f4 as OrqSelect,
  v4 as OrqSelectInline,
  Ft as OrqShimmer,
  p4 as OrqShortcut,
  h4 as OrqSingleAccordion,
  iD as OrqSpinner,
  Yq as OrqSwitcher,
  g4 as OrqTab,
  m4 as OrqTabItem,
  y4 as OrqTabs,
  b3 as OrqTabsItem,
  b4 as OrqTheme,
  _4 as OrqToast,
  Vd as OrqTooltip
};
